import React from 'react';
import logo from './logo.svg';
import './App.css';
import Heiner_Math_ML_Component from './Heiner_Math_ML_Component';
import vxnuaj_DeepLearningDay78_Page_Tweet_Embed from './vxnuaj_DeepLearningDay78_Page_Tweet_Embed'
// import { TwitterTimelineEmbed } from 'react-twitter-embed';
import { Timeline } from 'react-twitter-widgets';
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import EmbedComponent from './EmbedComponent';
import { RelativeTime } from '@primer/react'; // Assuming it's from Primer React or a similar library


import ArticleListAlexNichole from './ArticleListAlexNichole';
import John_Parkhill_MathMLComponent_1 from './John_Parkhill_MathMLComponent_1';
import { Slerp_for_quaternions_in_TF } from './Slerp_for_quaternions_in_TF';
import { Slerp_for_quaternions_in_TF_copy } from './Slerp_for_quaternions_in_TF_copy';
import { Slerp_for_quaternions_in_TF_copy1 } from './Slerp_for_quaternions_in_TF_copy1';
import Alexandre_MutelBlogPosts from './Alexandre_Mutel';
import Bishal_Santra_BlogPosts from './Bishal_Santra';
import CharlieMarsh_PublicProjects from './CharlieMarsh_PublicProjects';
import CharlieMarshNotionArticle from './CharlieMarshNotionArticle';
import CharlieMarsh_PostsList from './CharlieMarsh_PostsList';
import KevinFransPostCard from './KevinFransPostCard';
import KevinFransPostCardWithSeparateCSS from './KevinFransPostCardWithSeparateCSS';
import {stathiskamperisLinkedInPost} from './stathiskamperisLinkedInPost';
import StathisKamperisLinks from './StathisKamperisLinks';
import SewonMinTwitterUserDescription from './SewonMinTwitterUserDescription';
import KristofferCarlsson from './KristofferCarlsson';
import KristofferCarlssonTilesOnly from './KristofferCarlssonTilesOnly';
import KristofferCarlssonTilesOnly1 from './KristofferCarlssonTilesOnly1';
import roboticcam_machine_learning_notes_github_repository from './RoboticCamMachineLearningNotesGithubRepository';
import RoboticCamMachineLearningNotesGithubRepository from './RoboticCamMachineLearningNotesGithubRepository';
import JuanitorduzGitHubProfile from './Juanitorduz';
import AlexanderFischerGitHubProfile from './AlexanderFischerGitHubProfile';
import RossWightmanGitHubProfile from './RossWightmanGitHubProfile';
import DanielleNavarroGitHubProfile from './DanielleNavarroGitHubProfile';
import YixuanQiuGitHubProfile from './YixuanQiuGitHubProfile';
import YihuiXieGitHubProfile from './YihuiXieGitHubProfile';
import StevenGJohnsonGitHubProfile from './StevenGJohnsonGitHubProfile';
import JonShlensGitHubProfile from './JonShlens';
import Alexandre_MutelPR_From_2025_02_01_To_2025_02_28_Avalonia_AvaloniaUI from './Alexandre_MutelPR_From_2025_02_01_To_2025_02_28_Avalonia_AvaloniaUI';
import MilesCranmerPR_From_2025_03_01_To_2025_03_31_PySR_845_fix_comparison_operator_parsing from './MilesCranmerPR_From_2025_03_01_To_2025_03_31_PySR_845_fix_comparison_operator_parsing';
import MilesCranmerGitHubProfile from './MilesCranmer';
import HamelHusainGitHubProfile from './HamelHusain';
import ChristopheDervieuxGitHubProfile from './ChristopheDervieux';
import DavisVaughanGitHubProfile from './DavisVaughan';
import Bytefish_facerec_GitHubRepository from './BytefishFacerecGitHubRepository';
import Markheath_azure_functions_links_GitHubRepository from './Markheath_azure_functions_links_GitHubRepository';
import Cédric_Luthi_0xced_Chisel_GitHubRepository from './Cédric_Luthi_0xced_Chisel_GitHubRepository';
import Nelhage_llama_GitHubRepository from './NelhageLlamaGitHubRepository';
import DaniloPoccia_danilop_AWS_Lambda_in_ActionGitHubRepository from './DaniloPoccia_danilop_AWS_Lambda_in_ActionGitHubRepository';
import FeiPeng_fiigii_PacketTracerGitHubRepository from './FeiPeng_fiigii_PacketTracerGitHubRepository';
import YoshifumiKawai_Cysharp_ZLinq_GitHubRepository from './YoshifumiKawai_Cysharp_ZLinq_GitHubRepository';
import Serilog_serilog_aspnetcore_GitHubRepository from './Serilog_serilog_aspnetcore_GitHubRepository';
import IvanCesar_yohney_elastic_net_example_GitHubRepository from './IvanCesar_yohney_elastic_net_example_GitHubRepository';
import Divyashreepathihalli_Issue_keras_team_keras_hub_1875 from './divyashreepathihalli_Issue_keras_team_keras_hub_1875';
import TagList from './TagList';
import MilesCranmerPR_JuliaNLSolvers_Optim_jl_pull_1084_From_2025_03_01_To_2025_03_31_Create_benchmark_suite from './MilesCranmerPR_JuliaNLSolvers_Optim_jl_pull_1084_From_2025_03_01_To_2025_03_31_Create_benchmark_suite';
import Practical_otel_opentelemetry_aspire_collector_GitHubRepository from './Practical_otel_opentelemetry_aspire_collector_GitHubRepository';
import Martinjt_ocb_config_builder_GitHubRepository from './Martinjt_ocb_config_builder_GitHubRepository';
import Abpframework_abp_GitHubRepository from './Abpframework_abp_GitHubRepository';
import Open_telemetry_opentelemetry_collector_GitHubRepository from './Open_telemetry_opentelemetry_collector_GitHubRepository';
import Cédric_Luthi_0xced_dotnet_aspnetcore_pull_58161pull_58161_From_2024_10_01_To_2024_10_31_Implement_the_Mvc_PushFileStreamResult_API from './Cédric_Luthi_0xced_dotnet_aspnetcore_pull_58161pull_58161_From_2024_10_01_To_2024_10_31_Implement_the_Mvc_PushFileStreamResult_API';
import ChrisRackauckasPR_SciML_SciMLSensitivity_jl_pull_1159_From_2025_02_01_To_2025_02_28_Testmaster from './ChrisRackauckasPR_SciML_SciMLSensitivity_jl_pull_1159_From_2025_02_01_To_2025_02_28_Testmaster';
import GuillaumeLemaitrelPR_probabl_ai_skore_966_From_204_12_01_To_2024_12_31 from './GuillaumeLemaitrelPR_probabl_ai_skore_966_From_204_12_01_To_2024_12_31';
import AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31 from './AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31';
import AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31_Reviewers from './AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31_Reviewers';
import WhyThisRepo from './WhyThisRepo';
import MatthewRocklinPR_pytorch_pytorch_issues_9168_From_2018_7_01_To_2018_8_31 from './MatthewRocklinPR_pytorch_pytorch_issues_9168_From_2018_7_01_To_2018_8_31';
import Roboflow_rf_detr_graphs_contributors_ContributorList from './Roboflow_rf_detr_graphs_contributors';
import Erikbern_ann_benchmarks_GitHubRepository_CodeDisplay from './Erikbern_ann_benchmarks_GitHubRepository';
import Krasserm_fsdl_text_recognizer_2021_labs_From_2021_3_01_To_2021_3_31 from './Krasserm_fsdl_text_recognizer_2021_labs_From_2021_3_01_To_2021_3_31';
import Stevengj_JuliaMath_FastChebInterp_jl_issues_24_From_2025_1_01_To_2025_3_31 from './Stevengj_JuliaMath_FastChebInterp_jl_issues_24_From_2025_1_01_To_2025_3_31';
import Timiskhakov_ComputingTheConvexHullOnGpu_GitHubRepository from './Timiskhakov_ComputingTheConvexHullOnGpu_GitHubRepository';
import Huggingface_nanoVLM_Contributors_ContributorList from './huggingface_nanoVLM_Contributors';
import OriolNieto from './OriolNietoProfile';
import AndrésMarafioti from './AndrésMarafiotiGitHubProfile';
import MerlinVR_UdonSharp_ContributorList from './MerlinVR_UdonSharp_ContributorList';
import MomotheMonsterGitHubProfile from './MomotheMonsterGitHubProfile';
import ChristophKubischGitHubProfile from './ChristophKubischGitHubProfile';
import Rwightman_pull_mlfoundations_open_clip_pull_1069_From_2025_04_01_To_2025_04_30 from './rwightman_pull_mlfoundations_open_clip_pull_1069_From_2025_04_01_To_2025_04_30';
import MichaelTarlton_Twitter from './MichaelTarlton_Twitter';
import ZonghengYang_skypilot_org_skypilot_ContributorList from './ZonghengYang_skypilot_org_skypilot_ContributorList';
import GautamMittalGitHubProfile from './GautamMittalGitHubProfile';
import Max_Liani_Twitter_Following from './Max_Liani_Twitter_Following';
import Anthony_ShawPR_langchain_ai_langchain_community_pull_88_From_2025_5_01_To_2025_5_31 from './Anthony_ShawPR_langchain_ai_langchain_community_pull_88_From_2025_5_01_To_2025_5_31';
import Anthony_ShawPR_langchain_ai_langchain_community_pull_99_From_2025_6_01_To_2025_6_30 from './Anthony_ShawPR_langchain_ai_langchain_community_pull_99_From_2025_6_01_To_2025_6_30';
import Edzer_Pebesma_VCardDetails from './Edzer_Pebesma_VCardDetails';
import Jirka_Borovec_PR_Lightning_AI_lightning_thunder_pull_2208_From_2025_6_01_To_2025_6_30 from './Jirka_Borovec_PR_Lightning_AI_lightning_thunder_pull_2208_From_2025_6_01_To_2025_6_30';
import Pranjali_Awasthi_raidingAI_Twitter_Following from './Max_Liani_Twitter_Following copy';
import JimmyLefevre_kb_GitHubRepository from './Cédric_Luthi_0xced_Chisel_GitHubRepository copy';
import ShayRojanskyAccordion from './ShayRojanskyAccordion';
import Eric_Berg_MVP_TwitterProfile from './Eric_Berg_MVP_TwitterProfile';
import GorsairComponent from './GorsairComponent';
import Asankhaya_SharmaPR_codelion_openevolve_issues_148_From_2025_7_01_To_2025_7_31 from './Asankhaya_SharmaPR_codelion_openevolve_issues_148_From_2025_7_01_To_2025_7_31';
import Asankhaya_SharmaPR_codelion_openevolve_issues_147_From_2025_7_01_To_2025_7_31 from './Asankhaya_SharmaPR_codelion_openevolve_issues_147_From_2025_7_01_To_2025_7_31';
import AaronPowell_PR_github_awesome_copilot_discussions_64_From_2025_7_01_To_2025_7_31 from './AaronPowell_PR_github_awesome_copilot_discussions_64_From_2025_7_01_To_2025_7_31';
import Ambily_PR_github_awesome_copilot_pull_49_From_2025_7_01_To_2025_7_31 from './Ambily_PR_github_awesome_copilot_pull_49_From_2025_7_01_To_2025_7_31';
import Anthony_ShawPR_Azure_Samples_azure_search_openai_demo_pull_2553_From_2025_6_01_To_2025_6_30 from './Anthony_ShawPR_Azure_Samples_azure_search_openai_demo_pull_2553_From_2025_6_01_To_2025_6_30';
import Cédric_Luthi_0xced_PR_Arcenox_co_TickerQ_pull_169_From_2025_08_01_To_2025_08_31_Target_NET_8_and_NET_9 from './Cédric_Luthi_0xced_PR_Arcenox_co_TickerQ_pull_169_From_2025_08_01_To_2025_08_31_Target_.NET_8_and_.NET_9';
import Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31 from './Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31_1';
import Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31_1 from './Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31_1';

// Define the expected props type for the component
interface MyTwitterWidgetProps {
  name: string; // The 'name' prop will be a string
}

export function MyTwitterWidget({ name }:MyTwitterWidgetProps ) {
  return (
    <div>
      <h3>MyTwitterWidget</h3>
      <Timeline
        dataSource={{
          sourceType: 'profile',
          screenName: name,
        }}
        options={{
          height: '400',
        }}
      />
    </div>
  );
}

export function MyTwitterEmbed({ name }: MyTwitterWidgetProps) {
  return (
    <div>
      <h3>MyTwitterEmbed</h3>
      <TwitterTimelineEmbed
        sourceType="profile"
        screenName={name}
        options={{ height: 400 }}
      />
    </div>
  );
}


function App() {
  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        </header> */}
        <div className="App-header_replica">
        <TagList />
        <h3>In this article</h3>
        <ul>
       

<li>

{/* <a href="#@Alexandre_Mutel" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              @Alexandre_Mutel </span>
            
            </h1>
            <h3><div>Director C#/.NET Tech Group at Unity, OSS, lang/compilers, GPU/sound, architecture 🏎️
Microsoft MVP, ex-demoscene PC/Amiga 🎆
Veggie 🌿, opinions are my own.</div></h3>
          </a> */}
          <a href="#@Alexandre_Mutel" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      @Alexandre_Mutel
    </span>
    
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>
      Director C#/.NET Tech Group at Unity, OSS, lang/compilers, GPU/sound, architecture 🏎️
      Microsoft MVP, ex-demoscene PC/Amiga 🎆
      Veggie 🌿, opinions are my own.
    </div>
  </h3>
</a>

<Alexandre_MutelBlogPosts />
{/* 
          <h2 className="year" id="2018">
      2023
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#2018"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
        }}
      ></a>
    </h2>
<li 
// className="prefix-Alexandre-Mutel"
>
  <a href="https://xoofx.github.io/blog/2023/07/09/10x-performance-with-simd-in-csharp-dotnet">10x Performance with SIMD Vectorized Code in C#/.NET</a>
  <span className="blog-post-meta">
    - <span className="date"><time 
    // datetime="2023-07-09" itemprop="datePublished"
    >Jul 9</time></span>
    <i className="bi bi-tags"></i><a href="/blog/tag/csharp/" className="prefix-Alexandre-Mutel">C#</a>, <a href="/blog/tag/net/" className="prefix-Alexandre-Mutel">.NET</a>, <a href="/blog/tag/x86/" className="prefix-Alexandre-Mutel">x86</a>, <a href="/blog/tag/assembler/" className="prefix-Alexandre-Mutel">assembler</a>
  </span>
  <span className="subtitle">Use your CPU at its full width!</span>
</li>



<h2 className="year" id="2018">
      2018
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#2018"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
        }}
      ></a>
    </h2>
      <ul>
        <li>
          <a href="https://xoofx.github.io/blog/2018/12/26/generate-async-from-sync-code-with-roslyn">Generate automatically async/await code from sync code with Roslyn</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-12-26" itemprop="datePublished"
             >Dec 26</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/roslyn/">Roslyn</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/04/12/writing-managed-jit-in-csharp-with-coreclr">Writing a Managed JIT in C# with CoreCLR</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
           // datetime="2018-04-12" itemprop="datePublished"
            >Apr 12</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/coreclr/">CoreCLR</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/04/06/porting-unity-to-coreclr">Porting the Unity Engine to .NET CoreCLR</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-04-06" itemprop="datePublished"
            >Apr  6</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/coreclr/">CoreCLR</a>, <a href="/blog/tag/unity/">Unity</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/03/09/productivity-with-resharper">Productivity with ReSharper</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-03-09" itemprop="datePublished"
            >Mar  9</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/visual-studio/">Visual Studio</a>, <a href="/blog/tag/visual-studio-2015/">Visual Studio 2015</a>, <a href="/blog/tag/roslyn/">Roslyn</a>
          </span>
        </li>

      </ul> */}

</li>
<li>

{/* <a href="#Bishal_Santra" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              @Bishal Santra </span>
             
            </h1>
            <h3> <div>Research Engineer <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/microsoft/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/microsoft">@microsoft</a> Research India | 
            Working on Language Modeling for Retrieval | IIT KGP</div></h3>
          </a> */}
<a href="#Bishal_Santra" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      @Bishal Santra
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>
      Research Engineer 
      <a className="user-mention notranslate" 
         data-hovercard-type="organization" 
         data-hovercard-url="/orgs/microsoft/hovercard" 
         data-octo-click="hovercard-link-click" 
         data-octo-dimensions="link_type:self" 
         href="https://github.com/microsoft">
        @microsoft
      </a> 
      Research India | Working on Language Modeling for Retrieval | IIT KGP
    </div>
  </h3>
</a>

          <Bishal_Santra_BlogPosts />
</li>
<li>

{/* <a href="#KristofferCarlsson" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Kristoffer Carlsson </span>
             
            </h1>
            <h3>    <div>Software engineer, Julia Computing</div></h3>
          </a> */}

          <a href="#KristofferCarlsson" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Kristoffer Carlsson
    </span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>Software engineer, Julia Computing</div>
  </h3>
</a>



            <KristofferCarlssonTilesOnly1 />
          {/* <KristofferCarlssonTilesOnly /> */}
          {/* <KristofferCarlsson /> */}

</li>
<li>

{/* <a href="#StathisKamperis" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Stathis Kamperis </span>
              
            </h1>
            <h3>    <div>I am a radiation oncologist and physicist. I like to build bridges between different scientific disciplines (medicine, physics, informatics).</div></h3>
          </a> */}
          <a href="#StathisKamperis" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Stathis Kamperis
    </span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>
      I am a radiation oncologist and physicist. I like to build bridges between different scientific disciplines (medicine, physics, informatics).
    </div>
  </h3>
</a>


</li>
<li>
{/* <a href="#DanielleNavarro" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Danielle Navarro </span>
             
            </h1>
            <h3>    <p>Hi there! I’m Danielle Navarro. I’m a 
              <a href="https://blog.djnavarro.net/" data-original-href="https://blog.djnavarro.net/">
            data scientist</a>, 
            
            <a href="https://art.djnavarro.net/" data-original-href="https://art.djnavarro.net/">generative artist</a>, and a <a href="https://papers.djnavarro.net/" data-original-href="https://papers.djnavarro.net/">recovering academic</a> living in Sydney with my two kids and a Netflix subscription. Once upon a time I was a mathematical psychologist. After that I was developer advocate and occasional software engineer. I’ve sometimes been accused of being a statistician.</p></h3>
          </a> */}
<a href="#DanielleNavarro" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Danielle Navarro
    </span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <p>Hi there! I’m Danielle Navarro. I’m a 
      <a href="https://blog.djnavarro.net/" data-original-href="https://blog.djnavarro.net/">
        data scientist
      </a>, 
      <a href="https://art.djnavarro.net/" data-original-href="https://art.djnavarro.net/">
        generative artist
      </a>, and a 
      <a href="https://papers.djnavarro.net/" data-original-href="https://papers.djnavarro.net/">
        recovering academic
      </a> living in Sydney with my two kids and a Netflix subscription. Once upon a time I was a mathematical psychologist. After that I was developer advocate and occasional software engineer. I’ve sometimes been accused of being a statistician.
    </p>
  </h3>
</a>


</li>

<li>
<a
  href="#MilesCranmer"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Miles Cranmer
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Miles Cranmer.
      <a
        href="https://github.com/MilesCranmer"
        data-original-href="https://github.com/MilesCranmer"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

</li>

          <li>
            <a
              href="#Leland_McInnes"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Leland McInnes(lmcinnes)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m  Leland McInnes(lmcinnes).
                  <a
                    href="https://github.com/lmcinnes"
                    data-original-href="https://github.com/lmcinnes"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>


<li>

<a
  href="#DavisVaughan"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    DavisVaughan
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  DavisVaughan.
      <a
        href="https://github.com/DavisVaughan"
        data-original-href="https://github.com/DavisVaughan"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>
</li>



<li>

<a
  href="#JonShlens"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Jon Shlens
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Jon Shlens.
      <a
        href="https://github.com/shlens"
        data-original-href="https://github.com/yixuan/"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

</li>

<li>
{/* <a href="#YihuiXie" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">Yihui Xie </span>
             
            </h1>
            <h3>    <p>Hi there! I’m Yihui Xie. I’m a <a href="https://github.com/yihui" data-original-href="https://yihui.org/en/">
              Freelancer (open source programmer, contractor, blogger, and writer)</a></p></h3>
          </a> */}


          <a href="#YihuiXie" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">Yihui Xie</span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <p>Hi there! I’m Yihui Xie. I’m a 
      <a href="https://github.com/yihui" data-original-href="https://yihui.org/en/">
        Freelancer (open source programmer, contractor, blogger, and writer)
      </a>
    </p>
  </h3>
</a>

</li>
<li>
{/* <a href="#@tslumley" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            ThomasLumley </span></h1>
            <h3>    <p><span className="p-nickname vcard-username d-block">
            on Mastodon and Blu Esky
            </span></p> </h3>
          
        </a> */}


        <a href="#@tslumley" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      ThomasLumley
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p>
      <span className="p-nickname vcard-username d-block">
        on Mastodon and Blu Esky
      </span>
    </p>
  </h3>
</a>

        </li>
 <li>

   
        <a
  href="#roboticcam-machine-learning-note"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Prof Richard Xu
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Prof Richard Xu.
      <a
        href="https://github.com/roboticcam"
        data-original-href="https://github.com/roboticcam"
      >
        <div style={{ margin: 0 }}>
          I am a Professor at the Department of Mathematics, Hong Kong Baptist
          University (HKBU) 香港浸会大学数学系教授
        </div>
      </a>
    </p>
  </h3>
</a>

</li>
<li>
<a
  href="#AlexanderFischerGitHubProfile"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Alexander Fischer
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Alexander Fischer.
      <a
        href="https://github.com/s3alfisc"
        data-original-href="https://github.com/s3alfisc"
      >
          <div>Data Scientist <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/trivago/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/trivago">@trivago</a> </div>
      </a>
    </p>
  </h3>
</a>
</li>
<li>
            <a
              href="#KristofSchröder"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Kristof Schröder
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Kristof Schröder.
                  <a
                    href="https://github.com/schroedk"
                    data-original-href="https://github.com/schroedk"
                  >
                  </a>
                </p>
              </h3>
            </a>
</li>
          <li>
            <a
              href="#TrevorManz"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Trevor Manz
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Trevor Manz.
                  <a
                    href="hhttps://github.com/manzt"
                    data-original-href="https://github.com/manzt"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#PrettierIgnore_"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  prettier/prettier
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                prettier/prettier
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#py_econometrics_pyfixest"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  py-econometrics/pyfixest
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m the py-econometrics/pyfixest GitHub repository.
                  <a
                    href="https://github.com/py-econometrics/pyfixest"
                    data-original-href="https://github.com/py-econometrics/pyfixest"
                  >
                    Visit repo
                  </a>
                </p>
              </h3>
            </a>
          </li>
<li>
<a
  href="#RossWightmanGitHubProfile"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Ross Wightman
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Ross Wightman.
      <a
        href="https://github.com/rwightman"
        data-original-href="https://github.com/rwightman"
      >
          <div>Computer Vision <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/huggingface/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/huggingface">@huggingface</a>. Always learning, constantly curious. Building ML/AI systems, watching loss curves.</div>
      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#StevenGJohnson"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Steven G. Johnson
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Steven G. Johnson.
      <a
        href="https://github.com/stevengj"
        data-original-href="https://github.com/stevengj"
      >
           <div style={{ textAlign: 'center' }}>
      Professor of{' '}
      <a
        href="http://math.mit.edu/applied/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Applied Mathematics
      </a>{' '}
      and{' '}
      <a
        href="http://web.mit.edu/physics/people/faculty/johnson_steven.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Physics, Massachusetts Institute of Technology
      </a>
      <br />
    </div>

      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#YixuanQiu1"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yixuan Qiu
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Yixuan Qiu.
      <a
        href="https://github.com/yixuan/"
        data-original-href="https://github.com/yixuan/"
      >
          <div>
            
          <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p>
            </div>
      </a>
    </p>
  </h3>
</a>

</li>

<li>

<a
  href="#RogerKoenker"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Roger Koenker
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Roger Koenker.
      <a
        href="http://www.econ.uiuc.edu/~roger/"
        data-original-href="http://www.econ.uiuc.edu/~roger/"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
<a
  href="#ThomasStringer"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Thomas Stringer
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Thomas Stringer.
      <a
        href="https://github.com/trstringer"
        data-original-href="https://github.com/trstringer"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>
</li>
<li>

<a
  href="#MartinEvans"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Martin Evans
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Martin Evans.
      <a
        href="https://github.com/martindevans"
        data-original-href="https://github.com/martindevans"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

<a rel="nofollow me" className="Link--primary wb-break-all" href="http://martindevans.me">http://martindevans.me</a>


</li>

<li>
<a
  href="#CédricLuthi"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Cédric Luthi
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Cédric Luthi.
      <a
        href="https://github.com/0xced"
        data-original-href="https://github.com/0xced"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>


<a
  href="#MarkHeath"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Mark Heath
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Mark Heath.
      <a
        href="https://github.com/markheath"
        data-original-href="https://github.com/markheath"
      >
          

      </a>
    </p>
  </h3>
</a>

</li>

<li>

<a
  href="#Elasticsearch"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Elasticsearch
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Elasticsearch. The heart of the Elastic Stack
      <a
        href="https://www.elastic.co/elasticsearch"
        data-original-href="https://www.elastic.co/elasticsearch"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>



</li>
<li>
<a
    href="#Serilog"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Serilog
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Serilog
    </h3>
  </a>
</li>
          <li>
            <a
              href="#Base64_Conversion_"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Base64 Methods
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Base64 Methods
              </h3>
            </a>
          </li>
<li>
  <a
    href="#PhilippWagner"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Philipp Wagner
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Philipp Wagner.
    </h3>
  </a>
</li>
<li>

  <a
    href="#DaniloPoccia"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Danilo Poccia
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Danilo Poccia.
    </h3>
  </a>
</li>

<li>

<a
  href="#KerasHub"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    KerasHub: Multi-framework Pretrained Models
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Pretrained model hub for Keras 3.
      <a
        href="https://keras.io/keras_hub/"
        data-original-href="https://keras.io/keras_hub/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#MohammadElsheimy"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Mohammad Elsheimy
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Mohammad Elsheimy
      <a
        href="https://justlikemagic.home.blog/about/"
        data-original-href="https://justlikemagic.home.blog/about/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

</li>
          <li>
            <a
              href="#Azure"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Microsoft Azure
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Microsoft Azure
              </h3>
            </a>
          </li>
          <li>

            <a
              href="#LambdaExpressions"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Lambda Expressions
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Lambda Expressions.
                  <a
                    href=""
                    data-original-href=""
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#dotnet_runtime"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  dotnet/runtime
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m dotnet/runtime.
                  <a
                    href="https://github.com/dotnet/runtime"
                    data-original-href="https://github.com/dotnet/runtime"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#dotnet_logging"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  dotnet_logging
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m dotnet_logging.
                  <a
                    href="https://github.com/dotnet/runtime"
                    data-original-href="https://github.com/dotnet/runtime"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>
<li>

<a
  href="#YoshifumiKawai"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yoshifumi Kawai
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Yoshifumi Kawai
      <a
        href="https://github.com/neuecc"
        data-original-href="https://github.com/neuecc"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>
</li>
          <li>
            <a
              href="#Steve_hez2010"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Steve(hez2010)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Steve(hez2010).
                  <a
                    href="https://github.com/hez2010"
                    data-original-href="https://github.com/hez2010"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </li>
<li>
<a
    href="#IanCooper"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ian Cooper(@iancooper)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ian Cooper(@iancooper)
    </h3>
  </a>
</li>
<li>
<a
    href="#Dapr"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Dapr
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Dapr
    </h3>
  </a>
</li>
<li>
 
<a
  href="#Abpframework_abp"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    ABP
    </span>
  </h1>
  {/* <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m ABP.
      <a href="https://abp.io/" rel="nofollow">ABP</a>
    </p>
    

  </h3> */}
</a>
<p dir="auto"><a href="https://abp.io/" rel="nofollow">ABP</a> offers an <strong>opinionated architecture</strong> to build enterprise software solutions with <strong>best practices</strong> on top of the <strong>.NET</strong> and the <strong>ASP.NET Core</strong> platforms. 
   </p>
</li>
<li>
  
  
<a
  href="#OpenTelemetry_CNCF"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    OpenTelemetry - CNCF
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m OpenTelemetry - CNCF.
      <a
        href="https://github.com/open-telemetry"
        data-original-href="https://github.com/open-telemetry"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
<a
    href="#WebAssembly"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  WebAssembly
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        WebAssembly
    </h3>
  </a>
</li>
<li>
<a
    href="#DotNetRuntime"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  DotNet Runtime
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        DotNet Runtime
    </h3>
  </a>
</li>
<li>
<a
    href="#ApplicationSecurity"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Application Security
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Application Security
    </h3>
  </a>
</li>
          <li>
            <a
              href="#OAuth_and_OpenID_Connect"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}  OAuth and OpenID Connect
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                OAuth and OpenID Connect
              </h3>
            </a>
          </li>
<li>
  <a
    href="#JeffHollan"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jeff Hollan(@jeffhollan)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jeff Hollan(@jeffhollan)
    </h3>
  </a>
</li>
<li>
  <a
    href="#Eric_Berg_MVP"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Eric Berg - MVP(@ericberg_de)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Eric Berg - MVP(@ericberg_de)
    </h3>
  </a>
</li>
<li>
  
<a
  href="#SafiaAbdalla"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Safia Abdalla
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Safia Abdalla.
      <a
        href="https://github.com/captainsafia"
        data-original-href="https://github.com/captainsafia"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
  

<a
  href="#AnthonySneed"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Anthony Sneed
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Anthony Sneed
      <a
        href="https://github.com/tonysneed"
        data-original-href="https://github.com/tonysneed"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
<a
    href="#ConradLudgate"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Conrad Ludgate
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Conrad Ludgate.
    </h3>
  </a>
</li>
<li>
<a
    href="#SQLJoin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      SQL Join
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    SQL Join.
    </h3>
  </a>
</li>
<li>
  

<a
  href="#Vincent_D_Warmerdam"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Vincent D. Warmerdam
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Vincent D. Warmerdam
      <a
        href="https://github.com/koaning"
        data-original-href="https://github.com/koaning"
      >
          

      </a>
    </p>
  </h3>
</a>

</li>
<li>
  

<a
  href="#Single_instruction_multiple_data_(SIMD)"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Single instruction, multiple data (SIMD)
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Single instruction, multiple data (SIMD).
      <a
        href="https://en.wikipedia.org/wiki/Single_instruction,_multiple_data"
        data-original-href="https://en.wikipedia.org/wiki/Single_instruction,_multiple_data"
      >
          

      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#SciML"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    SciML Open Source Scientific Machine Learning
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Open source software for scientific machine learning
      <a
        href="https://github.com/SciML"
        data-original-href="https://github.com/SciML"
      >
          

      </a>
    </p>
  </h3>
</a>

</li>
<li>

  
<a
  href="#ml_linear_regression"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Linear Regression in Machine learning
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Linear Regression in Machine learning
      <a
        href="https://www.geeksforgeeks.org/ml-linear-regression/"
        data-original-href="https://www.geeksforgeeks.org/ml-linear-regression/"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>

<a
  href="#SamGreyDanus"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Sam Grey Danus
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Sam Grey Danus
      <a
        href="https://github.com/greydanus"
        data-original-href="https://github.com/greydanus"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
  
<a
  href="#YunjeyChoi"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yunjey Choi
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Yunjey Choi
      <a
        href="https://github.com/yunjey"
        data-original-href="https://github.com/yunjey"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>

<li>
  

<a
  href="#PaulBerg"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Paul Berg
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Paul Berg
      <a
        href="https://github.com/Pangoraw"
        data-original-href="https://github.com/Pangoraw"
      >
          

      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#BenoîtLegat"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Benoît Legat
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Benoît Legat
      <a
        href="https://github.com/blegat/"
        data-original-href="https://github.com/blegat/"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
   
<a
  href="#Dask_GitHub"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Dask
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Parallel computing with task scheduling
      <a
        href="https://github.com/dask/dask"
        data-original-href="https://github.com/dask/dask"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

</li>
<li>

<a
  href="#pickle_python_object_serialization"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    The Python Pickle Module
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    The Python Pickle Module
      <a
        href="https://www.geeksforgeeks.org/pickle-python-object-serialization/"
        data-original-href="https://www.geeksforgeeks.org/pickle-python-object-serialization/"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
  
  <a
    href="#AndriyBurkov"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Andriy Burkov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Andriy Burkov.
    </h3>
  </a>
</li>
<li>

  <a
    href="#richlander_containe_workshop"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      .NET 8 container workshop
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    .NET 8 container workshop.
    </h3>
  </a>
</li>
<li>
  <a
    href="#krasserm"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Martin Krasser
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Martin Krasser.
    </h3>
  </a>
</li>
<li>
  <a
    href="#SimonWillison"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Simon Willison
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Simon Willison.
    </h3>
  </a>
</li>
<li>
  
  <a
    href="#AhmetAlpBalkan"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ahmet Alp Balkan
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Ahmet Alp Balkan.
    </h3>
  </a>
</li>
<li>
  <a
    href="#AnisAthalye"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Anish Athalye
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Anish Athalye.
    </h3>
  </a>
</li>
<li>
<a
    href="#Xuan-SonNguyen"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Xuan-Son Nguyen
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Xuan-Son Nguyen
    </h3>
  </a>
</li>
<li>
<a
  href="#githubcom_huggingface_transformers_pull_35848"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Ross Wightman
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}> Hi there! I’m  Ross Wightman.
    <div>Computer Vision <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/huggingface/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/huggingface">@huggingface</a>. Always learning, constantly curious. Building ML/AI systems, watching loss curves.</div>
    </p>
    <p style={{ margin: 0 }}>
      These are my PRs
      <a
        href="https://github.com/rwightman"
        data-original-href="https://github.com/rwightman"
      >
         
      </a>
    </p>
  </h3>
</a>

</li>
<li>
  
  <a
    href="#AlexChiZ"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Alex Chi Z.
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      <p style={{ margin: 0 }}>
      Alex Chi Z.
        <a
          href=""
          data-original-href=""
        >
  
        </a>
      </p>
    </h3>
  </a>
</li>
<li>
<a
  href="#Rotation_related_problems"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Rotation related problems
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Rotation_related_problems. Quarternions. Rodrigues’ rotation formula
      <a
        href=""
        data-original-href=""
      >

      </a>
    </p>
  </h3>
</a>
</li>
<li>
  <a
    href="#CUDAProgrammingModel"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      CUDA Programming Model
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      <p style={{ margin: 0 }}>
      CUDA Programming Model
        <a
          href=""
          data-original-href=""
        >
  
        </a>
      </p>
    </h3>
  </a>
</li>
<li>

<a
    href="#MatLeonard"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Mat Leonard
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Mat Leonard.
    </h3>
  </a>

  </li>
<li>
<a
    href="#OriolNieto"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Oriol Nieto
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Oriol Nieto.
    </h3>
  </a>
</li>
<li>
<a
    href="#GuillaumeGuy"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Guillaume Guy
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Guillaume Guy
    </h3>
  </a>
</li>
<li>
<a
    href="#DB"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      DB
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    DB.
    </h3>
  </a>
</li>
<li>
            <a
              href="#krisajenkins"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Kris Jenkins(@krisajenkins)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Kris Jenkins(@krisajenkins)..
                  <a
                    href="https://github.com/schroedk"
                    data-original-href="https://github.com/schroedk"
                  >
                  </a>
                </p>
              </h3>
            </a>
</li>
<li>
<a
    href="#Books"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Books
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Books.
    </h3>
  </a>
</li>
<li>
<a
    href="#Span_T_andPipelines"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Span&lt;T&gt; and Pipelines
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
   {/* Span<T> and Pipelines */} Span&lt;T&gt; and Pipelines
    </h3>
  </a>
</li>
<li>
<a
    href="#ReshamaShaikh"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Reshama Shaikh (@reshamas)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Reshama Shaikh (@reshamas).
    </h3>
  </a>
</li>
<li>
<a
    href="#SuYang"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Su Yang
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Su Yang
    </h3>
  </a>
</li>
<li>
<a
    href="#AsankhayaSharma"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Asankhaya Sharma
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Asankhaya Sharma
    </h3>
  </a>
</li>
<li>
<a
    href="#Max_Liani"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Max Liani
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Max Liani
    </h3>
  </a>
</li>
<li>
<a
    href="#MicrosoftMVP"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Microsoft MVP
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Microsoft MVP
    </h3>
  </a>
</li>
<li>
<a
    href="#AnthonyShaw"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Anthony Shaw(@tonybaloney)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Anthony Shaw(@tonybaloney)
    </h3>
  </a>
</li>
<li>
<a
    href="#CSnakes_Repository"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       tonybaloney/CSnakes
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      tonybaloney/CSnakes
    </h3>
  </a>
</li>
<li>
<a
    href="#MatějŠtágl"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Matěj Štágl(lofcz)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Matěj Štágl(lofcz)
    </h3>
  </a>
</li>
<li>
<a
    href="#FastCloner_Repository"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       lofcz/FastCloner
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      lofcz/FastCloner
    </h3>
  </a>
</li>

<li>
  <a
    href="#PamelaFox"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Pamela Fox(@pamelafox)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Pamela Fox(@pamelafox)
    </h3>
  </a>
</li>
<li>
  <a
    href="#JerriePelser"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jerrie Pelser(@jerriep)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jerrie Pelser(@jerriep)
    </h3>
  </a>
</li>
<li>
<a
    href="#AaronPowell"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Aaron Powell(@aaronpowell)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Aaron Powell(@aaronpowell)
    </h3>
  </a>
</li>
          <li>
            <a
              href="#MiguelElGallo"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Miguel P Z(@MiguelElGallo)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Miguel P Z(@MiguelElGallo)
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#Git_add_example_to_the_rebase"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}   Git Rebase
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Git Rebase
              </h3>
            </a>
          </li>
<li>
  <a
    href="#AmbarishGanguly"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ambarish Ganguly(@ambarishg)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ambarish Ganguly(@ambarishg)
    </h3>
  </a>
</li>
<li>
<a
    href="#EthanHarris"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ethan Harris(@ethanwharris)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ethan Harris(@ethanwharris)
    </h3>
  </a>
</li>
<li>
<a
    href="#JirkaBorovec"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Jirka Borovec(@Borda)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jirka Borovec(@Borda)
    </h3>
  </a>
</li>
<li>
<a
    href="#DavidPine"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       David Pine(@IEvangelist)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      David Pine(@IEvangelist)
    </h3>
  </a>
</li>
<li>
<a
    href="#Friedrich_von_Never"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Friedrich von Never(@ForNeVeR)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Friedrich von Never(@ForNeVeR)
    </h3>
  </a>
</li>
<li>
<a
    href="#AdamSitnik"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Adam Sitnik(@adamsitnik)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Adam Sitnik(@adamsitnik)
    </h3>
  </a>
</li>
<li>
  <a
    href="#DmitryBrant"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Dmitry Brant(@dbrant)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Dmitry Brant(@dbrant)
    </h3>
  </a>
</li>
<li>
<a
    href="#AshVardanian"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ash Vardanian(@ashvardanian)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ash Vardanian(@ashvardanian)
    </h3>
  </a>
</li>
<li>
<a
    href="#JimmyLefevre"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Jimmy Lefevre(@JimmyLefevre)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
       Jimmy Lefevre(@JimmyLefevre)
    </h3>
  </a>
</li>
<li>
<a
    href="#ShayRojanskyAccordion"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Shay Rojansky(@roji)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Shay Rojansky(@roji)
    </h3>
  </a>
</li>
<li>
<a
    href="#TaniaAllard"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Tania Allard(@trallard)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Tania Allard(@trallard)
    </h3>
  </a>
</li>
<li>
<a
    href="#Ben_chmark_Adams"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ben (chmark) Adams(@benaadams)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ben (chmark) Adams(@benaadams)
    </h3>
  </a>
</li>
<li>
  <a
    href="#KarenPayne"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Karen Payne(@karenpayneoregon)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Karen Payne(@karenpayneoregon)
    </h3>
  </a>
</li>
<li>
<a
    href="#ReynoldXin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Reynold Xin(@rxin)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Reynold Xin(@rxin)
    </h3>
  </a>
</li>
<li>
<a
    href="#DavidOrtinau"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      David Ortinau(@davidortinau)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      David Ortinau(@davidortinau)
    </h3>
  </a>
</li>
<li>
  <a
    href="#BrendanLeGlaunec"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Brendan Le Glaunec(@Ullaakut)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Brendan Le Glaunec(@Ullaakut)
    </h3>
  </a>
</li>
<li>
  <a
    href="#JohannaLarsson"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Johanna Larsson(@joladev)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Johanna Larsson(@joladev)
    </h3>
  </a>
</li>
<li>
  <a
    href="#MiguelYoung"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Miguel Young(@mcy)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Miguel Young(@mcy)
    </h3>
  </a>
</li>
<li>
<a
    href="#EllieHuxtable"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      EllieHuxtable(@ellie)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      EllieHuxtable(@ellie)
    </h3>
  </a>
</li>
<li>
<a
    href="#KienDang"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Kien Dang(@kiendang)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Kien Dang(@kiendang)
    </h3>
  </a>
</li>
<li>
<a
    href="#OfekLev"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ofek Lev(ofek)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ofek Lev(ofek)
    </h3>
  </a>
</li>
          <li>

            <a
              href="#Michael_Chavinda"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Michael Chavinda(mchav)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Michael Chavinda(mchav)
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#Michael_Chavinda_gauss_function_to_plot_a_bell_curve"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Gauss function to plot a bell curve
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Gauss function to plot a bell curve
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#Maëlle_Salmon"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Maëlle Salmon(maelle)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Maëlle Salmon(maelle)
              </h3>
            </a>
          </li>  
          <li>
            <a
              href="#Use_clustered_medoid_for_stay_recommendations_#1"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                 clustered medoid
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                clustered medoid
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#Durand_Kerner_algorithm"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Durand Kerner algorithm
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Durand Kerner algorithm
              </h3>
            </a>
          </li>
          <li>
            <a
              href="3JWToken"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  JWToken JSON Web Token
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                JWToken JSON Web Token
              </h3>
            </a>
          </li>
          <li>
            <a
              href="#Json_serialization"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Json_serialization
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Json_serialization
              </h3>
            </a>
          </li>
            
{/* <li>
<a
    href="#Marlene"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Marlene
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Marlene
    </h3>
  </a>
</li> */}
<li>
        <h1 className="vcard-names1 ">
            <a href="#caleb-robinson-blog-archives" style={{ textDecoration: 'underline' }}>
            Caleb-robinson - Understanding intersection-over-union
            </a>
        </h1>
        <h3 className="archive__item-title" 
// itemprop="headline"
>  <span className="post-date">August 13, 2023 </span><a href="https://calebrob.com/algorithms/2023/08/13/ball-sort-puzzle.html" rel="permalink">Solving a game called  &#39;ball sort puzzle&#39; </a>
</h3>


<h3 className="archive__item-title" 
// itemprop="headline"
> <span className="post-date">October 02, 2019 </span> <a href="https://calebrob.com/fun/2019/10/02/elementary-cellular-automata.html" rel="permalink">Generating elementary cellular automata with Python</a>
</h3>

<h3 className="archive__item-title" 
// itemprop="headline"
> <span className="post-date">October 22, 2018 </span> <a href="https://calebrob.com/ml/imagenet/ilsvrc2012/2018/10/22/imagenet-benchmarking.html" rel="permalink">How to reproduce ImageNet validation results</a>
</h3>
<li>
                  <span className="post-date">October 22, 2018 </span>

                    <a className="post-link" href="#Caleb-Robinson-imagenet_validation">GitHub: How to reproduce ImageNet validation results</a>
                </li>


        </li>

        <li>
        <h1 className="vcard-names1 ">
            <a href="#dr-pasquale-minervini" style={{ textDecoration: 'underline' }}>
            Dr Pasquale Minervini - Some notes on Gaussian Fields and Label Propagation
            </a>
        </h1>
        </li> 
        <h1 className="vcard-names1 ">
          <a href="#PeterMelchior" style={{ textDecoration: 'underline' }}>
                Peter Melchior - 
              </a>
          </h1>
            <ul>
                    <li>
                        <strong>Scarlet2 – Thoughts for a major redesign</strong> 
                    </li>
                   <li>
                    <strong>Bayesian inference three ways</strong> Running MCMC, Hamiltonian MC, and simulation-based inference with a few lines of code

                   </li>
            </ul>
        <li>
        <h1 className="vcard-names1 ">
            <a href="#Nicolas_P_Rougier" style={{ textDecoration: 'underline' }}>
            Nicolas P. Rougier - From Python to Numpy
            </a>
        </h1>
            <p>There are already a fair number of books about Numpy (see Bibliography) and a legitimate question is to wonder if another book is really necessary. As you may have guessed by reading these lines, my personal answer is yes, mostly because I think there is room for a different approach concentrating on the migration from Python to Numpy through vectorization. </p>
        </li>
        <li>
        <h1 className="vcard-names1 ">
        <a href="#HeinerKüttler" style={{ textDecoration: 'underline' }}>
          Heiner Küttler - 
            </a>
          </h1>
            <li>
                  <span className="post-date">Feb 19, 2023</span>

                    <a className="post-link" href="https://heiner.ai/blog/2023/02/19/chain-rule-jacobians-autograd-shapes.html">The chain rule, Jacobians, autograd, and shapes</a>
                </li>
              
                <li>
                  <span className="post-date">Apr 14, 2021</span>

                    <a className="post-link" href="https://heiner.ai/blog/2021/04/14/gompertz-annuities-and-special-functions.html">Gompertz, annuities, and special functions</a>
                </li>
              
                <li>
                  <span className="post-date">Mar 23, 2021</span>

                    <a className="post-link" href="https://heiner.ai/blog/2021/03/23/pis-deaths-and-statistics.html">πs, deaths, and statistics</a>
                </li>
              
                <li>
                  <span className="post-date">Dec 29, 2020</span>

                    <a className="post-link" href="https://heiner.ai/blog/2020/12/29/well-definedness-in-measure-theory.html">Well-definedness in measure theory</a>
                </li>
              
                <li>
                  <span className="post-date">Sep 8, 2020</span>

                    <a className="post-link" href="https://heiner.ai/blog/2020/09/08/more-linear-regression-capm.html">More on linear regression: Capital asset pricing models</a>
                </li>
              
                <li>
                  <span className="post-date">Feb 19, 2020</span>

                    <a className="post-link" href="https://heiner.ai/blog/2020/02/19/linear-regression.html">On linear regression</a>
                </li>
              
                <li>
                  <span className="post-date">Aug 19, 2019</span>

                    <a className="post-link" href="https://heiner.ai/blog/2019/08/19/annuity-loans.html">Annuity loans</a>
                </li>
              
                <li>
                  <span className="post-date">Dec 25, 2016</span>

                    <a className="post-link" href="https://heiner.ai/blog/2016/12/25/dylaniki.html">Dylanchords</a>
                </li>
              
                <li>
                  <span className="post-date">Aug 21, 2016</span>

                    <a className="post-link" href="https://heiner.ai/blog/2016/08/21/in-every-beginning-there-is-a-delusion.html">In every beginning there is a delusion</a>
                </li>
          </li>
          <li>
          <h1 className="vcard-names1">
            <a href="#Felix-Altenberger" style={{ textDecoration: 'underline' }}>
                <strong>Felix-Altenberger - ML Engineer at ZenML.
                Posting about ML, MLOps, Computer Vision.</strong>
              </a>
          </h1>


              <li>
                    <span className="post-date">2021, Mar 30 </span>

                      <a className="post-link" href="https://fa9r.com/blog/2020/12/30/tips-for-gan-training.html">A Guide for Building GANs - 10 Tips and Tricks</a>
                  </li>
                  <li>
                    <span className="post-date">Feb 19, 2023 </span>

                      <a className="post-link" href="https://fa9r.com/blog/2021/03/30/icp-analysis.html">An Analysis of ICP Variants</a>
                  </li>
                  <li>
                    <span className="post-date">Feb 19, 2023 </span>

                      <a className="post-link" href="https://fa9r.com/projects/2021/03/30/differentiable-icp.html">3D Reconstruction with Differentiable ICP</a>
                  </li>
        </li>
        <li>
            <a href="#ArminRonacher" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Armin Ronacher
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                  mitsuhiko

                </span>
                </h1>
            </a>


          
              <li>
                    <span className="post-date">2018, Mar 18 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2018/3/31/you-cant-rust-that/">You can't Rust that
                      Some tips for how to be more productive in Rust by avoiding situations you cannot solve in Rust.</a>
                  </li>
                  <li>
                    <span className="post-date">Oct 19, 2016 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio/">I don't understand Python's Asyncio</a>
                  </li>
                  <li>
                    <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a>
                  </li>
        </li>

        <li>
            <a href="#PeterGoldsborough" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Peter Goldsborough
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
            </a>


          
              <li>
                    <span className="post-date">2018, Feb 4 </span>

                      <a className="post-link" href="https://www.goldsborough.me/ml/ai/python/2018/02/04/20-17-20-a_promenade_of_pytorch/">A Promenade of PyTorch.</a>
                  </li>
                  <li>
                    <span className="post-date">Jan 20, 2018 </span>

                      <a className="post-link" href="https://www.goldsborough.me/rust/web/tutorial/2018/01/20/17-01-11-writing_a_microservice_in_rust/">Writing a Microservice in Rust</a>
                  </li>
                  <li>
                    {/* <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a> */}
                  </li>
        </li>
        <li>
            <a href="#AayushAgrawal" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Aayush Agrawal
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
            </a>


          
              <li>
                    <span className="post-date">2022, Oct 12 </span>

                      <a className="post-link" href="https://aayushmnit.com/posts/2022-10-26-Model_Calibration/Model%20Calibration.html">Model calibration for classification tasks using Python</a>
                  </li>
                  <li>
                    <span className="post-date">Jan 20, 2024 </span>

                      <a className="post-link" href="https://aayushmnit.com/posts/2024-08-24-MLInterviewPrep/MLInterviewPrep.html">ML Interview Prepration Guide (Draft)</a>
                  </li>
                  <li>
                    {/* <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a> */}
                  </li>
        </li>
        <li>

                {/* <h1>
          <a href="http://blog.ezyang.com/about/" className="site-title">ezyang &#39;s blog</a>

          </h1> */}
            <a href="#ezyang" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  ezyang &#39;s blog
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
            </a>


            <li>

                <a href="http://blog.ezyang.com/2019/05/pytorch-internals/" rel="bookmark">PyTorch internals</a>
                <abbr className="published small" title="2019-05-16T22:11:22-0500">(May 16, 2019)</abbr>
              </li>
              
        </li>
  
        <li>

                {/* <h1>
          <a href="http://blog.ezyang.com/about/" className="site-title">ezyang &#39;s blog</a>

          </h1> */}
            <a href="#Vincent_Qin" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                   Vincent_Qin &#39;s blog
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
            </a>



          <li>

            <a className="post-title-link" href="https://vincentqin.tech/posts/python-zip/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
                {/* <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"> */}
                    📝Note: Python zip()
                    {/* </font></font> */}
                    </span>
            </a>
            </li>
            <li>

            <a className="post-title-link" href="https://vincentqin.tech/posts/light-field-depth-estimation/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
                {/* <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"> */}
                    Light Field Depth Estimation
                    {/* </font></font> */}
                    </span>
            </a>
            <abbr className="published small" title="2019-05-16T22:11:22-0500">( 16/05/2018)</abbr>
            </li>
            <li>

<a className="post-title-link" href="https://vincentqin.tech/posts/instant-ngp/" //itemprop="url"
>
<span 
 // itemprop="name"
 >
 {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
 📝Note: 5 seconds to train NeRF, NVIDIA Instant NeRF test
 {/* </font></font> */}
 </span>
 </a>
<abbr className="published small" title="2019-05-16T22:11:22-0500">( 01-05-2022)</abbr>
</li>


<li>
<a className="post-title-link" href="https://vincentqin.tech/posts/slam-common-issues-ICP/" //itemprop="url"
>
<span 
 // itemprop="name"
 >
 {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
 📝Note: SLAM FAQ (IV): Solve ICP and use SVD decomposition to get the rotation matrix
{/* </font></font> */}
 </span>
</a>
<abbr className="published small" title="2019-05-16T22:11:22-0500">( 18-08-2019)</abbr>
</li>



        </li>


        <li>

                {/* <h1>
          <a href="http://blog.ezyang.com/about/" className="site-title">ezyang &#39;s blog</a>

          </h1> */}
            {/* <a href="#Vincent_Qin" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Andrew Tulloch—Machine Learning, Statistics, Systems
               

                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
                <h2>
                About | Academic | GitHub | CV
                </h2>
            </a> */}

            <a href="#Vincent_Qin" style={{ textDecoration: 'underline' }}>
  <h1 className="vcard-names1" style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Andrew Tulloch—Machine Learning, Statistics, Systems
    </span>
    <span className="p-nickname vcard-username d-block">
      {/* Nickname (if needed) */}
    </span>
  </h1>
  <h2 style={{ margin: 0 }}>
    About | Academic | GitHub | CV
  </h2>
</a>

            <li>

            { <a className="post-title-link" href="https://tullo.ch/articles/pytorch-gpu-inference-performance/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
               
               Improving PyTorch inference performance on GPUs with a few simple tricks
                    
                    </span>
            </a> }
            <abbr className="published small" title="2019-05-16T22:11:22-0500">( 3/10/2021)</abbr>
            </li>
          <li>

            <a className="post-title-link" href="https://tullo.ch/articles/lasso-estimator/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
                {/* <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"> */}
                   The LASSO Estimator
                    {/* </font></font> */}
                    </span>
            </a>
            <abbr className="published small" title="2019-05-16T22:11:22-0500">( 13/05/2014)</abbr>
            </li>
            <li>

<a className="post-title-link" href="#Andrew_Tulloch_Cambridge_Part_III" 
// itemprop="url"

>
  <span 
  // itemprop="name"
  >
    {/* <font style="vertical-align: inherit;">
      <font style="vertical-align: inherit;"> */}
       Cambridge Part III Mathematics Notes
        {/* </font></font> */}
        </span>
</a>
<abbr className="published small" title="2019-05-16T22:11:22-0500">( 27/10/2014)</abbr>
</li>
            
        </li>

        <li>

                {/* <h1>
          <a href="http://blog.ezyang.com/about/" className="site-title">ezyang &#39;s blog</a>

          </h1> */}
            {/* <a href="#m-clark" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Michael Clarke
               

                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
                <h2>
                https://m-clark.github.io/about.html
                </h2>
            </a> */}

            <a href="#Vincent_Qin" style={{ textDecoration: 'underline' }}>
  <h1 className="vcard-names1" style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Andrew Tulloch—Machine Learning, Statistics, Systems
    </span>
    <span className="p-nickname vcard-username d-block">
      {/* Nickname (if needed) */}
    </span>
  </h1>
  <h2 style={{ margin: 0 }}>
    About | Academic | GitHub | CV
  </h2>
</a>

            <li>

            { <a className="post-title-link" href="https://m-clark.github.io/posts/2022-09-deep-linear-models/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
               
               Deep Linear Models
                    
                    </span>
            </a> }
            <abbr className="published small" title="2019-05-16T22:11:22-0500">( 10/10/2022)</abbr>
            </li>
          <li>

            <a className="post-title-link" href="https://m-clark.github.io/posts/2021-10-30-double-descent/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
                {/* <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"> */}
                   Double Descent
                    {/* </font></font> */}
                    </span>
            </a>
            <abbr className="published small" title="2019-05-16T22:11:22-0500">( 13/11/2021)</abbr>
            </li>

           
        </li>
        <li>
            <a href="#Hugo-Bowne-Anderson" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Hugo-Bowne-Anderson
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                  data scientist - educator - writer - podcaster

                </span>
                </h1>
            </a>


          
              <li>
                    <span className="post-date">2020, Apr 14 </span>

                      <a className="post-link" href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial">How to do Bayesian statistical modelling using numpy and PyMC3.</a>
                  </li>
                  <li>
                    <span className="post-date">2020, Apr 14 </span>

                      <a className="post-link" href="#bayesian-stats-modelling-tutorial">GitHUb Repository: How to do Bayesian statistical modelling using numpy and PyMC3.</a>
                  </li>
                  
                  {/* <li>
                    <span className="post-date">Oct 19, 2016 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio/">I don't understand Python's Asyncio</a>
                  </li>
                  <li>
                    <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a>
                  </li> */}
        </li>
        <li>
            <a href="#@sanjeevs_iitr" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Sanjeev Sharma

                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                @sanjeevs_iitr, Founder & CEO, Swaayatt Robot, Deep Eigen

                </span>
                </h1>
            </a>


          
              <li>
                    <span className="post-date">2024, Aug 24 </span>

                      <a className="post-link" href="https://x.com/sanjeevs_iitr/status/1827230702095495328">Projective 3-Point (P3P) algorithm plays a crucial role in understanding the Visual Odometry and typical SLAM algorithmic pipelines.</a>
                  </li>
                  {/* <li>
                    <span className="post-date">Oct 19, 2016 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio/">I don't understand Python's Asyncio</a>
                  </li>
                  <li>
                    <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a>
                  </li> */}
        </li>
        <li>
          <a href="#@gdb" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Greg Brockman </span>
            <span className="p-nickname vcard-username d-block">
            President & Co-Founder @OpenAI
            </span>
          </h1>
        </a>

        <li>
                    <span className="post-date">2019, Jul 30 </span>

                      <a className="post-link" href="https://blog.gregbrockman.com/how-i-became-a-machine-learning-practitioner">How I became a machine learning practitioner</a>
                  </li>
                  <li>
                    <span className="post-date">2025, Jan 01 </span>

                      <a className="post-link" href="https://x.com/goyal__pramod/status/1874379586714341803">If you are starting ML in 2025, read this blog by 
@gdb. I believe it will help you out.</a> Link: TwitterID: goyal__pramod
                  </li>
                  

        </li>
        <li>
            {/* <a href="#@GrantSlatton" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Grant Slatton </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>Formerly built the world's fastest filesystem at AWS, now the fastest spreadsheet at http://rowzero.com</h3>
          </a> */}

          <a href="#@GrantSlatton" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Grant Slatton
    </span>
    <span className="p-nickname vcard-username d-block">
      {/* Nickname (if needed) */}
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    Formerly built the world's fastest filesystem at AWS, now the fastest spreadsheet at <a href="http://rowzero.com">rowzero.com</a>
  </h3>
</a>


          <p><a href="https://grantslatton.com/binary-iq" className="grantslatton-a">Binary IQ</a> — A model of LLM capability</p>

<p><a href="https://grantslatton.com/rowzero-property-testing" className="grantslatton-a">Lightweight property-based testing at Row Zero</a> — How we verify correctness</p>

<p><a href="https://grantslatton.com/rust-macros" className="grantslatton-a">Rust Macros: Zero to Hero</a> — A comprehensive guide on Rust macros</p>
<p><a href="https://grantslatton.com/software-pathfinding" className="grantslatton-a">Algorithms we develop software by</a> — Pathfinding applied to the software solution domain</p>
<p><a href="https://grantslatton.com/filesystems" className="grantslatton-a">Building Filesystems</a> — High level ideas in filesystem design</p>
<p><a href="https://grantslatton.com/quasirandom" className="grantslatton-a">Quasirandom sequences</a> — Cool method to generate non-clumping random points</p>



        </li>
        <li>
        <a href="#@KanakaRajanPhD" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Kanaka Rajan </span>
            <span className="p-nickname vcard-username d-block">
            I'm an Entreprenuer| Researcher
            </span>
          </h1>
          <h3>
        
          </h3>
        </a>


       
        <li>
                    <span className="post-date">2024, Oct 17 </span>

                      <a className="post-link" href="https://www.rajanlab.com/resources">research. Resources.</a>
                  </li>
                  {/* <li>
                    <span className="post-date">Oct 19, 2016 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio/">I don't understand Python's Asyncio</a>
                  </li>
                  <li>
                    <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a>
                  </li> */}
        </li>


        <li>

<a href="#SewonMin" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Sewon Min </span>
            <span className="p-nickname vcard-username d-block">
            Incoming faculty @Berkeley_EECS @berkeley_ai ||  Research scientist at @allen_ai  ||  PhD from @uwcse @uwnlp.
            </span>
          </h1>
        </a>
</li>

        <li>

        <a href="#@j0hnparkhill" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    John Parkhill </span>
    <span className="p-nickname vcard-username d-block">
    ML, director of machine learning Terray Therapeutics (https://x.com/Terray_Tx).
    </span>
  </h1>
</a>
          
      {/* <ul className="post-list"> */}
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 19, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/CoinHedge/">
        Coin Vol-II Hedging your BTC/ETH - The basics
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 13, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/memecoin/">
        Coin Volatility Surfaces
      </a>
    </h3>
  </li> */}
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Sep 5, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/cryptocarrytrade/">
        The Crypto-Carry Trade
      </a>
    </h3>
  </li> */}
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Aug 5, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/quantumstorytelling/">
        Woo, Quantum Storytelling, Time Crystals and Misallocation
      </a>
    </h3>
  </li> */}
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta" style={{ marginRight: '10px' }}>May 30, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/torchSDE/">
        Pricing Options with TorchSDE
      </a>
    </h3>
  </div>
</li>

  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta" style={{ marginRight: '10px' }}>May 30, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/torchSDE/">
        Pricing Options with TorchSDE
      </a>
    </h3>
  </li> */}
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Apr 30, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/SolvingDiffusions/">
        Solving multidimensional PDEs in pytorch
      </a>
    </h3>
    </div>
  </li>
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Apr 7, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/HoldingVIX/">
        Using simple mean-reversion to remove carry from a VIX futures position
      </a>
    </h3>
    </div>
  </li>
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Mar 11, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuittingAAPL/">
        Moving on from the Macbook Pro
      </a>
    </h3>
  </li> */}
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Mar 6, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/InformationInStochasticSeries/">
        Simply Extracting information out of your Stochastic Series
      </a>
    </h3>
    </div>
  </li>
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
  <span className="post-meta">Jan 6, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/MultivariateGumbel/">
        Copulas made simple with Pytorch Distributions
      </a>
    </h3>
  </div>

  </li>
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Dec 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/HowToBet/">
        How to Size Bets. The Kelly Criterion in PyTorch
      </a>
    </h3>
    </div>
  </li>
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/TheMostUseful3DP/">
        The #1 Reason to have a 3D Printer.
      </a>
    </h3>
  </li> */}
  {/* <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Oct 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/MakeScienceGreatAgain/">
        Modest Proposals to Make Science Great Again.
      </a>
    </h3>
  </li> */}
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Sep 21, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/SomeArt/">
        Some Robot Art
      </a>
    </h3>
    </div>
  </li>
  <li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Sep 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuaternionAveraging/">
        Quaternion Averaging in Pytorch
      </a>
    </h3>
    </div>
  </li>
  {/* <li style={{ marginBottom: '8px' }}> 
    <span className="post-meta">Aug 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/welcome-to-jekyll/">
        Yet another static blog!
      </a>
    </h3>
  </li> */}
{/* </ul> */}



              {/* <li>
                    <span className="post-date">2024, Oct 17 </span>

                      <a className="post-link" href="https://www.rajanlab.com/resources">research. Resources.</a>
                  </li> */}
                  {/* <li>
                    <span className="post-date">Oct 19, 2016 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio/">I don't understand Python's Asyncio</a>
                  </li>
                  <li>
                    <span className="post-date">Nov 18, 2015 </span>

                      <a className="post-link" href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems/">Python's Hidden Regular Expression Gems</a>
                  </li> */}
        </li>



<li>
        <a href="#@tarantulae" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Christian S. Perone </span>
            <span className="p-nickname vcard-username d-block">
            / Machine Learning  (@polymtl/@UMontreal)
            </span>
          </h1>
        </a>
          
        <ul className="christianperone-list">
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/11/the-geometry-of-data-part-ii/">The geometry of data: the missing metric tensor and the Stein score [Part II]</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/08/torch-titan-distributed-training/">Torch Titan distributed training code analysis</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/08/mmap-torch-np-jax-tf/">Memory-mapped CPU tensor between Torch, Numpy, Jax and TensorFlow</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/06/schematism/">Generalisation, Kant’s schematism and Borges’ Funes el memorioso – Part I</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/12/pytorch-2-internals-talk/">PyTorch 2 Internals – Talk</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/09/thoughts-on-riemannian-metrics-and-its-connection-with-diffusion-score-matching-part-i/">Thoughts on Riemannian metrics and its connection with diffusion/score matching [Part I]</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/06/appreciating-llms-data-pipelines/">Large language model data pipelines and Common Crawl (WARC/WAT/WET)</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/03/feste-composing-nlp-tasks-with-automatic-parallelization-and-batching/">Feste: composing NLP tasks with automatic parallelization and batching</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/11/couple-of-recent-publications-in-uncertainty-estimation-and-autonomous-vehicles/">Couple of recent publications in uncertainty estimation and autonomous vehicles</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/05/dados-das-enchentes-no-rio-grande-do-sul-rs-em-2024/">[pt-br] Dados das enchentes no Rio Grande do Sul (RS) em 2024</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/09/tutorial-on-using-llvm-to-jit-pytorch-fx-graphs-to-native-code-x86-arm-risc-v-wasm-part-i-scalars/">Tutorial on using LLVM to JIT PyTorch fx graphs to native code (x86/arm/risc-v/w...)</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/01/arduino-wan-helium-network-and-cryptography/">Arduino WAN, Helium network and cryptographic co-processor</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2021/03/episuite-epidemiology-in-python/">Episuite: epidemiology in Python</a>
    </li>
</ul>

</li>
<li>
<a href="#@jfrankle.com" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Jonathan Frankle </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>Chief AI Scientist at Databricks. Founding team at MosaicML. MIT/Princeton alum. Lottery ticket enthusiast. Working on data intelligence.</h3>
          </a>
          <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 26, 2024</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://ofir.io/How-to-Build-Good-Language-Modeling-Benchmarks/">
      Reposted by Jonathan Frankle: Ofir Press‬ ‪@ofirpress.bsky.social· 
        I wrote some thoughts on how to build good LM benchmarks: ofir.io/How-to-Build...
      </a>
    </h3>
  </li>
</li>





<li>

<h1 style={{ 
  // fontSize: '32px',
   marginTop: '0.5em', marginBottom: '0'
  , textDecoration: 'underline' 
   }}>
      <a href="#@Charlie_Marsh" className="implicit">
        Charlie Marsh
      </a>
    </h1>

  
    <h3 style={{ fontWeight: 'normal', marginTop: '0.5em', marginBottom: '0', lineHeight: '1.4' }}>
  Building{' '}
  <b style={{ margin: '0' }}>
    <a target="_blank" rel="noopener noreferrer" href="https://astral.sh" style={{ margin: '0' }}>
      Astral
    </a>
  </b>
  : high-performance tools for Python, starting with{' '}
  <b style={{ margin: '0' }}>
    <a target="_blank" rel="noopener noreferrer" href="https://github.com/charliermarsh/ruff" style={{ margin: '0' }}>
      Ruff
    </a>
  </b>
  .
  <br />
  <br />
  In the past: Staff software engineer at{' '}
  <b style={{ margin: '0' }}>
    <a target="_blank" rel="noopener noreferrer" href="https://www.springdiscovery.com" style={{ margin: '0' }}>
      Spring Discovery
    </a>
  </b>
  , senior engineer at{' '}
  <b style={{ margin: '0' }}>
    <a target="_blank" rel="noopener noreferrer" href="https://www.khanacademy.org" style={{ margin: '0' }}>
      Khan Academy
    </a>
  </b>
  , and Computer Science major at <b style={{ margin: '0' }}>Princeton</b>.
  <br />
  <br />
  These days, I write on{' '}
  <a target="_blank" rel="noopener noreferrer" href="https://notes.crmarsh.com/" style={{ margin: '0' }}>
    Notion
  </a>
  .
  <br />
  <br />
  Check out some of my public projects:
</h3>

    <CharlieMarshNotionArticle />

</li>
<li>
{/* <h1 style={{fontSize: '3em',
    marginTop: '-0.5em'}} href="#@kevin_frans">kevin frans website v5</h1> */}
<a href="#@kevin_frans" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              kevin frans website v5</span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
          </a>

<p className="desc">
            {/* <!-- Hi, I'm Kevin! I'm a second-year undergrad at MIT. In the past, I was a research intern at OpenAI on the reinforcement learning team, and I was at Autodesk Research working on AI to automate design. In my free time, I play a lot of weird games and build some of my own. --> */}
            Hey, I'm Kevin. I am a PhD student at <a href="https://bair.berkeley.edu/">BAIR</a> 
            advised by <a href="https://people.eecs.berkeley.edu/~pabbeel/">Pieter Abbeel</a> and 
            <a href="https://people.eecs.berkeley.edu/~svlevine/">Sergey Levine</a>. 
            I did my B.S. and M.Eng at MIT with <a href="http://web.mit.edu/phillipi/">Phillip Isola</a>. 
            I&nbsp;am&nbsp;interested in deep reinforcement learning, unsupervised learning, and AI-based creative tools. 
            I&nbsp;also lead engineering at <a href="https://paragraphai.com/">ParagraphAI</a>. I&nbsp;have spent time at 
            <a href="https://crosslabs.org">Cross Labs</a>, <a href="https://twitter.com/sizigistudios">Sizigi</a>, 
            <a href="https://www.autodeskresearch.com/">Autodesk Research</a>, and <a href="https://openai.com/">OpenAI</a>. 
            In&nbsp;my&nbsp;free&nbsp;time, I&nbsp;like to design and build&nbsp;<a href="https://store.steampowered.com/app/810780/RAIN_Project__a_touhou_fangame/">video</a>
            &nbsp;<a href="https://store.steampowered.com/app/1256660/Iwate_Mountain_Dance/">games</a>.</p>

<KevinFransPostCardWithSeparateCSS />
</li>
<li>

{/* <a href="#@unixpickle" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Alex Nichol </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>AI researcher, hobby web developer, math geek. Constantly learning.</h3>
          </a> */}
          <a href="#@unixpickle" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Alex Nichol
    </span>
    <span className="p-nickname vcard-username d-block">
      {/* Nickname (if needed) */}
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    AI researcher, hobby web developer, math geek. Constantly learning.
  </h3>
</a>



<ul className="article-list">
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2024/11/29/honeycrisp-a-deep-learning-framework/">
              Honeycrisp: An Apple-First Deep Learning Framework
              <label className="article-date">(11/29/2024)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2024/01/01/vpn-tunneling-to-share-streaming-services/">
              Sharing Streaming Services Across Households
              <label className="article-date">(01/01/2024)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2023/05/20/representing-3d-models-as-decision-trees/">
              Representing 3D Models as Decision Trees
              <label className="article-date">(05/20/2023)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2022/12/31/large-scale-vehicle-classification/">
              Large-Scale Vehicle Classification
              <label className="article-date">(12/31/2022)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="/2021/04/12/data-and-machines/">
              Data and Machines
              <label className="article-date">(04/12/2021)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2020/03/04/vq-draw-a-new-generative-model/">
              VQ-DRAW: A New Generative Model
              <label className="article-date">(03/04/2020)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2020/01/18/research-didnt-pan-out/">
              Research Projects That Didn’t Pan Out
              <label className="article-date">(01/18/2020)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2019/07/24/competing-in-the-obstacle-tower-challenge/">
              Competing in the Obstacle Tower Challenge
              <label className="article-date">(07/24/2019)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2019/04/03/prierarchy-implicit-hierarchies/">
              Prierarchy: Implicit Hierarchies
              <label className="article-date">(04/03/2019)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2018/12/24/solving-murder-with-go/">
              Solving murder with Go
              <label className="article-date">(12/24/2018)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/12/23/what-i-dont-know/">
              What I Don’t Know
              <label className="article-date">(12/23/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/10/31/adversarial-traintest-splits/">
              Adversarial Train/Test Splits
              <label className="article-date">(10/31/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/08/30/decision-trees-as-rl-policies/">
              Decision Trees as RL Policies
              <label className="article-date">(08/30/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/07/04/keeping-tabs-on-all-my-neural-networks/">
              Keeping Tabs On All My Neural Networks
              <label className="article-date">(07/04/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/06/11/why-im-remaking-openai-universe/">
              Why I’m Remaking OpenAI Universe
              <label className="article-date">(06/11/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/04/15/the-meta-learning-quest-part-1/">
              The Meta-Learning Quest: Part 1
              <label className="article-date">(04/15/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/04/05/slice-aliasing/">
              Slice Aliasing Is Nicer Than You Realize
              <label className="article-date">(04/05/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/03/08/the-bug-that-wasted-a-month-of-gpu-time/">
              The Bug That Wasted a Month of GPU Time
              <label className="article-date">(03/08/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/03/01/random-fun-with-linear-svms/">
              Random Fun with Linear SVMs
              <label className="article-date">(03/01/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/02/14/can-neural-networks-learn-to-spell/">
              Can Neural Networks Learn to Spell?
              <label className="article-date">(02/14/2017)</label>
            </a>
          </li>
          <li style={{ marginBottom: '0' }}>
            <a href="https://blog.aqnichol.com/2017/02/12/ancient-philosophy-as-a-classification-problem/">
              Ancient Philosophy as a Classification Problem
              <label className="article-date">(02/12/2017)</label>
            </a>
          </li>
        </ul>

</li>

        </ul>

        <div className="sidebar sticky">
            <div 
            // itemscope itemtype="http://schema.org/Person"
            >
              <div className="author__avatar">
                <img src="https://calebrob.com/images/face.jpg" className="author__avatar" alt="Caleb Robinson"  style={{ width: '150px', height: 'auto' }} ></img>
              </div>
              
              <div id="#caleb-robinson-blog-archives" className="author__content">
                <h3 className="author__name">Caleb Robinson</h3>
                <p className="author__bio">
                  Principal Research Scientist Manager at 
                  <a style={{ color: 'black' }} href="https://www.microsoft.com/en-us/research/group/ai-for-good-research-lab/">Microsoft's AI for Good Lab</a> - 
                  <a style={{ color: 'black' }} href="https://www.microsoft.com/en-us/research/project/geospatial-machine-learning/">Geospatial ML center</a>

                </p>
              </div>
              
              <div className="author__urls-wrapper">
                <button className="btn btn--inverse">Follow</button>
                
                <ul className="author__urls social-icons" style={{display: 'none'}}>
                 {/*  <!-- Location --> */}
                  <li className="author__desktop">
                    <i className="fa-solid fa-location-dot icon-pad-right" aria-hidden="true"></i>Seattle, Washington
                  </li>
                  
                   {/* <!-- Email -->*/}
                  <li>
                    <a href="mailto:calebrob6@gmail.com">
                      <i className="fas fa-fw fa-envelope icon-pad-right" aria-hidden="true"></i>Email
                    </a>
                  </li>
                  
                   {/* <!-- Google Scholar -->*/}
                  <li>
                    <a href="https://scholar.google.com/citations?user=cjYgLT0AAAAJ">
                      <i className="ai ai-google-scholar icon-pad-right"></i>Google Scholar
                    </a>
                  </li>
                  
                  {/*  <!-- ORCID -->*/}
                  <li>
                    <a href="http://orcid.org/0000-0003-1975-4454">
                      <i className="ai ai-orcid ai-fw icon-pad-right"></i>ORCID
                    </a>
                  </li>
                  
                  {/*  <!-- Github -->*/}
                  <li>
                    <a href="https://github.com/calebrob6">
                      <i className="fab fa-fw fa-github icon-pad-right" aria-hidden="true"></i>Github
                    </a>
                  </li>
                  
                   {/* <!-- Twitter -->*/}
                  <li>
                    <a href="https://twitter.com/calebrob6">
                      <i className="fab fa-fw fa-x-twitter icon-pad-right" aria-hidden="true"></i>X (formerly Twitter)
                    </a>
                  </li>
                </ul>
               
              </div>
            </div>
          </div>

          <h1 className="page__title">
            <a href="https://calebrob.com/ml/2018/09/11/understanding-iou.html">
              Understanding intersection-over-union
            </a>
          </h1>


          <p>Intersection-over-union (IoU), also known as the Jaccard index, is a commonly used measure for determining how accurate a proposed image segmentation is, compared to a known/ground-truth segmentation. In segmentation tasks the IoU is prefered over accuracy as it is not as affected by the class imblances that are inherent in foreground/background segmentation tasks. As an example, if a ground truth image is made up of 90% background pixels, a proposed segmentation that classifies all pixels as background will have an accuracy of 90% whereas it would have an IoU of 0%.</p>



          <div className="post-meta-dr-pasquale-minervini">
              <time 
              // datetime="1 Jan 2017" 
              className="post-meta__date-dr-pasquale-minervini date">1 Jan 2017</time> • 
              <span className="post-meta__tags-dr-pasquale-minervini">on 
                <a href="/tags/#machine learning">machine learning</a> 
                <a href="/tags/#semi-supervised learning">semi-supervised learning</a> 
              </span>
</div>




<div className="list__item">
<article className="archive__item" 
// itemscope="" itemtype="http://schema.org/CreativeWork"
>
<h2 className="archive__item-title" 
// itemprop="headline"
> <a href="https://calebrob.com/algorithms/2023/08/13/ball-sort-puzzle.html" rel="permalink">Solving a game called  &#39;ball sort puzzle&#39; </a>
</h2>
<p className="page__meta"><i className="fa fa-clock-o" aria-hidden="true"></i> 9 minute read</p>
<p className="page__date"><strong><i className="fa fa-fw fa-calendar" aria-hidden="true"></i> Published:</strong> <time 
// datetime="2023-08-13T01:00:00-07:00"
>August 13, 2023</time></p>
<p className="archive__item-excerpt" 
// itemprop="description"
></p>
{/* <!-- --> */}</article></div>


<div className="list__item">
<article className="archive__item" 
// itemscope="" itemtype="http://schema.org/CreativeWork"
>
<h2 className="archive__item-title" 
// itemprop="headline"
> <a href="https://calebrob.com/fun/2019/10/02/elementary-cellular-automata.html" rel="permalink">Generating elementary cellular automata with Python</a>
</h2>
<p className="page__meta"><i className="fa fa-clock-o" aria-hidden="true"></i> 4 minute read</p>
<p className="page__date"><strong><i className="fa fa-fw fa-calendar" aria-hidden="true"></i> Published:</strong> <time 
// datetime="2023-08-13T01:00:00-07:00"
>October 02, 2019</time></p>
<p className="archive__item-excerpt" 
// itemprop="description"
></p>
{/* <!-- --> */}</article></div>

<div className="list__item">
<article className="archive__item" 
// itemscope="" itemtype="http://schema.org/CreativeWork"
>
<h2 className="archive__item-title" 
// itemprop="headline"
> <a href="https://calebrob.com/ml/imagenet/ilsvrc2012/2018/10/22/imagenet-benchmarking.html" rel="permalink">How to reproduce ImageNet validation results</a>
</h2>
<p className="page__meta"><i className="fa fa-clock-o" aria-hidden="true"></i> 4 minute read</p>
<p className="page__date"><strong><i className="fa fa-fw fa-calendar" aria-hidden="true"></i> Published:</strong> <time 
// datetime="2023-08-13T01:00:00-07:00"
>October 22, 2018</time></p>
<p className="archive__item-excerpt" 
// itemprop="description"
></p>
{/* <!-- --> */}</article></div>



<div id="Caleb-Robinson-imagenet_validation">

</div>
<div className="a row pr-2" style={{ padding: '.75em 1em' }}>
    <div className="col-sm-12">
        <div className="col-sm-12 col-lg-4 mt-6">
            <div className="rob-conery-card card shadow h-100" style={{ border: '2px solid black', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' 
             // Add shadow here 
             }}>
                <div className="Box d-flex p-3 width-full public source">
                    <div className="pinned-item-list-item-content">
                        <div className="d-flex width-full position-relative">
                            <div className="flex-1">
                                <svg
                                    aria-hidden="true"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    version="1.1"
                                    width="16"
                                    data-view-component="true"
                                    className="octicon octicon-repo mr-1 color-fg-muted"
                                >
                                    <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"></path>
                                </svg>
                                <span data-view-component="true" className="position-relative">
                                    <a
                                        href="https://github.com/calebrob6/imagenet_validation"
                                        className="Link mr-1 text-bold wb-break-word"
                                        aria-labelledby="tooltip-6baf9a22-427b-4407-9260-e2fbc25d7c37"
                                        style={{ textDecoration: 'underline' }} // Example of underlined link
                                    >
                                        <span className="repo">imagenet_validation </span>
                                    </a>
                                    <span></span>
                                    <span className="Label Label--attention v-align-middle mt-1 no-wrap v-align-baseline Label--inline">
                                        Public 
                                    </span>
                                </span>

                                <p className="pinned-item-desc color-fg-muted text-small mt-2 mb-0">
                                How to reproduce ImageNet validation results
                                </p>

                                <p className="mb-0 mt-2 f6 color-fg-muted">
                                    <a href="https://github.com/calebrob6/imagenet_validation" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="stars"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-star"
                                        >
                                            <path d="M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"></path>
                                        </svg>
                                        34
                                    </a>
                                    <a href="https://github.com/robconery/pg_docs_api/forks" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="forks"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-repo-forked"
                                        >
                                            <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"></path>
                                        </svg>
                                        9
                                    </a>
                                </p>

                                <p dir="auto">Jupyter Notebook</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p dir="auto">This code in this repository can be used to reproduce the <a href="https://keras.io/applications/index.html#documentation-for-individual-models" rel="nofollow">ImageNet validation results for Keras pretrained models</a>. A blog post describing this process in more detail is <a href="http://calebrob.com/ml/imagenet/ilsvrc2012/2018/10/22/imagenet-benchmarking.html" rel="nofollow">here</a>.</p>
<h3>Code</h3>
<ul>
  <li>
    <a href="https://github.com/calebrob6/imagenet_validation/blob/master/1.%20Preprocess%20ImageNet%20validation%20set.ipynb">1. Preprocess ImageNet validation set</a> - converts the raw ILSVRC2012 validation images/labels into NumPy arrays (<code className="language-plaintext highlighter-rouge">.npy</code> files) that can be used “as is” with pre-trained Keras models</li>
    <li><a href="https://github.com/calebrob6/imagenet_validation/blob/master/2.%20Benchmark%20Keras%20pretrained%20models%20on%20ImageNet.ipynb">2. Benchmark Keras pretrained models on ImageNet.ipynb</a> - uses the preprocessed data and the VGG19 pre-trained network to reproduce the Top-1 and Top-5 accuracy reported in the Keras documentation.
</li>
</ul>


        <h1 className="post-title-dr-pasquale-minervini" id="dr-pasquale-minervini">
          
        <a href="https://neuralnoise.com/2017/gaussian-fields/">
        Some notes on Gaussian Fields and Label Propagation
                    </a>
        </h1>

        <h3 id="propagation-as-a-cost-minimization-problem">Propagation as a Cost Minimization Problem</h3>


        <h1 className="title" id="PeterMelchior">Peter Melchior</h1>
       
        <div className="row-peter-melchior">
  <div className="col-md-12-peter-melchior">
    <table className="table table-striped-peter-melchior">
      <tbody>
        <tr>
          <td>
            <b><a href="https://pmelchior.net/blog/scarlet2-redesign.html">Scarlet2 – Thoughts for a major redesign</a></b><br></br>
            Astronomical source modeling and separation, all new and shiny
          </td>
        </tr>
        <tr>
          <td>
            <b><a href="https://pmelchior.net/blog/bayesian-inference-three-ways.html">Bayesian inference three ways</a></b><br></br>
            Running MCMC, Hamiltonian MC, and simulation-based inference with a few lines of code
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<h1 className="title" id="Nicolas_P_Rougier">From Python to Numpy</h1>
<p dir="auto">This is a collection of numpy exercises from numpy mailing list, stack overflow, and numpy documentation. I've also created some problems myself to reach the 100 limit. The goal of this collection is to offer a quick reference for both old and new users but also to provide a set of exercises for those who teach. For extended exercises, make sure to read <a href="http://www.labri.fr/perso/nrougier/from-python-to-numpy/" rel="nofollow">From Python to NumPy</a>.</p>
    
<p>There are already a fair number of books about Numpy (see <a className="reference internal" href="#bibliography">Bibliography</a>) and a
legitimate question is to wonder if another book is really necessary. As you
may have guessed by reading these lines, my personal answer is yes, mostly
because I think there is room for a different approach concentrating on the
migration from Python to Numpy through vectorization. There are a lot of
techniques that you don't find in books and such techniques are mostly learned
through experience. The goal of this book is to explain some of these
techniques and to provide an opportunity for making this experience in the
process.</p>

<p><strong>Website:</strong> <a className="reference external" href="http://www.labri.fr/perso/nrougier/from-python-to-numpy">http://www.labri.fr/perso/nrougier/from-python-to-numpy</a></p>
    

<div className="container-three-columns">
  <div className="column-one">

  <h2>Preface</h2>
    <ul>
      <li><a href="#id60">About the author</a></li>
      <li><a href="#id61">About this book</a></li>
      <li><a href="#id62">License</a></li>
    </ul>

    <h2>Introduction</h2>
    <ul>
      <li><a href="#simple-example">Simple Example</a></li>
      <li><a href="#readability-vs-speed">Readability vs Speed</a></li>
    </ul>

    <h2>Anatomy of an Array</h2>
    <ul>
      <li><a href="#id68">Introduction</a></li>
      <li><a href="#memory-layout">Memory Layout</a></li>
      <li><a href="#views-and-copies">Views and Copies</a></li>
      <li><a href="#id71">Conclusion</a></li>
    </ul>


    <h2>Code Vectorization</h2>
    <ul>
      <li><a href="#id72">Introduction</a></li>
      <li><a href="#uniform-vectorization">Uniform Vectorization</a></li>
      <li><a href="#temporal-vectorization">Temporal Vectorization</a></li>
      <li><a href="#spatial-vectorization">Spatial Vectorization</a></li>
      <li><a href="#id77">Conclusion</a></li>
    </ul>
  </div>
    

  <div className="column-two">

  <h2>Problem Vectorization</h2>
    <ul>
      <li><a href="#id78">Introduction</a></li>
      <li><a href="#path-finding">Path Finding</a></li>
      <li><a href="#fluid-dynamics">Fluid Dynamics</a></li>
      <li><a href="#blue-noise-sampling">Blue Noise Sampling</a></li>
      <li><a href="#id83">Conclusion</a></li>
    </ul>

    <h2>Custom Vectorization</h2>
    <ul>
      <li><a href="#id84">Introduction</a></li>
      <li><a href="#typed-list">Typed List</a></li>
      <li><a href="#memory-aware-array">Memory Aware Array</a></li>
      <li><a href="#id88">Conclusion</a></li>
    </ul>
  

    <h2>Beyond Numpy</h2>
    <ul>
      <li><a href="#back-to-python">Back to Python</a></li>
      <li><a href="#numpy-co">Numpy & co</a></li>
      <li><a href="#scipy-co">Scipy & co</a></li>
      <li><a href="#id93">Conclusion</a></li>
    </ul>
  </div>

  <div className="column-three">
   

    <h2>Quick References</h2>
    <ul>
      <li><a href="#id56">Data Type</a></li>
      <li><a href="#id57">Creation</a></li>
      <li><a href="#id58">Indexing</a></li>
      <li><a href="#reshaping">Reshaping</a></li>
      <li><a href="#broadcasting">Broadcasting</a></li>
    </ul>

    <h2>Bibliography</h2>
    <ul>
      <li><a href="#tutorials">Tutorials</a></li>
      <li><a href="#articles">Articles</a></li>
      <li><a href="#books">Books</a></li>
    </ul>
  </div>
</div>



<div className="contents-main-content-nicolas-p-rougie topic-nicolas-p-rougie" id="table-of-contents">
  <p className="topic-title-first-nicolas-p-rougie"><strong>Table of Contents</strong></p>
  <ul className="simple-nicolas-p-rougie">
    <li><a className="reference-internal-nicolas-p-rougie" href="#preface" id="id60">Preface</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#about-the-author" id="id61">About the author</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#about-this-book" id="id62">About this book</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#license" id="id63">License</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#introduction" id="id64">Introduction</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#simple-example" id="id65">Simple example</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#readability-vs-speed" id="id66">Readability vs speed</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#anatomy-of-an-array" id="id67">Anatomy of an array</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id3" id="id68">Introduction</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#memory-layout" id="id69">Memory layout</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#views-and-copies" id="id70">Views and copies</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#conclusion" id="id71">Conclusion</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#code-vectorization" id="id72">Code vectorization</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id5" id="id73">Introduction</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#uniform-vectorization" id="id74">Uniform vectorization</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#temporal-vectorization" id="id75">Temporal vectorization</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#spatial-vectorization" id="id76">Spatial vectorization</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id17" id="id77">Conclusion</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#problem-vectorization" id="id78">Problem vectorization</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id19" id="id79">Introduction</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#path-finding" id="id80">Path finding</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#fluid-dynamics" id="id81">Fluid Dynamics</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#blue-noise-sampling" id="id82">Blue noise sampling</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id27" id="id83">Conclusion</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#custom-vectorization" id="id84">Custom vectorization</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id29" id="id85">Introduction</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#typed-list" id="id86">Typed list</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#memory-aware-array" id="id87">Memory aware array</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id36" id="id88">Conclusion</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#beyond-numpy" id="id89">Beyond Numpy</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#back-to-python" id="id90">Back to Python</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#numpy-co" id="id91">Numpy &amp; co</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#scipy-co" id="id92">Scipy &amp; co</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id52" id="id93">Conclusion</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#id53" id="id94">Conclusion</a></li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#quick-references" id="id95">Quick References</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id56" id="id96">Data type</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id57" id="id97">Creation</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#id58" id="id98">Indexing</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#reshaping" id="id99">Reshaping</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#broadcasting" id="id100">Broadcasting</a></li>
      </ul>
    </li>
    <li><a className="reference-internal-nicolas-p-rougie" href="#bibliography" id="id101">Bibliography</a>
      <ul>
        <li><a className="reference-internal-nicolas-p-rougie" href="#tutorials" id="id102">Tutorials</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#articles" id="id103">Articles</a></li>
        <li><a className="reference-internal-nicolas-p-rougie" href="#books" id="id104">Books</a></li>
      </ul>
    </li>
  </ul>
</div>


<div id="HeinerKüttler">
    <ul className="posts">
    <p>I am Heinrich 'Heiner' Küttler.
    I am a member of the technical team at <a href="https://x.ai">xAI</a>.
    Previously, I was the LLM Infra Lead and a member of the founding team
    at <a href="https://inflection.ai">Inflection AI</a>.
    <a href="https://inflection.ai/inflection-1">We</a>
    <a href="https://inflection.ai/inflection-2">built</a>
    <a href="https://inflection.ai/inflection-2-5">LLMs</a>.
    Before this, was a Research Engineering Manager at <a href="https://ai.meta.com/research/">Meta AI
    Research</a> in London, leading
    Reinforcement Learning engineering across EMEA, and before that I was
    a Senior Research Engineer and Team Lead at
    <a href="https://deepmind.google/">DeepMind</a>, working on projects like DMLab,
    StarCraft, and AGI. I also once was a Technical Solutions Consultant
    at Google in London. I received my PhD in Mathematical Physics from
    <a href="https://www.lmu.de/">LMU Munich</a> in 2014.</p>
    <li>
      <span className="post-date">Feb 19, 2023</span>

        <a className="post-link" href="https://heiner.ai/blog/2023/02/19/chain-rule-jacobians-autograd-shapes.html">The chain rule, Jacobians, autograd, and shapes</a>
    </li>
  
    <li>
      <span className="post-date">Apr 14, 2021</span>

        <a className="post-link" href="https://heiner.ai/blog/2021/04/14/gompertz-annuities-and-special-functions.html">Gompertz, annuities, and special functions</a>
    </li>
  
    <li>
      <span className="post-date">Mar 23, 2021</span>

        <a className="post-link" href="https://heiner.ai/blog/2021/03/23/pis-deaths-and-statistics.html">πs, deaths, and statistics</a>
    </li>
  
    <li>
      <span className="post-date">Dec 29, 2020</span>

        <a className="post-link" href="https://heiner.ai/blog/2020/12/29/well-definedness-in-measure-theory.html">Well-definedness in measure theory</a>
    </li>
  
    <li>
      <span className="post-date">Sep 8, 2020</span>

        <a className="post-link" href="https://heiner.ai/blog/2020/09/08/more-linear-regression-capm.html">More on linear regression: Capital asset pricing models</a>
    </li>
  
    <li>
      <span className="post-date">Feb 19, 2020</span>

        <a className="post-link" href="https://heiner.ai/blog/2020/02/19/linear-regression.html">On linear regression</a>
    </li>
  
    <li>
      <span className="post-date">Aug 19, 2019</span>

        <a className="post-link" href="https://heiner.ai/blog/2019/08/19/annuity-loans.html">Annuity loans</a>
    </li>
  
    <li>
      <span className="post-date">Dec 25, 2016</span>

        <a className="post-link" href="https://heiner.ai/blog/2016/12/25/dylaniki.html">Dylanchords</a>
    </li>
  
    <li>
      <span className="post-date">Aug 21, 2016</span>

        <a className="post-link" href="https://heiner.ai/blog/2016/08/21/in-every-beginning-there-is-a-delusion.html">In every beginning there is a delusion</a>
    </li>
  
</ul>

<h1>πs, deaths, and statistics</h1>
<h3 id="pdfs-cdfs-and-hazard-functions">PDFs, CDFs, and Hazard Functions</h3>


<p>If you have taken a probability or statistics course, you probably
(ha!) know about <em>probability density functions</em> (pdfs). A pdf is a
positive function that we use as a density and to make it a
<em>probabilty</em> density it needs to integrate to one. If
</p> 
    <p>
    <Heiner_Math_ML_Component />
    </p>
</div>
  
{/* Reference: Tweet Embed: https://stackblitz.com/edit/react-ts-x5ckuu?file=index.tsx 
https://www.npmjs.com/package/react-twitter-embed
*/}
{/* <MyTwitterWidget name="vxnuaj" />
<MyTwitterEmbed name="vxnuaj"  /> */}



<div id="Felix-Altenberger">


<article className="Felix-Altenberger-post">
    
    <a className="post-thumbnail" 
    // style="background-image: url(/blog/images/icp-analysis.png)" 
    style={{ backgroundImage: 'url(https://fa9r.com/blog/images/icp-analysis.png)' }} 
    href="https://fa9r.com/blog/2021/03/30/icp-analysis.html"></a>
    
    <div className="post-content">
        <h2 className="post-title"><a href="https://fa9r.com/blog/2021/03/30/icp-analysis.html">An Analysis of ICP Variants</a></h2>
        <p>Over the years, various ICP modifications have been proposed. Now, which one should you use?...</p>
        <span className="post-date">2021, Mar 30&nbsp;&nbsp;&nbsp;—&nbsp;</span>
        <span className="post-words">6 minute read</span>
    </div>
</article>
<article className="Felix-Altenberger-post">
    
    <a className="post-thumbnail" 
    // style="background-image: url(/blog/images/gan.png)" 
    style={{ backgroundImage: 'url(https://fa9r.com/blog/images/gan.png' }} 
    href="/blog/2020/12/30/tips-for-gan-training.html"></a>
    
    <div className="post-content">
      <h2 className="post-title"><a href="/blog/2020/12/30/tips-for-gan-training.html">A Guide for Building GANs - 10 Tips and Tricks</a></h2>
      <p>After having focused on GANs exclusively for the last year and a half, I wanted...</p>
      <span className="post-date">2020, Dec 30&nbsp;&nbsp;&nbsp;—&nbsp;</span>
      <span className="post-words">7 minute read</span>
    </div>
  </article>

  <article className="Felix-Altenberger-post">
    
    <a className="post-thumbnail" 
     style={{ backgroundImage: 'url(https://fa9r.com/blog/images/difficp.png' }} 
    // style="background-image: url(/projects/images/difficp.png)" 
    href="https://fa9r.com/projects/2021/03/30/differentiable-icp.html"></a>
    <a className="post-thumbnail" 
   style={{ backgroundImage: 'url(https://fa9r.com/blog/images/difficp.png)', 
            width: '100%', height: '200px', 
            backgroundSize: 'cover', backgroundPosition: 'center' }} 
   href="https://fa9r.com/projects/2021/03/30/differentiable-icp.html">
</a>

    <div className="post-content">
      <h2 className="post-title"><a href="https://fa9r.com/projects/2021/03/30/differentiable-icp.html">3D Reconstruction with Differentiable ICP</a></h2>
      {/* <!--
      <p>The Iterative Closest Point (ICP) algorithm is a widely used registration method, which iteratively approximates...</p>
      --> */}
      <div className="page-tag">
        
        <a href="/tags#Python" className="tag"># Python</a>
        
        <a href="/tags#PyTorch" className="tag"># PyTorch</a>
        
        <a href="/tags#ML" className="tag"># ML</a>
        
        <a href="/tags#Graphics" className="tag"># Graphics</a>
        
        <a href="/tags#3D Reconstruction" className="tag"># 3D Reconstruction</a>
        
        <a href="/tags#ICP" className="tag"># ICP</a>
        
        <a href="/tags#WithCode" className="tag"># WithCode</a>
        
      </div>
      <br></br>
      <span className="post-date">2021, Mar 30&nbsp;&nbsp;&nbsp;—&nbsp;</span>
      <span className="post-words">9 minute read</span>
    </div>

    <ul>
      <li><strong>Duration:</strong> July 2020 to March 2021 (9 months)</li>
      <li><strong>Team:</strong> Me and supervising prof.</li>
      <li><strong>My Responsibilities:</strong> Research, design and implementation of differentiable
    ICP in Pytorch, ML model training and evaluation</li>
      <li><strong>Source Code:</strong> <a href="https://github.com/fa9r/DiffICP">https://github.com/fa9r/DiffICP</a></li>
    </ul>

    <h3 id="differentiable-icp">Differentiable ICP</h3>

    <p className="Felix-Altenberger">The ICP algorithm consists of the following five steps: source point selection,
    correspondence search, correspondence weighting, correspondence rejection,
    and the minimization of an error metric.
    Source point selection and correspondence weighting are by default 
    differentiable, so it is the remaining three steps that we need to explore
    in more detail.</p>

    <h4 id="differentiable-correspondence-finding">Differentiable Correspondence Finding</h4>
    <p className="Felix-Altenberger">Standard ICP correspondences are found by searching the nearest neighbor of each
    source point within the target point cloud, which can be formulated as follows:</p>



    <p>
      <img src="https://fa9r.com/projects/images/difficp_corrs.png" style={{width: '20%'}}></img>
    </p>
    <p className="Felix-Altenberger">The problem here is that the <em>argmin</em> operation is not properly differentiable,
        since its derivative is everywhere either 0 or undefined.
        There exist a variety of approximate methods, but they are similarly based on
        concrete selections and are, therefore, not differentiable either.</p>


        <p className="Felix-Altenberger">Fortunately, a soft relaxation can be formulated by
expressing correspondence points as linear combinations of all target points
with weights calculated as the softmax over negative distances:</p>


      <p >
        <img src="https://fa9r.com/projects/images/difficp_diffcorrs.png" style={{width: '50%'}}></img>
      </p>

  </article>



  {/* <div>
    <p>
    Software developer and Open Source nut. Creator of the Flask framework. Engineering at <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/getsentry/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/getsentry">@getsentry</a>. Other things of interest: <a class="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/pallets/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/pallets">@pallets</a> and <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/rust-lang/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/rust-lang">@rust-lang</a>

    </p>
  </div>
  <div className="m-0 mt-1 wb-break-all feed-sponsored-user-description Armin-Ronacher">
  <p>Creator of the Flask framework, Jinja template engine, Lektor CMS, Insta snapshot testing tool and more. These days I dedicate most of my work to @getsentry, but I maintain a range of Rust libraries and always create more Open Source work.</p>
  </div> */}


  <div>






<div id="ArminRonacher">


          <h1 className="vcard-names ">

          <span className="p-name vcard-fullname d-block overflow-hidden" 
          // itemprop="name"
          >
            Armin Ronacher
          </span>
          <span className="p-nickname vcard-username d-block" 
          //itemprop="additionalName"
          >
            mitsuhiko

          </span>
          </h1>


          <p>
          Software developer and Open Source nut. Creator of the Flask framework. Engineering at 
          <a 
          className="user-mention notranslate" 
          data-hovercard-type="organization" 
          data-hovercard-url="/orgs/getsentry/hovercard" 
          data-octo-click="hovercard-link-click" 
          data-octo-dimensions="link_type:self" 
          href="https://github.com/getsentry"
          >
          @getsentry
          </a>. 
          Other things of interest: 
          <a 
          className="user-mention notranslate" 
          data-hovercard-type="organization" 
          data-hovercard-url="/orgs/pallets/hovercard" 
          data-octo-click="hovercard-link-click" 
          data-octo-dimensions="link_type:self" 
          href="https://github.com/pallets"
          >
          @pallets
          </a> 
          and 
          <a 
          className="user-mention notranslate" 
          data-hovercard-type="organization" 
          data-hovercard-url="/orgs/rust-lang/hovercard" 
          data-octo-click="hovercard-link-click" 
          data-octo-dimensions="link_type:self" 
          href="https://github.com/rust-lang"
          >
          @rust-lang
          </a>
          </p>
          </div>



          <div className="entry-overview Armin-Ronacher">
            <div className="date">Mar 31, 2018</div>
            <div className="detail">
              <h1><a href="https://lucumr.pocoo.org/2018/3/31/you-cant-rust-that">You can't Rust that</a></h1>
              
              <div className="summary">
                <p>Some tips for how to be more productive in Rust by avoiding situations you cannot solve in Rust.</p>
              </div>
            </div>
          </div>


          <div className="entry-overview">
            <div className="date">Oct 30, 2016</div>
                <div className="detail">
                  <h1><a href="https://lucumr.pocoo.org/2016/10/30/i-dont-understand-asyncio">I don't understand Python's Asyncio</a></h1>
                  
                  <div className="summary"><p>A little confession that I have no idea how asyncio works in Python 3.</p>
                </div>
              
            </div>
          </div>

          <h2>The Primitives</h2>
                  <p><cite>asyncio</cite> is supposed to implement asynchronous IO with the help of
          coroutines.  Originally implemented as a library around the <cite>yield</cite> and
          <cite>yield from</cite> expressions it's now a much more complex beast as the
          language evolved at the same time.  So here is the current set of things
          that you need to know exist:</p>

          <ul className="ui-simple-Armin-Ronacher">
                  <li>event loops</li>
                  <li>event loop policies</li>
                  <li>awaitables</li>
                  <li>coroutine functions</li>
                  <li>old style coroutine functions</li>
                  <li>coroutines</li>
                  <li>coroutine wrappers</li>
                  <li>generators</li>
                  <li>futures</li>
                  <li>concurrent futures</li>
                  <li>tasks</li>
                  <li>handles</li>
                  <li>executors</li>
                  <li>transports</li>
                  <li>protocols</li>
                  </ul>
                  <p>In addition the language gained a few special methods that are new:</p>

                  {/* <ul className="simple">
                        <li><tt class="docutils literal">__aenter__</tt> and <tt class="docutils literal">__aexit__</tt> for asynchronous <cite>with</cite> blocks</li>
                        <li><tt class="docutils literal">__aiter__</tt> and <tt class="docutils literal">__anext__</tt> for asynchronous iterators (async loops
                        and async comprehensions).  For extra fun that protocol already changed
                        once.  In 3.5 it returns an awaitable (a coroutine) in Python 3.6 it
                        will return a newfangled async generator.</li>
                        <li><tt class="docutils literal">__await__</tt> for custom awaitables</li>
                        </ul> */}


                    <div className="entry-overview">
                                <div className="date">Nov 18, 2015</div>
                                <div className="detail">
                                  <h1 className="Felix-Altenberger"><a href="https://lucumr.pocoo.org/2015/11/18/pythons-hidden-re-gems">Python's Hidden Regular Expression Gems</a></h1>
                                  
                                  <div className="summary"><p className="Felix-Altenberger">Some hidden features of the Python re module and the support machinery
                                  that drives it.</p>
                                  </div>
                                  
                                </div>
                              </div>
                              <p className="Felix-Altenberger">There are many terrible modules in the Python standard library, but the
                                Python <cite>re</cite> module is not one of them.  While it's old and has not been
                                updated in many years, it's one of the best of all dynamic languages I
                                would argue.</p>

                                <h2>Fixing up Groups</h2>
                                <p>One annoying thing is that our group indexes are not local to our own
                              regular expression but to the combined one.  This means if you have a
                              rule like 
                              {/* <tt class="docutils literal">(a|b)</tt>  */}
                              and you want to access that group by index, it will
                              be wrong.  This would require a bit of extra engineering with a class that
                              wraps the SRE match object with a custom one that adjusts the indexes and
                              group names.  If you are curious about that I made a more complex version
                              of the above solution that implements a proper match wrapper <a className="reference external" href="https://github.com/mitsuhiko/python-regex-scanner">in a github
                              repository</a> together
                              with some samples of what you can do with it.</p>

          </div>
      

</div>
<div id="PeterGoldsborough">
<h1>
  <a href="https://www.goldsborough.me/ml/ai/python/2018/02/04/20-17-20-a_promenade_of_pytorch/" className="site-title">Peter Goldsborough</a>

  </h1>


    <h1>A Promenade of PyTorch</h1>
    <p>For the past two years, I’ve been quite heavily invested in
    <a href="http://tensorflow.org">TensorFlow</a>, either <a href="https://arxiv.org/pdf/1610.01178.pdf">writing papers about it</a>, giving
    <a href="https://www.youtube.com/watch?v=Lo1rXJdAJ7w">talks on how to extend its backend</a> or <a href="https://www.biorxiv.org/content/early/2017/12/02/227645">using it for my own deep learning
    research</a>. As part of this journey, I’ve gotten quite a good sense of both
    TensorFlow’s strong points as well as weaknesses – or simply architectural
    decisions – that leave room for competition. That said, I have recently joined
    the PyTorch team at <a href="https://research.fb.com/category/facebook-ai-research-fair/">Facebook AI Research</a> (FAIR), arguably TensorFlow’s biggest
    competitor to date, and currently much favored in the research community for
    reasons that will become apparent in subsequent paragraphs.</p>

    <a href="https://disqus.com/by/disqus_vSdwzFeUPA/" data-action="profile" data-tab="" data-username="disqus_vSdwzFeUPA" target="_blank" rel="noopener noreferrer">No Name</a>
    <p className="Felix-Altenberger">FYI: this idea of constructing a computation graph at runtime was done by Acar at CMU for self adjusting computations. You might be able to steal some ideas from them.</p>



    <footer className="comment__footer">
  <menu className="comment-footer__menu">
    {/* <!-- Voting Section --> */}
    <li className="voting" data-role="voting">
      <div className="post-votes">
        <a href="#" className="vote-up count-10" data-action="upvote" title="Vote up" 
        // name="Vote up"
        >Upvote
          <span className="control"></span>
          <span className="updatable count" data-role="likes"> 10</span>
        </a>
        <a href="#" className="vote-down count-0" data-action="downvote" title="Vote down" 
         // name="Vote down"
        > Downvote
          <span className="control"></span>
          <span className="updatable count" data-role="dislikes"> 0</span>
        </a>
      </div>
    </li>

    {/* <!-- Reply Section -->
    <li class="reply" data-role="reply-link">
      <a class="comment-footer__action" href="#" data-action="reply">
        <span class="text">Reply</span>
      </a>
    </li> */}

    {/* <!-- Share Section --> */}
    {/* <li id="comment__share-3771658268" class="comment__share">
      <a class="toggle" href="#" data-action="expand-share">
        <i class="icon icon-share"></i>
        <span class="text">Share ›</span>
      </a>
      <ul class="comment-share__buttons">
        <div class="comment-share__social-share-buttons">
          { <!-- Twitter Share Button --> }
          <li class="twitter share__button-container">
            <button class="share__button icon icon-twitter-x" data-action="share:twitter" aria-label="Share comment on X (Twitter)"></button>
          </li>
          { <!-- Facebook Share Button --> }
          <li class="facebook share__button-container">
            <button class="share__button icon icon-facebook" data-action="share:facebook" aria-label="Share comment on Facebook"></button>
          </li>
        </div>
        { <!-- Link Share Button --> }
        <li class="link share__button-container">
          <button class="share__button icon icon-link" value="http://disq.us/p/1qdjq58" name="Link" title="Click to copy post link" data-action="copy-link" aria-label="Copy link to comment"></button>
          <input class="share__button link_url" name="Link" title="Click to copy post link" data-action="copy-link" readonly>
        </li>
      </ul>
    </li> */}

    {/* <!-- Real-time Notification Section --> */}
    {/* <li class="realtime" data-role="realtime-notification:3771658268">
      <span class="realtime-replies realtime-replies--refresh icon icon-pencil" style="display: none;"></span>
      <a href="#" class="realtime-button realtime-button--refresh" style="display: none;"></a>
    </li> */}
  </menu>
</footer>
<a href="https://www.goldsborough.me/go/2020/12/06/12-24-24-non-blocking_parallelism_for_services_in_go/" className="post-link">
          <h3 className="h1 post-title">Non-Blocking Parallelism for Services in Go</h3>
        </a>
<h3 className="h1 post-title">Non-Blocking Parallelism for Services in Go</h3>
</div>
 
<div id="AayushAgrawal">
<a href="#AayushAgrawal" style={{ textDecoration: 'underline' }}>
            <h1 className="vcard-names1 ">

                <span className="p-name vcard-fullname d-block overflow-hidden" 
                // itemprop="name"
                >
                  Aayush Agrawal
                </span>
                <span className="p-nickname vcard-username d-block" 
                //itemprop="additionalName"
                >
                 

                </span>
                </h1>
            </a>

<p className="Felix-Altenberger">I’m an experienced Data Scientist with specialized skills in machine learning-based solutions. I enjoy staying on top of cutting-edge data technologies, including big data platforms, deep learning, optimization methods, and business analytics. My current work involves building data-driven products to enable smarter recommendations for Microsoft Partners, M365 service administrators and end-users to ensure the best usage of M365 services. Before that, I have experience working in various verticals like agricultural technology, pharmaceuticals, retail, e-commerce, and ride-sharing business model.</p>
  <a href="https://aayushmnit.com/posts/2022-10-26-Model_Calibration/Model%20Calibration.html" className="quarto-grid-link">
    <div className="card-body post-contents">
          <h5 className="no-anchor card-title listing-title">
          Model calibration for classification tasks using Python
          </h5>
          <div className="listing-reading-time card-text text-muted">
          6 min
          </div>
          <div className="listing-categories">
          <div className="listing-category" 
          // onclick="window.quartoListingCategory('Model Calibration'); return false;"
          >
          Model Calibration
          </div>
          <div className="listing-category" 
          // onclick="window.quartoListingCategory('Machine Learning'); return false;"
          >
          Machine Learning
          </div>
          </div>
          <div className="card-text listing-description">
          A hands-on introduction to model calibration using Python.
          </div>
          <div className="card-attribution card-text-small end">
          <div className="listing-date">
          Oct 12, 2022
          </div>
          </div>
          </div>
    </a>

        


    <a href="https://aayushmnit.com/posts/2024-08-24-MLInterviewPrep/MLInterviewPrep.html" className="quarto-grid-link">
    <div className="card-body post-contents">
            <h5 className="no-anchor card-title listing-title">
            ML Interview Prepration Guide (Draft)
            </h5>
            <div className="listing-reading-time card-text text-muted">
            11 min
            </div>
            <div className="listing-categories">
            <div className="listing-category" 
            // onclick="window.quartoListingCategory('ML Interview Guide'); return false;"
            >
            ML Interview Guide
            </div>
            </div>
            <div className="card-text listing-description">
            A collection of resources while preparing for MLE interviews at Meta or other big tech companies.
            </div>
            <div className="card-attribution card-text-small end">
            <div className="listing-date">
            Aug 24, 2024
            </div>
            </div>
            </div>

    </a>


</div>


<div id="ezyang">
<h1>
  <a href="http://blog.ezyang.com/about/" className="site-title">ezyang &#39;s blog</a>

  </h1>

<p>Edward Z. Yang is a research engineer at Facebook who works on PyTorch, an open source deep learning library.  In a previous life, he worked on Backpack, a new module system for Haskell.</p>

<p>You can find more outdated information about me at <a href="http://ezyang.com">http://ezyang.com</a>.</p>
<ul>
              <li>
          <a href="http://blog.ezyang.com/2024/10/tensor-programming-for-databases-with-first-class-dimensions/" rel="bookmark">Tensor programming for databases, with first class dimensions</a>
          <abbr className="published small" title="2024-10-14T01:07:14-0500">(October 14, 2024)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2024/10/whats-different-this-time-llm-edition/" rel="bookmark">What’s different this time? LLM edition</a>
          <abbr className="published small" title="2024-10-04T00:30:09-0500">(October 4, 2024)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2021/11/interactive-scraping-with-jupyter-and-puppeteer/" rel="bookmark">Interactive scraping with Jupyter and Puppeteer</a>
          <abbr className="published small" title="2021-11-23T09:28:07-0500">(November 23, 2021)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2021/05/pytorch-developer-podcast/" rel="bookmark">PyTorch Developer Podcast</a>
          <abbr className="published small" title="2021-05-05T11:26:42-0500">(May 5, 2021)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2021/04/rage-bug-reporting/" rel="bookmark">Rage bug reporting</a>
          <abbr className="published small" title="2021-04-25T00:03:41-0500">(April 25, 2021)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2021/01/pytorch-open-source-process/" rel="bookmark">The PyTorch open source process</a>
          <abbr className="published small" title="2021-01-06T11:56:33-0500">(January 6, 2021)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/10/the-hidden-problem-with-basic-block-procedures-in-ssa/" rel="bookmark">The hidden problem(?) with basic block procedures in SSA</a>
          <abbr className="published small" title="2020-10-24T19:34:21-0500">(October 24, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/10/idiomatic-algebraic-data-types-in-python-with-dataclasses-and-union/" rel="bookmark">Idiomatic algebraic data types in Python with dataclasses and Union</a>
          <abbr className="published small" title="2020-10-14T14:08:54-0500">(October 14, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/09/lets-talk-about-the-pytorch-dispatcher/" rel="bookmark">Let’s talk about the PyTorch dispatcher</a>
          <abbr className="published small" title="2020-09-10T14:29:05-0500">(September 10, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/08/dynamic-scoping-is-an-effect-implicit-parameters-are-a-coeffect/" rel="bookmark">Dynamic scoping is an effect, implicit parameters are a coeffect</a>
          <abbr className="published small" title="2020-08-27T01:51:36-0500">(August 27, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/05/a-brief-taxonomy-of-pytorch-operators-by-shape-behavior/" rel="bookmark">A brief taxonomy of PyTorch operators by shape behavior</a>
          <abbr className="published small" title="2020-05-06T11:56:43-0500">(May 6, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2020/01/vmap-in-haskell/" rel="bookmark">vmap in Haskell</a>
          <abbr className="published small" title="2020-01-29T14:14:34-0500">(January 29, 2020)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2019/05/pytorch-internals/" rel="bookmark">PyTorch internals</a>
          <abbr className="published small" title="2019-05-16T22:11:22-0500">(May 16, 2019)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2019/05/a-short-note-about-functional-linear-maps/" rel="bookmark">A short note about functional linear maps</a>
          <abbr className="published small" title="2019-05-15T17:42:10-0500">(May 15, 2019)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2019/03/microsoft-surface-book-2/" rel="bookmark">Microsoft Surface Book 2</a>
          <abbr className="published small" title="2019-03-17T21:59:52-0500">(March 17, 2019)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2018/09/hiw18-lets-go-mainstream-with-eta/" rel="bookmark">HIW’18: Let’s Go Mainstream with Eta!</a>
          <abbr className="published small" title="2018-09-23T11:02:53-0500">(September 23, 2018)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2018/07/a-year-into-backpack/" rel="bookmark">A year into Backpack</a>
          <abbr className="published small" title="2018-07-14T19:34:16-0500">(July 14, 2018)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2018/04/a-compile-time-debugger-that-helps-you-write-tensor-shape-checks/" rel="bookmark">A compile-time debugger that helps you write tensor shape checks</a>
          <abbr className="published small" title="2018-04-06T23:49:53-0500">(April 6, 2018)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2018/03/online-offline-continuous-integration/" rel="bookmark">Online/offline continuous integration</a>
          <abbr className="published small" title="2018-03-12T22:52:29-0500">(March 12, 2018)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2018/02/semantic-import-versioning-in-the-wild/" rel="bookmark">Semantic Import Versioning in the wild</a>
          <abbr className="published small" title="2018-02-23T00:06:00-0500">(February 23, 2018)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/12/systems-ml-workshop-panel/" rel="bookmark">Systems ML workshop panel</a>
          <abbr className="published small" title="2017-12-08T21:17:08-0500">(December 8, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/12/accelerating-persistent-neural-networks-at-datacenter-scale-daniel-lo/" rel="bookmark">Accelerating Persistent Neural Networks at Datacenter Scale (Daniel Lo)</a>
          <abbr className="published small" title="2017-12-08T15:08:44-0500">(December 8, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/12/mocha-federated-multi-tasks-learning-virginia-smith/" rel="bookmark">MOCHA: Federated Multi-Tasks Learning (Virginia Smith)</a>
          <abbr className="published small" title="2017-12-08T13:15:32-0500">(December 8, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/12/a-machine-learning-approach-to-database-indexes-alex-beutel/" rel="bookmark">A Machine Learning Approach to Database Indexes (Alex Beutel)</a>
          <abbr className="published small" title="2017-12-08T13:11:02-0500">(December 8, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/12/ray-a-distributed-execution-framework-for-emerging-ai-applications-ion-stoica/" rel="bookmark">Ray: A Distributed Execution Framework for Emerging AI Applications (Ion Stoica)</a>
          <abbr className="published small" title="2017-12-08T13:07:16-0500">(December 8, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/08/backpack-for-deep-learning/" rel="bookmark">Backpack for deep learning</a>
          <abbr className="published small" title="2017-08-17T22:05:03-0500">(August 17, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/03/proposal-suggest-explicit-type-application-for-foldable-length/" rel="bookmark">Proposal: Suggest explicit type application for Foldable length and friends</a>
          <abbr className="published small" title="2017-03-21T19:50:13-0500">(March 21, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/03/prio-private-robust-and-scalable-computation-of-aggregate-statistics/" rel="bookmark">Prio: Private, Robust, and Scalable Computation of Aggregate Statistics</a>
          <abbr className="published small" title="2017-03-17T19:35:48-0500">(March 17, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/03/designing-the-backpack-signature-ecosystem/" rel="bookmark">Designing the Backpack signature ecosystem</a>
          <abbr className="published small" title="2017-03-11T06:40:42-0500">(March 11, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2017/02/how-to-integrate-ghc-api-programs-with-cabal/" rel="bookmark">How to integrate GHC API programs with Cabal</a>
          <abbr className="published small" title="2017-02-08T19:45:00-0500">(February 8, 2017)</abbr>
        </li>
              {/* <li>
          <a href="http://blog.ezyang.com/2017/01/try-backpack-cabal-packages/" rel="bookmark">Try Backpack: Cabal packages</a>
          <abbr class="published small" title="2017-01-17T23:17:21-0500">(January 17, 2017)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/12/a-tale-of-backwards-compatibility-in-asts/" rel="bookmark">A tale of backwards compatibility in ASTs</a>
          <abbr class="published small" title="2016-12-31T23:35:33-0500">(December 31, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/12/backpack-and-the-pvp/" rel="bookmark">Backpack and the PVP</a>
          <abbr class="published small" title="2016-12-30T01:32:31-0500">(December 30, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/12/left-recursive-parsing-of-haskell-imports-and-declarations/" rel="bookmark">Left-recursive parsing of Haskell imports and declarations</a>
          <abbr class="published small" title="2016-12-21T20:24:11-0500">(December 21, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/12/the-problem-of-reusable-and-composable-specifications/" rel="bookmark">The problem of reusable and composable specifications</a>
          <abbr class="published small" title="2016-12-17T05:54:31-0500">(December 17, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/12/thoughts-about-spec-ulation-rich-hickey/" rel="bookmark">Thoughts about Spec-ulation (Rich Hickey)</a>
          <abbr class="published small" title="2016-12-16T19:26:00-0500">(December 16, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/10/try-backpack-ghc-backpack/" rel="bookmark">Try Backpack: <code>ghc --backpack</code></a>
          <abbr class="published small" title="2016-10-10T04:39:14-0500">(October 10, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/09/seize-the-means-of-production-of-apis/" rel="bookmark">Seize the Means of Production (of APIs)</a>
          <abbr class="published small" title="2016-09-13T01:09:52-0500">(September 13, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/09/the-base-of-a-string-theory-for-haskell/" rel="bookmark">The Base of a String Theory for Haskell</a>
          <abbr class="published small" title="2016-09-07T02:22:53-0500">(September 7, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/09/the-edit-recompile-manager/" rel="bookmark">The Edit-Recompile Manager</a>
          <abbr class="published small" title="2016-09-02T20:40:43-0500">(September 2, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/09/backpack-and-separate-compilation/" rel="bookmark">Backpack and separate compilation</a>
          <abbr class="published small" title="2016-09-01T02:26:40-0500">(September 1, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/08/cabal-new-build-is-a-package-manager/" rel="bookmark">cabal new-build is a package manager</a>
          <abbr class="published small" title="2016-08-29T17:32:36-0500">(August 29, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/08/optimizing-incremental-compilation/" rel="bookmark">Optimizing incremental compilation</a>
          <abbr class="published small" title="2016-08-27T06:03:03-0500">(August 27, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/07/what-template-haskell-gets-wrong-and-racket-gets-right/" rel="bookmark">What Template Haskell gets wrong and Racket gets right</a>
          <abbr class="published small" title="2016-07-18T11:19:37-0500">(July 18, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/05/debugging-tcifaceglobal-errors-in-ghc-a-study-in-interpreting-trace-output/" rel="bookmark">Debugging tcIfaceGlobal errors in GHC: a study in interpreting trace output</a>
          <abbr class="published small" title="2016-05-15T18:02:52-0500">(May 15, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/05/announcing-cabal-new-build-nix-style-local-builds/" rel="bookmark">Announcing cabal new-build: Nix-style local builds</a>
          <abbr class="published small" title="2016-05-02T12:45:01-0500">(May 2, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/04/hindley-milner-with-top-level-existentials/" rel="bookmark">Hindley-Milner with top-level existentials</a>
          <abbr class="published small" title="2016-04-24T04:05:09-0500">(April 24, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2016/01/ghc-shake-reimplementing-ghc-make/" rel="bookmark">ghc-shake: Reimplementing ghc -&ZeroWidthSpace;-make</a>
          <abbr class="published small" title="2016-01-07T12:59:32-0500">(January 7, 2016)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/12/the-convergence-of-compilers-build-systems-and-package-managers/" rel="bookmark">The convergence of compilers, build systems and package managers</a>
          <abbr class="published small" title="2015-12-07T01:50:28-0500">(December 7, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/11/what-is-stateless-user-interface/" rel="bookmark">What is Stateless User Interface?</a>
          <abbr class="published small" title="2015-11-27T01:53:49-0500">(November 27, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/09/is-no-reinstall-cabal-coming-to-ghc-8/" rel="bookmark">Is no-reinstall Cabal coming to GHC 8.0?</a>
          <abbr class="published small" title="2015-09-18T23:15:47-0500">(September 18, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/08/help-us-beta-test-no-reinstall-cabal/" rel="bookmark">Help us beta test “no-reinstall Cabal”</a>
          <abbr class="published small" title="2015-08-29T00:31:15-0500">(August 29, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/05/ubuntu-vivid-upgrade-xmonad/" rel="bookmark">Ubuntu Vivid upgrade (Xmonad)</a>
          <abbr class="published small" title="2015-05-29T14:09:30-0500">(May 29, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/05/width-adaptive-xmonad-layout/" rel="bookmark">Width-adaptive XMonad layout</a>
          <abbr class="published small" title="2015-05-02T00:36:55-0500">(May 2, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2015/01/an-eq-instance-for-non-de-bruijn-terms/" rel="bookmark">An Eq instance for non de Bruijn terms</a>
          <abbr class="published small" title="2015-01-30T21:14:10-0500">(January 30, 2015)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/12/unintended-consequences-bound-threads-and-unsafe-ffi-calls/" rel="bookmark">Unintended consequences: Bound threads and unsafe FFI calls</a>
          <abbr class="published small" title="2014-12-08T19:09:33-0500">(December 8, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/12/ubuntu-utopic-upgrade-xmonad/" rel="bookmark">Ubuntu Utopic upgrade (Xmonad)</a>
          <abbr class="published small" title="2014-12-04T18:48:19-0500">(December 4, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/11/tomatoes-are-a-subtype-of-vegetables/" rel="bookmark">Tomatoes are a subtype of vegetables</a>
          <abbr class="published small" title="2014-11-14T21:00:36-0500">(November 14, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/09/haskell-implementors-workshop-14/" rel="bookmark">Haskell Implementor’s Workshop ’14</a>
          <abbr class="published small" title="2014-09-07T09:05:02-0500">(September 7, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/09/open-type-families-are-not-modular/" rel="bookmark">Open type families are not modular</a>
          <abbr class="published small" title="2014-09-04T18:12:23-0500">(September 4, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/08/a-taste-of-cabalized-backpack/" rel="bookmark">A taste of Cabalized Backpack</a>
          <abbr class="published small" title="2014-08-26T18:01:48-0500">(August 26, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/08/the-fundamental-problem-of-programming-language-package-management/" rel="bookmark">The fundamental problem of programming language package management</a>
          <abbr class="published small" title="2014-08-21T09:02:53-0500">(August 21, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/08/whats-a-module-system-good-for-anyway/" rel="bookmark">What’s a module system good for anyway?</a>
          <abbr class="published small" title="2014-08-09T19:21:19-0500">(August 9, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/07/new-theme/" rel="bookmark">New theme!</a>
          <abbr class="published small" title="2014-07-26T09:58:27-0500">(July 26, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/07/type-classes-confluence-coherence-global-uniqueness/" rel="bookmark">Type classes: confluence, coherence and global uniqueness</a>
          <abbr class="published small" title="2014-07-11T12:07:53-0500">(July 11, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/05/parsec-try-a-or-b-considered-harmful/" rel="bookmark">Parsec: “try a &lt;|&gt; b” considered harmful</a>
          <abbr class="published small" title="2014-05-17T21:46:52-0500">(May 17, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/05/ghc-and-mutable-arrays-a-dirty-little-secret/" rel="bookmark">GHC and mutable arrays: a DIRTY little secret</a>
          <abbr class="published small" title="2014-05-09T02:34:46-0500">(May 9, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/05/elimination-with-a-motive-in-coq/" rel="bookmark">Elimination with a Motive (in Coq)</a>
          <abbr class="published small" title="2014-05-07T23:13:15-0500">(May 7, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/05/the-cost-of-weak-pointers-and-finalizers-in-ghc/" rel="bookmark">The cost of weak pointers and finalizers in GHC</a>
          <abbr class="published small" title="2014-05-04T04:55:36-0500">(May 4, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/04/calculating-shanten-in-mahjong/" rel="bookmark">Calculating Shanten in Mahjong</a>
          <abbr class="published small" title="2014-04-01T04:20:46-0500">(April 1, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/03/haskell-for-coq-programmers/" rel="bookmark">Haskell for Coq programmers</a>
          <abbr class="published small" title="2014-03-17T02:06:47-0500">(March 17, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/equality-roughly-speaking/" rel="bookmark">Equality, roughly speaking</a>
          <abbr class="published small" title="2014-01-30T00:05:03-0500">(January 30, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/how-to-maintain-a-pristine-copy-of-your-configuration-files/" rel="bookmark">How to maintain a pristine copy of your configuration files</a>
          <abbr class="published small" title="2014-01-20T19:02:31-0500">(January 20, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/pepm14-the-hermit-in-the-stream/" rel="bookmark">PEPM’14: The HERMIT in the Stream</a>
          <abbr class="published small" title="2014-01-17T02:36:41-0500">(January 17, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/ott-iff-plt-redex/" rel="bookmark">Ott ⇔ PLT Redex</a>
          <abbr class="published small" title="2014-01-13T19:11:39-0500">(January 13, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/when-a-lock-is-better-than-an-mvar/" rel="bookmark">When a lock is better than an MVar</a>
          <abbr class="published small" title="2014-01-07T18:47:26-0500">(January 7, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2014/01/so-you-want-to-add-a-new-concurrency-primitive-to-ghc/" rel="bookmark">So you want to add a new concurrency primitive to GHC…</a>
          <abbr class="published small" title="2014-01-01T10:37:00-0500">(January 1, 2014)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/12/two-bugs-in-the-borrow-checker-every-rust-developer-should-know-about/" rel="bookmark">Two bugs in the borrow checker every Rust developer should know about</a>
          <abbr class="published small" title="2013-12-17T07:57:31-0500">(December 17, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/10/visualizing-a-block-allocator/" rel="bookmark">Visualizing a block allocator</a>
          <abbr class="published small" title="2013-10-30T21:48:02-0500">(October 30, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/10/xmonad-and-media-keys-on-saucy/" rel="bookmark">Xmonad and media keys on Saucy</a>
          <abbr class="published small" title="2013-10-27T16:30:39-0500">(October 27, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/09/if-youre-using-lift-youre-doing-it-wrong-probably/" rel="bookmark">If you’re using lift, you’re doing it wrong (probably)</a>
          <abbr class="published small" title="2013-09-26T15:03:42-0500">(September 26, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/09/of-monadic-fixpoints-and-heap-offsets/" rel="bookmark">Of Monadic Fixpoints and Heap Offsets</a>
          <abbr class="published small" title="2013-09-24T22:20:57-0500">(September 24, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/09/induction-and-logical-relations/" rel="bookmark">Induction and logical relations</a>
          <abbr class="published small" title="2013-09-18T19:35:37-0500">(September 18, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/09/cost-semantics-for-stg-in-modern-ghc/" rel="bookmark">Cost semantics for STG in modern GHC</a>
          <abbr class="published small" title="2013-09-07T16:54:51-0500">(September 7, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/08/blame-trees/" rel="bookmark">Blame Trees</a>
          <abbr class="published small" title="2013-08-12T14:55:28-0500">(August 12, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/07/oplss-lecture-notes/" rel="bookmark">OPLSS lecture notes</a>
          <abbr class="published small" title="2013-07-29T00:02:10-0500">(July 29, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/07/no-grammar-no-problem/" rel="bookmark">No grammar? No problem!</a>
          <abbr class="published small" title="2013-07-02T22:17:02-0500">(July 2, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/07/hott-exercises-in-coq-in-progress/" rel="bookmark">HoTT exercises in Coq (in progress)</a>
          <abbr class="published small" title="2013-07-01T16:21:18-0500">(July 1, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/06/homotopy-type-theory-chapter-one/" rel="bookmark">(Homotopy) Type Theory: Chapter One</a>
          <abbr class="published small" title="2013-06-24T18:56:27-0500">(June 24, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/05/the-ast-typing-problem/" rel="bookmark">The AST Typing Problem</a>
          <abbr class="published small" title="2013-05-28T07:25:03-0500">(May 28, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/05/anatomy-of-an-mvar-operation/" rel="bookmark">Anatomy of an MVar operation</a>
          <abbr class="published small" title="2013-05-19T20:00:37-0500">(May 19, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/05/hotos-unconference-reportverifying-systems/" rel="bookmark">HotOS “Unconference” report:<br>Verifying Systems</a>
          <abbr class="published small" title="2013-05-14T00:58:40-0500">(May 14, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/05/category-theory-for-loop-optimizations/" rel="bookmark">Category theory for loop optimizations</a>
          <abbr class="published small" title="2013-05-12T00:25:40-0500">(May 12, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/the-difference-between-recursion-induction/" rel="bookmark">The Difference between Recursion &amp; Induction</a>
          <abbr class="published small" title="2013-04-27T03:30:17-0500">(April 27, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/kindle-is-not-good-for-textbooks/" rel="bookmark">Kindle is not good for textbooks</a>
          <abbr class="published small" title="2013-04-15T19:52:20-0500">(April 15, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/a-zerocoin-puzzle/" rel="bookmark">A Zerocoin puzzle</a>
          <abbr class="published small" title="2013-04-11T18:54:02-0500">(April 11, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/a-classical-logic-fairy-tale/" rel="bookmark">A classical logic fairy tale</a>
          <abbr class="published small" title="2013-04-07T17:52:08-0500">(April 7, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/ndseg/" rel="bookmark">NDSEG</a>
          <abbr class="published small" title="2013-04-05T22:40:31-0500">(April 5, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/04/resource-limits-for-haskell/" rel="bookmark">Resource limits for Haskell</a>
          <abbr class="published small" title="2013-04-02T16:36:40-0500">(April 2, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/03/the-single-export-pattern/" rel="bookmark">The single export pattern</a>
          <abbr class="published small" title="2013-03-31T20:39:41-0500">(March 31, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/03/duality-of-weak-maps-and-private-symbols/" rel="bookmark">The duality of weak maps and private symbols</a>
          <abbr class="published small" title="2013-03-19T00:12:16-0500">(March 19, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/03/what-is-a-membran/" rel="bookmark">What is a membrane?</a>
          <abbr class="published small" title="2013-03-15T03:49:08-0500">(March 15, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/01/kindle-paperwhite-notes/" rel="bookmark">Kindle Paperwhite notes</a>
          <abbr class="published small" title="2013-01-30T09:00:17-0500">(January 30, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/01/the-ghc-scheduler/" rel="bookmark">The GHC scheduler</a>
          <abbr class="published small" title="2013-01-28T03:00:48-0500">(January 28, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2013/01/nlp-the-missing-framework/" rel="bookmark">NLP: the missing framework</a>
          <abbr class="published small" title="2013-01-02T00:00:30-0500">(January 2, 2013)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/12/googl-nexus-7-setup-notes/" rel="bookmark">Google Nexus 7 setup notes</a>
          <abbr class="published small" title="2012-12-31T21:19:30-0500">(December 31, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/12/metro-maps-of-the-news/" rel="bookmark">Metro Maps of the News</a>
          <abbr class="published small" title="2012-12-13T04:44:40-0500">(December 13, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/12/maildir-synchronizing-sup/" rel="bookmark">Maildir synchronizing Sup</a>
          <abbr class="published small" title="2012-12-01T18:33:38-0500">(December 1, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/11/why-cant-i-just-be-a-little-lazy/" rel="bookmark">Why can’t I just be a little lazy?</a>
          <abbr class="published small" title="2012-11-26T09:00:28-0500">(November 26, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/11/functional-encryption/" rel="bookmark">Functional Encryption</a>
          <abbr class="published small" title="2012-11-25T15:24:20-0500">(November 25, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/11/extremist-programming/" rel="bookmark">Extremist Programming</a>
          <abbr class="published small" title="2012-11-20T16:15:06-0500">(November 20, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/11/plan-9-mounts-and-dependency-injection/" rel="bookmark">Plan 9 mounts and dependency injection</a>
          <abbr class="published small" title="2012-11-08T19:45:57-0500">(November 8, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/11/hpd3-js-an-interactive-heap-profile-viewer/" rel="bookmark">hp/D3.js: an interactive heap profile viewer</a>
          <abbr class="published small" title="2012-11-02T02:42:18-0500">(November 2, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/ubuntu-quantal-upgrade-thinkpadxmonad/" rel="bookmark">Ubuntu Quantal upgrade (Thinkpad/Xmonad)</a>
          <abbr class="published small" title="2012-10-24T11:00:01-0500">(October 24, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/acm-xrds-jeff-dean-profile/" rel="bookmark">ACM XRDS: Jeff Dean profile</a>
          <abbr class="published small" title="2012-10-22T10:00:04-0500">(October 22, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/duality-for-haskellers/" rel="bookmark">Duality for Haskellers</a>
          <abbr class="published small" title="2012-10-19T11:00:50-0500">(October 19, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/hails-protecting-data-privacy-in-untrusted-web-applications/" rel="bookmark">Hails: Protecting Data Privacy in Untrusted Web Applications</a>
          <abbr class="published small" title="2012-10-16T11:00:33-0500">(October 16, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/visualizing-satisfiability-validity-and-entailment/" rel="bookmark">Visualizing satisfiability, validity &amp; entailment</a>
          <abbr class="published small" title="2012-10-15T11:00:51-0500">(October 15, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/get-browser-exe/" rel="bookmark">GET /browser.exe</a>
          <abbr class="published small" title="2012-10-12T14:26:17-0500">(October 12, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/10/generalizing-the-programmable-semicolon/" rel="bookmark">Generalizing the programmable semicolon</a>
          <abbr class="published small" title="2012-10-03T17:49:28-0500">(October 3, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/09/template-project-for-ghc-plugins/" rel="bookmark">Template project for GHC plugins</a>
          <abbr class="published small" title="2012-09-28T18:56:20-0500">(September 28, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/09/feit-thompson-true/" rel="bookmark">“This is really the End.”</a>
          <abbr class="published small" title="2012-09-24T09:00:12-0500">(September 24, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/09/common-misconceptions-about-safe-haskell/" rel="bookmark">Unintuitive facts about Safe Haskell</a>
          <abbr class="published small" title="2012-09-17T20:34:45-0500">(September 17, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/09/y-combinator-and-strict-positivity/" rel="bookmark">The Y Combinator and strict positivity</a>
          <abbr class="published small" title="2012-09-12T18:52:23-0500">(September 12, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/so-you-want-to-hack-on-imap/" rel="bookmark">So you want to hack on IMAP…</a>
          <abbr class="published small" title="2012-08-31T10:00:34-0500">(August 31, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/offlineimap-sucks/" rel="bookmark">OfflineIMAP sucks</a>
          <abbr class="published small" title="2012-08-30T01:07:58-0500">(August 30, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/how-offlineimap-works/" rel="bookmark">How OfflineIMAP works</a>
          <abbr class="published small" title="2012-08-27T10:00:33-0500">(August 27, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/the-monad-reader-issue-20/" rel="bookmark">The Monad Reader: Issue 20</a>
          <abbr class="published small" title="2012-08-25T23:39:18-0500">(August 25, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/applicative-functors/" rel="bookmark">Applicative functors</a>
          <abbr class="published small" title="2012-08-16T05:34:30-0500">(August 16, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/practical-foundations-for-programming-languages/" rel="bookmark">Practical Foundations for Programming Languages (first impressions)</a>
          <abbr class="published small" title="2012-08-15T01:00:31-0500">(August 15, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/is-haskell-liberal-or-conservative/" rel="bookmark">Is Haskell liberal or conservative?</a>
          <abbr class="published small" title="2012-08-10T09:12:50-0500">(August 10, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/08/statically-checked-perfect-binary-trees/" rel="bookmark">Two ways of representing perfect binary trees</a>
          <abbr class="published small" title="2012-08-04T11:04:33-0500">(August 4, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/07/polymorphic-variants-in-urweb/" rel="bookmark">Polymorphic variants in Ur/Web</a>
          <abbr class="published small" title="2012-07-29T01:33:18-0500">(July 29, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/07/managing-the-server-client-split-in-ur-web/" rel="bookmark">Managing the server/client split in Ur/Web</a>
          <abbr class="published small" title="2012-07-25T01:17:14-0500">(July 25, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/07/secure-multiparty-bitcoin-anonymization/" rel="bookmark">Secure multiparty Bitcoin anonymization</a>
          <abbr class="published small" title="2012-07-20T11:42:13-0500">(July 20, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/06/why-verification-results-in-higher-quality-code/" rel="bookmark">Why verification results in higher quality code</a>
          <abbr class="published small" title="2012-06-23T00:40:11-0500">(June 23, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/05/thoughts-on-gamifying-textbooks/" rel="bookmark">Thoughts on gamifying textbooks</a>
          <abbr class="published small" title="2012-05-24T19:10:57-0500">(May 24, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/05/an-interactive-tutorial-of-the-sequent-calculus/" rel="bookmark">An Interactive Tutorial of the Sequent Calculus</a>
          <abbr class="published small" title="2012-05-22T09:00:28-0500">(May 22, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/05/ubuntu-precise-upgrade-thinkpad-xmonad/" rel="bookmark">Ubuntu Precise upgrade (Thinkpad/Xmonad)</a>
          <abbr class="published small" title="2012-05-18T20:51:12-0500">(May 18, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/05/what-happens-when-you-mix-three-research-programming-languages-together/" rel="bookmark">What happens when you mix three research programming languages together</a>
          <abbr class="published small" title="2012-05-16T02:54:22-0500">(May 16, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/05/some-thoughts-about-literature-review/" rel="bookmark">Some thoughts about literature review</a>
          <abbr class="published small" title="2012-05-13T19:03:00-0500">(May 13, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/04/how-urweb-records-work-and-what-it-might-mean-for-haskell/" rel="bookmark">How Ur/Web records work and what it might mean for Haskell</a>
          <abbr class="published small" title="2012-04-20T01:24:41-0500">(April 20, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/04/use-the-source-dont-read-it/" rel="bookmark">Use the source, don’t read it</a>
          <abbr class="published small" title="2012-04-17T12:51:49-0500">(April 17, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/03/reduce-ubuntu-latency-by-disabling-mdns/" rel="bookmark">Reduce Ubuntu latency by disabling mDNS</a>
          <abbr class="published small" title="2012-03-24T15:56:04-0500">(March 24, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/03/visit-month-princeton/" rel="bookmark">Visit month: Princeton</a>
          <abbr class="published small" title="2012-03-20T09:00:46-0500">(March 20, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/03/is-it-better-to-teach-formalism-or-intuition/" rel="bookmark">Is it better to teach formalism or intuition?</a>
          <abbr class="published small" title="2012-03-18T16:51:31-0500">(March 18, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/03/visit-month-upen/" rel="bookmark">Visit month: University of Pennsylvania</a>
          <abbr class="published small" title="2012-03-16T01:59:16-0500">(March 16, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/03/you-could-have-invented-fractional-cascading/" rel="bookmark">You could have invented fractional cascading</a>
          <abbr class="published small" title="2012-03-05T01:30:22-0500">(March 5, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/02/visualizing-range-trees/" rel="bookmark">Visualizing range trees</a>
          <abbr class="published small" title="2012-02-26T03:41:40-0500">(February 26, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/02/anatomy-of-you-could-have-invented/" rel="bookmark">Anatomy of “You could have invented…”</a>
          <abbr class="published small" title="2012-02-23T14:42:04-0500">(February 23, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/02/transcript-of-inventing-on-principleb/" rel="bookmark">Transcript of “Inventing on Principle”</a>
          <abbr class="published small" title="2012-02-20T16:23:10-0500">(February 20, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/02/travel-spring-2012-edition/" rel="bookmark">Travel: Spring 2012 Edition</a>
          <abbr class="published small" title="2012-02-18T10:55:15-0500">(February 18, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/02/how-to-build-drm-you-can-trust/" rel="bookmark">How to build DRM you can trust</a>
          <abbr class="published small" title="2012-02-15T16:49:19-0500">(February 15, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/popl/" rel="bookmark">POPL</a>
          <abbr class="published small" title="2012-01-28T08:30:59-0500">(January 28, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/modelling-io/" rel="bookmark">Modelling IO: MonadIO and beyond</a>
          <abbr class="published small" title="2012-01-24T13:31:06-0500">(January 24, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/monadbasecontrol-is-unsound/" rel="bookmark">monad-control is tricky</a>
          <abbr class="published small" title="2012-01-23T12:39:00-0500">(January 23, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/mystery-hunt-and-the-scientific-endeavour/" rel="bookmark">Mystery Hunt and the Scientific Endeavour</a>
          <abbr class="published small" title="2012-01-16T16:12:52-0500">(January 16, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/problem-set-the-codensity-transformation/" rel="bookmark">Problem Set: The Codensity Transformation</a>
          <abbr class="published small" title="2012-01-07T03:00:20-0500">(January 7, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2012/01/why-iteratees-are-hard-to-understand/" rel="bookmark">Why iteratees are hard to understand</a>
          <abbr class="published small" title="2012-01-04T08:00:26-0500">(January 4, 2012)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/12/bugs-and-battleships/" rel="bookmark">Bugs and Battleships</a>
          <abbr class="published small" title="2011-12-19T11:04:51-0500">(December 19, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/12/how-to-build-i686-glibc-on-ubuntu/" rel="bookmark">How to build i686 glibc on Ubuntu</a>
          <abbr class="published small" title="2011-12-18T18:03:44-0500">(December 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/12/interactive-demo-of-zero-knowledge-proofs/" rel="bookmark">Interactive Demo of Zero-Knowledge Proofs</a>
          <abbr class="published small" title="2011-12-17T13:56:39-0500">(December 17, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/12/accessing-lazy-structures-from/" rel="bookmark">Accessing lazy structures from C</a>
          <abbr class="published small" title="2011-12-15T17:18:27-0500">(December 15, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/11/transparent-xmobar/" rel="bookmark">Transparent xmobar</a>
          <abbr class="published small" title="2011-11-28T05:09:32-0500">(November 28, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/11/ubuntu-oneiric-thinkpad-xmonad/" rel="bookmark">Ubuntu Oneiric upgrade (Thinkpad/Xmonad)</a>
          <abbr class="published small" title="2011-11-24T03:59:50-0500">(November 24, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/11/how-to-read-haskell/" rel="bookmark">How to read Haskell like Python</a>
          <abbr class="published small" title="2011-11-14T09:00:26-0500">(November 14, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/10/the-new-reflections-on-trusting-trust/" rel="bookmark">The new Reflections on Trusting Trust</a>
          <abbr class="published small" title="2011-10-28T09:00:57-0500">(October 28, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/10/obviously-correct/" rel="bookmark">Obviously Correct</a>
          <abbr class="published small" title="2011-10-24T09:00:34-0500">(October 24, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/10/polyglot-programming/" rel="bookmark">Polyglot programming</a>
          <abbr class="published small" title="2011-10-12T22:22:54-0500">(October 12, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/09/do-not-phd-in-systems/" rel="bookmark">Why you shouldn’t do a PhD in systems</a>
          <abbr class="published small" title="2011-09-26T02:41:39-0500">(September 26, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/09/lets-play-a-game/" rel="bookmark">Let’s play a game</a>
          <abbr class="published small" title="2011-09-05T04:04:46-0500">(September 5, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/8-ways-to-report-errors-in-haskell-revisited/" rel="bookmark">8 ways to report errors in Haskell revisited</a>
          <abbr class="published small" title="2011-08-29T12:30:02-0500">(August 29, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/joseph-and-the-amazing-technicolor-box/" rel="bookmark">Joseph and the Amazing Technicolor Box</a>
          <abbr class="published small" title="2011-08-23T03:46:58-0500">(August 23, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/diskless-paxos-crash-recovery/" rel="bookmark">Diskless Paxos crash recovery</a>
          <abbr class="published small" title="2011-08-14T00:41:30-0500">(August 14, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/first-impressions-of-module-programming/" rel="bookmark">First impressions of module programming</a>
          <abbr class="published small" title="2011-08-05T09:00:21-0500">(August 5, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/in-program-gc-stats-redux/" rel="bookmark">In-program GC stats redux</a>
          <abbr class="published small" title="2011-08-03T09:00:08-0500">(August 3, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/08/changes-to-intmap/" rel="bookmark">Changes to IntMap</a>
          <abbr class="published small" title="2011-08-01T09:00:27-0500">(August 1, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/food-related-functional-humor/" rel="bookmark">Food-related functional humor</a>
          <abbr class="published small" title="2011-07-29T09:00:18-0500">(July 29, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/blockedindefinitelyonmvar/" rel="bookmark">BlockedIndefinitelyOnMVar</a>
          <abbr class="published small" title="2011-07-27T09:00:08-0500">(July 27, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/data-type-definitions-to-code/" rel="bookmark">From data type definitions to code</a>
          <abbr class="published small" title="2011-07-25T09:00:48-0500">(July 25, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/variant-types-and-gadts/" rel="bookmark">Variant types and GADTs</a>
          <abbr class="published small" title="2011-07-22T09:00:21-0500">(July 22, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/in-program-gc-stats-for-ghc/" rel="bookmark">In-program GC stats for GHC</a>
          <abbr class="published small" title="2011-07-20T09:00:00-0500">(July 20, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/synthetic-git-merges/" rel="bookmark">Synthetic Git merges</a>
          <abbr class="published small" title="2011-07-18T09:00:14-0500">(July 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/parallelism-to-plug-space-leaks/" rel="bookmark">Parallelism to plug space leaks</a>
          <abbr class="published small" title="2011-07-15T09:00:26-0500">(July 15, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/facebook-support-for-barnowl/" rel="bookmark">Facebook support for BarnOwl</a>
          <abbr class="published small" title="2011-07-13T09:00:15-0500">(July 13, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/grad-school-oh-my/" rel="bookmark">Grad School, Oh My</a>
          <abbr class="published small" title="2011-07-11T09:00:07-0500">(July 11, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/cambridge-hps/" rel="bookmark">Cambridge retrospective: History and Philosophy of Science</a>
          <abbr class="published small" title="2011-07-08T09:00:02-0500">(July 8, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/a-new-vision-for-mendeley/" rel="bookmark">A new vision for Mendeley</a>
          <abbr class="published small" title="2011-07-06T09:00:54-0500">(July 6, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/ivar-leaks/" rel="bookmark">IVar leaks</a>
          <abbr class="published small" title="2011-07-04T09:00:17-0500">(July 4, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/07/scheduling-ivar/" rel="bookmark">Scheduling IVars</a>
          <abbr class="published small" title="2011-07-01T09:00:20-0500">(July 1, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/the-iva-monad/" rel="bookmark">The IVar monad</a>
          <abbr class="published small" title="2011-06-29T08:57:31-0500">(June 29, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/debugging-compilers-with-optimization-fuel/" rel="bookmark">Debugging compilers with optimization fuel</a>
          <abbr class="published small" title="2011-06-27T09:00:49-0500">(June 27, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/multi-monitor-xmobar-placement-on-nome/" rel="bookmark">Multi-monitor xmobar placement on Gnome</a>
          <abbr class="published small" title="2011-06-24T09:00:57-0500">(June 24, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/a-year-of-notebooking-part-2/" rel="bookmark">A Year of Notebooking (Part 2)</a>
          <abbr class="published small" title="2011-06-22T09:00:50-0500">(June 22, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/a-year-of-notebooking-part-1/" rel="bookmark">A Year of Notebooking (Part 1)</a>
          <abbr class="published small" title="2011-06-20T09:13:29-0500">(June 20, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/a-pattern-for-increasing-sharing/" rel="bookmark">A pattern for increasing sharing</a>
          <abbr class="published small" title="2011-06-17T12:55:32-0500">(June 17, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/on-type-synonyms/" rel="bookmark">On type synonyms</a>
          <abbr class="published small" title="2011-06-15T12:22:05-0500">(June 15, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/taxonomy-of-socialization-on-the-internet/" rel="bookmark">A Taxonomy of Socialization on the Internet</a>
          <abbr class="published small" title="2011-06-13T11:19:01-0500">(June 13, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/pinpointing-space-leaks-in-big-programs/" rel="bookmark">Pinpointing space leaks in big programs</a>
          <abbr class="published small" title="2011-06-10T09:00:53-0500">(June 10, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/measurement-quantification-and-reduction/" rel="bookmark">Measurement, quantification and reduction</a>
          <abbr class="published small" title="2011-06-08T09:00:26-0500">(June 8, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/philosophy-of-software-engineering/" rel="bookmark">What Philosophy of Science Can Say for Software Engineers</a>
          <abbr class="published small" title="2011-06-06T09:00:05-0500">(June 6, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/the-cryptography-of-bitcoin/" rel="bookmark">The Cryptography of Bitcoin</a>
          <abbr class="published small" title="2011-06-03T09:00:11-0500">(June 3, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/06/bitcoin-is-not-decentralized/" rel="bookmark">Bitcoin is not decentralized</a>
          <abbr class="published small" title="2011-06-01T07:00:52-0500">(June 1, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/neural-networks/" rel="bookmark">Chain Rule + Dynamic Programming <br>= Neural Networks</a>
          <abbr class="published small" title="2011-05-30T09:00:24-0500">(May 30, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/an-insufficiently-lazy-map/" rel="bookmark">An insufficiently lazy map</a>
          <abbr class="published small" title="2011-05-27T09:00:58-0500">(May 27, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/byron-cook-sla/" rel="bookmark">If it has lots of comments, it’s probably buggy</a>
          <abbr class="published small" title="2011-05-25T09:00:04-0500">(May 25, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/tail-recursion-makes-your-loops-cleaner/" rel="bookmark">Tail recursion makes your loops cleaner</a>
          <abbr class="published small" title="2011-05-23T09:00:04-0500">(May 23, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/computing-function-composition/" rel="bookmark">Computing function composition</a>
          <abbr class="published small" title="2011-05-20T09:00:50-0500">(May 20, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/anatomy-of-a-thunk-leak/" rel="bookmark">Anatomy of a thunk leak</a>
          <abbr class="published small" title="2011-05-18T08:29:19-0500">(May 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/space-leak-zoo/" rel="bookmark">Space leak zoo</a>
          <abbr class="published small" title="2011-05-16T09:00:28-0500">(May 16, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/reified-laziness/" rel="bookmark">Reified laziness</a>
          <abbr class="published small" title="2011-05-13T21:45:11-0500">(May 13, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/calling-all-space-leaks/" rel="bookmark">Calling all space leaks</a>
          <abbr class="published small" title="2011-05-11T16:00:15-0500">(May 11, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/bindings-and-cafs-on-the-haskell-heap/" rel="bookmark">Bindings and CAFs on the Haskell Heap</a>
          <abbr class="published small" title="2011-05-09T11:23:43-0500">(May 9, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/how-aristotle-got-it-wrongon-the-importance-of-conceptual-frameworks/" rel="bookmark">How Aristotle got it Wrong<br>On the importance of conceptual frameworks</a>
          <abbr class="published small" title="2011-05-06T09:00:35-0500">(May 6, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/unraveling-the-mystery-of-the-io-monad/" rel="bookmark">Unraveling the mystery of the IO monad</a>
          <abbr class="published small" title="2011-05-04T09:00:24-0500">(May 4, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/05/haskell-not-pure-enough/" rel="bookmark">Haskell: Not pure enough?</a>
          <abbr class="published small" title="2011-05-02T09:00:06-0500">(May 2, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/how-the-grinch-stole-the-haskell-heap/" rel="bookmark">How the Grinch stole the Haskell Heap</a>
          <abbr class="published small" title="2011-04-29T07:31:26-0500">(April 29, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/functions-produce-the-haskell-heap/" rel="bookmark">Functions produce the Haskell Heap</a>
          <abbr class="published small" title="2011-04-27T11:18:38-0500">(April 27, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/implementing-the-haskell-heap-in-python-v1/" rel="bookmark">Implementing the Haskell Heap in Python, v1</a>
          <abbr class="published small" title="2011-04-25T09:00:47-0500">(April 25, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/io-evaluates-the-haskell-heap/" rel="bookmark">IO evaluates the Haskell Heap</a>
          <abbr class="published small" title="2011-04-24T12:36:46-0500">(April 24, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/evaluation-on-the-haskell-heap/" rel="bookmark">Evaluation on the Haskell Heap</a>
          <abbr class="published small" title="2011-04-20T16:41:00-0500">(April 20, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/the-haskell-heap/" rel="bookmark">The Haskell Heap</a>
          <abbr class="published small" title="2011-04-18T09:00:46-0500">(April 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/mailbox-advice-for-a-sup-first-timer/" rel="bookmark">Mailbox: Advice for a sup first-timer</a>
          <abbr class="published small" title="2011-04-16T13:48:54-0500">(April 16, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/tracing-the-compilation-of-hello-factorial/" rel="bookmark">Tracing the compilation of Hello Factorial!</a>
          <abbr class="published small" title="2011-04-13T12:27:18-0500">(April 13, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/bugs-from-using-the-wrong-variable/" rel="bookmark">Bugs from using the wrong variable</a>
          <abbr class="published small" title="2011-04-11T09:00:44-0500">(April 11, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/hoopl-dataflow-analysis/" rel="bookmark">Hoopl: Dataflow analysis</a>
          <abbr class="published small" title="2011-04-08T21:07:34-0500">(April 8, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/type-kata-local-data-type/" rel="bookmark">Type Kata: Local data type</a>
          <abbr class="published small" title="2011-04-05T06:20:52-0500">(April 5, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/hoopl-dataflow-lattices/" rel="bookmark">Hoopl: Dataflow lattices</a>
          <abbr class="published small" title="2011-04-04T09:00:31-0500">(April 4, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/04/hoopl-guided-tour-base-system/" rel="bookmark">Hoopl guided tour: Base system</a>
          <abbr class="published small" title="2011-04-01T09:00:44-0500">(April 1, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/ghc-migrating-to-git/" rel="bookmark">GHC migrating to Git</a>
          <abbr class="published small" title="2011-03-30T09:00:46-0500">(March 30, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/html-purifier-4-3-0-released/" rel="bookmark">HTML Purifier 4.3.0 released</a>
          <abbr class="published small" title="2011-03-28T09:00:39-0500">(March 28, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/ely-cycles/" rel="bookmark">Ely Cycles</a>
          <abbr class="published small" title="2011-03-25T09:00:00-0500">(March 25, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/interleaving-stream-processor/" rel="bookmark">Interleaving stream processors</a>
          <abbr class="published small" title="2011-03-23T09:00:36-0500">(March 23, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/the-return-of-hellenistic-reasonin/" rel="bookmark">The return of Hellenistic reasoning</a>
          <abbr class="published small" title="2011-03-21T09:00:42-0500">(March 21, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/spring-reading-2011-edition/" rel="bookmark">Spring Reading: 2011 edition</a>
          <abbr class="published small" title="2011-03-18T18:29:11-0500">(March 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/on-expressivity/" rel="bookmark">On expressivity</a>
          <abbr class="published small" title="2011-03-16T09:00:12-0500">(March 16, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/someone-is-wrong-on-the-internet/" rel="bookmark">Someone is wrong on the Internet</a>
          <abbr class="published small" title="2011-03-14T09:00:01-0500">(March 14, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/many-valued-logics-and-bottom/" rel="bookmark">Many-valued logics and bottom</a>
          <abbr class="published small" title="2011-03-11T09:00:05-0500">(March 11, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/killer-mutants-attack-mutation-gone-wrong/" rel="bookmark">Killer mutants attack (mutation gone wrong)</a>
          <abbr class="published small" title="2011-03-09T09:00:46-0500">(March 9, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/type-tech-tree/" rel="bookmark">Type Technology Tree</a>
          <abbr class="published small" title="2011-03-07T09:00:26-0500">(March 7, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/petri-net-concurrency/" rel="bookmark">Petri net concurrency</a>
          <abbr class="published small" title="2011-03-04T09:00:50-0500">(March 4, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/03/the-creation-of-a-statically-typed-functional-programmer/" rel="bookmark">The creation of a statically-typed functional programmer</a>
          <abbr class="published small" title="2011-03-02T09:00:26-0500">(March 2, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/on-cargo-culting-and-hacking/" rel="bookmark">On cargo culting and hacking</a>
          <abbr class="published small" title="2011-02-28T09:00:46-0500">(February 28, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/multi-day-debugging/" rel="bookmark">Multi-day debugging</a>
          <abbr class="published small" title="2011-02-25T09:00:51-0500">(February 25, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/ad-hoc-approximations/" rel="bookmark">Ad hoc approximations</a>
          <abbr class="published small" title="2011-02-23T09:00:25-0500">(February 23, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/semi-automatic-testing/" rel="bookmark">Semi-automatic testing</a>
          <abbr class="published small" title="2011-02-21T09:00:14-0500">(February 21, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/two-short-tips-for-ffi-binding/" rel="bookmark">Two short tips for FFI bindings</a>
          <abbr class="published small" title="2011-02-20T20:57:03-0500">(February 20, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/on-checked-exceptions-and-proof-obligations/" rel="bookmark">On checked exceptions and proof obligations</a>
          <abbr class="published small" title="2011-02-18T09:00:05-0500">(February 18, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/picturing-hoopl-transferrewrite-functions/" rel="bookmark">Picturing Hoopl transfer/rewrite functions</a>
          <abbr class="published small" title="2011-02-16T09:00:44-0500">(February 16, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/picturing-binomial-coefficient-identities/" rel="bookmark">Picturing binomial coefficient identities</a>
          <abbr class="published small" title="2011-02-14T09:00:10-0500">(February 14, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/android-2-x-sensor-simulator/" rel="bookmark">Android 2.x Sensor Simulator</a>
          <abbr class="published small" title="2011-02-11T09:00:16-0500">(February 11, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/inden-php-vim/" rel="bookmark">A suggestion for indent/php.vim</a>
          <abbr class="published small" title="2011-02-09T09:00:17-0500">(February 9, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/lavnet-is-watching-you/" rel="bookmark">Lav’net is watching you</a>
          <abbr class="published small" title="2011-02-07T09:00:02-0500">(February 7, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/ocaml-gotchas/" rel="bookmark">OCaml gotchas</a>
          <abbr class="published small" title="2011-02-04T09:00:04-0500">(February 4, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2011/02/all-about-mvars/" rel="bookmark">All about MVars</a>
          <abbr class="published small" title="2011-02-02T09:00:37-0500">(February 2, 2011)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/a-year-of-blogging/" rel="bookmark">A year of blogging</a>
          <abbr class="published small" title="2010-12-31T09:00:04-0500">(December 31, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/greetings-from-switzerland/" rel="bookmark">Greetings from Switzerland</a>
          <abbr class="published small" title="2010-12-29T14:25:35-0500">(December 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/no-one-expects-the-scott-induction/" rel="bookmark">No one expects the Scott induction!</a>
          <abbr class="published small" title="2010-12-27T09:00:42-0500">(December 27, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/thriller/" rel="bookmark">Thriller: Doing it for the thrills</a>
          <abbr class="published small" title="2010-12-24T09:00:28-0500">(December 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/travel-advisory/" rel="bookmark">Travel advisory</a>
          <abbr class="published small" title="2010-12-21T04:36:05-0500">(December 21, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/generalization-and-vagueness-in-specifications/" rel="bookmark">Generalization and vagueness in specifications</a>
          <abbr class="published small" title="2010-12-20T09:00:35-0500">(December 20, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/tourist-by-day-blogger-by-night/" rel="bookmark">Tourist by day, Blogger by night</a>
          <abbr class="published small" title="2010-12-17T09:00:00-0500">(December 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/omega-i-m-lubbin-it/" rel="bookmark">ω: I’m lubbin’ it</a>
          <abbr class="published small" title="2010-12-15T09:00:14-0500">(December 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/getting-a-fix-on-fixpoints/" rel="bookmark">Getting a fix on fixpoints</a>
          <abbr class="published small" title="2010-12-13T09:00:20-0500">(December 13, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/errata-for-gin-and-monotonic/" rel="bookmark">Errata for gin and monotonic</a>
          <abbr class="published small" title="2010-12-10T09:00:25-0500">(December 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/gin-and-monotonic/" rel="bookmark">Gin and monotonic</a>
          <abbr class="published small" title="2010-12-08T09:00:02-0500">(December 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/hussling-haskell-types-into-hasse-diagrams/" rel="bookmark">Hussling Haskell types into Hasse diagrams</a>
          <abbr class="published small" title="2010-12-06T09:00:24-0500">(December 6, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/talk-friday/" rel="bookmark">Talk Friday</a>
          <abbr class="published small" title="2010-12-03T09:00:25-0500">(December 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/12/how-i-learned-to-stop-worrying-and-love-the-bottom/" rel="bookmark">How I Learned to Stop Worrying and Love the ⊥</a>
          <abbr class="published small" title="2010-12-01T09:00:09-0500">(December 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/my-first-proof-in-isabelle/" rel="bookmark">My first proof in Isabelle</a>
          <abbr class="published small" title="2010-11-29T09:00:28-0500">(November 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/reflexivity-qed/" rel="bookmark">Reflexivity. Qed.</a>
          <abbr class="published small" title="2010-11-26T09:00:24-0500">(November 26, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/integer-sequences-every-computer-scientist-should-know/" rel="bookmark">Integer sequences every computer scientist should know?</a>
          <abbr class="published small" title="2010-11-24T09:00:09-0500">(November 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/is-multiply-carry-strongly-universal/" rel="bookmark">Is multiply-carry strongly universal?</a>
          <abbr class="published small" title="2010-11-22T09:00:33-0500">(November 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/cambridge-potpourri/" rel="bookmark">Cambridge potpourri</a>
          <abbr class="published small" title="2010-11-19T09:00:39-0500">(November 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/haskell-org-committee/" rel="bookmark">Haskell.org committee</a>
          <abbr class="published small" title="2010-11-17T09:00:40-0500">(November 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/its-just-a-longjmp-to-the-left/" rel="bookmark">It’s just a longjmp to the left</a>
          <abbr class="published small" title="2010-11-15T09:00:56-0500">(November 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/another-ghc-hacking-post/" rel="bookmark">You are in a maze of twisty little passages, all alike… (a GHC hacking post)</a>
          <abbr class="published small" title="2010-11-12T09:00:00-0500">(November 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/mod_fcgid-is-broke/" rel="bookmark">mod_fcgid 2.3 is broken (fixed in 2.3.6)</a>
          <abbr class="published small" title="2010-11-10T09:00:48-0500">(November 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/medieval-medicine-and-computers/" rel="bookmark">Medieval medicine and computers</a>
          <abbr class="published small" title="2010-11-08T09:00:15-0500">(November 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/dp-zoo-tour/" rel="bookmark">DP Zoo Tour</a>
          <abbr class="published small" title="2010-11-05T09:00:46-0500">(November 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/dead-edward-day/" rel="bookmark">Dead Edward Day</a>
          <abbr class="published small" title="2010-11-03T09:00:02-0500">(November 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/11/dp-zoo/" rel="bookmark">DP Zoo</a>
          <abbr class="published small" title="2010-11-01T09:00:09-0500">(November 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/finer-distinctions/" rel="bookmark">Intelligence is the ability to make finer distinctions: Another Haskell Advocacy Post</a>
          <abbr class="published small" title="2010-10-29T09:00:13-0500">(October 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/blog-name-changed/" rel="bookmark">Blog name changed…</a>
          <abbr class="published small" title="2010-10-27T09:00:07-0500">(October 27, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/ocaml-for-haskellers/" rel="bookmark">OCaml for Haskellers</a>
          <abbr class="published small" title="2010-10-25T09:00:54-0500">(October 25, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/dry-is-context-dependen/" rel="bookmark">Don’t Repeat Yourself is context dependent</a>
          <abbr class="published small" title="2010-10-22T09:00:52-0500">(October 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/purpose-of-proof-sem-formal-methods/" rel="bookmark">Purpose of proof: semi-formal methods</a>
          <abbr class="published small" title="2010-10-20T09:00:42-0500">(October 20, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/rapid-prototyping-in-haskell/" rel="bookmark">Rapidly prototyping scripts in Haskell</a>
          <abbr class="published small" title="2010-10-18T09:00:08-0500">(October 18, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/existential-type-curry/" rel="bookmark">Existential type-curry</a>
          <abbr class="published small" title="2010-10-15T09:00:02-0500">(October 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/quote-day/" rel="bookmark">Quote Day</a>
          <abbr class="published small" title="2010-10-13T09:00:56-0500">(October 13, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/why-being-a-sysadmin-will-help-you-do-scienc/" rel="bookmark">Why being a sysadmin will help you do Science!</a>
          <abbr class="published small" title="2010-10-11T09:00:40-0500">(October 11, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/the-html-purification-manifesto/" rel="bookmark">The HTML purification manifesto</a>
          <abbr class="published small" title="2010-10-08T09:00:07-0500">(October 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/beyond-generalizatio/" rel="bookmark">Abstraction without a concrete concept</a>
          <abbr class="published small" title="2010-10-06T09:00:28-0500">(October 6, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/why-i-m-in-cambridge/" rel="bookmark">Why I am in Cambridge</a>
          <abbr class="published small" title="2010-10-04T09:00:10-0500">(October 4, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/10/tips-for-running-a-hackatho/" rel="bookmark">Tips for running a hackathon</a>
          <abbr class="published small" title="2010-10-01T09:00:54-0500">(October 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/how-to-get-answers-from-busy-maintainers/" rel="bookmark">How to get answers from busy maintainers</a>
          <abbr class="published small" title="2010-09-29T09:00:45-0500">(September 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/so-long-america/" rel="bookmark">So long America!</a>
          <abbr class="published small" title="2010-09-27T09:00:18-0500">(September 27, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/high-performance-monads/" rel="bookmark">High performance monads</a>
          <abbr class="published small" title="2010-09-24T09:00:51-0500">(September 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/data-is-code/" rel="bookmark">Data is Code</a>
          <abbr class="published small" title="2010-09-22T09:00:38-0500">(September 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/tension-of-patch-and-tree-version-control/" rel="bookmark">Tension of patch and tree version control</a>
          <abbr class="published small" title="2010-09-20T09:00:06-0500">(September 20, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/session-types-subtyping-and-dependent-types/" rel="bookmark">Session types, subtyping and dependent types</a>
          <abbr class="published small" title="2010-09-17T09:00:09-0500">(September 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/evolution-of-a-shared-web-host/" rel="bookmark">Evolution of a Shared Web Host</a>
          <abbr class="published small" title="2010-09-15T09:00:03-0500">(September 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/keyword-arguments-in-haskell/" rel="bookmark">Keyword arguments in Haskell</a>
          <abbr class="published small" title="2010-09-13T09:00:24-0500">(September 13, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/towards-platform-agnostic-interruptibility/" rel="bookmark">Towards platform-agnostic interruptibility</a>
          <abbr class="published small" title="2010-09-10T09:00:47-0500">(September 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/pthread-cancel-on-window/" rel="bookmark">pthread_cancel on Windows</a>
          <abbr class="published small" title="2010-09-08T09:00:27-0500">(September 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/embracing-window/" rel="bookmark">Embracing Windows</a>
          <abbr class="published small" title="2010-09-06T09:00:27-0500">(September 6, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/annotating-slides/" rel="bookmark">Annotating slides</a>
          <abbr class="published small" title="2010-09-03T09:00:53-0500">(September 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/09/my-type-signature-overfloweth/" rel="bookmark">My type signature overfloweth</a>
          <abbr class="published small" title="2010-09-01T09:00:35-0500">(September 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/defining-haskelly/" rel="bookmark">Defining “Haskelly”</a>
          <abbr class="published small" title="2010-08-30T09:00:05-0500">(August 30, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/interrupting-ghc/" rel="bookmark">Interrupting GHC</a>
          <abbr class="published small" title="2010-08-27T09:00:27-0500">(August 27, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/galois-tech-talk-abcbridge-functional-interfaces-for-aigs-and-sat-solving/" rel="bookmark">abcBridge: Functional interfaces for AIGs and SAT solving</a>
          <abbr class="published small" title="2010-08-25T09:00:48-0500">(August 25, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/type-kata-newtypes/" rel="bookmark">Type Kata: Distinguishing different data with the same underlying representation</a>
          <abbr class="published small" title="2010-08-23T09:00:36-0500">(August 23, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/day-in-the-life-of-a-galois-intern/" rel="bookmark">Day in the life of a Galois intern</a>
          <abbr class="published small" title="2010-08-20T09:00:11-0500">(August 20, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/type-kata-controlled-sharing-of-references/" rel="bookmark">Type kata: Controlled sharing of references</a>
          <abbr class="published small" title="2010-08-18T09:00:51-0500">(August 18, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/what-high-school-algebra-quizzes-and-np-complete-problems-have-in-common/" rel="bookmark">What high school Algebra quizzes and NP-complete problems have in common</a>
          <abbr class="published small" title="2010-08-16T09:00:03-0500">(August 16, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/generalizing-apis/" rel="bookmark">Generalizing APIs</a>
          <abbr class="published small" title="2010-08-13T09:00:54-0500">(August 13, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/the-radical-hackage-social-experiment/" rel="bookmark">A radical Hackage social experiment</a>
          <abbr class="published small" title="2010-08-11T09:00:26-0500">(August 11, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/paper-monday/" rel="bookmark">Paper Monday</a>
          <abbr class="published small" title="2010-08-09T09:00:03-0500">(August 9, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/the-gateway-drug-to-type-programming/" rel="bookmark">The Gateway Drug to Type Programming</a>
          <abbr class="published small" title="2010-08-06T09:00:14-0500">(August 6, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/tour-of-preach-distributed-erlang/" rel="bookmark">Tour of a distributed Erlang application</a>
          <abbr class="published small" title="2010-08-05T09:00:16-0500">(August 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/buffered-streams-and-iteratee/" rel="bookmark">Buffered streams and iteratees</a>
          <abbr class="published small" title="2010-08-04T09:00:42-0500">(August 4, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/08/strings-in-haskell/" rel="bookmark">How to pick your string library in Haskell</a>
          <abbr class="published small" title="2010-08-02T09:00:50-0500">(August 2, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/suggestion-box/" rel="bookmark">Suggestion box</a>
          <abbr class="published small" title="2010-07-30T09:00:46-0500">(July 30, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/delaying-implicit-parameter-binding/" rel="bookmark">Delaying implicit parameter binding</a>
          <abbr class="published small" title="2010-07-28T09:00:38-0500">(July 28, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/implicit-parameters-in-haskell/" rel="bookmark">Reader monad and implicit parameters</a>
          <abbr class="published small" title="2010-07-26T12:46:43-0500">(July 26, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/managing-foreign-pointers-effectively/" rel="bookmark">Managing foreign pointers effectively</a>
          <abbr class="published small" title="2010-07-23T09:00:43-0500">(July 23, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/pipelines-and-continuation/" rel="bookmark">Pipelines and continuations</a>
          <abbr class="published small" title="2010-07-21T09:00:19-0500">(July 21, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/system-posix-redirect/" rel="bookmark">System.Posix.Redirect</a>
          <abbr class="published small" title="2010-07-19T09:00:28-0500">(July 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/maximum-matching-deadlock-solution/" rel="bookmark">Maximum matching deadlock solution</a>
          <abbr class="published small" title="2010-07-16T09:00:13-0500">(July 16, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/flipping-arrows-in-coburger-king/" rel="bookmark">Flipping arrows in coBurger King</a>
          <abbr class="published small" title="2010-07-14T09:00:40-0500">(July 14, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/graphs-not-grids/" rel="bookmark">Graphs not grids: How caches are corrupting young algorithms designers and how to fix it</a>
          <abbr class="published small" title="2010-07-12T09:00:17-0500">(July 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/safety-first-ffi-and-threading/" rel="bookmark">Safety first: FFI and threading</a>
          <abbr class="published small" title="2010-07-09T09:00:05-0500">(July 9, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/groom-human-readable-show-for-haskell/" rel="bookmark">Groom: human readable Show for Haskell</a>
          <abbr class="published small" title="2010-07-07T09:00:34-0500">(July 7, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/littles-law/" rel="bookmark">Little’s law</a>
          <abbr class="published small" title="2010-07-05T09:00:47-0500">(July 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/07/mvc-and-purity/" rel="bookmark">MVC and Purity</a>
          <abbr class="published small" title="2010-07-02T09:00:21-0500">(July 2, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/call-and-fun-marshalling-redux/" rel="bookmark">Call and fun: marshalling redux</a>
          <abbr class="published small" title="2010-06-30T09:00:36-0500">(June 30, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/thinking-about-talk/" rel="bookmark">Thinking about talk</a>
          <abbr class="published small" title="2010-06-28T09:00:44-0500">(June 28, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/marshalling-with-get-and-set/" rel="bookmark">Marshalling with get and set</a>
          <abbr class="published small" title="2010-06-25T09:00:43-0500">(June 25, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/first-steps-in-c2hs/" rel="bookmark">First steps in c2hs</a>
          <abbr class="published small" title="2010-06-23T09:00:52-0500">(June 23, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/secret-of-autogenerated-docs/" rel="bookmark">The secret to successful autogenerated docs</a>
          <abbr class="published small" title="2010-06-21T09:00:26-0500">(June 21, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/principles-of-ffi-api-design/" rel="bookmark">Principles of FFI API design</a>
          <abbr class="published small" title="2010-06-18T09:00:26-0500">(June 18, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/well-founded-recursion-in-agda/" rel="bookmark">Well-founded recursion in Agda</a>
          <abbr class="published small" title="2010-06-16T09:00:35-0500">(June 16, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/setting-up-cabal-the-ffi-and-c2hs/" rel="bookmark">Setting up Cabal, the FFI and c2hs</a>
          <abbr class="published small" title="2010-06-14T09:00:18-0500">(June 14, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/the-haskell-preprocessor-hierarchy/" rel="bookmark">The Haskell Preprocessor Hierarchy</a>
          <abbr class="published small" title="2010-06-11T09:00:12-0500">(June 11, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/static-analysis-mozilla/" rel="bookmark">Static Analysis for everyday (not-PhD) man</a>
          <abbr class="published small" title="2010-06-09T09:00:48-0500">(June 9, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/ap-physics-stuck-in-the-concrete/" rel="bookmark">AP Physics: Stuck in the concrete</a>
          <abbr class="published small" title="2010-06-07T09:00:32-0500">(June 7, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/databases-are-categories/" rel="bookmark">Databases are categories</a>
          <abbr class="published small" title="2010-06-04T09:00:38-0500">(June 4, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/06/bug-boogie-git-and-symlinks/" rel="bookmark">Bug boogie: Git and symlinks</a>
          <abbr class="published small" title="2010-06-02T09:00:09-0500">(June 2, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/punt-the-prelude/" rel="bookmark">Punt the Prelude</a>
          <abbr class="published small" title="2010-05-31T09:00:03-0500">(May 31, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/use-the-monoid/" rel="bookmark">Use The Monoid: A worked example</a>
          <abbr class="published small" title="2010-05-28T09:00:14-0500">(May 28, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/bananas-lenses-envelopes-and-barbed-wire-a-translation-guide/" rel="bookmark">Bananas, Lenses, Envelopes and Barbed Wire <br>A Translation Guide</a>
          <abbr class="published small" title="2010-05-26T09:00:05-0500">(May 26, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/imprecise-exceptions-and-io/" rel="bookmark">Lazy exceptions and IO</a>
          <abbr class="published small" title="2010-05-24T09:00:41-0500">(May 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/upgrading-to-ubuntu-lucid/" rel="bookmark">Upgrading to Ubuntu Lucid</a>
          <abbr class="published small" title="2010-05-21T09:00:58-0500">(May 21, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/class-reflections/" rel="bookmark">Class Reflections</a>
          <abbr class="published small" title="2010-05-19T09:00:49-0500">(May 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/i-hate-patches-confessions-of-an-open-source-developer/" rel="bookmark">I Hate Patches: <br>Confessions of an Open-Source Developer</a>
          <abbr class="published small" title="2010-05-17T09:00:11-0500">(May 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/spring-2010-a-random-walk/" rel="bookmark">Spring 2010: A Random Walk</a>
          <abbr class="published small" title="2010-05-14T09:00:05-0500">(May 14, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/refactoring-haskell-code/" rel="bookmark">Refactoring Haskell code?</a>
          <abbr class="published small" title="2010-05-12T09:00:41-0500">(May 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/nd-vs-catamorphisms/" rel="bookmark">Nested Data Parallelism versus Creative Catamorphisms</a>
          <abbr class="published small" title="2010-05-10T09:00:49-0500">(May 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/omnipresent-cabal/" rel="bookmark">Omnipresent Cabal</a>
          <abbr class="published small" title="2010-05-07T09:00:34-0500">(May 7, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/name-conflicts-on-hackage/" rel="bookmark">Name conflicts on Hackage</a>
          <abbr class="published small" title="2010-05-05T09:00:12-0500">(May 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/05/design-patterns-in-haskel/" rel="bookmark">Design Patterns in Haskell</a>
          <abbr class="published small" title="2010-05-03T09:00:32-0500">(May 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/art-code-math-and-mit-scheme/" rel="bookmark">Art. Code. Math. (And mit-scheme)</a>
          <abbr class="published small" title="2010-04-30T09:00:49-0500">(April 30, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/inessential-guide-to-fclabels/" rel="bookmark">Inessential guide to fclabels</a>
          <abbr class="published small" title="2010-04-28T09:00:04-0500">(April 28, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/the-problem-with-xunit/" rel="bookmark">The Problem with xUnit</a>
          <abbr class="published small" title="2010-04-26T09:00:07-0500">(April 26, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/creative-catamorphisms/" rel="bookmark">Creative catamorphisms</a>
          <abbr class="published small" title="2010-04-23T09:00:57-0500">(April 23, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/association-maps-in-mit-scheme/" rel="bookmark">Association maps in mit-scheme</a>
          <abbr class="published small" title="2010-04-21T09:00:08-0500">(April 21, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/thoughts-on-discussion/" rel="bookmark">Thoughts on discussion</a>
          <abbr class="published small" title="2010-04-19T09:00:52-0500">(April 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/dudamel-visits-mit/" rel="bookmark">Dudamel visits MIT</a>
          <abbr class="published small" title="2010-04-16T09:00:54-0500">(April 16, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/inessential-guide-to-data-accessor/" rel="bookmark">Inessential Guide to data-accessor</a>
          <abbr class="published small" title="2010-04-14T09:00:23-0500">(April 14, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/later-impressions-of-the-vx-8r/" rel="bookmark">Later Impressions of the VX-8R</a>
          <abbr class="published small" title="2010-04-12T09:00:02-0500">(April 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/diagramming-in-xournal-and-gimp/" rel="bookmark">Diagramming in Xournal and Gimp</a>
          <abbr class="published small" title="2010-04-09T09:00:35-0500">(April 9, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/you-could-have-invented-zippers/" rel="bookmark">You could have invented zippers</a>
          <abbr class="published small" title="2010-04-07T09:00:54-0500">(April 7, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/cup-of-fp-java-twis/" rel="bookmark">Cup of FP with a Java twist</a>
          <abbr class="published small" title="2010-04-05T09:00:26-0500">(April 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/04/summer-internship-at-galois/" rel="bookmark">Summer internship at Galois</a>
          <abbr class="published small" title="2010-04-02T09:00:46-0500">(April 2, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/more-fun-with-futamura-projections/" rel="bookmark">More fun with Futamura projections</a>
          <abbr class="published small" title="2010-03-31T09:00:41-0500">(March 31, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/the-case-of-the-hash-array-mapped-trie/" rel="bookmark">The case of the Hash Array Mapped Trie</a>
          <abbr class="published small" title="2010-03-29T09:00:46-0500">(March 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/ad-hoc-wireless/" rel="bookmark">Ad hoc wireless</a>
          <abbr class="published small" title="2010-03-24T09:00:05-0500">(March 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/abstractions-in-mathematics/" rel="bookmark">Hunting for abstractions in mathematics</a>
          <abbr class="published small" title="2010-03-22T09:00:20-0500">(March 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/mutation-sleuthing-in-python/" rel="bookmark">Mutation sleuthing in Python</a>
          <abbr class="published small" title="2010-03-19T09:00:27-0500">(March 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/haskell-the-hard-sell/" rel="bookmark">Haskell, The Hard Sell</a>
          <abbr class="published small" title="2010-03-17T09:00:13-0500">(March 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/straitjacket-programming/" rel="bookmark">Straitjacket programming</a>
          <abbr class="published small" title="2010-03-15T09:00:41-0500">(March 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/five-tips-for-maintainable-shell-scripts/" rel="bookmark">Five tips for maintainable shell scripts</a>
          <abbr class="published small" title="2010-03-12T09:00:07-0500">(March 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/replacing-small-c-programs-with-haskell/" rel="bookmark">Replacing small C programs with Haskell</a>
          <abbr class="published small" title="2010-03-10T09:00:24-0500">(March 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/expert-considered-harmful/" rel="bookmark">Being an expert considered harmful</a>
          <abbr class="published small" title="2010-03-08T09:00:20-0500">(March 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/vim-textwidth/" rel="bookmark">How to use Vim’s textwidth like a pro</a>
          <abbr class="published small" title="2010-03-05T09:00:53-0500">(March 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/third-party-unattended-upgrade/" rel="bookmark">Third-party unattended upgrades in three steps</a>
          <abbr class="published small" title="2010-03-03T12:00:59-0500">(March 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/03/writing-generator-friendly-code/" rel="bookmark">Writing generator friendly code</a>
          <abbr class="published small" title="2010-03-01T12:00:34-0500">(March 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/history-as-documentation/" rel="bookmark">History as documentation</a>
          <abbr class="published small" title="2010-02-26T12:00:40-0500">(February 26, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/art-of-posing-a-problem/" rel="bookmark">The Art of Posing a Problem</a>
          <abbr class="published small" title="2010-02-24T12:00:01-0500">(February 24, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/comonads-and-convolutions/" rel="bookmark">Comonads and Convolutions</a>
          <abbr class="published small" title="2010-02-22T12:00:08-0500">(February 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/type-manipulation-tricks-of-the-trade/" rel="bookmark">Type manipulation: Tricks of the trade</a>
          <abbr class="published small" title="2010-02-19T12:00:56-0500">(February 19, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/why-mit-students-stay-up-late/" rel="bookmark">Why we stay up late</a>
          <abbr class="published small" title="2010-02-17T12:00:58-0500">(February 17, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/hunting-for-constraints/" rel="bookmark">Hunting for constraints</a>
          <abbr class="published small" title="2010-02-15T12:00:31-0500">(February 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/scheming-environment/" rel="bookmark">Scheming environments</a>
          <abbr class="published small" title="2010-02-12T12:00:59-0500">(February 12, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/sources-of-music/" rel="bookmark">Sources of music</a>
          <abbr class="published small" title="2010-02-10T12:00:18-0500">(February 10, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/nested-loops-and-exceptions-oleg-kiselyov/" rel="bookmark">Nested loops and exceptions (Oleg Kiselyov)</a>
          <abbr class="published small" title="2010-02-08T12:00:52-0500">(February 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/nested-loops-and-continuation/" rel="bookmark">Nested loops and continuations</a>
          <abbr class="published small" title="2010-02-05T12:00:43-0500">(February 5, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/classes-begin/" rel="bookmark">Classes begin</a>
          <abbr class="published small" title="2010-02-03T12:00:49-0500">(February 3, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/02/kernel-macro-tricks/" rel="bookmark">Cute macro tricks in the kernel</a>
          <abbr class="published small" title="2010-02-01T12:00:16-0500">(February 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/single-user-git-workflow/" rel="bookmark">Workflows in Git: Single-user style</a>
          <abbr class="published small" title="2010-01-29T12:00:41-0500">(January 29, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/arcadia-rising-posters/" rel="bookmark">Arcadia Rising posters</a>
          <abbr class="published small" title="2010-01-27T12:00:08-0500">(January 27, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/to-the-right-autocompletable-names/" rel="bookmark">To the right! Autocompletable names</a>
          <abbr class="published small" title="2010-01-25T12:00:00-0500">(January 25, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/hacking-git-rerere/" rel="bookmark">Hacking git-rerere</a>
          <abbr class="published small" title="2010-01-22T12:00:31-0500">(January 22, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/too-many-leftovers/" rel="bookmark">Too many leftovers!</a>
          <abbr class="published small" title="2010-01-20T12:00:02-0500">(January 20, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/advanced-git-merge/" rel="bookmark">Five advanced Git merge techniques</a>
          <abbr class="published small" title="2010-01-18T12:00:17-0500">(January 18, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/typeclasses-matter/" rel="bookmark">Typeclasses matter</a>
          <abbr class="published small" title="2010-01-15T12:00:46-0500">(January 15, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/sup/" rel="bookmark">Sup: Mail for Nerds</a>
          <abbr class="published small" title="2010-01-13T12:00:35-0500">(January 13, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/vx-8r-review/" rel="bookmark">First impressions of the VX-8R</a>
          <abbr class="published small" title="2010-01-11T23:01:42-0500">(January 11, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/why-haskell/" rel="bookmark">Why Haskell? The big question</a>
          <abbr class="published small" title="2010-01-08T12:00:03-0500">(January 8, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/rxvt-unicode-for-gnome-terminal-refugees/" rel="bookmark">rxvt-unicode for gnome-terminal refugees</a>
          <abbr class="published small" title="2010-01-06T12:00:24-0500">(January 6, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/audio-connectors/" rel="bookmark">Audio connectors and radios</a>
          <abbr class="published small" title="2010-01-04T12:00:50-0500">(January 4, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2010/01/adventures-in-three-monads/" rel="bookmark">Adventures in Three Monads</a>
          <abbr class="published small" title="2010-01-01T13:16:05-0500">(January 1, 2010)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2009/12/2010-roadmap/" rel="bookmark">2010: A Roadmap</a>
          <abbr class="published small" title="2009-12-31T00:12:36-0500">(December 31, 2009)</abbr>
        </li>
              <li>
          <a href="http://blog.ezyang.com/2009/12/iron-blogger/" rel="bookmark">Iron Blogger</a>
          <abbr class="published small" title="2009-12-28T14:20:54-0500">(December 28, 2009)</abbr>
        </li> */}
          </ul>

</div>


<div id="Vincent_Qin">
<h1>
<a href="https://vincentqin.tech/" className="site-title">Vincent_Qin &#39;s blog</a>
</h1>

        {/* <h1 className="vcard-names1 ">

                        <span className="p-name vcard-fullname d-block overflow-hidden" 
                        // itemprop="name"
                        >
                          Vincent_Qin &#39;s blog
                        </span>
                        <span className="p-nickname vcard-username d-block" 
                        //itemprop="additionalName"
                        >
                        

                        </span>
                        </h1> */}


<ul>
<li>🔭 I am currently working on SLAM.</li>
<li>🌱 I am currently learning SLAM and AI.</li>
<li>💬 Ask me about depth estimation/light filed/SLAM etc.</li>
<li>👯 I am looking to collaborate on repo <a target="_blank" rel="noopener" href="https://github.com/Vincentqyw/Recent-Stars-2020">Recent-Stars-2020</a></li>
<li>📫 How to reach me: vincentqin#hotmail.com (#-&gt;@)</li>
<li>⚡ Fun fact: I 🧡🐈</li>
</ul>


<section className="section-gap-Realcat-Vincentqyw">
<p>
Realcat Vincentqyw(<a href="https://github.com/Vincentqyw">https://github.com/Vincentqyw</a>) starred a repository on 13/5/25
  <br />
  <a href="https://github.com/ngxson/smolvlm-realtime-webcam">ngxson/smolvlm-realtime-webcam </a> (HTML) 3.2k STARS

</p>
</section>


<section className="section-gap-Realcat-Vincentqyw">
<p>
Realcat Vincentqyw(<a href="https://github.com/Vincentqyw">https://github.com/Vincentqyw</a>) starred a repository on 7/5/25
  <br />
  <a href="https://github.com/huggingface/nanoVLM">huggingface/nanoVLM </a> (Jupyter Notebook 79.9%, Python 20.1%) 961 STARS

</p>
<Huggingface_nanoVLM_Contributors_ContributorList />
<AndrésMarafioti /> 
<p>
  follows
</p> 
<OriolNieto />
<a href="https://www.urinieto.com/2017/02/deep-xor/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Tutorial - Deep XOR | Posts · 26/2/2017 · 1 minute 
    </a>
</section>


<section className="section-gap-Realcat-Vincentqyw">
<p>
Realcat Vincentqyw(<a href="https://github.com/Vincentqyw">https://github.com/Vincentqyw</a>) starred a repository on 3/5/25
  <br />
  <a href="https://github.com/skyzh/tiny-llm">skyzh/tiny-llm </a> (Python, C++) 1.8k STARS

</p>
</section>



<article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
        11-05
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://vincentqin.tech/posts/python-zip/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  📝Note: Python zip()
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article>
  <article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
        2018-05-16
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
            <a className="post-title-link" href="https://vincentqin.tech/posts/light-field-depth-estimation/" 
            // itemprop="url"
            
            >
              <span 
              // itemprop="name"
              >
                {/* <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"> */}
                    Light Field Depth Estimation
                    {/* </font></font> */}
                    </span>
            </a>
        </div>

     
      
    </header>
  </article>

  <article 
  // itemscope="" itemtype="http://schema.org/Article"
  >
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-05-01T02:28:39+08:00" content="2022-05-01"
        >
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
          01-05-2022
        {/* </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://vincentqin.tech/posts/instant-ngp/" //itemprop="url"
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
                📝Note: 5 seconds to train NeRF, NVIDIA Instant NeRF test
            {/* </font></font> */}
            </span>
          </a>
      </div>

      
    </header>
  </article>




  <article 
  // itemscope="" itemtype="http://schema.org/Article"
  >
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-05-01T02:28:39+08:00" content="2022-05-01"
        >
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
          18-08-2019
        {/* </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://vincentqin.tech/posts/slam-common-issues-ICP/" //itemprop="url"
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"> */}
                📝Note: SLAM FAQ (IV): Solve ICP and use SVD decomposition to get the rotation matrix
            {/* </font></font> */}
            </span>
          </a>
      </div>

      
    </header>
  </article>

</div>


<div id="Andrew_Tulloch">
<h1>
<a href="https://tullo.ch/" className="site-title">Andrew Tulloch &#39;s New blog</a>
</h1>
<h1>
<a href="https://ajtulloch.github.io/" className="site-title">Andrew Tulloch &#39;s Old blog</a>
</h1>

        {/* <h1 className="vcard-names1 ">

                        <span className="p-name vcard-fullname d-block overflow-hidden" 
                        // itemprop="name"
                        >
                          Vincent_Qin &#39;s blog
                        </span>
                        <span className="p-nickname vcard-username d-block" 
                        //itemprop="additionalName"
                        >
                        

                        </span>
                        </h1> */}

<article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
      3-10-2021
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://tullo.ch/articles/pytorch-gpu-inference-performance/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  Improving PyTorch inference performance on GPUs with a few simple tricks
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article>

<article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
        13-05-2014
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://tullo.ch/articles/lasso-estimator/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  The LASSO Estimator
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article>
 
  <article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
        27-10-2014
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://tullo.ch/articles/cambridge-mathematics-notes/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  Cambridge Part III Mathematics Notes
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article> 

  <div id="Andrew_Tulloch_Cambridge_Part_III">
      <div className="the-content">
        <section className="intro-content">
            <p>I've cleaned up (somewhat) my notes from Cambridge Part III and have put them online - with LaTeX sources available on 
            <a href="https://github.com/ajtulloch/CambridgeMathematicsPartIII">GitHub</a> and PDFs linked below.</p>

            <h3 id="advanced-financial-models" className="Andrew-Tulloch-H3">Advanced Financial Models</h3>
            <ul>
                <li><a href="/static/cambridge/AdvancedFinancialModels-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/AdvancedFinancialModels-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="advanced-probability" className="Andrew-Tulloch-H3">Advanced Probability</h3>
            <ul>
                <li><a href="/static/cambridge/AdvancedProbability-LectureNotes.pdf">Lecture Notes</a></li>
            </ul>

            <h3 id="applied-bayesian-statistics" className="Andrew-Tulloch-H3">Applied Bayesian Statistics</h3>
            <ul>
                <li><a href="/static/cambridge/AppliedBayesianStatistics-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="convex-optimization" className="Andrew-Tulloch-H3">Convex Optimization</h3>
            <ul>
                <li><a href="/static/cambridge/ConvexOptimization-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/ConvexOptimization-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="mathematics-of-operations-research" className="Andrew-Tulloch-H3">Mathematics Of Operations Research</h3>
            <ul>
                <li><a href="/static/cambridge/MathematicsOfOperationsResearch-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/MathematicsOfOperationsResearch-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="non-parametric-statistics" className="Andrew-Tulloch-H3">Non-Parametric Statistics</h3>
            <ul>
                <li><a href="/static/cambridge/NonParametricStatistics-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/NonParametricStatistics-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="percolation" className="Andrew-Tulloch-H3">Percolation</h3>
            <ul>
                <li><a href="/static/cambridge/Percolation-LectureNotes.pdf">Lecture Notes</a></li>
            </ul>

            <h3 id="ramsay-theory" className="Andrew-Tulloch-H3">Ramsay Theory</h3>
            <ul>
                <li><a href="/static/cambridge/RamsayTheory-LectureNotes.pdf">Lecture Notes</a></li>
            </ul>

            <h3 id="statistical-theory" className="Andrew-Tulloch-H3">Statistical Theory</h3>
            <ul>
                <li><a href="/static/cambridge/StatisticalTheory-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/StatisticalTheory-Summary.pdf">Summary</a></li>
            </ul>

            <h3 id="time-series-and-monte-carlo-analysis" className="Andrew-Tulloch-H3">Time Series and Monte Carlo Analysis</h3>
            <ul>
                <li><a href="/static/cambridge/TimeSeriesMonteCarlo-LectureNotes.pdf">Lecture Notes</a></li>
                <li><a href="/static/cambridge/TimeSeriesMonteCarlo-Summary.pdf">Summary</a></li>
            </ul>
        </section>
    </div>
</div>



</div>

<div id="m-clark">
<h1>
<a href="https://m-clark.github.io/about.html" className="site-title">Michael Clarke &#39;s blog</a>
</h1>


        {/* <h1 className="vcard-names1 ">

                        <span className="p-name vcard-fullname d-block overflow-hidden" 
                        // itemprop="name"
                        >
                          Vincent_Qin &#39;s blog
                        </span>
                        <span className="p-nickname vcard-username d-block" 
                        //itemprop="additionalName"
                        >
                        

                        </span>
                        </h1> */}
<p>From t-tests to deep learning, I&#39;ve covered a lot of ground in modeling, visualizing, and understanding data. I can provide inference for models on millions of observations, classify biomedical images to determine pathology, and scrape the web to explore political sentiment. What &#39;s more, I can help others understand the results and take appropriate action regarding them.</p>
<article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
      10-10-2022
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://m-clark.github.io/posts/2022-09-deep-linear-models/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  Deep Linear Models
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article>

<article 
// itemscope="" itemtype="http://schema.org/Article"
>
    <header className="post-header">
      <div className="post-meta-container">
        <time 
        // itemprop="dateCreated" datetime="2022-11-05T21:01:43+08:00" content="2022-11-05"
        >
        13-11-2021
          {/* <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">
          
        </font></font> */}
        </time>
      </div>

      <div className="post-title">
          <a className="post-title-link" href="https://m-clark.github.io/posts/2021-10-30-double-descent/" 
          // itemprop="url"
          
          >
            <span 
            // itemprop="name"
            >
              {/* <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;"> */}
                  Double Descent
                  {/* </font></font> */}
                  </span>
          </a>
      </div>

     
      
    </header>
  </article>
 
    

</div>

<div id="Hugo-Bowne-Anderson">

  <a href="https://hugobowne.github.io/#writing" className="vcard-names1">
    <h1>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        Hugo-Bowne-Anderson
      </span>
      <span className="p-nickname vcard-username d-block">
        data scientist - educator - writer - podcaster
      </span>
    </h1>
  </a>




<div className="row">
    <div className="col-sm-4">
        <img 
            src="https://hugobowne.github.io/img/hba-fb-live.jpeg" 
            alt="HBA FB Live" 
            className="img-responsive img-rounded center-block"
        />
    </div>
    <div className="col-sm-8">
        <h3>other initiatives</h3>
        <p>
            I'm interested in exploring other ways to teach and discuss data science, machine learning, and AI. To this end, I piloted a series of 
            <u>Facebook Live coding sessions</u> at DataCamp, which saw up to 40K unique viewers. Two of my favourites are 
            <a 
                href="https://www.datacamp.com/community/tutorials/tidyverse-tutorial-r" 
                className="link-primary"
            >
                Getting Started with the Tidyverse
            </a> through the Titanic data set and 
            <a 
                href="https://www.datacamp.com/community/tutorials/web-scraping-python-nlp" 
                className="link-primary"
            >
                Web Scraping &amp; NLP in Python
            </a>,  in which I scrape novels from the web and plot word frequency distributions.
        </p>
        <p>
            I enjoy <u>writing tutorials</u>. You can find a bunch I've written on 
            <a 
                href="https://www.datacamp.com/community/tutorials" 
                className="link-primary"
            >
                DataCamp's community page
            </a> by searching for my name. Here are a few to get started with:
        </p>
        <p>
            <a 
                className="btn btn-primary" 
                href="https://www.datacamp.com/community/tutorials/pandas-split-apply-combine-groupby"
            >
                Groupby, split-apply-combine and pandas 
                <span className="glyphicon glyphicon-chevron-right"></span>
            </a>
            <a 
                className="btn btn-primary" 
                href="https://www.datacamp.com/community/tutorials/pandas-multi-index"
            >
                Hierarchical indices, groupby and pandas 
                <span className="glyphicon glyphicon-chevron-right"></span>
            </a>
            <a 
                className="btn btn-primary" 
                href="https://www.datacamp.com/community/tutorials/preprocessing-in-data-science-part-1-centering-scaling-and-knn"
            >
                Preprocessing in Data Science (Part 1)
                <span className="glyphicon glyphicon-chevron-right"></span>
            </a>
            <a 
                className="btn btn-primary" 
                href="https://www.datacamp.com/community/tutorials/preprocessing-in-data-science-part-2-centering-scaling-and-logistic-regression"
            >
                Preprocessing in Data Science (Part 2)
                <span className="glyphicon glyphicon-chevron-right"></span>
            </a>
            <a 
                className="btn btn-primary" 
                href="https://www.datacamp.com/community/tutorials/preprocessing-in-data-science-part-3-scaling-synthesized-data"
            >
                Preprocessing in Data Science (Part 3)
                <span className="glyphicon glyphicon-chevron-right"></span>
            </a>
        </p>
        <p>
            I'm constantly thinking about <u>how data science notebook technologies can be used to design productive educational environments</u>. You can check out Eric Ma's and my interactive Jupyter notebooks for our Bayesian data science workshops 
            <a 
                href="https://gke.mybinder.org/v2/gh/ericmjl/bayesian-stats-modelling-tutorial/master" 
                className="link-primary"
            >
                here on Binder
            </a> (more context in the GitHub repo 
            <a 
                href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial" 
                className="link-primary"
                style={{ fontSize: '2.5rem', fontWeight: 'bold' }}
            >
                here
            </a>). I also built a DataCamp project that leverages the capabilities of Jupyter notebooks to create a novel educational experience: it's called 
            <a 
                href="https://www.datacamp.com/projects/38" 
                className="link-primary"
            >
                "Word Frequency in Moby Dick"
            </a> and in it, you'll get to scrape the novel Moby Dick from the website Project Gutenberg (which contains a large corpus of books), extract words from it, and dive into analyzing the distribution of words using the Natural Language Toolkit (nltk).
        </p>
        <p>
            I've given a lot of <u>webinars for business leaders, managers, and learning and development leaders across several verticals</u>. Highlights include:
            <a 
                href="https://support.datacamp.com/hc/en-us/articles/360008278474-August-2018-Webinar-What-Managers-Need-To-Know-About-Machine-Learning" 
                className="link-primary"
            >
                What Managers Need To Know About Machine Learning
            </a>, 
            <a 
                href="https://support.datacamp.com/hc/en-us/articles/360006341254-June-2018-Webinar-Inside-the-Data-Science-Workflow" 
                className="link-primary"
            >
                Inside the Data Science Workflow
            </a> and 
            <a 
                href="https://support.datacamp.com/hc/en-us/articles/360013643274-Dec-2018-Webinar-Data-Literacy-in-the-21st-Century" 
                className="link-primary"
            >
                Data Literacy in the 21st Century
            </a>.
        </p>
    </div>
</div>


{/* <div className="row">
                <div className="col-sm-4">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/0pZc5u3e884"></iframe>
                    </div>
                </div>
                <div className="col-sm-8">
                    <h3>Bayesian Data Science by Simulation</h3>
                    <p>PyCon 2019 Tutorial</p>
                    <p>This tutorial was an Introduction to Bayesian data science through the lens of simulation or hacker statistics. Learners became familiar with many common probability distributions through i) matching them to real-world stories &amp; ii) simulating them. They worked with joint/conditional probabilities, Bayes Theorem, prior/posterior distributions and likelihoods, while seeing their applications in real-world data analyses. They then saw the utility of Bayesian inference in parameter estimation and comparing groups and we wrapped up with a dive into the wonderful world of probabilistic programming using PyMC3.</p>
                    <a className="btn btn-primary" href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial">Tutorial material<span className="glyphicon glyphicon-chevron-right">
                    </span></a>
                </div>
            </div> */}

{/* 
            <div className="row hugo bowne-anderson-SelectedTalks">
    // <!-- Video on the left, 4 columns wide --> 
    <div className="col-sm-4">
        <div className="embed-responsive embed-responsive-16by9">
            <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/0pZc5u3e884"></iframe>
        </div>
    </div>
    
    // <!-- Description on the right, 8 columns wide --> 
    <div className="col-sm-8">
        <h3>Bayesian Data Science by Simulation</h3>
        <p>PyCon 2019 Tutorial</p>
        <p>This tutorial was an Introduction to Bayesian data science through the lens of simulation or hacker statistics. Learners became familiar with many common probability distributions through i) matching them to real-world stories &amp; ii) simulating them. They worked with joint/conditional probabilities, Bayes Theorem, prior/posterior distributions and likelihoods, while seeing their applications in real-world data analyses. They then saw the utility of Bayesian inference in parameter estimation and comparing groups and we wrapped up with a dive into the wonderful world of probabilistic programming using PyMC3.</p>
        <a className="btn btn-primary" href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial">Tutorial material<span className="glyphicon glyphicon-chevron-right"></span></a>
    </div>
</div> 
*/}
<h2>Selected Talks</h2>
<div className="hugo bowne-anderson-SelectedTalks">
                <div className="col-sm-4">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/89ye2hfsAsk"></iframe>
                    </div>
                </div>
                <div className="col-sm-8">
                    <h3>Bayesian Data Science Two Ways: Simulation and Probabilistic Programming </h3>
                    <p>SciPy 2018 Tutorial</p>
                    <p>This was a tutorial that I co-taught with Eric Ma to build participants&#39; knowledge of Bayesian inference, workflows and decision making under uncertainty. We started with the basics of probability via simulation and analysis of real-world datasets, building up to an understanding of Bayes&#39; theorem. We then introduced the use of probabilistic programming to do statistical modelling. Throughout this tutorial, we used a mixture of instructional time and hands-on time. During instructional time, we used a variety of datasets to anchor our instruction; during hands-on time, which immediately followed instructional time, our participants applied the concepts learned to <a href="https://datadryad.org/resource/doi:10.5061/dryad.g6g3h" style={{color: 'rgb(0, 0, 150)'}}>the Darwin&#39;s finches dataset</a>, which permeated the entire tutorial. </p>
                    <a className="btn btn-primary" href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial">Tutorial material<span className="glyphicon glyphicon-chevron-right">
                    </span></a>
                </div>
            </div>

            <div className="hugo bowne-anderson-SelectedTalks">
    <div className="col-sm-4">
        <div className="embed-responsive embed-responsive-16by9">
            <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/0pZc5u3e884"></iframe>
        </div>
    </div>
    <div className="col-sm-8">
        <h3>Bayesian Data Science by Simulation</h3>
        <p>PyCon 2019 Tutorial</p>
        <p>This tutorial was an Introduction to Bayesian data science through the lens of simulation or hacker statistics. Learners became familiar with many common probability distributions through i) matching them to real-world stories &amp; ii) simulating them. They worked with joint/conditional probabilities, Bayes Theorem, prior/posterior distributions and likelihoods, while seeing their applications in real-world data analyses. They then saw the utility of Bayesian inference in parameter estimation and comparing groups and we wrapped up with a dive into the wonderful world of probabilistic programming using PyMC3.</p>
        <a className="btn btn-primary" href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial">Tutorial material<span className="glyphicon glyphicon-chevron-right"></span></a>
    </div>
</div>


<div id="robconery_github_repo">



</div>


<div id="bayesian-stats-modelling-tutorial">

</div>
<div className="a row pr-2" style={{ padding: '.75em 1em' }}>
    <div className="col-sm-12">
        <div className="col-sm-12 col-lg-4 mt-6">
            <div className="rob-conery-card card shadow h-100" style={{ border: '2px solid black', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' 
             // Add shadow here 
             }}>
                <div className="Box d-flex p-3 width-full public source">
                    <div className="pinned-item-list-item-content">
                        <div className="d-flex width-full position-relative">
                            <div className="flex-1">
                                <svg
                                    aria-hidden="true"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    version="1.1"
                                    width="16"
                                    data-view-component="true"
                                    className="octicon octicon-repo mr-1 color-fg-muted"
                                >
                                    <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"></path>
                                </svg>
                                <span data-view-component="true" className="position-relative">
                                    <a
                                        href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial"
                                        className="Link mr-1 text-bold wb-break-word"
                                        aria-labelledby="tooltip-6baf9a22-427b-4407-9260-e2fbc25d7c37"
                                        style={{ textDecoration: 'underline' }} // Example of underlined link
                                    >
                                        <span className="repo">bayesian-stats-modelling-tutorial</span>
                                    </a>
                                    <span></span>
                                    <span className="Label Label--attention v-align-middle mt-1 no-wrap v-align-baseline Label--inline">
                                        Public 
                                    </span>
                                </span>

                                <p className="pinned-item-desc color-fg-muted text-small mt-2 mb-0">
                                How to do Bayesian statistical modelling using numpy and PyMC3
                                </p>

                                <p className="mb-0 mt-2 f6 color-fg-muted">
                                    <a href="https://github.com/ericmjl/bayesian-stats-modelling-tutorial" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="stars"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-star"
                                        >
                                            <path d="M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"></path>
                                        </svg>
                                        659
                                    </a>
                                    <a href="https://github.com/robconery/pg_docs_api/forks" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="forks"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-repo-forked"
                                        >
                                            <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"></path>
                                        </svg>
                                        279
                                    </a>
                                </p>

                                <p dir="auto">Jupyter Notebook</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



</div>

<div id="@sanjeevs_iitr">
<a href="https://sanjeevsharma.ai/" className="vcard-names1">
    <h1>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        Sanjeev Sharma </span>
      <span className="p-nickname vcard-username d-block">
       I'm an Entreprenuer| Researcher
      </span>
    </h1>
    <h3>
    As the founder of Swaayatt Robots and Deep Eigen, I focus on developing cutting-edge algorithms for autonomous vehicles, enabling them to navigate highly complex and unpredictable environments.
    </h3>
  </a>


<div id="row">
<TwitterTweetEmbed tweetId="1827230702095495328"  />
  
</div>
    

</div>

<div id="@KanakaRajanPhD">
<a href="https://www.rajanlab.com/resources" className="vcard-names1">
    <h1>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Kanaka Rajan </span>
      <span className="p-nickname vcard-username d-block">
       I'm an Entreprenuer| Researcher
      </span>
    </h1>
    <h3>
   
    </h3>
  </a>
 
  <p>Both lectures are available on the COSYNE YouTube channel (see lecture title links) under a Creative Commons license. To request access to the lecture slides, please email: <a href="mailto:kanaka_rajan@hms.harvard.edu">kanaka_rajan@hms.harvard.edu</a> &amp; <a href="mailto:kanaka-admin@stellatecomms.com">kanaka-admin@stellatecomms.com</a></p>
{/* <ul role="list">
  <li>
  <a href="https://colab.research.google.com/drive/1JUqsVxFhPYy6XsqHOvD0JzbXyIyOsxXN?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Julia</a> solution script</li>
  <li><a href="https://drive.google.com/drive/folders/1inwMSHnld_50oAx0ohdnepIHqCM5NorL?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>MATLAB solution scripts</a>
    <ul role="list">
      <li><a href="https://drive.google.com/file/d/1eXF8Xgv6DJsZuJd1oMdq6rNZi6b-FZO0/view?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Problem 3: train RNN (generate data)</a>
      </li>
    </ul>
  </li>
    <li>Python:
      <ul role="list">
            <li><a href="https://colab.research.google.com/drive/1mhhGJ0QlwwyCj7me891tqN06QrAWxHni?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Problem 1</a></li>
          <li><a href="https://colab.research.google.com/drive/1KK-6DhjIfPy87VaMcfeETy9USwRhfhvY?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Problem 2</a></li>
          <li><a href="https://colab.research.google.com/drive/1OyW3xiW3BbvY2JsTBauj2_Cb2fIClchU?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Problem 3</a> and <a href="https://drive.google.com/file/d/13kMPt-ayxRrJGhfdGHgLNvltdLAV6nzK/view?usp=sharing" target="_blank"  style={{textDecoration: 'underline' }}>Problem 3 data.mat</a>
        </li>
      </ul>
    </li>
</ul> */}
<div className="rob-conery-card card shadow h-100" 
     style={{
        border: '2px solid black',  // Black border for the card
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',  // Shadow effect
        padding: '1em',  // Padding inside the card for spacing
        borderRadius: '8px',  // Optional: Rounded corners for a smoother look
        backgroundColor: '#fff'  // White background for the card
    }}>

  <p className="text-size-regular">If you &#39;d like to deepen your understanding of recurrent neural networks, I encourage you to <a href="https://drive.google.com/file/d/15xhRdgyyLB2YQNDvWybtAW0-Gazyg3v0/view" target="_blank"   className="link-primary"
                style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>complete a problem set</a> created in collaboration with the COSYNE Tutorial TAs. The problem set has detailed instructions and questions to work through. Problems 1 and 2 are intermediate and should be done after watching Lecture 1; Problem 3 is advanced and should be done after watching Lecture 2. Solutions are available in Julia, MATLAB, and Python.</p>
  <h3>Solution Scripts</h3>
  <ul role="list" style={{ listStyleType: 'none', paddingLeft: '0' }}>
    <li>
      <a 
        href="https://colab.research.google.com/drive/1JUqsVxFhPYy6XsqHOvD0JzbXyIyOsxXN?usp=sharing" 
        target="_blank"  
        style={{ textDecoration: 'underline' }}>
        Julia solution script
      </a>
    </li>
    <li>
      <a 
        href="https://drive.google.com/drive/folders/1inwMSHnld_50oAx0ohdnepIHqCM5NorL?usp=sharing" 
        target="_blank"  
        style={{ textDecoration: 'underline' }}>
        MATLAB solution scripts
      </a>
      <ul role="list" style={{ listStyleType: 'none', paddingLeft: '20px' }}>
        <li>
          <a 
            href="https://drive.google.com/file/d/1eXF8Xgv6DJsZuJd1oMdq6rNZi6b-FZO0/view?usp=sharing" 
            target="_blank"  
            style={{ textDecoration: 'underline' }}>
            Problem 3: train RNN (generate data)
          </a>
        </li>
      </ul>
    </li>
    <li>
      Python:
      <ul role="list" style={{ listStyleType: 'none', paddingLeft: '20px' }}>
        <li>
          <a 
            href="https://colab.research.google.com/drive/1mhhGJ0QlwwyCj7me891tqN06QrAWxHni?usp=sharing" 
            target="_blank"  
            style={{ textDecoration: 'underline' }}>
            Problem 1
          </a>
        </li>
        <li>
          <a 
            href="https://colab.research.google.com/drive/1KK-6DhjIfPy87VaMcfeETy9USwRhfhvY?usp=sharing" 
            target="_blank"  
            style={{ textDecoration: 'underline' }}>
            Problem 2
          </a>
        </li>
        <li>
          <a 
            href="https://colab.research.google.com/drive/1OyW3xiW3BbvY2JsTBauj2_Cb2fIClchU?usp=sharing" 
            target="_blank"  
            style={{ textDecoration: 'underline' }}>
            Problem 3
          </a> 
          and 
          <a 
            href="https://drive.google.com/file/d/13kMPt-ayxRrJGhfdGHgLNvltdLAV6nzK/view?usp=sharing" 
            target="_blank"  
            style={{ textDecoration: 'underline' }}>
            Problem 3 data.mat
          </a>
        </li>
      </ul>
    </li>
  </ul>



</div>

<div id="row">
<TwitterTweetEmbed tweetId="1846965942422507703"  />
   
</div>

<div id="@j0hnparkhill">

<a href="#@j0hnparkhill" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            John Parkhill </span>
            <span className="p-nickname vcard-username d-block">
            ML, director of machine learning Terray Therapeutics (https://x.com/Terray_Tx).
            </span>
          </h1>
        </a>

<h3>
  <a href="https://x.com/memming/following" target="_blank" rel="noopener noreferrer">
    Followings of @memming on X
  </a>
</h3>


<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/_Jaivardhan_" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Jaivardhan Kapoor</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/_Jaivardhan_" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@_Jaivardhan_</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @_Jaivardhan_" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow _Jaivardhan_
    </div>
  </div>
</div>


<h3>
  <a href="https://x.com/_Jaivardhan_/following" target="_blank" rel="noopener noreferrer">
    Followings of @_Jaivardhan_ on X
  </a>
</h3>


<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/tarantulae" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Christian S. Perone</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/tarantulae" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@tarantulae</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @_Jaivardhan_" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow tarantulae
    </div>
  </div>
</div>



<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/sedielem" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Sander Dieleman</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/sedielem" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@sedielem</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @_Jaivardhan_" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow sedielem
    </div>
  </div>
</div>


<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/j0hnparkhill" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>johnparkhill</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/j0hnparkhill" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@j0hnparkhill</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @_Jaivardhan_" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow j0hnparkhill
    </div>
  </div>
</div>



<div 
  dir="auto" 
  className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-1h8ys4a r-1jeg54m" 
  style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}
>
  <span 
    className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" 
    style={{ textOverflow: 'unset' }}
  >
    ML, director of machine learning at Terray Therapeutics (
  </span>
  <a 
    dir="ltr" 
    href="https://x.com/Terray_Tx" 
    role="link" 
    className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1loqt21" 
    style={{ textOverflow: 'unset', color: 'rgb(29, 155, 240)' }}
  >
    <span 
      aria-hidden="true" 
      className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-qlhcfr r-qvk6io" 
      style={{ textOverflow: 'unset' }}
    >
      https://
    </span>
    x.com/Terray_Tx
  </a>
  <span 
    className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" 
    style={{ textOverflow: 'unset' }}
  >
    ). Father. NSF CAREER award giver-upper. Gibe and gambol enjoyer.
  </span>
</div>

<ul className="post-list">
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 19, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/CoinHedge/">
        Coin Vol-II Hedging your BTC/ETH - The basics
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 13, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/memecoin/">
        Coin Volatility Surfaces
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Sep 5, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/cryptocarrytrade/">
        The Crypto-Carry Trade
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Aug 5, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/quantumstorytelling/">
        Woo, Quantum Storytelling, Time Crystals and Misallocation
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">May 30, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/torchSDE/">
        Pricing Options with TorchSDE
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Apr 30, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/SolvingDiffusions/">
        Solving multidimensional PDEs in pytorch
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Apr 7, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/HoldingVIX/">
        Using simple mean-reversion to remove carry from a VIX futures position
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Mar 11, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuittingAAPL/">
        Moving on from the Macbook Pro
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Mar 6, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/InformationInStochasticSeries/">
        Simply Extracting information out of your Stochastic Series
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Jan 6, 2021</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/MultivariateGumbel/">
        Copulas made simple with Pytorch Distributions
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Dec 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/HowToBet/">
        How to Size Bets. The Kelly Criterion in PyTorch
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Nov 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/TheMostUseful3DP/">
        The #1 Reason to have a 3D Printer.
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Oct 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/MakeScienceGreatAgain/">
        Modest Proposals to Make Science Great Again.
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Sep 21, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/SomeArt/">
        Some Robot Art
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Sep 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuaternionAveraging/">
        Quaternion Averaging in Pytorch
      </a>
    </h3>
  </li>
  <li style={{ marginBottom: '8px' }}> 
    <span className="post-meta">Aug 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/welcome-to-jekyll/">
        Yet another static blog!
      </a>
    </h3>
  </li>
</ul>


<li style={{ marginBottom: '8px' }}>
    <span className="post-meta">Sep 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuaternionAveraging/">
        Quaternion Averaging in Pytorch: Detailed Page
      </a>
    </h3>
  </li>

  <p>At atomsandbits.ai we implement some seriously large formulas in TensorFlow. If we just went from LaTeX to tf. we wouldn&#39;t be able to do it. Here&#39;s a list of tricks and tools we use, applied to the problem of averaging rotations. Come for the tf. stay for the hypersphere.</p>
  <p>The tensormol0.2 model chemistry reproduces a huge swath of chemistry (37 elements), which is in some sense a large fraction of our world. It&#39;s a big ole&#39; formula for some geometry:</p>

  <p><img src="/assets/tensormol.png" alt="TensorMol"></img></p>

  {/* <p><img src="https://drive.google.com/file/d/1nVDhSeA60emakzFdNo9qY8gCawcI-lza/view?usp=drive_link" alt="tm"></img></p>
  <p><img src="https://drive.google.com/uc?export=view&id=1nVDhSeA60emakzFdNo9qY8gCawcI-lza" alt="tm"></img></p> */}
<p>How does one use TensorFlow effectively to get something complicated done? It&#39;s not easy. I thought I&#39;d write up an example a little simpler than modeling all of chemistry. How about averaging rotations/axis systems? Simple right? Well interesting story… The math is mostly due to Hamilton (~1843), however it wasn’t until the advent of computer graphics in 1985 that people even bothered to work out how to interpolate between rotations perfectly.</p>
<p>#Rotation &amp; Quaternions</p>

<p>The rotational algebra of our world is a beautiful bedeviling thing. The reason is that although rotations act on a three dimensional space, when embedded in three dimensions, rotations are not smooth or unique. When represented with Euler angles or matrices, every rotation has multiple representations. Change the order of rotations and you also change the endpoint (rotations are non-commutative) Traveling smoothly along some paths of rotations using a three dimensional embedding, suddenly the third degree of freedom can become inaccessible (the phenomenon of “Gimbal lock”). If you try to define an average or interpolated point-of-view in a naive way (axes=&gt; angles =&gt; interpolated angles) you will find gibberish zero axes, and jerky non-smooth behavior.</p>
<blockquote>
  <p className="custom-blockquote-John-Parkhill-Blog">The rotational algebra of our world is a beautiful bedeviling thing. The reason is that although rotations act on a three dimensional space, when embedded in three dimensions, rotations are not smooth or unique. When represented with Euler angles or matrices, every rotation has multiple representations. Change the order of rotations and you also change the endpoint (rotations are non-commutative) Traveling smoothly along some paths of rotations using a three dimensional embedding, suddenly the third degree of freedom can become inaccessible (the phenomenon of “Gimbal lock”). If you try to define an average or interpolated point-of-view in a naive way (axes=&gt; angles =&gt; interpolated angles) you will find gibberish zero axes, and jerky non-smooth behavior.</p>
</blockquote>
<p>To have smooth topology rotations must be embedded within a four-dimensional hypersphere, so we can forgive your brain. In this space a rotation is a 4-dimensional point, a quaternion, whose components can be thought of as the angle and 3 axis components of the rotation. Given a 3x3 rotation matrix Q, one can parameterize a quaternion (w,x,y,z)</p>
<p className="-John-Parkhill-Blog">
  To have smooth topology rotations must be embedded within a four-dimensional hypersphere, so we can forgive your brain. In this space a rotation is a 4-dimensional point, a quaternion, whose components can be thought of as the angle and 3 axis components of the rotation. Given a 3x3 rotation matrix Q, one can parameterize a quaternion (w,x,y,z).
</p>
<p><img src="/assets/quat2.png" alt="qm"/></p>


<p>Given any set of orthogonal axes (rows of Q), Euler&#39;s theorem guarantees an axis-angle rotation which can map the natural xyz axes back and forth into the new frame. The formula above yields the natural 4-d form of that rotation.</p>
<p>Now suppose you have two, three or four systems of axes (ax_1, ax_2, ax_3). For example you want to look at the sun then the moon, or you want to fit 4 pretty objects in your field of vision, or define invariant axes for a cloud of points (the reason we use this math in TensorMol). Can you simply average the quaternion components q_av = (ax_1+ax_2+ax_3)/3? Sadly no… You can immediately understand why if you imagine averaging rotations around opposite axis vectors as an owl might when spinning his head. The “good, smooth” quaternions keep to the surface of the 4-d hypersphere (a curvy subset of 4d-euclidean space). To interpolate lines on that sphere, you can use SLERP. To average multiple quaternions we must construct the 4x4 matrix which is the outer product of the list of quaternions (Nx4) with itself, weighted if desired:</p>
<John_Parkhill_MathMLComponent_1 />
<p>The largest eigenvector of this matrix is the desired average quaternion.</p>

<h1 id="implementing-complex-math-in-tf">Implementing complex math in tf.</h1>
<p>Again, my goal is to get rotationally invariant axes for a set of points which smooth, differentiable and local. I will walk through my whole implementation of this in tf.
Step 1- Don&#39;t use tf. Write a simple test of your formulas in a notebook like math interface (mathematica, ipython/sage). Verify everything is working when you use all the fancy library routines tf. doesn&#39;t have (eigenvectors etc.). Here&#39;s what that looks like using mathematica.</p>
<p><img src="/assets/quatrot.png" alt="qmrr"/></p>

<p>Those fancy manipulate sliders are a nice way to get tangible faith that the point cloud is rotationally invariant when transformed using an averaged axis system depending on points in the cloud. It remains for us to do this same thing in tf. Were&#39; ready for step 2:</p>
<script src="https://gist.github.com/krishnakurtakoti/f1226b9efe7b7a0a639bd77d166fbd92.js"></script>
{/* <Slerp_for_quaternions_in_TF /> */}
<Slerp_for_quaternions_in_TF_copy />
{/* <Slerp_for_quaternions_in_TF_copy1 /> */}

<p>Style notes about the tf. code given above:</p>


<ul>
  <li>Each routine can be easily compared with the mathematica output, to quickly debug.</li>
  <li>In general it is best to choose an order of dimensions for your tensor which goes (least often contracted,…,most often contracted), because several helpful tf. functions assume the first dimension of a tensor is the batch dimension.</li>
  <li>tf.sqrt, and 1/(tensor) are both unstable operations in tf. They are unstable in a tricky way, because the implied chain-rule derivative graph (coming from tf.gradients(… op…, var) will still often evaluate NaN’s even when it appears that the arguments to the routine would always be in the well-behaved domain. One must make liberal use of tf.clip_by_value() , tf.where(), and infinitesimals to ensure both the routine and routine’s derivatives are well-behaved. Safe_norm is a good example.</li>
</ul>

<h1 id="epilogue">Epilogue</h1>

<p>So is all this serious rotational mathematics only good for defining axis systems for atomic positions. No! Facebook AI-Research and collaborators from the EPFL published a nice use of quaternions for skeletal motion planning <a href="https://arxiv.org/abs/1805.06485">last week</a></p>

</div>



<div id="@tarantulae">
<a href="https://x.com/tarantulae" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Christian S. Perone </span>
            <span className="p-nickname vcard-username d-block">
            / Machine Learning  (@polymtl/@UMontreal)
            </span>
          </h1>
        </a>
          
        <ul className="christianperone-list">
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/11/the-geometry-of-data-part-ii/">The geometry of data: the missing metric tensor and the Stein score [Part II]</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/08/torch-titan-distributed-training/">Torch Titan distributed training code analysis</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/08/mmap-torch-np-jax-tf/">Memory-mapped CPU tensor between Torch, Numpy, Jax and TensorFlow</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/06/schematism/">Generalisation, Kant’s schematism and Borges’ Funes el memorioso – Part I</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/12/pytorch-2-internals-talk/">PyTorch 2 Internals – Talk</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/09/thoughts-on-riemannian-metrics-and-its-connection-with-diffusion-score-matching-part-i/">Thoughts on Riemannian metrics and its connection with diffusion/score matching [Part I]</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/06/appreciating-llms-data-pipelines/">Large language model data pipelines and Common Crawl (WARC/WAT/WET)</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2023/03/feste-composing-nlp-tasks-with-automatic-parallelization-and-batching/">Feste: composing NLP tasks with automatic parallelization and batching</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/11/couple-of-recent-publications-in-uncertainty-estimation-and-autonomous-vehicles/">Couple of recent publications in uncertainty estimation and autonomous vehicles</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2024/05/dados-das-enchentes-no-rio-grande-do-sul-rs-em-2024/">[pt-br] Dados das enchentes no Rio Grande do Sul (RS) em 2024</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/09/tutorial-on-using-llvm-to-jit-pytorch-fx-graphs-to-native-code-x86-arm-risc-v-wasm-part-i-scalars/">Tutorial on using LLVM to JIT PyTorch fx graphs to native code (x86/arm/risc-v/w...)</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2022/01/arduino-wan-helium-network-and-cryptography/">Arduino WAN, Helium network and cryptographic co-processor</a>
    </li>
    <li className="christianperone-item">
        <a href="https://blog.christianperone.com/2021/03/episuite-epidemiology-in-python/">Episuite: epidemiology in Python</a>
    </li>
</ul>

</div>


<div id="@gdb">
<a href="https://x.com/gdb" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Greg Brockman </span>
            <span className="p-nickname vcard-username d-block">
            President & Co-Founder @OpenAI
            </span>
          </h1>
        </a>



        <a href="https://gregbrockman.com/" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Greg Brockman's Blog </span>
            {/* <span className="p-nickname vcard-username d-block">
            President & Co-Founder @OpenAI
            </span> */}
          </h1>
        </a>


        <article id="u5TReR2cWsQifoMYSHMtAg" className="post user_show">
    <time 
    // datetime="2019-07-30" 
    className="article_time">Jul 30, 2019</time>
    <h1 className="article_title"><a href="https://blog.gregbrockman.com/how-i-became-a-machine-learning-practitioner">How I became a machine learning practitioner</a></h1>
    <a href="https://blog.gregbrockman.com/how-i-became-a-machine-learning-practitioner" className="content">
    <p>For the first three years of OpenAI, I dreamed of becoming a machine learning expert but made little progress towards that goal. Over the past nine months, I&#39;ve finally made the transition to being a machine learning practitioner. It was hard but not impossible, and I think most people who are good programmers and know (or are willing to learn) the math can do it too. There are many online courses to self-study the technical side, and what turned out to be my biggest blocker was a mental barrier — getting ok with being a beginner again.</p>
<p className="bleed_image">
  <img src="https://svbtleusercontent.com/dvwQxNxkr6FKLVsDTBoqwm0xspap_small.png" alt="gdb-ml1.png" className="bleed" data-rjs="https://svbtleusercontent.com/dvwQxNxkr6FKLVsDTBoqwm0xspap_retina.png"></img></p><p><em>Studying machine learning during the 2018 holiday season.</em></p>
<h1>Early days 
</h1>
<p>A founding principle of OpenAI is that we value research and engineering equally&nbsp;—&nbsp;our goal is to build working systems that solve previously impossible tasks, so we need both. (In fact, our team is comprised of 25% people primarily using software skills, 25% primarily using machine...</p></a>
    <p className="continue_mark"><a href="https://blog.gregbrockman.com/how-i-became-a-machine-learning-practitioner" className="buttonize outline small">Continue reading →</a></p>
  </article>

  <h1 id="early-days_1">Early days <a className="head_anchor" href="#early-days_1">#</a></h1>

  <p>A founding principle of OpenAI is that we value research and engineering equally&nbsp;—&nbsp;our goal is to build working systems that solve previously impossible tasks, so we need both. (In fact, our team is comprised of 25% people primarily using software skills, 25% primarily using machine learning skills, and 50% doing a hybrid of the two.) So from day one of OpenAI, my software skills were always <a href="https://blog.gregbrockman.com/define-cto-openai#gym_1">in demand</a>, and I kept procrastinating on picking up the machine learning skills I wanted.</p>
  <p>After helping build <a href="https://openai.com/blog/openai-gym-beta/">OpenAI Gym</a>, I was called to work on <a href="https://openai.com/blog/universe/">Universe</a>. And as Universe was winding down, we decided to start working on <a href="https://openai.com/five/#timeline">Dota</a> — and we needed someone to turn the game into a reinforcement learning environment before any machine learning could begin.</p>
  <h1 id="dota_1">Dota <a className="head_anchor" href="#dota_1">#</a></h1>



  <h1 id="time-out_1">Time out <a className="head_anchor" href="#time-out_1">#</a></h1>
  <p>After we lost two games in The International in 2018, most observers thought we&#39;d <a href="https://twitter.com/polynoamial/status/1032988066967965696">topped out</a> what our approach could do. But we knew from our metrics that we were right on the edge of success and mostly needed more training. This meant the demands on my time had relented, and in November 2018, I felt I had an opening to take a gamble with three months of my time.</p>
  <p className="gregbrockman-p"><em>I learn best when I have something specific in mind to build.</em> I decided to try building a chatbot. I started self-studying the curriculum we developed for our <a href="https://openai.com/blog/openai-fellows/">Fellows</a> program, selecting only the NLP-relevant modules. For example, I wrote and trained an LSTM language model and then a Transformer-based one. I also read up on topics like <a href="https://colah.github.io/posts/2015-09-Visual-Information/">information theory</a> and read many papers, poring over each line until I fully absorbed it.</p>

  <p><em>I learn best when I have something specific in mind to build.</em> I decided to try building a chatbot. I started self-studying the curriculum we developed for our <a href="https://openai.com/blog/openai-fellows/">Fellows</a> program, selecting only the NLP-relevant modules. For example, I wrote and trained an LSTM language model and then a Transformer-based one. I also read up on topics like <a href="https://colah.github.io/posts/2015-09-Visual-Information/">information theory</a> and read many papers, poring over each line until I fully absorbed it.</p>

  <p className="gregbrockman-p">It was slow going, but this time I expected it. I didn&#39;t experience flow state. I was reminded of how I&#39;d felt when I just started programming, and I kept thinking of how many years it had taken to achieve a feeling of mastery. I honestly wasn&#39;t confident that I would ever become good at machine learning. But I kept pushing because… well, honestly because I didn&#39;t want to be constrained to only understanding one part of my projects. I wanted to see the whole picture clearly.</p>

  <p>It was slow going, but this time I expected it. I didn&#39;t experience flow state. I was reminded of how I&#39;d felt when I just started programming, and I kept thinking of how many years it had taken to achieve a feeling of mastery. I honestly wasn&#39;t confident that I would ever become good at machine learning. But I kept pushing because… well, honestly because I didn&#39;t want to be constrained to only understanding one part of my projects. I wanted to see the whole picture clearly.</p>


  <p className="gregbrockman-p">One important conceptual step was overcoming a barrier I&#39;d been too timid to do with Dota: make substantive changes to someone else&#39;s machine learning code. I fine-tuned <a href="https://github.com/openai/finetune-transformer-lm">GPT-1</a> on chat datasets I&#39;d found, and made a small change to add my own naive sampling code. But it became so painfully slow as I tried to generate longer messages that my frustration overwhelmed my fear, and I implemented GPU caching — a change which touched the entire model.</p>


  <p>One important conceptual step was overcoming a barrier I&#39;d been too timid to do with Dota: make substantive changes to someone else&#39;s machine learning code. I fine-tuned <a href="https://github.com/openai/finetune-transformer-lm">GPT-1</a> on chat datasets I&#39;d found, and made a small change to add my own naive sampling code. But it became so painfully slow as I tried to generate longer messages that my frustration overwhelmed my fear, and I implemented GPU caching — a change which touched the entire model.</p>

  <p className="gregbrockman-p">I had to try a few times, throwing out my changes as they exceeded the complexity I could hold in my head. By the time I got it working a few days later, I realized I&#39;d learned something that I would have previously thought impossible: I now understood how the whole model was put together, down to small stylistic details like how the codebase elegantly handles TensorFlow variable scopes.</p>


  <p>I had to try a few times, throwing out my changes as they exceeded the complexity I could hold in my head. By the time I got it working a few days later, I realized I&#39;d learned something that I would have previously thought impossible: I now understood how the whole model was put together, down to small stylistic details like how the codebase elegantly handles TensorFlow variable scopes.</p>

</div>


<div id="goyal__pramod">
<TwitterTweetEmbed tweetId="1874379586714341803"  />
   
</div>

<div id="@GrantSlatton">
{/* <a href="https://x.com/GrantSlatton" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Grant Slatton </span>
              <span className="p-nickname vcard-username d-block">
                Formerly built the world's fastest filesystem at AWS, now the fastest spreadsheet at http://rowzero.com
              </span>
            </h1>
          </a> */}


          <a href="https://x.com/GrantSlatton" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Grant Slatton </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>Formerly built the world's fastest filesystem at AWS, now the fastest spreadsheet at http://rowzero.com</h3>
          </a>
          
        <a href="https://grantslatton.com/" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Grant Slatton's Blog </span>
            {/* <span className="p-nickname vcard-username d-block">
            President & Co-Founder @OpenAI
            </span> */}
          </h1>
        </a>

        <p><a href="https://grantslatton.com/binary-iq" className="grantslatton-a">Binary IQ</a> — A model of LLM capability</p>

<p><a href="https://grantslatton.com/rowzero-property-testing" className="grantslatton-a">Lightweight property-based testing at Row Zero</a> — How we verify correctness</p>

<p><a href="https://grantslatton.com/rust-macros" className="grantslatton-a">Rust Macros: Zero to Hero</a> — A comprehensive guide on Rust macros</p>
<p><a href="https://grantslatton.com/software-pathfinding" className="grantslatton-a">Algorithms we develop software by</a> — Pathfinding applied to the software solution domain</p>
<p><a href="https://grantslatton.com/filesystems" className="grantslatton-a">Building Filesystems</a> — High level ideas in filesystem design</p>
<p><a href="https://grantslatton.com/quasirandom" className="grantslatton-a">Quasirandom sequences</a> — Cool method to generate non-clumping random points</p>

 <p><a href="https://grantslatton.com/how-to-software">How to write complex software</a> — A general method</p>
 <p><a href="https://grantslatton.com/bureaulogy">Bureaulogy</a> — The study of bureaucracy</p>
 <p><a href="https://grantslatton.com/peasants-plight">A peasant's plight</a> — On the shackling of the peasantry</p>
 <p><a href="https://grantslatton.com/personal-api">Every Man his own API</a> — A sociotechnological trend</p>
 <p><a href="https://grantslatton.com/culture-schelling">Culture is a set of social Schelling points</a> — Solving coordination problems in community-building</p>
 <p><a href="https://grantslatton.com/portals">Portals are Undertheorized</a> — The importance of arrival</p>
 <p><a href="https://grantslatton.com/binary-iq">Binary IQ</a> — A model of LLM capability</p>
 <p><a href="https://grantslatton.com/bug-proof-engines">Designing bug-proof engines</a> — A spectrum of engineering philosophies</p>
 <p><a href="https://grantslatton.com/accidental-urbanism">Accidental Urbanism</a> — How I got into the scene</p>
 <p><a href="https://grantslatton.com/town-bootstrapping">How to Bootstrap a Town</a> — A modest plan</p>
 <p><a href="https://grantslatton.com/sports-vs-games">Sports vs Games</a> — An aesthetic distinction</p>
 <p><a href="https://grantslatton.com/nobody-cares">Nobody Cares</a> — A rant about caring</p>
 <p><a href="https://grantslatton.com/rowzero-property-testing">Lightweight property-based testing at Row Zero</a> — How we verify correctness</p>
 <p><a href="https://grantslatton.com/rust-macros">Rust Macros: Zero to Hero</a> — A comprehensive guide on Rust macros</p>
 <p><a href="https://grantslatton.com/software-pathfinding">Algorithms we develop software by</a> — Pathfinding applied to the software solution domain</p>
 <p><a href="https://grantslatton.com/status-among-whom">Status among whom?</a> — An essay about status relativism</p>
 <p><a href="https://grantslatton.com/bjj-ghost-escape">Ghost Side Control Escape System (BJJ)</a> — A video instructional on my preferred side control escape system</p>
 <p><a href="https://grantslatton.com/filesystems">Building Filesystems</a> — High level ideas in filesystem design</p><p><a href="ai-auditability">AI follows auditability</a> — An essay about the order AI will move through the economy</p>
 <p><a href="https://grantslatton.com/books">Book List</a> — Stuff I've read</p>
 <p><a href="https://grantslatton.com/onsen-unreality">Onsen Unreality</a> — Our experience at an onsen 'theme park' in Tokyo</p>
 <p><a href="https://grantslatton.com/tesla-fsd">Tesla Full Self-Driving</a> — My experience with FSD</p>
 <p><a href="https://grantslatton.com/internet-fiction">Internet Fiction</a> — Collection of amateur stories — mainly sci-fi — that I like</p>
 <p><a href="https://grantslatton.com/all-the-way-down">All the way down</a> — Very short story about simulation</p>
 <p><a href="https://grantslatton.com/story-ideas">Story Ideas</a> — A collection of premises for stories</p>
 <p><a href="https://grantslatton.com/things-i-wish-i-knew">Things I wish I knew earlier</a> — Collection of stuff I would tell my younger self if I could</p>
 <p><a href="https://grantslatton.com/road-widths">Road Width Extremism</a> — In favor of narrow roads</p>
 <p><a href="https://grantslatton.com/small-web">Links to See Also</a> — Other "small web" personal sites I recommend</p>
 <p><a href="https://grantslatton.com/canvas-simulations">HTML5 Canvas simulations</a> — A collection of little HTML5 canvas demos</p>
 <p><a href="https://grantslatton.com/twitter">Twitter</a> — Essay about how getting on Twitter unexpectedly added a lot of value to my life</p>
 <p><a href="https://grantslatton.com/shuttle">Shuttle</a> — A useful concurrency checker library we used to verify our filesystem at AWS</p>
 <p><a href="https://grantslatton.com/quasirandom">Quasirandom sequences</a> — Cool method to generate non-clumping random points</p>
 <p><a href="https://grantslatton.com/book-review-the-perfectionists">Book Review: 'The Perfectionists: How Precision Engineers Created the Modern World'</a> — Excellent book about the history of precision machining</p>
 <p><a href="https://grantslatton.com/markdown-nom-parser">Markdown-ish</a> — Writing a Markdown(ish) parser with the nom library</p>
    <p><img src="/images/grant_and_sampson.jpg" alt="Grant holding Sampson at sunset overlooking Puget Sound"></img></p>

{/* <body style="">
    <h1>Howdy</h1>
    <p>I'm Grant Slatton. I'm a founding engineer at <a href="https://rowzero.io/">Row Zero</a> where we've built the world's fastest spreadsheet.</p>
    <p>Formerly, I was a senior engineer at <a href="https://en.wikipedia.org/wiki/Amazon_S3">AWS S3</a> where I led the team that built and owned the custom, high-performance storage node at the heart of the world's largest cloud storage service.</p>
    <p>When I'm not writing code, you can find me woodworking in my garage, training BJJ at the gym, or walking around West Seattle with my wife, Jessica, and our corgi, Sampson.</p>
    <p>Feel free to contact me at me@grantslatton.com, or <a href="https://twitter.com/grantslatton">on Twitter</a>.</p>
    <hr>
    <p>Here are some articles I've written that you might like:</p>
   
  <script defer="" src="https://static.cloudflareinsights.com/beacon.min.js/vcd15cbe7772f49c399c6a5babf22c1241717689176015" integrity="sha512-ZpsOmlRQV6y907TI0dKBHq9Md29nnaEIPlkf84rnaERnq6zvWvPUqr2ft8M1aS28oN72PdrCzSjY4U6VaAw1EQ==" data-cf-beacon="{&quot;rayId&quot;:&quot;8fc0b6466999b2ab&quot;,&quot;version&quot;:&quot;2024.10.5&quot;,&quot;r&quot;:1,&quot;token&quot;:&quot;44f687eddfe14cd0acf2364d2d86e762&quot;,&quot;serverTiming&quot;:{&quot;name&quot;:{&quot;cfExtPri&quot;:true,&quot;cfL4&quot;:true,&quot;cfSpeedBrain&quot;:true,&quot;cfCacheStatus&quot;:true}}}" crossorigin="anonymous"></script>


</body> */}

        {/* <p><a href="https://grantslatton.com/binary-iq">Binary IQ</a> — A model of LLM capability</p>



        <p><a href="https://grantslatton.com/rowzero-property-testing">Lightweight property-based testing at Row Zero</a> — How we verify correctness</p> */}
</div>

<div id="@unixpickle">



<a href="https://github.com/unixpickle" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Alex Nichol </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>AI researcher, hobby web developer, math geek. Constantly learning.</h3>
          </a>

          <a href="https://blog.aqnichol.com/" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Alex Nichol Blog - Pickled ML</span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
          </a>
          
          <article>
        {/* <h1>Posts</h1> */}
       <ArticleListAlexNichole />
    </article>
</div>

<div id="@jfrankle.com">



<a href="https://bsky.app/profile/jfrankle.com" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Jonathan Frankle </span>
              <span className="p-nickname vcard-username d-block">
              
              </span>
            </h1>
            <h3>Chief AI Scientist at Databricks. Founding team at MosaicML. MIT/Princeton alum. Lottery ticket enthusiast. Working on data intelligence.</h3>
          </a>


<EmbedComponent />
{/* <blockquote class="bluesky-embed" data-bluesky-uri="at://did:plc:jt6vfiqztljw7kvv3qekdfer/app.bsky.feed.post/3lbsj6eh63c24" data-bluesky-cid="bafyreict6c5ls3l6pkimwvm4kwyy6suh7acjzmhfkihad6t6dduog2nnte"><p lang="en">I wrote some thoughts on how to build good LM benchmarks: ofir.io/How-to-Build...<br><br><a href="https://bsky.app/profile/did:plc:jt6vfiqztljw7kvv3qekdfer/post/3lbsj6eh63c24?ref_src=embed">[image or embed]</a></p>&mdash; Ofir Press (<a href="https://bsky.app/profile/did:plc:jt6vfiqztljw7kvv3qekdfer?ref_src=embed">@ofirpress.bsky.social</a>) <a href="https://bsky.app/profile/did:plc:jt6vfiqztljw7kvv3qekdfer/post/3lbsj6eh63c24?ref_src=embed">November 26, 2024 at 3:24 AM</a>
</blockquote><script async src="https://embed.bsky.app/static/embed.js" charset="utf-8"></script>
 */}
</div>





<div>
  
  
  
  <section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" 
  alt="@Rishit-dagli profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/Rishit-dagli" data-view-component="true" className="Link--primary Link text-bold">Rishit Dagli</a>
              <span data-view-component="true" className="color-fg-muted text-normal">Rishit-dagli</span>
            </p>
              <div className="m-0 mt-1 wb-break-all"><div>CS + Math <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/UofT/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/UofT">@UofT</a> |
AI Research, Qualcomm |
Research ML, Vision  UofT, Vector |
RT <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/kubernetes/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/kubernetes">@kubernetes</a> 1.26-9</div></div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    106
                    repositories
                  </span>
                  <span>
                    891
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>
</div>



<div id="@Alexandre_Mutel">

<a href="#@Alexandre_Mutel" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              @Alexandre_Mutel </span>
              {/* <span className="p-nickname vcard-username d-block"></span> */}
            </h1>
            <h3><div>Director C#/.NET Tech Group at Unity, OSS, lang/compilers, GPU/sound, architecture 🏎️
Microsoft MVP, ex-demoscene PC/Amiga 🎆
Veggie 🌿, opinions are my own.</div></h3>
          </a>
</div>

<h3>
  <a href="https://x.com/nietras1/following" target="_blank" rel="noopener noreferrer">
    Followings of @nietras1 on X
  </a>
</h3>


<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/xoofx" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Alexandre Mutel ▶ https://mastodon.social/@xoofx</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/xoofx" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@xoofx</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @_Jaivardhan_" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow nietras1
    </div>
  </div>
</div>

<div>
  
  
  
  <section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/715038?v=4" 
  alt="@xoofx profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none mb-2" 
/>
</a>
          <div className="ml-2 mb-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/xoofx" data-view-component="true" className="Link--primary Link text-bold">xoofx </a>
              <span data-view-component="true" className="color-fg-muted text-normal mb-2 mt-2">Alexandre Mutel</span>
            </p>
              {/* <div className="m-0 mt-1 wb-break-all"><div>CS + Math <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/UofT/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/UofT">@UofT</a> |
AI Research, Qualcomm |
Research ML, Vision  UofT, Vector |
RT <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/kubernetes/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/kubernetes">@kubernetes</a> 1.26-9</div></div> */}

<div>Director C#/.NET Tech Group at Unity, OSS, lang/compilers, GPU/sound, architecture 🏎️
Microsoft MVP, ex-demoscene PC/Amiga 🎆
Veggie 🌿, opinions are my own.</div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    88
                    repositories
                  </span>
                  <span>
                    1.4k
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>
</div>

<h2 className="year" id="2018">
      2023
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#2018"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
        }}
      ></a>
    </h2>
<li 
// className="prefix-Alexandre-Mutel"
>
  <a href="https://xoofx.github.io/blog/2023/07/09/10x-performance-with-simd-in-csharp-dotnet">10x Performance with SIMD Vectorized Code in C#/.NET</a>
  <span className="blog-post-meta">
    - <span className="date"><time 
    // datetime="2023-07-09" itemprop="datePublished"
    >Jul 9</time></span>
    <i className="bi bi-tags"></i><a href="/blog/tag/csharp/" className="prefix-Alexandre-Mutel">C#</a>, <a href="/blog/tag/net/" className="prefix-Alexandre-Mutel">.NET</a>, <a href="/blog/tag/x86/" className="prefix-Alexandre-Mutel">x86</a>, <a href="/blog/tag/assembler/" className="prefix-Alexandre-Mutel">assembler</a>
  </span>
  <span className="subtitle">Use your CPU at its full width!</span>
</li>
<h2 className="year" id="2018">
      2020
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#2018"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
        }}
      ></a>
    </h2>
<ul>
        <li 
        // className="prefix-Alexandre-Mutel"
        >
          <a href="https://xoofx.github.io/blog/2020/03/21/stark-native-compiler">Stark - Native Compiler - Prototype 2019</a>
          <span className="blog-post-meta">
            - <span className="date"><time
            // datetime="2020-03-21" itemprop="datePublished"
            >Mar 21</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/stark/">Stark</a>, <a href="/blog/tag/melody/">Melody</a>, <a href="/blog/tag/os/">OS</a>, <a href="/blog/tag/compiler/">Compiler</a>, <a href="/blog/tag/llvm/">LLVM</a>, <a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>
          </span>
          <span className="subtitle">Development of an AOT native compiler using RyuJIT</span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2020/03/06/stark-language-frontend-compiler">Stark - Language And Frontend Compiler - Prototype 2019</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2020-03-06" itemprop="datePublished"
            >Mar  6</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/stark/">Stark</a>, <a href="/blog/tag/melody/">Melody</a>, <a href="/blog/tag/os/">OS</a>, <a href="/blog/tag/compiler/">Compiler</a>, <a href="/blog/tag/llvm/">LLVM</a>, <a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>
          </span>
          <span className="subtitle">Syntax of the language and the development of the front-end compiler</span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2020/03/05/stark-melody-dotnet-sel4">The Odyssey of Stark and Melody</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2020-03-05" itemprop="datePublished"
            >Mar  5</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/stark/">Stark</a>, <a href="/blog/tag/melody/">Melody</a>, <a href="/blog/tag/os/">OS</a>, <a href="/blog/tag/compiler/">Compiler</a>, <a href="/blog/tag/llvm/">LLVM</a>, <a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>
          </span>
          <span className="subtitle">Prototyping a new language and OS with the help of the .NET ecosystem and seL4 micro-kernel</span>
        </li>

      </ul>
    
      <h2 className="year" id="2018">
      2018
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#2018"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
        }}
      ></a>
    </h2>
      <ul>
        <li>
          <a href="https://xoofx.github.io/blog/2018/12/26/generate-async-from-sync-code-with-roslyn">Generate automatically async/await code from sync code with Roslyn</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-12-26" itemprop="datePublished"
             >Dec 26</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/roslyn/">Roslyn</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/04/12/writing-managed-jit-in-csharp-with-coreclr">Writing a Managed JIT in C# with CoreCLR</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
           // datetime="2018-04-12" itemprop="datePublished"
            >Apr 12</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/coreclr/">CoreCLR</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/04/06/porting-unity-to-coreclr">Porting the Unity Engine to .NET CoreCLR</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-04-06" itemprop="datePublished"
            >Apr  6</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/csharp/">C#</a>, <a href="/blog/tag/net/">.NET</a>, <a href="/blog/tag/coreclr/">CoreCLR</a>, <a href="/blog/tag/unity/">Unity</a>
          </span>
        </li>

        <li>
          <a href="https://xoofx.github.io/blog/2018/03/09/productivity-with-resharper">Productivity with ReSharper</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2018-03-09" itemprop="datePublished"
            >Mar  9</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/visual-studio/">Visual Studio</a>, <a href="/blog/tag/visual-studio-2015/">Visual Studio 2015</a>, <a href="/blog/tag/roslyn/">Roslyn</a>
          </span>
        </li>

      </ul>
      <h2 className="year" id="2009">
  2009
  <a
    className="anchorjs-link"
    aria-label="Anchor"
    data-anchorjs-icon=""
    href="#2009"
    style={{
      font: '1em / 1 anchorjs-icons',
      marginLeft: '0.1875em',
      paddingRight: '0.1875em',
      paddingLeft: '0.1875em',
    }}
  />
</h2>
<ul>
<li>
          <a href="https://xoofx.github.io/blog/2009/10/25/random-float-number-using-x86-asm-code.html">Random float number generator using x86 ASM code optimized in size</a>
          <span className="blog-post-meta">
            - <span className="date"><time 
            // datetime="2009-10-25" itemprop="datePublished"
            >Oct 25</time></span>
            <i className="bi bi-tags"></i><a href="/blog/tag/assembler/">assembler</a>, <a href="/blog/tag/x86/">x86</a>
          </span>
        </li>

      </ul>

      <section className="section-gap-AlexandreMutel">
             <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 1/7/25
          <br />
          <a href="https://github.com/sailro/AzdTool">sailro/AzdTool </a> (C#) 1 STARS
          </p>
      </section>

      <section className="section-gap-AlexandreMutel">
             <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 20/6/25
          <br />
          <a href="https://github.com/JimmyLefevre/kb">JimmyLefevre/kb </a> (C) 275 STARS
          </p>
      </section>


      <div id="YanCui(theburningmonk)">
      <section className="section-gap-AlexandreMutel">
            <p>
              Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 10/5/25
                <br />
                <a href="https://github.com/metalama/Metalama">metalama/Metalama </a> (C#) 292 STARS

              </p>
              <p className="f4 my-3">
                      A meta-programming framework for code generation, aspect-oriented programming, and architecture verification of large C# codebases.
                    </p>
                    <h3>
                    <a href="https://github.com/gfraiteur?tab=following" target="_blank" rel="noopener noreferrer">
                      Followings of	Gael Fraiteur on GitHub
                    </a>
                  </h3>
        <a
            href="https://github.com/theburningmonk"
            className="vcard-names1"
            style={{ textDecoration: 'underline' }}
          >
            <h1 style={{ margin: 0 }}>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Yan Cui
              </span>
            </h1>
            <h3 style={{ margin: 0 }}>
              Hi there! I’m Yan Cui(theburningmonk).
            </h3>
          </a>
          <a href="https://theburningmonk.com/2023/12/how-to-perform-database-migration-for-a-live-service-with-no-downtime/" 
            target="_blank" 
            rel="noopener noreferrer">
            Visit the full article: How to perform database migration for a live service with no downtime | Posts · AWS, DynamoDB, Serverless · 12/2023 
          </a>
          <p></p>
          <a href="https://theburningmonk.com/2021/04/building-a-custom-iam-system-has-made-me-appreciate-aws-iam-even-more/" 
            target="_blank" 
            rel="noopener noreferrer">
            Visit the full article: Building a custom IAM system has made me appreciate AWS IAM even more | Posts · AppSync, AWS, Lambda, Serverless · 12/2023 
          </a>
          </section>
      </div>


      <section className="section-gap-AlexandreMutel">
      <p>
              Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) followed a GitHub user on 2/5/25
                <br />
                <a href="https://github.com/meziantou">meziantou </a>

              </p>
      </section>
 

      <section className="section-gap-AlexandreMutel">
      <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 7/4/25
          <br />
          <a href="https://github.com/Alan-Rock-GS/GpuScript">Alan-Rock-GS/GpuScript </a> (C#) 171 STARS

        </p>
      </section>
<p>
Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 5/4/25
  <br />
  <a href="https://github.com/nietras/Llm.cs">https://github.com/nietras/Llm.cs </a> (C#) 49 STARS

</p>
<Alexandre_MutelPR_From_2025_02_01_To_2025_02_28_Avalonia_AvaloniaUI />



<div id="Bishal_Santra">
  
  
  
  <section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/6783945?v=4" 
  alt="@xoofx profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/bsantraigi/" data-view-component="true" className="Link--primary Link text-bold">Bishal Santra </a>
              <span data-view-component="true" className="color-fg-muted text-normal">Bishal Santra</span>
            </p>
            <div>Research Engineer <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/microsoft/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/microsoft">@microsoft</a> Research India | 
            Working on Language Modeling for Retrieval | IIT KGP</div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    103
                    repositories
                  </span>
                  <span>
                    36
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>



        <ul className="bishal-santra-post-list">
  <li>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="bishal-santra-post-meta">Aug 12, 2023</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/08/12/llm-channel-method-flaw.html">
        Explaining Issues with Channel Method in LLM Prompt-based Classification
      </a>
    </h3>
    </div>
  </li>
  <li>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="bishal-santra-post-meta" style={{ marginRight: '10px' }}>Aug 12, 2023</span>
    <h3 style={{ margin: '0' }}>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/08/12/llm-channel-method-flaw.html">
        Explaining Issues with Channel Method in LLM Prompt-based Classification
      </a>
    </h3>
  </div>
</li>

  <li>
    <span className="bishal-santra-post-meta">Feb 11, 2023</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/02/11/2022-02-11-algebraic-numbers-countable-proof.html">
        Prove that the set of algebraic numbers are countable (using primes)
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Feb 10, 2023</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/blog/2023/02/10/2023-02-10-sum-1-by-n-divergent.html">
        Is ∑<sub>i=1</sub><sup>n</sup> 1/n divergent?
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Oct 7, 2021</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2021/10/07/how-to-ssh-jump-cnerg.html">
        How to Connect through an SSH Jump Server (For CNeRG project students)
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Oct 26, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/10/26/transformer-language-models-and-pretraining.html">
        Transformer Language Models and Pretraining
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Aug 31, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/08/31/english-to-hindi-transliteration-using-seq2seq-model.html">
        English to Hindi Transliteration using Seq2Seq Model
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Aug 31, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/08/31/deep-sentiment-analysis.html">
        Deep Sentiment Analysis
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Jul 13, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/2019/07/13/text-classification-using-naive-bayes-method.html">
        Text Classification using Naive Bayes Method
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Jul 8, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/08/training-xtra-small-transformer-language-model.html">
        Training a Language Model with a Xtra-Small Transformer (Transformer-XS)
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Jul 7, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/07/simple-reddit-dialogue-preprocessor.html">
        Simple Reddit Dialogue Preprocessor
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Jul 3, 2019</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2019/07/03/how-i-made-this-site.html">
        How I created this site using Jekyll?
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Jan 12, 2017</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2017/01/12/generating-gamma-rv-cuda.html">
        Generating Gamma Random Variable in CUDA in Parallel
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Aug 6, 2016</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2016/08/06/mmse-estimator.html">
        Minimum Mean Squared Error (MMSE) Estimator
      </a>
    </h3>
  </li>
  <li>
    <span className="bishal-santra-post-meta">Mar 14, 2016</span>
    <h3>
      <a className="bishal-santra-post-link" href="https://bsantraigi.github.io/tutorial/2016/03/14/decycledjson.html">
        DecycledJSON - Circular reference breakers for JSON
      </a>
    </h3>
  </li>
</ul>




</div>


<div id="@Charlie_Marsh">

<h1 style={{ fontSize: '80px', marginTop: '0.5em', marginBottom: '0' }}>
      <a className="implicit" href="https://www.crmarsh.com/">
        Charlie Marsh
      </a>
    </h1>

<h2 style={{ fontWeight: 'normal', marginTop: '0.5em', lineHeight: '1.4' }}>
      Building{' '}
      <b>
        <a target="_blank" rel="noopener noreferrer" href="https://astral.sh">
          Astral
        </a>
      </b>
      : high-performance tools for Python, starting with{' '}
      <b>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/charliermarsh/ruff">
          Ruff
        </a>
      </b>
      .
      <br />
      <br />
      In the past: Staff software engineer at{' '}
      <b>
        <a target="_blank" rel="noopener noreferrer" href="https://www.springdiscovery.com">
          Spring Discovery
        </a>
      </b>
      , senior engineer at{' '}
      <b>
        <a target="_blank" rel="noopener noreferrer" href="https://www.khanacademy.org">
          Khan Academy
        </a>
      </b>
      , and Computer Science major at <b>Princeton</b>.
      <br />
      <br />
      These days, I write on{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://notes.crmarsh.com/">
        Notion
      </a>
      .
      <br />
      <br />
      Check out some of my public projects:
    </h2>

    <CharlieMarsh_PublicProjects />

<CharlieMarshNotionArticle />

{/* <article id="block-6d52b13d76774644b6424d22b79d7ea1" className="notion-root max-width has-footer">
  <p id="block-d16f6052f7f2490d84d90e313df30d1a" className="notion-text notion-text__content notion-semantic-string">Hi, I&#39;m <a href="https://www.crmarsh.com/" className="notion-link link" target="_blank" rel="noopener noreferrer">Charlie Marsh</a>.</p>
  <div id="block-faa963b710ea4dd7ad3ddd8b9c7f0735" className="notion-text"></div>
  <p id="block-14d8a36b9fe8467d9f7a4877ef596fdc" className="notion-text notion-text__content notion-semantic-string">I&#39;m building high-performance developer tools for Python, starting with <a href="https://github.com/charliermarsh/ruff" className="notion-link link" target="_blank" rel="noopener noreferrer">Ruff</a>, an extremely fast Python linter written in Rust.</p>
  <div id="block-4e8cb5d4688b44f3a5b76f567d06650a" class="notion-text"></div>
  <p id="block-09e4ccc0bcbf43f98e5991be767e4fd8" class="notion-text notion-text__content notion-semantic-string">I was most recently a staff software engineer at <a href="https://www.springdiscovery.com/" class="notion-link link" target="_blank" rel="noopener noreferrer">Spring Discovery</a>. Before that, I was a senior software engineer at <a href="https://www.khanacademy.org/" class="notion-link link" target="_blank" rel="noopener noreferrer">Khan Academy</a>.</p>
  <div id="block-a8de7fd07b2b476fa13f9c7b5655566e" class="notion-text"></div>
  <p id="block-3e79c0b321a94f82b834418b2c840a5a" class="notion-text notion-text__content notion-semantic-string">This is a collection of notes and blog posts I’ve written on Notion:</p>
  <a id="block-using-mypy-in-production-at-spring" class="notion-link notion-page emoji" href="/using-mypy-in-production-at-spring"><span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">🐍</span></span>
  <span class="notion-page__title notion-semantic-string">Using Mypy in production at Spring</span></a><a id="block-whats-webassembly" class="notion-link notion-page emoji" href="/whats-webassembly"><span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">🌐</span></span><span class="notion-page__title notion-semantic-string">What’s WebAssembly?</span></a><a id="block-python-tooling-could-be-much-much-faster" class="notion-link notion-page emoji" href="/python-tooling-could-be-much-much-faster">
  <span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">🛠️</span></span>
  <span class="notion-page__title notion-semantic-string">Python tooling could be much, much faster</span></a>
  <a id="block-building-large-language-model-powered-applications" class="notion-link notion-page emoji" href="/building-large-language-model-powered-applications"><span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">🤖</span></span><span class="notion-page__title notion-semantic-string">Building large language model-powered applications</span></a><a id="block-isolates-microvms-and-webassembly" class="notion-link notion-page emoji" href="/isolates-microvms-and-webassembly"><span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">☁️</span></span><span class="notion-page__title notion-semantic-string">Isolates, microVMs, and WebAssembly</span></a><a id="block-ruff-the-first-200-releases" class="notion-link notion-page emoji" href="/ruff-the-first-200-releases"><span class="notion-page__icon"><span class="notion-icon text" style="width:20px;height:20px;font-size:20px;fill:var(--color-text-default-light)">⚡</span></span><span class="notion-page__title notion-semantic-string">Ruff: The First 200 Releases</span></a>
  <div id="block-6794a992cb584bb8b74aa9ff339b404f" class="notion-text"></div>
  <p id="block-9fb5f04bf7274d309fb92d0001cf2e36" class="notion-text notion-text__content notion-semantic-string">You can find me on <a href="https://twitter.com/charliermarsh" class="notion-link link" target="_blank" rel="noopener noreferrer">Twitter</a>.</p>
  <div id="block-3e5145177df04491ad1646c446e029af" class="notion-text"></div>
  <p id="block-4dbb17370d7a42cf8a5f9114b0f62494" class="notion-text notion-text__content notion-semantic-string">For older posts and projects, check out my <a href="https://www.crmarsh.com/" class="notion-link link" target="_blank" rel="noopener noreferrer">personal site</a>.</p><div id="block-6b7e97965ac9469791dfdc655481fbca" class="notion-text"></div>
  </article> */}

<CharlieMarsh_PostsList />
{/* 
<ul className="posts-list">
  <li><a target="_blank" href="https://engineering.khanacademy.org/posts/a-really-small-app.htm">Building a Really, Really Small Android App</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/test-plans">Writing a Reproducible Test Plan</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/code-review">Reviewing Code from Both Sides</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/configuring-robolectric">Getting up and Running with Robolectric</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/learning-android">Learning Android in a Production Setting</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/flow">Exploring Flow, Facebook's JavaScript Type Checker</a> (JavaScript Weekly)</li>
  <li><a target="_blank" href="https://www.crmarsh.com/script">Bitcoin Script: An In-Browser Playground</a> (Hacker News)</li>
  <li><a target="_blank" href="https://www.crmarsh.com/svg-performance">Speeding up SVGs with CSS Transforms at Khan Academy</a> (Hacker News)</li>
  <li><a target="_blank" href="https://www.crmarsh.com/react-ssr">Rendering React Components on the Server</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/pdf/Styling_React_Components.pdf">Styling React Components: How to Escape Selector Hell</a> (talk delivered @ Khan Academy)</li>
  <li><a target="_blank" href="https://www.toptal.com/python/python-class-attributes-an-overly-thorough-guide">An Overly Thorough Guide to Python Class Attributes</a> (Python Weekly)</li>
  <li><a target="_blank" href="https://www.toptal.com/python/computational-geometry-in-python-from-theory-to-implementation">A Primer on Computational Geometry in Python</a> (Python Weekly)</li>
  <li><a target="_blank" href="https://www.toptal.com/python/why-are-there-so-many-pythons">Why Are There So Many Pythons?</a> (Hacker News, Python Weekly, Pycoder's Weekly)</li><li><a target="_blank" href="/compiling-to-js">Compiling to JavaScript: A Case-by-Case Guide to the *Scripts</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/phantomjs">PhantomJS: Common Gotchas for Beginners</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/aws">The Idiot-Proof Guide to Setting up Your Personal AWS Instance</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/intro-to-sdn">An Introduction to Rule Optimization in Software Defined Networking</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/prefix-vs-ternary">Prefix vs. Ternary Rules in SDN</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/ocaml-dev-environment">Setting up an OCaml Environment on Mac OS X</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/programming-languages">Programming Languages and the Solutions they Suggest</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/intro-to-ocaml">First Thoughts on OCaml</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/streams">A Primer on Streams and Lazy Computation</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/binomial-heaps">Binomial Heaps: Merge Better</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/ios-performance">Performance Improvements in iOS</a></li>
  <li><a target="_blank" href="https://www.crmarsh.com/np-vs-not-p">NP != NOT P</a></li>
  </ul> */}


</div>

<div id="@kevin_frans">
<h1 style={{fontSize: '3em',
    marginTop: '-0.5em'}}>kevin frans website v5</h1>


<p className="desc">
            {/* <!-- Hi, I'm Kevin! I'm a second-year undergrad at MIT. In the past, I was a research intern at OpenAI on the reinforcement learning team, and I was at Autodesk Research working on AI to automate design. In my free time, I play a lot of weird games and build some of my own. --> */}
            Hey, I'm Kevin. I am a PhD student at <a href="https://bair.berkeley.edu/">BAIR</a> 
            advised by <a href="https://people.eecs.berkeley.edu/~pabbeel/">Pieter Abbeel</a> and 
            <a href="https://people.eecs.berkeley.edu/~svlevine/">Sergey Levine</a>. 
            I did my B.S. and M.Eng at MIT with <a href="http://web.mit.edu/phillipi/">Phillip Isola</a>. 
            I&nbsp;am&nbsp;interested in deep reinforcement learning, unsupervised learning, and AI-based creative tools. 
            I&nbsp;also lead engineering at <a href="https://paragraphai.com/">ParagraphAI</a>. I&nbsp;have spent time at 
            <a href="https://crosslabs.org">Cross Labs</a>, <a href="https://twitter.com/sizigistudios">Sizigi</a>, 
            <a href="https://www.autodeskresearch.com/">Autodesk Research</a>, and <a href="https://openai.com/">OpenAI</a>. 
            In&nbsp;my&nbsp;free&nbsp;time, I&nbsp;like to design and build&nbsp;<a href="https://store.steampowered.com/app/810780/RAIN_Project__a_touhou_fangame/">video</a>
            &nbsp;<a href="https://store.steampowered.com/app/1256660/Iwate_Mountain_Dance/">games</a>.</p>

            <KevinFransPostCard />

</div>


<div id="StathisKamperis">

    
<section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/9994264?v=4" 
  alt="@xoofx profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/ekamperi" data-view-component="true" className="Link--primary Link text-bold">Stathis Kamperis </a>
              <span data-view-component="true" className="color-fg-muted text-normal">Stathis Kamperis</span>
            </p>
            <div>I am a radiation oncologist and physicist. I like to build bridges between different scientific disciplines (medicine, physics, informatics).</div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    15
                    repositories
                  </span>
                  <span>
                    29
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>

{/* <stathiskamperisLinkedInPost /> */}
<StathisKamperisLinks />


</div>
<div id="SewonMin">

<a href="#SewonMin" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Sewon Min </span>
            <span className="p-nickname vcard-username d-block">
            Incoming faculty @Berkeley_EECS @berkeley_ai ||  Research scientist at @allen_ai  ||  PhD from @uwcse @uwnlp.
            </span>
          </h1>
        </a>



<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/sewon__min" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@sewon__min</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/sewon__min" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@sewon__min</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @sewon__min" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow sewon__min
    </div>
  </div>





</div>


<SewonMinTwitterUserDescription />
<p id="news-0"><span className="glyphicon glyphicon-ok"></span> 11/2024: I won't be attending EMNLP or NeurIPS this year, but my co-authors will be presenting our work!
  Check out our papers on
  <a href="https://www.arxiv.org/abs/2407.07087" target="_blank">Benchmarking the Reproduction of Copyrighted Text</a><sup>(EMNLP Main, NeurIPS Regulatable ML Workshop Contributed Talk)</sup>,
  <a href="https://arxiv.org/abs/2407.12854" target="_blank">Scaling a Datastore in Retrieval-Based LMs</a><sup>(NeurIPS Main)</sup>, and
  <a href="https://arxiv.org/abs/2409.02060" target="_blank">An Open Mixture-of-Experts LM</a><sup>(NeurIPS Workshop on Efficient Natural Language and Speech Processing (ENLSP), Oral Talk)</sup>.
  </p>
  <p id="news-1"><span className="glyphicon glyphicon-ok"></span> 11/2024: <b>I am recruiting PhD students at UC Berkeley's EECS!</b>
  If you're interested, please apply directly through the UC Berkeley admissions portal (details <a href="https://www.sewonmin.com/faq.html" target="_blank">here</a>).
  Kindly note that I cannot discuss applications outside the official admissions process.</p><p id="news-2"><span className="glyphicon glyphicon-ok"></span> 12/2023: I am attending EMNLP and NeurIPS!
    At EMNLP, I will give an invited talk on <a href="https://arxiv.org/abs/2202.12837" target="_blank">Rethinking the Role of Demonstrations</a> at <a href="https://www.bigpictureworkshop.com/" target="_blank">the Big Picture Workshop</a> on Dec 7th,
    and give an oral talk on <a href="https://arxiv.org/abs/2305.14251" target="_blank">FActScore</a> on Dec 8th.
    At NeurIPS, I will give a spotlight talk on <a href="https://arxiv.org/abs/2308.04430" target="_blank">SILO</a> at <a href="https://sites.google.com/view/distshift2023" target="_blank">the Distribution Shifts Workshop</a> on Dec 15th,
    and give an oral talk on <a href="https://arxiv.org/abs/2308.04430" target="_blank">SILO</a> at <a href="https://regulatableml.github.io/" target="_blank">the Regulatable ML Workshop</a> on Dec 16th.</p><p id="news-3"><span className="glyphicon glyphicon-ok"></span> 08/2023: Together with <a href="https://suchin.io/" target="_blank">Suchin Gururangan</a>,
  we present <a href="https://arxiv.org/abs/2308.04430" target="_blank">SILO</a>, 
  proposing to segregate the training data and the inference-time data in nonparametric LMs to mitigate legal risk in LMs.
  </p>
  <p id="news-4"><span className="glyphicon glyphicon-ok"></span> 07/2023: <a href="https://arxiv.org/abs/2212.10001" target="_blank">Our paper that examines the role of demonstrations in CoT prompting</a>,
  led by <a href="https://boshi-wang.github.io/" target="_blank">Boshi Wang</a>, won an Honorable Mention at ACL 2023.
  </p>
  <p id="news-5"><span className="glyphicon glyphicon-ok"></span> 07/2023: I co-taught a tutorial on <a href="https://ACL2023-Retrieval-LM.github.io" target="_blank">retrieval-based LMs</a> at ACL 2023. Slides &amp; recordings are available on the website.</p><p id="news-6"><span className="glyphicon glyphicon-ok"></span> 12/2022: Check out our new preprint,
  <a href="https://arxiv.org/abs/2212.01349" target="_blank">Nonparametric Masked Language Modeling</a>.
  Code and model checkpoints available <a href="https://github.com/facebookresearch/NPM" target="_blank">here</a>.
  </p>
  <p id="news-7"><span className="glyphicon glyphicon-ok"></span> 09/2022: I was selected by the EECS Rising Stars Program.</p><p id="news-8"><span className="glyphicon glyphicon-ok"></span> 08/2022: Together with <a href="https://cs.stanford.edu/~eix/" target="_blank">Sang Michael Xie</a>, we wrote a post on <a href="https://ai.stanford.edu/blog/understanding-incontext/" target="_blank">How does in-context learning work? A framework for understanding the differences from traditional supervised learning</a> at Stanford AI Blog.</p>
  <p id="news-9"><span className="glyphicon glyphicon-ok"></span> 05/2022: I co-taught the ACL tutorial on Few-Shot NLP with Pretrained Language Models (<a href="https://github.com/allenai/acl2022-zerofewshot-tutorial" target="_blank">slides</a>, <a href="https://underline.io/events/284/sessions?eventSessionId=10748" target="_blank">recordings</a>).</p>
  <p id="news-10"><span className="glyphicon glyphicon-ok"></span> 02/2022: Check out our new preprint, <a href="https://arxiv.org/abs/2202.12837" target="_blank">Rethinking the Role of Demonstrations: What makes In-context Learning Work?</a>
  All experiments reproducible from <a href="https://github.com/Alrope123/rethinking-demonstrations" target="_blank">this code</a>.
  (Update 10/2022: The paper was accepted to EMNLP 2022.)
  </p>
  <p id="news-11"><span className="glyphicon glyphicon-ok"></span> 02/2022: I am co-organizing two workshops at ACL 2022: <a href="https://sites.google.com/view/repl4nlp2022/home" target="_blank">Repl4NLP</a> (<a href="https://sites.google.com/view/repl4nlp2022/call-for-papers?authuser=0" target="_blank">CFP</a>) and 
   <a href="http://semiparametric.ml/" target="_blank">Spa-NLP</a> (<a href="http://www.semiparametric.ml/cfp.html" target="_blank">CFP</a>).</p><p id="news-12"><span className="glyphicon glyphicon-ok"></span> 10/2021: Our new preprint, <a href="https://arxiv.org/abs/2110.15943" target="_blank">MetaICL: Learning to Learn In Context</a> is out (w/ <a href="https://github.com/facebookresearch/MetaICL" target="_blank">code</a>).
  Check out the <a href="http://qa.cs.washington.edu:2021" target="_blank">demo</a>!
  (Update 04/2022: The paper was accepted to NAACL 2022.)
  </p>

{/* <p id="news-10"><span className="glyphicon glyphicon-ok"></span> 02/2022: Check out our new preprint, <a href="https://arxiv.org/abs/2202.12837" target="_blank">Rethinking the Role of Demonstrations: What makes In-context Learning Work?</a>
  All experiments reproducible from <a href="https://github.com/Alrope123/rethinking-demonstrations" target="_blank">this code</a>.
  (Update 10/2022: The paper was accepted to EMNLP 2022.)
  </p> */}
<p id="news-13"><span className="glyphicon glyphicon-ok"></span> 08/2021: Our new preprint, <a href="https://arxiv.org/abs/2108.04106" target="_blank">Noisy Channel Language Model Prompting for Few-Shot Text Classification</a> is out w/ <a href="https://github.com/shmsw25/Channel-LM-Prompting" target="_blank">code</a>!
  (Update 02/2022: The paper was accepted to ACL 2022.)
  </p>
  <p id="news-14"><span className="glyphicon glyphicon-ok"></span> 07/2021: Our new preprint, <a href="https://arxiv.org/abs/2107.02153" target="_blank">FaVIQ: FAct Verification from Information-seeking Questions</a> is out! Visit <a href="https://faviq.github.io" target="_blank">FaVIQ website</a> to download data and see samples.
  (Update 02/2022: The paper was accepted to ACL 2022.)
  </p>
  <p id="news-15"><span className="glyphicon glyphicon-ok"></span> 07/2021: I am co-organizing <a href="https://uskb-workshop.github.io/" target="_blank">The 2nd Workshop on Unstructured/Structured KBs</a>, hosted at AKBC 2021.</p><p id="news-16"><span className="glyphicon glyphicon-ok"></span> 06/2021: I co-taught the NAACL-HLT tutorial on <a href="https://github.com/allenai/naacl2021-longdoc-tutorial" target="_blank">Beyond Paragraphs: NLP for Long Sequences</a>.</p><p id="news-17"><span className="glyphicon glyphicon-ok"></span> 04/2021: Our new preprint, <a href="https://arxiv.org/abs/2104.08445" target="_blank">Joint Passage Ranking for Diverse Multi-Answer Retrieval</a>
  is out! This is done as part of my internship at Google.
  (Update 08/2021: The paper was accepted to EMNLP.)
  </p>
  <p id="news-18"><span className="glyphicon glyphicon-ok"></span> 01/2021: We, the NeurIPS 2020 EfficientQA organizers, together with participants,
  wrote <a href="https://arxiv.org/abs/2101.00133" target="_blank">NeurIPS 2020 EfficientQA Competition:
  	Systems, Analyses and Lessons Learned</a>.
  The video of the NeuIPS event is also available <a href="https://www.youtube.com/watch?v=3tdWV4vAf2I" target="_blank">here</a>.
   (Update 05/2021: The paper was accepted to PMLR.)</p>
   <p id="news-19"><span className="glyphicon glyphicon-ok"></span> 12/2020: I am co-organizing <a href="https://mrqa.github.io/" target="_blank">The 3rd Workshop on Machine Reading for Question Answering</a>, hosted at EMNLP 2021. Stay tuned for Call for papers!</p><p id="news-20"><span className="glyphicon glyphicon-ok"></span> 09/2020: I made an <a href="http://qa.cs.washington.edu:2020" target="_blank">Open-domain QA Demo</a> using <a href="https://arxiv.org/abs/2004.04906" target="_blank">DPR</a>. Give it a try!</p>
   <p id="news-21"><span className="glyphicon glyphicon-ok"></span> 06/2020: I am co-organizing <a href="http://efficientqa.github.io/" target="_blank">Competition on Efficient Open-Domain Question Answering</a>, hosted at NeurIPS 2020. [<a href="https://ai.google.com/research/NaturalQuestions/efficientqa" target="_blank">leaderboard</a>]</p>
   <p id="news-22"><span className="glyphicon glyphicon-ok"></span> 06/2020: I am co-organizing <a href="https://uskb-workshop.github.io/" target="_blank">Workshop on Unstructured/Structured KBs</a>, hosted at AKBC 2020.</p>
   <p id="news-23"><span className="glyphicon glyphicon-ok"></span> 04/2020: Our new preprint, <a href="https://arxiv.org/abs/2004.10645" target="_blank">AmbigQA: Answering Ambiguous Open-domain Questions</a>
  is out! Visit <a href="https://nlp.cs.washington.edu/ambigqa/" target="_blank">AmbigQA website</a> to download data and see samples.</p>
  <p id="news-24"><span className="glyphicon glyphicon-ok"></span> 04/2020: Our new preprint, <a href="https://arxiv.org/abs/2004.04906" target="_blank">Dense Passage Retrieval for Open-domain Question Answering</a>
  is out (w/ <a href="https://github.com/facebookresearch/DPR" target="_blank">code</a>)!</p><p style={{marginTop: '5px'}}></p>

</div>




<div id="KristofferCarlsson">

<a href="https://kristofferc.github.io/" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Kristoffer Carlsson </span>
              {/* <span className="p-nickname vcard-username d-block"></span> */}
            </h1>
            <h3>    <div>Software engineer, Julia Computing</div></h3>
          </a>
<KristofferCarlsson />


<p>Here are some of the open source projects I have created or been involved with:</p>
<ul>
<li><a href="https://github.com/JuliaLang/Pkg.jl" target="_blank">Pkg.jl</a> – Julia’s package manager.</li>
<li><a href="https://github.com/KristofferC/NearestNeighbors.jl" target="_blank">NearestNeighbors.jl</a> – High performance nearest neighbor data structures and algorithms.</li>
<li><a href="https://github.com/KristofferC/Tensors.jl" target="_blank">Tensors.jl</a> – Efficient computations with symmetric and non-symmetric tensors with support for automatic differentiation.</li>
<li><a href="https://github.com/KristofferC/OhMyREPL.jl" target="_blank">OhMyREPL.jl</a> – Syntax highlighting and other enhancements for the Julia REPL.</li>
<li><a href="https://github.com/KristofferC/Crayons.jl" target="_blank">Crayons.jl</a> – Colored and styled strings for terminals.</li>
<li><a href="https://github.com/KristofferC/PGFPlotsX" target="_blank">PGFPlotsX.jl</a> – Seamlessly create plots in Julia using the PGFPlots LaTeX package.</li>
<li><a href="https://github.com/JuliaSparse/Pardiso.jl" target="_blank">Pardiso.jl</a> – Calling the PARDISO sparse solver library.</li>
<li><a href="https://github.com/KristofferC/Tokenize.jl" target="_blank">Tokenize.jl</a> –Tokenization for Julia source code.</li>
<li><a href="https://github.com/KristofferC/TimerOutputs.jl" target="_blank">TimerOutputs.jl</a> – Formatted output of timed sections.</li>
<li><a href="https://github.com/KristofferC/BlockArrays.jl" target="_blank">BlockArrays.jl</a> – Interface for blocked arrays.</li>
<li><a href="https://github.com/JuliaStats/Distances.jl" target="_blank">Distances.jl</a> – A Julia package for evaluating distances(metrics) between vectors.</li>
<li><a href="https://github.com/EconForge/NLsolve.jl" target="_blank">NLsolve.jl</a> – Julia solvers for systems of nonlinear equations and mixed complementarity problems</li>
<li><a href="https://github.com/KristofferC/MMA.jl" target="_blank">MMA.jl</a> – The “Method of Moving Asymptotes”-algorithm. (old package)</li>
</ul>


</div>



<div id="DanielleNavarro">



<a href="https://djnavarro.net/about/" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Danielle Navarro </span>
              {/* <span className="p-nickname vcard-username d-block"></span> */}
            </h1>
            <h3>    <p>Hi there! I’m Danielle Navarro. I’m a 
              <a href="https://blog.djnavarro.net/" data-original-href="https://blog.djnavarro.net/">
            data scientist</a>, 
            
            <a href="https://art.djnavarro.net/" data-original-href="https://art.djnavarro.net/">generative artist</a>, and a <a href="https://papers.djnavarro.net/" data-original-href="https://papers.djnavarro.net/">recovering academic</a> living in Sydney with my two kids and a Netflix subscription. Once upon a time I was a mathematical psychologist. After that I was developer advocate and occasional software engineer. I’ve sometimes been accused of being a statistician.</p></h3>
          </a>




  
          <section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/2896325?v=4" 
  alt="@djnavarro profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/djnavarro" data-view-component="true" className="Link--primary Link text-bold">djnavarro  </a>
              <span data-view-component="true" className="color-fg-muted text-normal">Danielle Navarro</span>
            </p>
            <div>Data scientist. Former academic. Occasional generative artist</div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    233
                    repositories
                  </span>
                  <span>
                    1.1k
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>









          <header id="title-block-header" className="quarto-title-block default">
<div className="quarto-title">
<h1 className="title">Contact details, social media, etc</h1>
</div>



<div className="quarto-title-meta">

    
  
    
  </div>
  


</header>


<ul>
<li>Email: <a href="mailto:djnavarro@protonmail.com" data-original-href="mailto:djnavarro@protonmail.com">djnavarro@protonmail.com</a></li>
<li>GitHub: <a href="https://github.com/djnavarro" data-original-href="https://github.com/djnavarro">github.com/djnavarro</a></li>
<li>Mastodon: <a href="https://hachyderm.io/@djnavarro" data-original-href="https://hachyderm.io/@djnavarro">hachyderm.io/<span className="citation" data-cites="djnavarro">@djnavarro</span></a></li>
<li>LinkedIn: <a href="https://www.linkedin.com/in/djnavarro" data-original-href="https://www.linkedin.com/in/djnavarro">linkedin.com/in/djnavarro</a> 
{/* <!-- 
- YouTube: [www.youtube.com/c/daniellenavarro77](https://www.youtube.com/c/daniellenavarro77)
- Twitter (defunct): [twitter.com/djnavarro](https://twitter.com/djnavarro)
--> */}
</li>
<li>Orcid: <a href="https://orcid.org/0000-0001-7648-6578" data-original-href="https://orcid.org/0000-0001-7648-6578">orcid.org/0000-0001-7648-6578</a></li>
<li>Scholar: <a href="https://scholar.google.com/citations?user=QPH_lRIAAAAJ" data-original-href="https://scholar.google.com/citations?user=QPH_lRIAAAAJ">scholar.google.com/citations?user=QPH_lRIAAAAJ</a></li>
</ul>


<div className="quarto-title column-page-left">
      <h1 className="title">Notes from a data witch</h1>
            <p className="subtitle lead">A blog by Danielle Navarro</p>
                      </div>
                      <h3>    <p>Hi there! I’m Danielle Navarro.</p> 
              <p><a href="https://blog.djnavarro.net/" data-original-href="https://blog.djnavarro.net/">
              A blog by Danielle Navarro</a></p>
            </h3>

</div>





<div id="YihuiXie">



<a href="https://github.com/yihui" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">Yihui Xie </span>
              {/* <span className="p-nickname vcard-username d-block"></span> */}
            </h1>
            <h3>    <p>Hi there! I’m Yihui Xie. I’m a <a href="https://github.com/yihui" data-original-href="https://yihui.org/en/">
              Freelancer (open source programmer, contractor, blogger, and writer)</a></p></h3>
          </a>



          <p>I’m currently a freelancer, and was a software engineer at Posit Software, PBC
(2013-2023). I earned my PhD from the Department of Statistics, Iowa State
University. My <a href="https://lib.dr.iastate.edu/etd/13518/" title="https://lib.dr.iastate.edu/etd/13518/" target="_blank">thesis</a> was <em>Dynamic
<a href="https://github.com/ggobi/cranvas" title="https://github.com/ggobi/cranvas" target="_blank">Graphics</a> and <a href="/knitr/" title="https://yihui.org/knitr/">Reporting</a> for
Statistics</em>, advised by <a href="https://www.dicook.org" title="https://www.dicook.org/" target="_blank">Di Cook</a> and <a href="https://www.stat.iastate.edu/people/heike-hofmann" title="https://www.stat.iastate.edu/people/heike-hofmann" target="_blank">Heike
Hofmann</a>. I have developed a
series of R packages either seriously or for
<a href="https://cran.rstudio.com/package=fun" title="https://cran.rstudio.com/package=fun" target="_blank">fun</a> (or both), such as
<a href="/litedown/" title="https://yihui.org/litedown/">litedown</a>, <a href="/knitr/" title="https://yihui.org/knitr/">knitr</a>, <a href="/animation/" title="https://yihui.org/animation/">animation</a>,
<a href="https://bookdown.org" title="https://bookdown.org/" target="_blank">bookdown</a>,
<a href="https://github.com/rstudio/blogdown" title="https://github.com/rstudio/blogdown" target="_blank">blogdown</a>,
<a href="https://github.com/rstudio/pagedown" title="https://github.com/rstudio/pagedown" target="_blank">pagedown</a>,
<a href="https://slides.yihui.org/xaringan/" title="https://slides.yihui.org/xaringan/" target="_blank">xaringan</a>, and <a href="/tinytex/" title="https://yihui.org/tinytex/">tinytex</a>. I
founded a Chinese website called “<a href="https://cosx.org" title="https://cosx.org/" target="_blank">Capital of Statistics</a>” in
2006, which has grown into a large online community on statistics. I initiated
the China R conference in 2008. I’m a big fan of
<a href="https://github.com/yihui" title="https://github.com/yihui" target="_blank">GitHub</a>, <a href="https://www.lyx.org" title="https://www.lyx.org/" target="_blank">LyX</a> and
<a href="https://pandoc.org" title="https://pandoc.org/" target="_blank">Pandoc</a>. I used to hate IE but no longer care since it has
almost died. I fall asleep when I see beamer slides, and I yell at people who
use <code>\textbf{}</code> to write <code>\title{}</code>. I know I cannot eat code, so I cook almost
every day to stay away from my computer for two hours.</p>


<p>Author: <a href="https://github.com/yihui" target="_blank">Yihui Xie</a><br></br>
  I was introduced to this Author by this Mastodon post - 
  <a href="https://hachyderm.io/@djnavarro/113477662963181887" target="_blank">hachyderm.io/@djnavarro/113477662963181887</a><br></br>
  by the Author 
  <a href="https://hachyderm.io/@djnavarro" target="_blank">hachyderm.io/@djnavarro</a>
</p>


  
<section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/Rishit-dagli" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/163582?v=4" 
  alt="@djnavarro profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/yihui" data-view-component="true" className="Link--primary Link text-bold">yihui </a>
              <span data-view-component="true" className="color-fg-muted text-normal">Yihui Xie</span>
            </p>
            <div> <p>Hi there! I’m Yihui Xie. I’m a <a href="https://github.com/yihui" data-original-href="https://yihui.org/en/">
            Freelancer (open source programmer, contractor, blogger, and writer)</a></p></div>

              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    89
                    repositories
                  </span>
                  <span>
                    9.6k
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>




<h2>2018</h2>
<li><span>2018-07-30</span> <a href="https://yihui.org/en/2018/07/sql-stats-computing/">Solving Statistical Computing Problems with SQL</a></li>
</div>

<div id="@tslumley">

<a href="https://x.com/tslumley" className="vcard-names1" style={{ textDecoration: 'underline' }}>
          <h1>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            ThomasLumley </span>
            <span className="p-nickname vcard-username d-block">
            on Mastodon and Blu Esky
            </span>
          </h1>
        </a>

<p>
  I got this tweet: <a href="https://x.com/tslumley/status/1023850297028829184" target="_blank">Thomas Lumley on X: "Blog post, software, and preprint for my #JSM2018 talk/poster"</a><br></br>
  from this Author: <a href="https://yihui.org/en/" target="_blank">Yihui Xie</a><br></br>
  from his blog post: <a href="https://yihui.org/en/2018/07/sql-stats-computing/" target="_blank">Solving Statistical Computing Problems with SQL - Yihui Xie | 谢益辉</a>
</p>


<a href="https://notstatschat.rbind.io/2018/03/05/faster-generalised-linear-models-in-largeish-data/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
  <h1 className="article-title" style={{ margin: 0, flex: 1 }}>
    Faster generalised linear models in largeish data
  </h1>
  <span className="article-date" style={{ marginLeft: '10px' }}>
    2018/03/05
  </span>
</a>


<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/tslumley" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Thomas Lumley</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/tslumley" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@tslumley</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @tslumley" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow tslumley
    </div>
  </div>
</div>






</div>




<div id="roboticcam-machine-learning-note">


          <a
  href="https://github.com/roboticcam"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Prof Richard Xu
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Prof Richard Xu. I’m a{' '}
      <a
        href="https://github.com/roboticcam"
        data-original-href="https://github.com/roboticcam"
      >
        <div style={{ margin: 0 }}>
          I am a Professor at the Department of Mathematics, Hong Kong Baptist
          University (HKBU) 香港浸会大学数学系教授
        </div>
      </a>
    </p>
  </h3>
</a>



<section aria-label="card content" data-view-component="true" className="mt-0">       
     <div className="d-flex color-bg-subtle rounded-1 flex-justify-between p-3">
        <div className="d-flex">
          <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;avatar&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="3d157f5bd2d7b8717fe26a1be53aea1739fdce9b4de42cb7541db64bd93f260e" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_avatar&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="/roboticcam" data-view-component="true" className="Link d-block">
          {/* <img src="https://avatars.githubusercontent.com/u/39672672?s=96&amp;v=4" alt="@Rishit-dagli profile" size="48" height="48" width="48" data-view-component="true" className="feed-item-user-avatar avatar circle box-shadow-none"></img>
           */}
          <img 
  src="https://avatars.githubusercontent.com/u/13326498?v=4" 
  alt="@roboticcam profile" 
  height="48" 
  width="48" 
  data-view-component="true" 
  className="feed-item-user-avatar avatar circle box-shadow-none" 
/>
</a>
          <div className="ml-2">
            <p className="css-truncate text-bold wb-break-all m-0">
              <a data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;feed_user_link&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;metadata&quot;:{&quot;clicked_resource_type&quot;:&quot;USER&quot;,&quot;clicked_resource_id&quot;:39672672},&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="03ec8bcf1c360f8a58bb14636519040264e7fa8309f53fc8de53845452d0d76b" data-hovercard-type="user" data-hovercard-url="/users/Rishit-dagli/hovercard?event_type=feeds.feed_click&amp;hover_target=feed_user_login&amp;payload%5Bfeed_card%5D%5Bassignment_context%5D=c-cb738117%3A109742%3Bjccid629%3A115315%3B79878423%3A116832%3B6cha1124%3A143780%3B4h1jc170%3A184406%3B&amp;payload%5Bfeed_card%5D%5Bcard_position%5D=4&amp;payload%5Bfeed_card%5D%5Bcard_retrieved_id%5D=2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&amp;payload%5Bfeed_card%5D%5Bcard_sub_position%5D=&amp;payload%5Bfeed_card%5D%5Bcard_type%5D=FOLLOW&amp;payload%5Bfeed_card%5D%5Bcreated_at%5D=2025-01-06+21%3A15%3A42+-0800&amp;payload%5Bfeed_card%5D%5Bgatherer%5D=user&amp;payload%5Bfeed_card%5D%5Branking_model_id%5D=chronological&amp;payload%5Bfeed_card%5D%5Brecord_id%5D=39672672&amp;payload%5Bfeed_card%5D%5Bresource_id%5D=44053202&amp;payload%5Bfeed_card%5D%5Bresource_relationship%5D=followed&amp;payload%5Bfeed_card%5D%5Bresource_type%5D=USER&amp;payload%5Bfeed_card%5D%5Bvariant%5D=%7B%7D&amp;payload%5Bmetadata%5D%5Bclicked_resource_id%5D=39672672&amp;payload%5Bmetadata%5D%5Bclicked_resource_type%5D=USER&amp;payload%5Boriginal_request_id%5D=6ABF%3AB6243%3A26C236%3A2F7A3C%3A677CC3A7" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/roboticcam" data-view-component="true" className="Link--primary Link text-bold">roboticcam  </a>
              <span data-view-component="true" className="color-fg-muted text-normal">   Prof Richard Xu                 徐亦达教授</span>
            </p>
       
            <div>I am a Professor at the Department of Mathematics, Hong Kong Baptist University (HKBU) 香港浸会大学数学系教授</div>
              <p className="m-0 mt-1 color-fg-muted">
                  <span className="mr-3">
                    13
                    repositories
                  </span>
                  <span>
                    5.1k
                    followers
                  </span>
              </p>
          </div>
        </div>

        <div className="ml-1">
          
{/* <span className="user-following-container js-form-toggle-container">
     <!-- '"` --><!-- </textarea></xmp> --> 
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" accept-charset="UTF-8" method="post" hidden=""><input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w">
      <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow">
</form>
   <!-- '"` --><!-- </textarea></xmp> --> 
  <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" accept-charset="UTF-8" method="post"><input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw">
    <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli">
</form>  </span> */}


<span className="user-following-container js-form-toggle-container">
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are following Rishit-dagli" data-turbo="false" action="/users/follow?target=Rishit-dagli" acceptCharset="UTF-8" method="post" hidden>
        <input type="hidden" name="authenticity_token" value="JodqzEyzLBXuymirb0_UYousEn4-PCoRC2oVdnJcD7PhXgLGtiMCx7JqSAYjcENt3axB03RDq5zMwrfL7Eg74w" />
        <input type="submit" name="commit" value="Follow" className="btn btn-sm" title="Follow Rishit-dagli" aria-label="Follow Rishit-dagli" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Follow" />
    </form>
    {/* <!-- '"` --><!-- </textarea></xmp> --> */}
    <form className="js-form-toggle-target" data-sr-feedback="You are unfollowing Rishit-dagli" data-turbo="false" action="/users/unfollow?target=Rishit-dagli" acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value="DVmoX7Y9dBK9A0ZB1JcSEI8Qy0iFgS0NXJCLXk-PaNoH4quScA5OP-LwYDfMJoA4aYkK3zf03rFiVwsB65j9Dw" />
        <input type="submit" name="commit" value="Unfollow" className="btn btn-sm" data-hydro-click="{&quot;event_type&quot;:&quot;feeds.feed_click&quot;,&quot;payload&quot;:{&quot;click_target&quot;:&quot;follow_button&quot;,&quot;feed_card&quot;:{&quot;card_type&quot;:&quot;FOLLOW&quot;,&quot;resource_relationship&quot;:&quot;followed&quot;,&quot;created_at&quot;:&quot;2025-01-06T21:15:42.000-08:00&quot;,&quot;record_id&quot;:39672672,&quot;resource_type&quot;:&quot;USER&quot;,&quot;resource_id&quot;:44053202,&quot;card_position&quot;:4,&quot;card_sub_position&quot;:null,&quot;card_retrieved_id&quot;:&quot;2F69FF6F-BD7C-4531-BE52-D8EED1D68A91&quot;,&quot;ranking_model_id&quot;:&quot;chronological&quot;,&quot;gatherer&quot;:&quot;user&quot;,&quot;variant&quot;:&quot;{}&quot;,&quot;assignment_context&quot;:&quot;c-cb738117:109742;jccid629:115315;79878423:116832;6cha1124:143780;4h1jc170:184406;&quot;},&quot;original_request_id&quot;:&quot;6ABF:B6243:26C236:2F7A3C:677CC3A7&quot;,&quot;originating_url&quot;:&quot;https://github.com/conduit/for_you_feed&quot;,&quot;user_id&quot;:30724917}}" data-hydro-click-hmac="48c17575211694b6fb0401c069c7e9882740180e5345c331dc3789526fdce814" data-disable-with="Unfollow" title="Unfollow Rishit-dagli" aria-label="Unfollow Rishit-dagli" />
    </form>
</span>


        </div>
      </div>
</section>


<RoboticCamMachineLearningNotesGithubRepository  />

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Course on Foundational Mathematics in Machine Learning 机器学习基础数学课程</h1>
<h1 
// tabindex="-1"
 className="heading-element" dir="auto">Course on Intemediate Mathematics in Machine Learning 机器学习中级数学课程</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Sinovation DeeCamp 创新工场DeeCAMP讲义</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Deep Learning Research Topics 深度学习研究</h1>
<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Optimization Method 优化方法</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Deep Learning Basics 深度学习基础</h1>
<h3 
// tabindex="-1" 
className="heading-element" dir="auto"><a href="https://github.com/roboticcam/machine-learning-notes/blob/master/files/rbm_cd.pdf">Restricted Boltzmann Machine</a></h3>
<h1
 // tabindex="-1" 
className="heading-element" dir="auto">3D Geometry Computer vision 3D几何计算机视觉</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Reinforcement Learning 强化学习</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Natural Language Processing 自然语言处理</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Data Science PowerPoint and Source Code 数据科学 PowerPoint 和源代码</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Probabilistic Model 概率模型课件</h1>

<h1 
// tabindex="-1"
 className="heading-element" dir="auto">Monte-Carlo Inference 蒙特卡洛推理</h1>

<h1 
// tabindex="-1" 
className="heading-element" dir="auto">Advanced Probabilistic Model 高级概率模型课件</h1>
</div>



<div id="AlexanderFischerGitHubProfile">


<a
  href="https://github.com/s3alfisc"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Alexander Fischer
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Alexander Fischer.
      <a
        href="https://github.com/s3alfisc"
        data-original-href="https://github.com/s3alfisc"
      >
          <div>Data Scientist <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/trivago/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/trivago">@trivago</a> </div>
      </a>
    </p>
  </h3>
</a>


<JuanitorduzGitHubProfile /> 
<p>
  follows
</p>
<AlexanderFischerGitHubProfile />



            <li className="no-margin-bottom1">
              <a
                href="#KristofSchröder_scikit_learn_scikit_learn_issues_30748_Unexpected_behavior_for_subclassing_Pipeline"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    Kristof Schröder(@schroedk)
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <p>
                  Kristof Schröder(<a href="https://github.com/schroedk">https://github.com/schroedk</a>) Created an issue in 1 repository
                  <br />
                  <a href="scikit-learn/scikit-learn/issues/30748">scikit-learn/scikit-learn</a> on 2/2/25 that received 4 comments
                </p>
                <p style={{ margin: 0 }}>
                  <a href="https://github.com/scikit-learn/scikit-learn/issues/30748">Visit the GitHub Issue: Unexpected behavior for subclassing Pipeline #30748  </a>
                </p>
              </section>
            </li>

</div>

          <div id="KristofSchröder">
            <a
              href="https://github.com/schroedk"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Kristof Schröder
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Kristof Schröder.
                  <a
                    href="https://github.com/schroedk"
                    data-original-href="https://github.com/schroedk"
                  >
                  </a>
                </p>
              </h3>
            </a>

            <div id="KristofSchröder_scikit_learn_scikit_learn_issues_30748_Unexpected_behavior_for_subclassing_Pipeline">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Kristof Schröder(<a href="https://github.com/schroedk">https://github.com/schroedk</a>) Created an issue in 1 repository
                  <br />
                  <a href="scikit-learn/scikit-learn/issues/30748">scikit-learn/scikit-learn</a> on 2/2/25 that received 4 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/scikit-learn/scikit-learn/issues/30748">Visit the GitHub Issue: Unexpected behavior for subclassing Pipeline #30748  </a>
                </div>
              </section>
            </div>
          </div>

          <div id="py_econometrics_pyfixest">
            <a
              href="https://github.com/py-econometrics/pyfixest"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  py-econometrics/pyfixest
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m py-econometrics/pyfixest GitHub repository.
                  <a
                    href="https://github.com/py-econometrics/pyfixest"
                    data-original-href="https://github.com/py-econometrics/pyfixest"
                  >
                  </a>
                </p>
              </h3>
            </a>
          </div>

          <div id="TrevorManz">
            <a
              href="https://github.com/manzt"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Trevor Manz
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Trevor Manz.
                  <a
                    href="https://github.com/manzt"
                    data-original-href="https://github.com/manzt"
                  >
                  </a>
                </p>
              </h3>
            </a>

            <div id="Trevor_Manz_marimo_team_marimo_lsp_pull_159_Remove_type_assertions_from_mocks">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Trevor Manz(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created a PR in 1 repository
                  <br />
                  <a href="marimo-team/marimo-lsp/pull/159">marimo-team/marimo-lsp/</a> on 22/10/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/marimo-team/marimo-lsp/pull/159">Visit the GitHub PR: Remove type assertions from mocks #159  </a>
                </div>
              </section>
            </div>
          </div>

          <div id="marimo_team_marimo">
            <a
              href="https://github.com/marimo-team/marimo"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  marimo-team/marimo
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                /marimo-team/marimo
              </h3>
            </a>
          </div>


<div id="RossWightmanGitHubProfile">


<a
  href="https://github.com/rwightman"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Ross Wightman
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Ross Wightman.
      <a
        href="https://github.com/rwightman"
        data-original-href="https://github.com/rwightman"
      >
          <div>Computer Vision <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/huggingface/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/huggingface">@huggingface</a>. Always learning, constantly curious. Building ML/AI systems, watching loss curves.</div>
      </a>
    </p>
  </h3>
</a>

<RossWightmanGitHubProfile/>
</div>
{/* <div id="YixuanQiu">


<DanielleNavarroGitHubProfile /> <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ width: '96px', height: '78px', marginLeft: '10px' }}/>
</div> */}


          <div id="MilesCranmer">
            <a
              href="https://github.com/MilesCranmer"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Miles Cranmer
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m  Miles Cranmer.
                  <a
                    href="https://github.com/MilesCranmer"
                    data-original-href="https://github.com/MilesCranmer"
                  >
                    <div>

                      {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
                    </div>
                  </a>
                </p>
              </h3>
            </a>
            <MilesCranmerGitHubProfile />
            <MilesCranmerPR_From_2025_03_01_To_2025_03_31_PySR_845_fix_comparison_operator_parsing />

            <MilesCranmerPR_JuliaNLSolvers_Optim_jl_pull_1084_From_2025_03_01_To_2025_03_31_Create_benchmark_suite />

            <div style={{ display: 'flex', alignItems: 'center' }}>

              {/* <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <JonShlensGitHubProfile />
  <strong style={{ marginLeft: '10px' }}>Reference:  </strong>
  <a href="https://github.com/tensorflow/models/issues/2778" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none', color: '#007bff' }}>
    PR - Odd batch_size specific behaviour with nasnet_large on ImageNet validation #2778
  </a> */}

              {/* <a href="https://hachyderm.io/@djnavarro/113477662963181887" target="_blank">hachyderm.io/@djnavarro/113477662963181887</a><br></br> */}
            </div>

          </div>

          <div id="prasanta_chandra_mahalanobis">
            <a
              href="https://azimpremjiuniversity.edu.in/indian-economists/prasanta-chandra-mahalanobis"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Prasanta Chandra (P.C.) Mahalanobis
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m  Prasanta Chandra (P.C.) Mahalanobis.
                  <a
                    href="https://azimpremjiuniversity.edu.in/indian-economists/prasanta-chandra-mahalanobis"
                    data-original-href="https://azimpremjiuniversity.edu.in/indian-economists/prasanta-chandra-mahalanobis"
                  >
                  </a>
                </p>
              </h3>
            </a>


            <li className="no-margin-bottom1">
              <a
                href="#lmcinnes_pynndescent_pull_257__Add_docstrings_for_various_distance_functions_in_distances_py_file"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  lmcinnes/pynndescent
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Leland McInnes(lmcinnes)(<a href="https://github.com/lmcinnes">https://github.com/lmcinnes</a>) Opened 1  PR
                  <br />
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">lmcinnes/pynndescent</a> on 7/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub PR: Optimize 0.6dev #257 </a>
                </div>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub commit: Add docstrings for various distance functions in distances.py
                    #257 </a>
                </div>
              </section>
            </li>


            <li className="no-margin-bottom1">
              <a
                href="#wiki_Artificial_Intelligence:_A_Modern_Approach#Chapter18_7_NonParametricModels_18_7_1_NearestNeighbor_models_Mahalanobis_Distance_Page677_678"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  Artificial_Intelligence:_A_Modern_Approach  Mahalanobis_Distance_Page677_678
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p> Page 678 Chapter 18 Learning from Examples <br></br>
                  Often Euclidean distance is used if the dimensions are measuring similar properties, such as weight, height, and depth of parts, and Manhattan distance is used if they are dissimilar, such as age, weight, and gender of a patient. Note that if we use the raw numbers from each dimension then the total distance will be affected by a change in units in any dimensions. That is, if we chanage the <i>height</i> dimension from metres to miles while keeping the <i>width</i> and <i>depth</i> dimensions the same, we’ll get different nearest neighbours. And how do we compare a difference in age to difference in weight? A common approach is to apply <strong>normalization</strong> to the measurements in each dimension.
                  Μi
                  A more complex metric known as <strong>Mahalanobis distance</strong> takes into account the covariance between dimensions.
                </p>
              </section>
            </li>


          </div>


          <div id="Leland_McInnes">
            <a
              href="https://github.com/lmcinnes"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Leland McInnes(lmcinnes)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m  Leland McInnes(lmcinnes).
                  <a
                    href="https://github.com/lmcinnes"
                    data-original-href="https://github.com/lmcinnes"
                  >
                  </a>
                </p>
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#lmcinnes_pynndescent_pull_257__Add_docstrings_for_various_distance_functions_in_distances_py_file"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  lmcinnes/pynndescent
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Leland McInnes(lmcinnes)(<a href="https://github.com/lmcinnes">https://github.com/lmcinnes</a>) Opened 1  PR
                  <br />
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">lmcinnes/pynndescent</a> on 7/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub PR: Optimize 0.6dev #257 </a>
                </div>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub commit: Add docstrings for various distance functions in distances.py
                    #257 </a>
                </div>
              </section>
            </li>

            <li className="no-margin-bottom1">
              <a
                href="#TutteInstitute_hirank_issues_11"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}  TutteInstitute/hirank Random thoughts #11
                  </span>
                </h3>
              </a>
              
               <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/TutteInstitute/hirank/issues/11"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Random thoughts #11
                </a>
                <p>
                  Leland McInnes(lmcinnes)(<a href="https://github.com/lmcinnes">https://github.com/lmcinnes</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/TutteInstitute/hirank/issues/11">TutteInstitute/hirank</a> on 23/6/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/TutteInstitute/hirank/issues/11"> Visit the full Article: Random thoughts #11  </a>
                </div>
              </section>
            </li>






          </div>




          <div id="lmcinnes_pynndescent">
            <a
              href="https://github.com/lmcinnes/pynndescent"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  lmcinnes/pynndescent
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                lmcinnes/pynndescent
              </h3>
            </a>

            <div id="lmcinnes_pynndescent_pull_257__Add_docstrings_for_various_distance_functions_in_distances_py_file">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Leland McInnes(lmcinnes)(<a href="https://github.com/lmcinnes">https://github.com/lmcinnes</a>) Opened 1  PR
                  <br />
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">lmcinnes/pynndescent</a> on 7/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub PR: Optimize 0.6dev #257 </a>
                </div>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lmcinnes/pynndescent/pull/257">Visit the GitHub commit: Add docstrings for various distance functions in distances.py
                    #257 </a>
                </div>
              </section>
            </div>
          </div>




<div id="DavisVaughan">



<a
  href="https://github.com/DavisVaughan"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    DavisVaughan
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  DavisVaughan.
      <a
        href="https://github.com/DavisVaughan"
        data-original-href="https://github.com/DavisVaughan"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

{/* <div style={{ display: 'flex', alignItems: 'center' }}>
<HamelHusainGitHubProfile />
https://github.com/hamelsmu?tab=following
<p></p>
  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <ChristopheDervieuxGitHubProfile />
  https://bsky.app/profile/cderv.bsky.social
  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <p>
  https://bsky.app/profile/davisvaughan.bsky.social
  
  <strong style={{ marginLeft: '10px' }}>Reference:  </strong>
  <a href="https://bsky.app/profile/davisvaughan.bsky.social/post/3lip3me7i5c2i" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none', color: '#007bff' }}>
  Air, an extremely fast R formatter by Davis Vaughan
  </a>
  </p>
</div> */}


<div style={{ display: 'flex', alignItems: 'center' }}>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <HamelHusainGitHubProfile />
    <a href="https://github.com/hamelsmu?tab=following" target="_blank" style={{ textDecoration: 'none', color: '#007bff', marginTop: '5px' }}>
      https://github.com/hamelsmu?tab=following
    </a>
  </div>

  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />

  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <ChristopheDervieuxGitHubProfile />
    <a href="https://bsky.app/profile/cderv.bsky.social" target="_blank" style={{ textDecoration: 'none', color: '#007bff', marginTop: '5px' }}>
      https://bsky.app/profile/cderv.bsky.social
    </a>
  </div>

  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />

  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <a href="https://bsky.app/profile/davisvaughan.bsky.social" target="_blank" style={{ textDecoration: 'none', color: '#007bff', marginTop: '5px' }}>
      https://bsky.app/profile/davisvaughan.bsky.social
    </a>
    
    <strong style={{ marginTop: '10px' }}>Reference: </strong>
    <a href="https://bsky.app/profile/davisvaughan.bsky.social/post/3lip3me7i5c2i" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none', color: '#007bff' }}>
      Air, an extremely fast R formatter by Davis Vaughan
    </a>
  </div>
</div>
<DavisVaughanGitHubProfile />



<div className="quarto-grid-item-container">
  <a className="quarto-grid-link" href="https://blog.davisvaughan.com/posts/2017-05-10-aws-rds-r/" data-original-href="https://blog.davisvaughan.com/posts/2017-05-10-aws-rds-r/">
    <div className="quarto-grid-item card h-100 card-center borderless">
      <div className="card-body post-contents">
        <h5 className="no-anchor card-title listing-title">
          Amazon RDS + R
        </h5>
        <div className="card-attribution card-text-small end">
          <div className="listing-date">
            May 10, 2017
          </div>
        </div>
      </div>
    </div>
  </a>
</div>

</div>

<div id="JonShlens">



<a
  href="https://github.com/shlens"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Jon Shlens
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Jon Shlens.
      <a
        href="https://github.com/shlens"
        data-original-href="https://github.com/yixuan/"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

<div style={{ display: 'flex', alignItems: 'center' }}>
<RossWightmanGitHubProfile />
  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <JonShlensGitHubProfile />
  <strong style={{ marginLeft: '10px' }}>Reference:  </strong>
  <a href="https://github.com/tensorflow/models/issues/2778" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none', color: '#007bff' }}>
    PR - Odd batch_size specific behaviour with nasnet_large on ImageNet validation #2778
  </a>
 
  {/* <a href="https://hachyderm.io/@djnavarro/113477662963181887" target="_blank">hachyderm.io/@djnavarro/113477662963181887</a><br></br> */}
</div>


<div className="" id="publications-text">
    <h2 id="tutorials">Tutorials</h2>

    <p>These tutorials provide a general introduction to topics I find quite interesting but often lack good explanations in textbooks or the online literature.</p>

    <section className="tutorial">
        <a target="_blank" href="http://arxiv.org/abs/1404.2986">
            Tutorial on Independent Component Analysis
        </a>
        <p>A complete introduction and discussion of independent component analysis. Builds on previous tutorial on principal component analysis.</p>
        <p><strong>Version 1.0</strong></p>
    </section>

    <section className="tutorial">
        <a target="_blank" href="http://arxiv.org/abs/1404.1100">
            Tutorial on Principal Component Analysis
        </a>
        <p>A full introduction, description, derivation, and discussion of principal component analysis. Concrete examples for intuition building, the mathematical relation to SVD, and new extensions of this algorithm.</p>
        <p><strong>Version 3.02</strong></p>
    </section>

    <section className="tutorial">
        <a target="_blank" href="http://arxiv.org/abs/1404.1998">
            A Light Discussion and Derivation of Entropy
        </a>
        <p>A light discussion of the underlying assumptions behind entropy followed by a rigorous but simple derivation of the formula for entropy.</p>
        <p><strong>Version 1.01</strong></p>
    </section>

    <section className="tutorial">
        <a target="_blank" href="http://arxiv.org/abs/1404.2000">
            Notes on Kullback-Leibler Divergence and Likelihood
        </a>
        <p>An intuitive discussion about where Kullback-Leibler divergence arises and its relationship to likelihood theory.</p>
        <p><strong>Version 1.01</strong></p>
    </section>

    <section className="tutorial">
        <a target="_blank" href="http://arxiv.org/abs/1404.1999">
            Notes on Generalized Linear Models of Neurons
        </a>
        <p>An introduction to the application of GLMs to model neurons and networks of neurons. Brief discussion and derivation of primary equations pertaining to maximum likelihood estimation.</p>
        <p><strong>Version 1.51</strong></p>
    </section>

</div>



</div>





<div id="YixuanQiu1">



<a
  href="https://github.com/yixuan/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yixuan Qiu
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Yixuan Qiu.
      <a
        href="https://github.com/yixuan/"
        data-original-href="https://github.com/yixuan/"
      >
          <div>
            
          <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p>
            </div>
      </a>
    </p>
  </h3>
</a>

<div style={{ display: 'flex', alignItems: 'center' }}>
<DanielleNavarroGitHubProfile />
  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <YihuiXieGitHubProfile />
  <strong style={{ marginLeft: '10px' }}>Reference:  Mastodon post - </strong>
  <a href="https://hachyderm.io/@djnavarro/113477662963181887" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none', color: '#007bff' }}>
    hachyderm.io/@djnavarro/113477662963181887
  </a>
 
  {/* <a href="https://hachyderm.io/@djnavarro/113477662963181887" target="_blank">hachyderm.io/@djnavarro/113477662963181887</a><br></br> */}
</div>
<div style={{ display: 'flex', alignItems: 'center' }}>
<YihuiXieGitHubProfile />
  <img src="/assets/right-arrow-svgrepo-com.svg" alt="Right Arrow" style={{ marginLeft: '10px', width: '96px', height: '78px' }} />
  <YixuanQiuGitHubProfile />
  <strong style={{ marginLeft: '10px' }}>Reference:  Yihui Xie's post - </strong>
 
  <a href="https://yihui.org/en/2018/07/sql-stats-computing/" target="_blank" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center'}}>Solving Statistical Computing Problems with SQL - Yihui Xie | 谢益辉</a>
 

</div>

</div>



<div id="StevenGJohnson">


<a
  href="https://github.com/stevengj"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Steven G. Johnson
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Steven G. Johnson.
      <a
        href="https://github.com/stevengj"
        data-original-href="https://github.com/stevengj"
      >
           <div style={{ textAlign: 'center' }}>
      Professor of{' '}
      <a
        href="http://math.mit.edu/applied/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Applied Mathematics
      </a>{' '}
      and{' '}
      <a
        href="http://web.mit.edu/physics/people/faculty/johnson_steven.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Physics, Massachusetts Institute of Technology
      </a>
      <br />
    </div>

      </a>
    </p>
  </h3>
</a>

<StevenGJohnsonGitHubProfile />
<Stevengj_JuliaMath_FastChebInterp_jl_issues_24_From_2025_1_01_To_2025_3_31 />
<a
        href="https://github.com/stevengj?tab=overview&from=2023-07-01&to=2023-07-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from July 1, 2023 to July 31, 2023
      </a>
<div>
<a
        href="https://github.com/stevengj?tab=overview&from=2023-07-01&to=2023-07-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/stevengj?tab=overview&from=2023-07-01&to=2023-07-31
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
>
  <bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title">
  Random.randcycle(1) should throw?
  </bdi>
  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/JuliaLang/julia/issues/50479" target="_blank" rel="noopener noreferrer">
      #50479
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/stevengj" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">stevengj</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>opened </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/JuliaLang/julia/issues/50479" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Jul 09, 2023</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
 
  
</div>
<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>  on </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/JuliaLang/julia/issues/50479#issuecomment-1627827580" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Jul 10, 2023</relative-time></a>
</div>
<p dir="auto">I found <a href="https://sci-hub.se/https://doi.org/10.1007/BF01941134" rel="nofollow">another paper on Sattolo's algorithm</a> that defines cyclic permutations in a different way, which allows the identity permutation <em>only</em> for n=1:</p>
</div>



<div id="merveenoyan">
<h1
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
  // style={{
  //  // '--custom-font-size': '26px, 26px, var(--text-title-size-large, 32px)',
  //   '--custom-line-height': '1',
  //   '--custom-font-weight': 'normal',
  // }}
>
  <bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title">
    <code>AutoModel</code> class for <code>image-text-to-text</code> models
  </bdi>
  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/huggingface/transformers/issues/32042" target="_blank" rel="noopener noreferrer">
      #32042
    </a>
   
    </span>
</h1>
{/* 
<h1 className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO" data-component="PH_Title" data-hidden="false" style="--custom-font-size: 26px,26px,var(--text-title-size-large, 32px),var(--text-title-size-large, 32px); --custom-line-height: 1; --custom-font-weight: normal;">
  <bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title"><code>AutoModel</code> class for <code>image-text-to-text</code> models</bdi>&nbsp;<span className="Box-sc-g0xbh4-0 YJa-Di">#32042</span></h1> */}

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/merveenoyan" data-hovercard-url="/users/merveenoyan/hovercard" data-testid="issue-body-header-author">merveenoyan</a>


<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>opened </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/huggingface/transformers/issues/32042#issue-2415755863" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Jul 18, 2024</relative-time></a>
<span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/merveenoyan">merveenoyan</a></span></span></div>
</div>




</div>


<div id="ThomasStringer">



<a
  href="https://github.com/trstringer"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Thomas Stringer
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Thomas Stringer.
      <a
        href="https://github.com/trstringer"
        data-original-href="https://github.com/trstringer"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>
 <section className="section-gap-trstringer">
<a
  href="https://github.com/trstringer/manual-approval/issues/148"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>

                      <h3 style={{ margin: 0 }}>
            <p style={{ margin: 0 }}>
            Call for maintainers! #148.
              <a
                href="https://github.com/trstringer/manual-approval/issues/148"
                data-original-href="https://github.com/trstringer/manual-approval/issues/148"
              >
                  <div>
                    
                  {/* <p>Currently an associate professor in
        <a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
        <a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
                    </div>
              </a>
            </p>
          </h3>
        </a>
        <p dir="auto"><strong>Who should be a maintainer?</strong> Somebody with GitHub Actions experience, or the desire to obtain that experience. Also a maintainer should be a modern code craftsperson that is passionate about shipping production-quality software. This GitHub Action can be part of important build and deployment pipelines. Not to mention, it is likely running inside many existing users' environments in their runners. It is important that changes are well-tested, and are the right thing for our users.</p>

        <p>
              <strong>Manual Approval in a GitHub Actions Workflow</strong><br />
              <strong>Posted:</strong> March 28, 2022<br />
              <strong>Updated:</strong> March 28, 2022<br />
              <a href="https://trstringer.com/github-actions-manual-approval/">Visit the full article here</a>
            </p>
            <a href="https://trstringer.com/github-actions-manual-approval/" target="_blank" rel="noopener noreferrer"> Visit the full article: Manual Approval in a GitHub Actions Workflow | Posts · 28/3/2022 · 4 minutes </a>
            <p></p>
        <a href="https://github.com/trstringer/manual-approval/issues" 
          target="_blank" 
          rel="noopener noreferrer">
          Open an issue on the trstringer/manual-approval repository
        </a>

 </section>


</div>

<div id="MartinEvans">



<a
  href="https://github.com/martindevans"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Martin Evans
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Martin Evans.
      <a
        href="https://github.com/martindevans"
        data-original-href="https://github.com/martindevans"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

<a rel="nofollow me" className="Link--primary wb-break-all" href="http://martindevans.me">http://martindevans.me</a>
<h2 id="llamasharp">LLamaSharp</h2>
<p><a href="https://github.com/SciSharp/LLamaSharp">LLamaSharp</a> is a C# wrapper around <a href="https://github.com/ggerganov/llama.cpp">llama.cpp</a>. This is <strong>not</strong> my project alone, but I became one of the lead maintainers last year and I&#39;ve continued working on it this year.</p>
<p>In 2024 my major contribution to LLamaSharp was the development of the <a href="https://github.com/SciSharp/LLamaSharp/blob/master/LLama/Batched/BatchedExecutor.cs"><code className="language-plaintext highlighter-rouge">BatchedExecutor</code></a> which is an entirely new low-level abstraction around language models. The <code className="language-plaintext highlighter-rouge">BatchedExecutor</code> is designed to expose all of the power of llama.cpp in a safe way, for example multiple parallel sequences evaluated all together in one batch is as simple as:</p>
<p>Sequences can be easily saved and loaded, forked into 2 sequences with the same prefix (which internally share the same space in memory), the KV cache can be accessed and manipulated (e.g. to implement context shifting), sequences can even be prompted with embeddings directly which allows things like LLava.</p>
<p>My long term goal for 2025 is to rewrite many of the higher level parts of LLamaSharp to operate on top of the <code className="language-plaintext highlighter-rouge">BatchedExecutor</code>, this will reduce the overall complexity of the project by implementing it all in one place and should offer more power to advanced users since they can always build on top of <code className="language-plaintext highlighter-rouge">BatchedExecutor</code> instead of using the low level llama.cpp primitives.</p>
</div>


<div id="MartinEvans">



<a
  href="https://github.com/martindevans"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Martin Evans
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m  Martin Evans.
      <a
        href="https://github.com/martindevans"
        data-original-href="https://github.com/martindevans"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>
<section className="section-gap-MartinEvans">
<p>
Martin Evans (<a href="https://github.com/martindevans">https://github.com/martindevans</a>) starred a repository on 5/4/25
  <br />
  <a href="https://github.com/MerlinVR/UdonSharp">https://github.com/MerlinVR/UdonSharp </a> (C#) 706 STARS
</p>
<MerlinVR_UdonSharp_ContributorList />
<MomotheMonsterGitHubProfile />
<h3>
  <a href="https://github.com/momo-the-monster?tab=following" target="_blank" rel="noopener noreferrer">
    Followings of	Momo the Monster(momo-the-monster) on GitHub
  </a>
</h3>
<h3>
  <a href="https://github.com/jcowles?tab=following" target="_blank" rel="noopener noreferrer">
    Followings of	Jeremy Cowles (jcowles) on GitHub
  </a>
</h3>
<ChristophKubischGitHubProfile />
<a href="https://pixeljetstream.blogspot.com/2015/02/life-of-triangle-nvidias-logical.html" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the full article: Life of a triangle - NVIDIA's logical pipeline | Posts · 6/02/2016 
  </a>
  <h2>Further reading</h2>
  {/* <p>
  Next to the white papers mentioned at the beginning, the article series <a href="https://fgiesen.wordpress.com/2011/07/09/a-trip-through-the-graphics-pipeline-2011-index/">"A trip through the graphics-pipeline"</a> by Fabian Giesen is worth a read and there is also a <a href="http://on-demand.gputechconf.com/gtc/2013/video/S3466-Performance-Optimization-Guidelines-GPU-Architecture-Details.mp4">quite in-depth talk</a>
  </p> */}
  <p>
  Next to the white papers mentioned at the beginning, the article series 
  <a href="https://fgiesen.wordpress.com/2011/07/09/a-trip-through-the-graphics-pipeline-2011-index/">"A trip through the graphics-pipeline"</a> 
  by Fabian Giesen is worth a read and there is also a 
  <a href="http://on-demand.gputechconf.com/gtc/2013/video/S3466-Performance-Optimization-Guidelines-GPU-Architecture-Details.mp4">quite in-depth talk</a>
</p>

<a href="https://fgiesen.wordpress.com/" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the Blog: The ryg blog (When I grow up I'll be an inventor)
  </a>
</section>


<p>
Martin Evans (<a href="https://github.com/martindevans">https://github.com/martindevans</a>) starred a repository on 5/4/25
  <br />
  <a href="https://github.com/nietras/Llm.cs">https://github.com/nietras/Llm.cs </a> (C#) 49 STARS

</p>
</div>

<div id="CédricLuthi">

  
<a
  href="https://github.com/0xced"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Cédric Luthi
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Cédric Luthi.
      <a
        href="https://github.com/0xced"
        data-original-href="https://github.com/0xced"
      >
          

      </a>
    </p>
  </h3>
</a>

<a rel="nofollow me" className="Link--primary wb-break-all" href="https://hachyderm.io/@0xced">@0xced@hachyderm.io</a>

<section  className="section-gap-cédric-luthi">
    <p>
        Philipp Wagner (<a href="https://github.com/bytefish">https://github.com/bytefish</a>) 
        followed Cédric Luthi (<a href="https://github.com/0xced">https://github.com/0xced</a>) on 25/1/25.
    </p>

   
</section>


<section className="section-gap-cédric-luthi">
    <p>
Cédric Luthi (<a href="https://github.com/0xced">https://github.com/0xced</a>) Created a pull request on 13/8/25
  <br />
  <a href="https://github.com/Arcenox-co/TickerQ/pull/169">Arcenox-co/TickerQ/pull/169 </a> that received 18 comments

</p>
<Cédric_Luthi_0xced_PR_Arcenox_co_TickerQ_pull_169_From_2025_08_01_To_2025_08_31_Target_NET_8_and_NET_9 />
</section>

<section className="section-gap-cédric-luthi">
<p>
        {/* You can find a discussion on this issue in a Hachyderm post by */}
        <a href="https://hachyderm.io/@0xced/114309797988146204">Visit the @0xced/114309797988146204 post page on Hachyderm</a>, 
        which references the relevant issue on GitHub 
        <a href="https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139">ServiceBusAdministrationClient support #17</a>. 
        The posted date is 10/4/25.
    </p>
    <p>
        In the discussion on 
        <a href="https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139" target="_blank">GitHub Link - https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139</a>, 
        a user expressed difficulties encountered while attempting to install and run the Azure Service Bus Emulator. 
        They reported persistent errors that persisted despite following the provided installation instructions. 
        The community responded with suggestions to verify system requirements and permissions, 
        encouraging further dialogue to troubleshoot and resolve these issues collaboratively.
    </p>
</section>

<section className="section-gap-cédric-luthi">
    <div>
        <h3>GitHub - 0xced/Chisel: Remove Unwanted Dependencies from Your .NET Projects</h3>
        <h5>Remove Unwanted Dependencies from Your .NET Projects - 0xced/Chisel</h5>
        <a href="https://hachyderm.io/@0xced/114021283741021680" target="_blank" rel="noopener noreferrer">
            Visit the 0xced/Chisel page on Hachyderm
        </a>
    </div>
</section>



{/*
<section>
 <p>
Philipp Wagner(<a href="https://github.com/bytefish">https://github.com/bytefish</a>) followed Cédric Luthi (<a href="https://github.com/0xced">https://github.com/0xced</a>) on 25/1/25
</p>
</section>

<section>
<p>

<a href="https://hachyderm.io/@0xced/114309797988146204">Visit the @0xced/114309797988146204 post page on Hachyderm</a>, which references the relevant issue on GitHub <a href="https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139">ServiceBusAdministrationClient support #17</a>. The posted date is 10/4/25.
</p>
<p>
In the discussion on <a href="https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139" target="_blank">GitHub Link - https://github.com/Azure/azure-service-bus-emulator-installer/issues/17#issuecomment-2790842139</a>, a user expressed difficulties encountered while attempting to install and run the Azure Service Bus Emulator. They reported persistent errors that persisted despite following the provided installation instructions. The community responded with suggestions to verify system requirements and permissions, encouraging further dialogue to troubleshoot and resolve these issues collaboratively.
</p>

</section>



<section>
<div>
    <h3>GitHub - 0xced/Chisel: Remove Unwanted Dependencies from Your .NET Projects</h3>
    <h5>Remove Unwanted Dependencies from Your .NET Projects - 0xced/Chisel</h5>
    <a href="https://hachyderm.io/@0xced/114021283741021680" target="_blank" rel="noopener noreferrer">
        Visit the 0xced/Chisel page on Hachyderm
    </a>
</div>

<Cédric_Luthi_0xced_Chisel_GitHubRepository />

</section> */}



</div>


<div id="MarkHeath">
  <a
    href="https://github.com/markheath"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        Mark Heath
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Mark Heath.
    </h3>
  </a>

  <div>
    <h3>GitHub - markheath/azure-functions-links: Useful Links for Azure Functions</h3>
    <h5>Useful Links for Azure Functions - markheath/azure-functions-links</h5>
    <a
      href="https://github.com/markheath/azure-functions-links"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the Azure Functions Links GitHub Repository
    </a>
  </div>

  <Markheath_azure_functions_links_GitHubRepository />
</div>



<div id="DaniloPoccia">
  <a
    href="https://github.com/danilop"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Danilo Poccia
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Danilo Poccia.
    </h3>
  </a>

  <div>
    <h3>GitHub - danilop/AWS_Lambda_in_Action: This source code distribution is a companion to the AWS Lambda in Action book available from Manning Publications.</h3>
    <h5>https://www.manning.com/books/aws-lambda-in-action</h5>
    <a
      href="https://github.com/danilop/AWS_Lambda_in_Action"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the AWS_Lambda_in_Action GitHub Repository
    </a>
  </div>

  <DaniloPoccia_danilop_AWS_Lambda_in_ActionGitHubRepository />

  <div>
    <h3>New – A Shared File System for Your Lambda Functions</h3>
    <h5>https://aws.amazon.com/blogs/aws/new-a-shared-file-system-for-your-lambda-functions/</h5>
    <p>by Danilo Poccia on 16 JUN 2020 in Amazon Elastic File System (EFS), Announcements, AWS Lambda, Compute, Launch, News, Serverless, Storage</p>
    <a
      href="https://aws.amazon.com/blogs/aws/new-a-shared-file-system-for-your-lambda-functions/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the New – A Shared File System for Your Lambda Functions Blog Post
    </a>
</div>

</div>

<div id="FeiPeng">
  <a
    href="https://github.com/fiigii"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Fei Peng
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Fei Peng.
    </h3>
  </a>

  <div>
    <h3>Hardware Intrinsic in .NET Core 3.0 - Introduction</h3>
    <h5>https://fiigii.com/2019/03/03/Hardware-intrinsic-in-NET-Core-3-0-Introduction/</h5>
    <p>by Fei Peng on 2019-03-03 in .NET Core, SIMD, x86</p>
    <a
      href="https://fiigii.com/2019/03/03/Hardware-intrinsic-in-NET-Core-3-0-Introduction/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the Hardware Intrinsic in .NET Core 3.0 - Introduction Documentation
    </a>
  </div>

<div>
    <h3>API Proposal: Add Intel Hardware Intrinsic Functions and Namespace #23057</h3>
    <h5>https://github.com/dotnet/runtime/issues/23057</h5>
    <p>Repository: <a href="https://github.com/dotnet/runtime" target="_blank" rel="noopener noreferrer">github.com/dotnet/runtime</a></p>
    <a
      href="https://github.com/dotnet/runtime/issues/23057"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the GitHub Issue for API Proposal: Add Intel Hardware Intrinsic Functions and Namespace
    </a>
</div>


<FeiPeng_fiigii_PacketTracerGitHubRepository />

</div>


<div id="TimurIskhakov">
  <a
    href="https://github.com/timiskhakov"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Timur Iskhakov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Timur Iskhakov.
    </h3>
  </a>
  <p>
    On April 20, 2025, a Reddit user shared their excitement about completing their first significant AI project in C#, which utilized ONNX (Open Neural Network Exchange). They expressed how impressed they were by the capabilities of the ONNX framework, highlighting its ability to streamline model training and deployment across various platforms. The post detailed their journey through the project, including the challenges they faced and the solutions they discovered. The author encouraged others in the community to explore ONNX for their own AI endeavors, noting its versatility and the positive impact it had on their workflow. The enthusiasm radiating from their experience resonated with fellow enthusiasts, sparking discussions and sharing of similar projects. 
    <a href="https://www.reddit.com/r/csharp/comments/1k37gj7/my_first_big_ai_project_in_c_onnx_blown_away_by/">Link to the post</a> - Posted on 20/4/25.
</p>

<p><a href="https://www.reddit.com/r/csharp/comments/1k37gj7/my_first_big_ai_project_in_c_onnx_blown_away_by/">https://www.reddit.com/r/csharp/comments/1k37gj7/my_first_big_ai_project_in_c_onnx_blown_away_by/</a></p>
  <p>My biggest tip is to do as much as possible on the GPU—I use ILGPU to do this, but you could also use something like compute shaders in Silk.NET, OpenTK, or ComputeSharp. — <a href="https://www.reddit.com/user/nullandkale/">nullandkale</a>, posted on 21/4/25</p>

<p>I searched in Microsoft Bing Browser with the query "<strong>ilgpu c#</strong>" and found these helpful results: 
<a href="https://timiskhakov.github.io/posts/computing-the-convex-hull-on-gpu">Computing the Convex Hull on GPU</a> and 
<a href="https://timiskhakov.github.io/posts/vectorized-computations-and-simd">Vectorized Computations and SIMD</a>.</p>

<Timiskhakov_ComputingTheConvexHullOnGpu_GitHubRepository />

<div id="TimurIskhakov_Span_T_andPipelines">
<a href="https://timiskhakov.github.io/posts/exploring-spans-and-pipelines" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Exploring Spans and Pipelines | Improving the performance of file parsing by using new goodies in .NET Core | Posts · 31/10/2019 · 5 minutes · c# cuda algorithms
    </a>
</div>


</div>

<div id="KristofferCarlsson_SIMD_and_SIMD_intrinsics_in_Julia">
{/* <a href="#KristofferCarlsson" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Kristoffer Carlsson </span>
             
            </h1>
            <h3>    <div>Software engineer, Julia Computing</div></h3>
          </a> */}

<a href="KristofferCarlsson_SIMD_and_SIMD_intrinsics_in_Julia" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Kristoffer Carlsson
    </span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>Software engineer, Julia Computing</div>
  </h3>
</a>
<h3 className="KristofferCarlsson-article-title" 
  // itemprop="name"
  >
    <a href="http://kristofferc.github.io/post/intrinsics/" 
    // itemprop="url"
    >SIMD and SIMD-intrinsics in Julia</a>
  </h3>
  
  <h3 className="KristofferCarlsson-article-title" 
  // itemprop="name"
  >
  Visit the Blog Post titled 
  <a href="http://kristofferc.github.io/post/intrinsics/" 
  // itemprop="url"
  > SIMD and SIMD-intrinsics in Julia</a> 
</h3> Posted on Tue, Nov 13, 2018 
<span className="article-tags">
    <i className="fa fa-tags"></i>
    
    <a className="article-tag-link" href="http://kristofferc.github.iotags/simd"> simd</a>, 
    
    <a className="article-tag-link" href="http://kristofferc.github.iotags/intrinsics">intrinsics</a>, 
    
    <a className="article-tag-link" href="http://kristofferc.github.iotags/julia">julia</a>
    
  </span>
</div>




<div id="PhilippWagner">
  <a
    href="https://github.com/bytefish"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Philipp Wagner
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Philipp Wagner.
    </h3>
  </a>

  <div>
    <h3>GitHub - bytefish/facerec: Implements face recognition algorithms for MATLAB/GNU Octave and Python.</h3>
    {/* <h5>Useful Links for Azure Functions - markheath/azure-functions-links</h5> */}
    <a
      href="https://github.com/bytefish/facerec"
      target="_blank"
      rel="noopener noreferrer"
    >
      Implements face recognition algorithms for MATLAB/GNU Octave and Python
    </a>
  </div>

  <h3 
  // tabindex="-1" 
  className="heading-element" dir="auto">Advanced Examples: Building your own PredictableModel</h3>
 <p dir="auto">Basically all face recognition algorithms are the combination of a <a href="https://github.com/bytefish/facerec/blob/master/py/facerec/feature.py">feature extraction</a>
 and a <a href="https://github.com/bytefish/facerec/blob/master/py/facerec/classifier.py">classifier</a>. The Eigenfaces method for example is a Principal Component Analysis with a Nearest Neighbor classifier. Local Binary Patterns Histograms . The feature (which must be an <a href="https://github.com/bytefish/facerec/blob/master/py/facerec/feature.py">AbstractFeature</a>) and the classifier (which must be an <a href="https://github.com/bytefish/facerec/blob/master/py/facerec/classifier.py">AbstractClassifier</a>) form a <a href="https://github.com/bytefish/facerec/blob/master/py/facerec/model.py">PredictableModel</a>, which does the feature extraction and learns the classifier.</p>
  <Bytefish_facerec_GitHubRepository />



 
</div>




<div id="Elasticsearch">



<a
  href="https://www.elastic.co/elasticsearch"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Elasticsearch
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Elasticsearch. The heart of the Elastic Stack
      <a
        href="https://www.elastic.co/elasticsearch"
        data-original-href="https://www.elastic.co/elasticsearch"
      >
          <div>
            
          {/* <p>Currently an associate professor in
<a href="https://ssm.sufe.edu.cn/">School of Statistics and Management</a> at
<a href="https://english.sufe.edu.cn/">Shanghai University of Finance and Economics (SUFE)</a>.</p> */}
            </div>
      </a>
    </p>
  </h3>
</a>

<p>Elasticsearch is an open source distributed, RESTful search and analytics engine, scalable data store, and vector database capable of addressing a growing number of use cases. As the heart of the Elastic Stack, it centrally stores your data for lightning-fast search, fine‑tuned relevancy, and powerful analytics that scale with ease.</p>



<li>


<a
  href="#ItamarSyn-Hershko"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    ItamarSyn-Hershko
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m ItamarSyn-Hershko.
      <a
        href="https://github.com/synhershko"
        data-original-href="https://github.com/synhershko"
      >
           <div>CTO &amp; Founder of BigData Boutique. Search, BigData and Cloud expert - making the cloud a better place day by day.</div>

      </a>
    </p>
  </h3>
</a>     

</li>

<li>
  <a
    href="#AndrewLock_.NETEscapades"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      AndrewLock
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m AndrewLock.
    </h3>
  </a>
  </li>
  <li>

  <a
    href="#IvanCesar"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ivan Cesar
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Ivan Cesar.
    </h3>
  </a>
</li>
</div>

<div id="AndrewLock_.NETEscapades">
  <a
    href="https://github.com/andrewlock"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      AndrewLock
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m AndrewLock.
    </h3>
  </a>

  <div id="AndrewLock_.NETEscapades_Elasticsearch_Fluentd_Serilog_ASP_DOTNET_Core">
    <h3>Writing Logs to Elasticsearch with Fluentd using Serilog in ASP.NET Core</h3>
    <h5>https://andrewlock.net/writing-logs-to-elasticsearch-with-fluentd-using-serilog-in-asp-net-core/</h5>
    <p>Category: <strong>ASP.NET Core, DevOps, Logging, Docker</strong></p>
    <p>Published on: <strong>June 20, 2018</strong></p>
    <p>Estimated Reading Time: <strong>~7 min read</strong></p>
    <a href="https://andrewlock.net/writing-logs-to-elasticsearch-with-fluentd-using-serilog-in-asp-net-core/" 
       target="_blank" 
       rel="noopener noreferrer">
        Visit the full article: Writing Logs to Elasticsearch with Fluentd using Serilog in ASP.NET Core
    </a>
</div>

<Serilog_serilog_aspnetcore_GitHubRepository />
</div>

<div id="AnthonySneed">

  
<a
  href="https://github.com/tonysneed"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Anthony Sneed
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Anthony Sneed
      <a
        href="https://github.com/tonysneed"
        data-original-href="https://github.com/tonysneed"
      >
          

      </a>
    </p>
  </h3>
</a>
<p></p>

<a href="https://blog.tonysneed.com/" target="_blank">
    View the Blog Page
  </a>
  <p></p>
  <a href="https://blog.tonysneed.com/2022/03/21/event-driven-microservices-dotnet-platform/" 
       target="_blank" 
       rel="noopener noreferrer">
        Visit the full article: Announcing Event Driven .NET – An Event Driven Microservices Platform for .NET | Posted on March 21, 2022 by Tony Sneed
    </a>
  <WhyThisRepo />
  <p>https://blog.tonysneed.com/2020/06/25/event-stream-processing-micro-framework-apache-kafka/</p>
</div>

<div id="IvanCesar">
  <a
    href="https://github.com/yohney"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ivan Cesar
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Ivan Cesar.
    </h3>
  </a>

<div>
    <h3>An Elasticsearch Tutorial for .NET Developers</h3>
    <h5>https://www.toptal.com/dot-net/elasticsearch-dot-net-developers</h5>
    <p>Category: <strong>Elasticsearch, .NET, Tutorial</strong></p>
    <p>Published on: <strong>8 September 2017</strong></p>
    <p>Author: <strong>Ivan Cesar</strong></p>
    <a href="https://www.toptal.com/dot-net/elasticsearch-dot-net-developers" 
       target="_blank" 
       rel="noopener noreferrer">
        Visit the full article: An Elasticsearch Tutorial for .NET Developers
    </a>
</div>
<IvanCesar_yohney_elastic_net_example_GitHubRepository />
</div>

<div id="ItamarSyn-Hershko">

  
<a
  href="https://github.com/synhershko"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    ItamarSyn-Hershko
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m ItamarSyn-Hershko.
      <a
        href="https://github.com/synhershko"
        data-original-href="https://github.com/synhershko"
      >
           <div>CTO &amp; Founder of BigData Boutique. Search, BigData and Cloud expert - making the cloud a better place day by day.</div>

      </a>
    </p>
  </h3>
</a>     

<a href="https://logz.io/blog/securing-elasticsearch-clusters/">Securing Elasticsearch Clusters</a>

  <p>A number of articles have been written over the past few days documenting the various methods of securing Elasticsearch, most notably of which is <a href="https://code972.com/blog/2017/01/107-dont-be-ransacked-securing-your-elasticsearch-cluster-properly/" target="_blank" rel="noopener noreferrer">this piece by Itamar Dyn-Hershko</a>. For all our readers using Elasticsearch — especially those who are using it in production — who are not necessarily aware of the various pitfalls that need to be taken into consideration, we’ve summed up some of the methods that we recommend employing.</p>

</div>


<div id="MarcClifton">

  
<a
  href="https://github.com/cliftonm"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Marc Clifton
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Marc Clifton.
      <a
        href="https://github.com/cliftonm"
        data-original-href="https://github.com/cliftonm"
      >
          

      </a>
    </p>
  </h3>
</a>     
<p>
  <a rel="nofollow me" className="Link--primary wb-break-all" href="http://marcclifton.wordpress.com/">http://marcclifton.wordpress.com/</a>
</p>

<p>
  <a href="https://muckrack.com/marc-clifton/articles">Articles by Marc Clifton</a>
</p>

<p>
  <a href="https://www.codeproject.com/Articles/1280139/Azure-Function-Compute-Pi-Stress-Test">Azure Function: Compute Pi Stress Test</a>
</p>

</div>





<div id="KerasHub">



<a
  href="https://keras.io/keras_hub/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    KerasHub: Multi-framework Pretrained Models
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Pretrained model hub for Keras 3.
      <a
        href="https://keras.io/keras_hub/"
        data-original-href="https://keras.io/keras_hub/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

<li>

<a
  href="#AnshumanMishra"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Anshuman Mishra
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Anshuman Mishra
      <a
        href="https://github.com/shivance"
        data-original-href="https://github.com/shivance"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

</li>




</div>


<div id="AnshumanMishra">


<a
  href="https://github.com/shivance"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Anshuman Mishra
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Anshuman Mishra
      <a
        href="https://github.com/shivance"
        data-original-href="https://github.com/shivance"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

<div>GDE; Google Summer of Code'23 <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/tensorflow/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/tensorflow">@tensorflow</a>; Contributor <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/keras-team/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/keras-team">@keras-team</a>; </div>

<div className="authoring-page-link">
  <p>Visit the authoring page here: <a href="https://shivance.github.io/pages/authoring.html" target="_blank">Authoring Page</a></p>
</div>


<h3 className="anchored" data-anchor-id="medium" style={{ position: 'relative' }}>
      <a href="https://medium.com/" data-original-href="https://medium.com/">Medium</a>
      <a
        className="anchorjs-link"
        aria-label="Anchor"
        data-anchorjs-icon=""
        href="#medium"
        style={{
          font: '1em / 1 anchorjs-icons',
          marginLeft: '0.1875em',
          paddingRight: '0.1875em',
          paddingLeft: '0.1875em',
          position: 'absolute',
          top: '50%',
          right: '-20px',
          transform: 'translateY(-50%)',
        }}
      ></a>
    </h3>

<ul>
<li><a href="https://shivance.medium.com/interview-with-2x-kaggle-grandmaster-data-science-manager-at-emirates-nbd-ravi-ramakrishnan-3308a3936c07" data-original-href="https://shivance.medium.com/interview-with-2x-kaggle-grandmaster-data-science-manager-at-emirates-nbd-ravi-ramakrishnan-3308a3936c07">Interview with 2x Kaggle Grandmaster, Data Science Manager at Emirates NBD: Ravi Ramakrishnan</a></li>
<li><a href="https://juliazoid.com/fluxible-unet-c71e411c8b2d" data-original-href="https://juliazoid.com/fluxible-unet-c71e411c8b2d">Flux.jl is so flexible — Deep Learning in Julia</a></li>
<li><a href="https://shivance.medium.com/kaggle-x-julia-advanced-house-price-prediction-eda-1124b9a96f97" data-original-href="https://shivance.medium.com/kaggle-x-julia-advanced-house-price-prediction-eda-1124b9a96f97">Kaggle x Julia : Advanced House Price Prediction : EDA</a></li>
</ul>


<div className="tweet-container">
  <p><strong>Anshuman Mishra (@mishradotexe)</strong></p>
  <p>I wrote Qwen 2.5 from scratch. Works with JAX, PyTorch and Tensorflow. This marks my return to open source after an year.</p>
  <a href="https://x.com/mishradotexe/status/1902005764493017527" target="_blank">
    View the Tweet
  </a>
  <br></br>
  <a href="https://github.com/keras-team/keras-hub/pull/2088" target="_blank">
    PR mentioned in the tweet: Add Qwen 2.5 by shivance · Pull Request #2088 · keras-team/keras-hub · GitHub
  </a>
</div>



<div className="commit-container">
  <p><strong>Commit: </strong>checkpoint conversion wip</p>
  <p><strong>New File Added: </strong><code>tools/checkpoint_conversion/convert_qwen_checkpoints.py</code></p>
  <a href="https://github.com/keras-team/keras-hub/pull/2088/commits/f7e8ee52b1ff56dc34165f29fe6e8b86bab28a29" target="_blank">
    View Commit
  </a>
</div>


<div className="pr-info">
  <p>Now, see another PR by the same Keras Team: <strong>SIMILAR TASK</strong></p>
</div>

<Divyashreepathihalli_Issue_keras_team_keras_hub_1875 />


</div>

  
  
<div id="Dask_GitHub">

<a
  href="https://github.com/dask/dask"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Dask
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Parallel computing with task scheduling
      <a
        href="https://github.com/dask/dask"
        data-original-href="https://github.com/dask/dask"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>



<li>

<a
  href="#Dask_Parallel_Python_Fast_and_Easy"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Dask
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Dask is a Python library for parallel and distributed computing. 
      <a
        href="https://www.dask.org/"
        data-original-href="https://www.dask.org/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>
</li>

</div>
<div id="Dask_Parallel_Python_Fast_and_Easy">



<a
  href="https://www.dask.org/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Dask
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Dask is a Python library for parallel and distributed computing. 
      <a
        href="https://www.dask.org/"
        data-original-href="https://www.dask.org/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>
</div>
          <div id="LambdaExpressions">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Lambda Expressions
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Lambda Expressions.
                  <a
                    href=""
                    data-original-href=""
                  >
                  </a>
                </p>
              </h3>
            </a>
          </div>

          <li className="no-margin-bottom1">
            <a
              href="#Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h3 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Artificial Intelligence: A Modern Approach
                </span>
              </h3>
            </a>
            <section className="section-gap-AnthonyShaw">
              <p>
                {/* <img src="https://tarlton.info/attachments/Backprop-chain-Drawing-3.png" // width="auto" height="auto" 
  alt=""></img> */}
                Just re-illustrating the example from the Russell book Chapter 21. Note how the unit “numbers” have changed.
                Give it a shot if you have literally nothing else to do. There is a reason we make computers do this.</p>

              <a href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                target="_blank"
                rel="noopener noreferrer">
                Visit the Wikipedia Page: Artificial Intelligence: A Modern Approach |  Written by Stuart J. Russell and Peter Norvig
              </a>
              {/* <div className="mw-body-content"> */}
              <p>
                <i>AIMA</i> has been called "the most popular artificial intelligence textbook in the world",
                <sup id="cite_ref-2" className="reference">
                  <a href="#cite_note-2">
                    <span className="cite-bracket">[</span>2<span className="cite-bracket">]</span>
                  </a>
                </sup>{" "}
                and is considered the standard text in the field of AI.
                <sup id="cite_ref-3" className="reference">
                  <a href="#cite_note-3">
                    <span className="cite-bracket">[</span>3<span className="cite-bracket">]</span>
                  </a>
                </sup>
                <sup id="cite_ref-4" className="reference">
                  <a href="#cite_note-4">
                    <span className="cite-bracket">[</span>4<span className="cite-bracket">]</span>
                  </a>
                </sup>{" "}
                As of 2023, it was being used at over 1500 universities worldwide,
                <sup id="cite_ref-5" className="reference">
                  <a href="#cite_note-5">
                    <span className="cite-bracket">[</span>5<span className="cite-bracket">]</span>
                  </a>
                </sup>{" "}
                and it has over 59,000 citations on{" "}
                <a href="/wiki/Google_Scholar" title="Google Scholar">
                  Google Scholar
                </a>
                .
                <sup id="cite_ref-6" className="reference">
                  <a href="#cite_note-6">
                    <span className="cite-bracket">[</span>6<span className="cite-bracket">]</span>
                  </a>
                </sup>
              </p>
            </section>
          </li>



          <div id="Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7">
            <a
              href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Artificial Intelligence: A Modern Approach
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Artificial Intelligence: A Modern Approach.
                  <a
                    href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                    data-original-href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                  >
                  </a>
                </p>
              </h3>
            </a>

              <div id="wiki_Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7">
              <section className="section-gap-AnthonyShaw">
                <p>
                  {/* <img src="https://tarlton.info/attachments/Backprop-chain-Drawing-3.png" // width="auto" height="auto" 
  alt=""></img> */}
                  Just re-illustrating the example from the Russell book Chapter 21. Note how the unit “numbers” have changed.
                  Give it a shot if you have literally nothing else to do. There is a reason we make computers do this.</p>

                <a href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the Wikipedia Page: Artificial Intelligence: A Modern Approach |  Written by Stuart J. Russell and Peter Norvig
                </a>
                {/* <div className="mw-body-content"> */}
                <p>
                  <i>AIMA</i> has been called "the most popular artificial intelligence textbook in the world",
                  <sup id="cite_ref-2" className="reference">
                    <a href="#cite_note-2">
                      <span className="cite-bracket">[</span>2<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  and is considered the standard text in the field of AI.
                  <sup id="cite_ref-3" className="reference">
                    <a href="#cite_note-3">
                      <span className="cite-bracket">[</span>3<span className="cite-bracket">]</span>
                    </a>
                  </sup>
                  <sup id="cite_ref-4" className="reference">
                    <a href="#cite_note-4">
                      <span className="cite-bracket">[</span>4<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  As of 2023, it was being used at over 1500 universities worldwide,
                  <sup id="cite_ref-5" className="reference">
                    <a href="#cite_note-5">
                      <span className="cite-bracket">[</span>5<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  and it has over 59,000 citations on{" "}
                  <a href="/wiki/Google_Scholar" title="Google Scholar">
                    Google Scholar
                  </a>
                  .
                  <sup id="cite_ref-6" className="reference">
                    <a href="#cite_note-6">
                      <span className="cite-bracket">[</span>6<span className="cite-bracket">]</span>
                    </a>
                  </sup>
                </p>
              </section>
            </div>




            <div id="wiki_Artificial_Intelligence:_A_Modern_Approach#Chapter18_7_NonParametricModels_18_7_1_NearestNeighbor_models_Mahalanobis_Distance_Page677_678">
              <section className="section-gap-AnthonyShaw">
                <p> Page 678 Chapter 18 Learning from Examples <br></br>
                  Often Euclidean distance is used if the dimensions are measuring similar properties, such as weight, height, and depth of parts, and Manhattan distance is used if they are dissimilar, such as age, weight, and gender of a patient. Note that if we use the raw numbers from each dimension then the total distance will be affected by a change in units in any dimensions. That is, if we chanage the <i>height</i> dimension from metres to miles while keeping the <i>width</i> and <i>depth</i> dimensions the same, we’ll get different nearest neighbours. And how do we compare a difference in age to difference in weight? A common approach is to apply <strong>normalization</strong> to the measurements in each dimension.
                  Μi
                  A more complex metric known as <strong>Mahalanobis distance</strong> takes into account the covariance between dimensions.
                </p>
              </section>
            </div>


          </div>

          <div id="dotnet_runtime">
            <a
              href="https://github.com/dotnet/runtime"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  dotnet/runtime
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m dotnet/runtime.
                  <a
                    href="https://github.com/dotnet/runtime"
                    data-original-href="https://github.com/dotnet/runtime"
                  >
                  </a>
                </p>
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#Steve_hez2010__dotnet_runtime_issues_117244_Tensor_Create_overloads_are_extremely_confusing_and_can_lead_to_unintended_behaviors"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    Steve(hez2010)
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Steve(hez2010)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created an issue
                  <br />
                  <a href="https://github.com/dotnet/runtime/issues/117244">dotnet/runtime</a> on 2/7/25 that received 4 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/dotnet/runtime/issues/117244">Visit the GitHub Issue: Tensor.Create overloads are extremely confusing and can lead to unintended behaviors #117244  </a>
                </div>
              </section>
            </li>
          </div>
          
          <div id="dotnet_logging">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  dotnet_logging
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                dotnet_logging
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#Aaron_Powell__LANCommander_LANCommander_pull_365_Adding_logging_to_library_endpoints_for_better_debugging"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    LANCommander/LANCommander
                  </span>
                </h3>
              </a>

              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Created a PR
                  <br />
                  <a href="https://github.com/LANCommander/LANCommander">LANCommander/LANCommander</a> on 2/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/LANCommander/LANCommander/pull/365">Visit the GitHub PR: Adding logging to library endpoints for better debugging #365 </a>
                </div>
              </section>
            </li>

          </div>
<div id="YoshifumiKawai">


<a
  href="https://github.com/neuecc"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yoshifumi Kawai
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Yoshifumi Kawai
      <a
        href="https://github.com/neuecc"
        data-original-href="https://github.com/neuecc"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>
            <section className="section-gap-AnthonyShaw">
              <p>
                Yoshifumi Kawai (<a href="https://github.com/neuecc">https://github.com/neuecc</a>)  starred a repository on 24/11/25
                <br />
                <a href="https://github.com/hez2010/TypedSql">https://github.com/hez2010/TypedSql</a> (C# ) 120 STARS
              </p>
            </section>
<YoshifumiKawai_Cysharp_ZLinq_GitHubRepository />


</div>
          <div id="Steve_hez2010">
            <a
              href="https://github.com/hez2010"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Steve(hez2010)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Steve(hez2010).
                  <a
                    href="https://github.com/hez2010"
                    data-original-href="https://github.com/hez2010"
                  >
                  </a>
                </p>
              </h3>
            </a>
            <section className="section-gap-AnthonyShaw">
              <p>
                Yoshifumi Kawai (<a href="https://github.com/neuecc">https://github.com/neuecc</a>)  starred a repository on 24/11/25
                <br />
                <a href="https://github.com/hez2010/TypedSql">https://github.com/hez2010/TypedSql</a> (C# ) 120 STARS
              </p>
            </section>
            <div id="Steve_hez2010__dotnet_runtime_issues_117244_Tensor_Create_overloads_are_extremely_confusing_and_can_lead_to_unintended_behaviors">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Steve(hez2010)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created an issue
                  <br />
                  <a href="https://github.com/dotnet/runtime/issues/117244">dotnet/runtime</a> on 2/7/25 that received 4 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/dotnet/runtime/issues/117244">Visit the GitHub Issue: Tensor.Create overloads are extremely confusing and can lead to unintended behaviors #117244  </a>
                </div>
              </section>
            </div>
          </div>

<div id="MohammadElsheimy">


<a
  href="https://justlikemagic.home.blog/about/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Mohammad Elsheimy
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Mohammad Elsheimy
      <a
        href="https://justlikemagic.home.blog/about/"
        data-original-href="https://justlikemagic.home.blog/about/"
      >
          <div>
            
         
            </div>
      </a>
    </p>
  </h3>
</a>

</div>
<div id="SamGreyDanus">

  
<a
  href="https://github.com/greydanus"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Sam Grey Danus
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Sam Grey Danus
      <a
        href="https://github.com/greydanus"
        data-original-href="https://github.com/greydanus"
      >
          

      </a>
    </p>
  </h3>
</a>
<div>Windscape AI and Greenfield Properties. Previously <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/google/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/google">@google</a> Brain, <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/dartmouth/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/dartmouth">@dartmouth</a> College</div>
<a rel="nofollow me" className="Link--primary wb-break-all" href="https://greydanus.github.io/about_me/">https://greydanus.github.io/about_me/</a>
<br></br>
<a rel="nofollow me" className="Link--primary wb-break-all" href="https://twitter.com/samgreydanus">@samgreydanus</a>

<p>
Sam Grey Danus (<a href="https://github.com/greydanus">https://github.com/greydanus</a>) starred 2 repositories on 02/4/25
  <br />
  <a href="https://github.com/zwimpee/cursivetransformer">https://github.com/zwimpee/cursivetransformer</a> (Jupyter Notebook) 3 Stars
  <br />
  <a href="https://github.com/zwimpee2/cursivetransformer">https://github.com/zwimpee2/cursivetransformer</a> (Jupyter Notebook) 1 Star
</p>
<p>
Both repositories, <a href="https://github.com/zwimpee/cursivetransformer">https://github.com/zwimpee/cursivetransformer</a> and  <a href="https://github.com/zwimpee2/cursivetransformer">https://github.com/zwimpee2/cursivetransformer</a>, focus on training a transformer model to generate cursive, with progress updates noted in their respective README files (February 12, 2025, and August 13, 2025).
</p>

</div>

<div id="MartinDotNet">

  
<a
  href="https://github.com/martinjt"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    MartinDotNet
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m MartinDotNet.
      <a
        href="https://github.com/martinjt"
        data-original-href="https://github.com/martinjt"
      >
          

      </a>
    </p>
  </h3>
</a>

<a rel="nofollow me" className="Link--primary wb-break-all" href="https://martinjt.me">https://martinjt.me</a>
<p>
  timdeschryver (<a href="https://github.com/timdeschryver">https://github.com/timdeschryver</a>) starred 2 repositories on 25/3/25
  <br />
  <a href="https://github.com/practical-otel/opentelemetry-aspire-collector">practical-otel/opentelemetry-aspire-collector</a> (C#) 28 STARS
  <br />
  <a href="https://github.com/microsoft/playwright-mcp"> microsoft/playwright-mcp</a>
</p>

<Practical_otel_opentelemetry_aspire_collector_GitHubRepository />
<p>Visit the article "Building a Secure OpenTelemetry Collector" published on <strong>20 December, 2023</strong> here: <a href="https://martinjt.me/2023/12/20/building-a-secure-opentelemetry-collector/" target="_blank">Building a Secure OpenTelemetry Collector</a></p>


<Martinjt_ocb_config_builder_GitHubRepository />

</div>
<div id="Abpframework_abp">

  
<a
  href="https://github.com/abpframework/abp"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    ABP
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m ABP.
      <a href="https://abp.io/" rel="nofollow">ABP</a>
    </p>
    <p dir="auto"><a href="https://abp.io/" rel="nofollow">ABP</a> offers an <strong>opinionated architecture</strong> to build enterprise software solutions with <strong>best practices</strong> on top of the <strong>.NET</strong> and the <strong>ASP.NET Core</strong> platforms. 
   </p>

  </h3>
</a>




<Abpframework_abp_GitHubRepository />



<p>
Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 25/3/25
  <br />
  <a href="https://github.com/abpframework/abp">abpframework/abp </a> (C#) 13.3k STARS

</p>

<p dir="auto"><a href="https://abp.io/" rel="nofollow">ABP</a> offers an <strong>opinionated architecture</strong> to build enterprise software solutions with <strong>best practices</strong> on top of the <strong>.NET</strong> and the <strong>ASP.NET Core</strong> platforms. It provides the fundamental infrastructure, production-ready startup templates, pre-built application modules, UI themes, tooling, guides and documentation to implement that architecture properly and <strong>automate the details</strong> and repetitive works as much as possible.</p>

</div>



<div id="OpenTelemetry_CNCF">

  
<a
  href="https://github.com/open-telemetry"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    OpenTelemetry - CNCF
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m OpenTelemetry - CNCF.
      <a
        href="https://github.com/open-telemetry"
        data-original-href="https://github.com/open-telemetry"
      >
          

      </a>
    </p>
  </h3>
</a>
<div>OpenTelemetry makes robust, portable telemetry a built-in feature of cloud-native software.</div>
<Open_telemetry_opentelemetry_collector_GitHubRepository />

<li>

<a
  href="#MartinDotNet"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    MartinDotNet
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m MartinDotNet.
      <a
        href="https://github.com/martinjt"
        data-original-href="https://github.com/martinjt"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>




</div>

<div id="SafiaAbdalla">

  
<a
  href="https://github.com/captainsafia"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Safia Abdalla
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Safia Abdalla.
      <a
        href="https://github.com/captainsafia"
        data-original-href="https://github.com/captainsafia"
      >
          

      </a>
    </p>
  </h3>
</a>
<Cédric_Luthi_0xced_dotnet_aspnetcore_pull_58161pull_58161_From_2024_10_01_To_2024_10_31_Implement_the_Mvc_PushFileStreamResult_API />

</div>


<div id="RogerKoenker">

  
<a
  href="http://www.econ.uiuc.edu/~roger/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Roger Koenker
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
      Hi there! I’m Roger Koenker.
      <a
        href="http://www.econ.uiuc.edu/~roger/"
        data-original-href="http://www.econ.uiuc.edu/~roger/"
      >
          

      </a>
    </p>
  </h3>
</a>


<div style={{ fontFamily: 'Arial, sans-serif', margin: '20px', color: '#333' }}>
    <h1 style={{ color: '#2c3e50' }}>How to Run Regression on Large Datasets in R</h1>
    <p style={{ fontSize: '1em', color: '#7f8c8d', marginBottom: '15px' }}>October 2, 2011 | Programming, R, Statistics</p>
    <p style={{ fontSize: '1.1em', lineHeight: '1.6' }}>Visit the original article on <a href="https://statr.me/2011/10/large-regression/" target="_blank" style={{ color: '#3498db' }}>Statr.me(https://statr.me/2011/10/large-regression/)</a>.</p>
  </div>


  <div style={{ fontFamily: 'Arial, sans-serif', margin: '20px', color: '#333' }}>
    <p style={{ fontSize: '1.1em', lineHeight: '1.6' }}>Xiao Nan yixuanq 12 years ago: Yup. There's more. Prof. Roger Koenker once combined MySQL with his qr: <a href="http://www.econ.uiuc.edu/~roger/" target="_blank" style={{ color: '#3498db' }}>Link</a>. There's barely few experiments on the cluster & classification's hpc topic. I think the algorithms are just naturally inefficient or too complicated to reimplement.</p>
  </div>


  <div style={{ fontFamily: 'Arial, sans-serif', margin: '20px', color: '#333' }}>
    <p style={{ fontSize: '1.1em', lineHeight: '1.6' }}>
    <a  href="http://www.econ.uiuc.edu/~roger/research/rq/LM.html" target="_blank" style={{ color: '#3498db' }}> <strong>Statistical Analysis of Large Datasets - An Exploration of R - MySQL Interface:</strong> 
        Visit the link
      </a> by Roger Koenker, University of Illinois, and Álvaro A. Novo, University of Illinois. Topics include Least Squares and Quantile Regression.
    </p>
  </div>

  <a
      href="http://www.econ.uiuc.edu/~roger/research/vinaigrettes/vinaigrette.html"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the R Vinaigrettes Page - contains
    </a> 
    <p>
      Conformal Quantile Regression	<a href="http://www.econ.uiuc.edu/~roger/research/vinaigrettes/conformal.pdf"> pdf </a>
    </p>

</div>

<div id="Single_instruction_multiple_data_(SIMD)">

  
<a
  href="https://en.wikipedia.org/wiki/Single_instruction,_multiple_data"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Single instruction, multiple data (SIMD)
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Single instruction, multiple data (SIMD).
      <a
        href="https://en.wikipedia.org/wiki/Single_instruction,_multiple_data"
        data-original-href="https://en.wikipedia.org/wiki/Single_instruction,_multiple_data"
      >
          

      </a>
    </p>
  </h3>
</a>


<li>

  <a
    href="#FeiPeng"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Fei Peng
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Fei Peng.
    </h3>
  </a>
</li>
<li>
  
  <a
    href="#TimurIskhakov"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Timur Iskhakov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Timur Iskhakov.
    </h3>
  </a>
</li>
<li>

{/* <a href="#KristofferCarlsson" className="vcard-names1" style={{ textDecoration: 'underline' }}>
            <h1>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Kristoffer Carlsson </span>
             
            </h1>
            <h3>    <div>Software engineer, Julia Computing</div></h3>
          </a> */}

          <a href="#KristofferCarlsson_SIMD_and_SIMD_intrinsics_in_Julia" className="vcard-names1" style={{ textDecoration: 'underline' }}>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
      Kristoffer Carlsson
    </span>
    {/* <span className="p-nickname vcard-username d-block"></span> */}
  </h1>
  <h3 style={{ margin: 0 }}>
    <div>Software engineer, Julia Computing</div>
  </h3>
</a>
<h3 className="no-margin KristofferCarlsson-article-title" 
  // itemprop="name"
  >
  Visit the Blog Post titled 
  <a href="http://kristofferc.github.io/post/intrinsics/" 
  // itemprop="url"
  > SIMD and SIMD-intrinsics in Julia</a>
  </h3>
</li>


<li className="no-margin-bottom1">
  <section className="section-gap-Single_instruction_multiple_data_SIMD" style={{ margin: 0 }}>
  <a
    href="#GéraldBarré_SIMD"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Gérald Barré (@meziantou)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Gérald Barré (@meziantou).
    </h3>
  </a>
  <a href="https://www.meziantou.net/replace-characters-in-a-string-using-vectorization.htm" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Replace characters in a string using Vectorization | Posts · 11/7/2022 · 4 minutes 
    </a>
  </section>

</li>
<li className="no-margin-bottom1">
  <section className="section-gap-Single_instruction_multiple_data_SIMD" style={{ margin: 0 }}>
    <a
    href="#Friedrich_von_Never"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Friedrich von Never(@ForNeVeR)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Friedrich von Never(@ForNeVeR)
    </h3>
  </a>
   <a href="https://fornever.me/en/posts/2023-10-21.code-vectorization.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Code Vectorization in .NET and Other Technologies | Posts · 32/10/2023 · 5 minutes 
    </a>
  </section>
  </li>
</div>


<div id="SciML">

  
<a
  href="https://github.com/SciML"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    SciML Open Source Scientific Machine Learning
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Open source software for scientific machine learning
      <a
        href="https://github.com/SciML"
        data-original-href="https://github.com/SciML"
      >
          

      </a>
    </p>
  </h3>
</a>

</div>
<ChrisRackauckasPR_SciML_SciMLSensitivity_jl_pull_1159_From_2025_02_01_To_2025_02_28_Testmaster />


<div id="YunjeyChoi">

  
<a
  href="https://github.com/yunjey"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Yunjey Choi
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Yunjey Choi
      <a
        href="https://github.com/yunjey"
        data-original-href="https://github.com/yunjey"
      >
          

      </a>
    </p>
  </h3>
</a>

<p>https://github.com/yunjey/pytorch-tutorial</p>

</div>

<div id="Vincent_D_Warmerdam">

  
<a
  href="https://github.com/koaning"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Vincent D. Warmerdam
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Vincent D. Warmerdam
      <a
        href="https://github.com/koaning"
        data-original-href="https://github.com/koaning"
      >
          

      </a>
    </p>
  </h3>
</a>


<a
      href="https://koaning.io/posts/factorio/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the The factorio benchmark blog posted on Date 2025/03/10
    </a>
    <p><a href="https://jackhopkins.github.io/factorio-learning-environment">This page</a> has all the details of the work, which include:</p>
    <ul>
<li>A <a href="https://github.com/JackHopkins/factorio-learning-environment">Python library</a> that can interact with the game, which is the main entrypoint for the agents that compete in tasks.</li>
<li>A <a href="https://jackhopkins.github.io/factorio-learning-environment/leaderboard">leaderboard</a> with the results of the agents that have competed so far (Claude seems the winner, but the fact that one of the authors is from Anthropic might help there).</li>
</ul>

<p>https://github.com/JackHopkins/factorio-learning-environment</p>

<WhyThisRepo />
<a href="https://github.com/JackHopkins/factorio-learning-environment/commit/47e5d1ab3234ba462544f419b9b205f1d686a922">
  https://github.com/JackHopkins/factorio-learning-environment/commit/47e5d1ab3234ba462544f419b9b205f1d686a922
</a>

</div>

<div id="ml_linear_regression">

  
<a
  href="https://www.geeksforgeeks.org/ml-linear-regression/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Linear Regression in Machine learning
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Linear Regression in Machine learning
      <a
        href="https://www.geeksforgeeks.org/ml-linear-regression/"
        data-original-href="https://www.geeksforgeeks.org/ml-linear-regression/"
      >
          

      </a>
    </p>
  </h3>
</a>



<li>

<a
  href="#BenoîtLegat_ml_linear_regression"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Benoît Legat
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Benoît Legat
      <a
        href="https://github.com/blegat/"
        data-original-href="https://github.com/blegat/"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>

</div>

<div id="BenoîtLegat_ml_linear_regression">

  
<a
  href="https://github.com/blegat/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Benoît Legat
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Benoît Legat
      <a
        href="https://github.com/blegat/"
        data-original-href="https://github.com/blegat/"
      >
          

      </a>
    </p>
  </h3>
</a>
<a href="https://blegat.github.io/ccir/practical1/" target="_blank" rel="noopener noreferrer">
      Practical 1 – Linear regressions | Benoît Legat | Written by: Jean Bouchat
    </a>

<p>
  <strong>Recommended for you:</strong><br />
  jump-dev/MathOptInterface.jl (<a href="https://github.com/jump-dev/MathOptInterface.jl">https://github.com/jump-dev/MathOptInterface.jl</a>) is a data structure for mathematical optimization problems in Julia.
  <br />
  <a href="https://github.com/jump-dev/MathOptInterface.jl">MathOptInterface.jl</a> (Julia) 434 Stars
  <br />
  Contributors: 
  <a href="https://github.com/jump-dev/MathOptInterface.jl/graphs/contributors">View Contributors</a>
</p>

</div>
<div id="PaulBerg">

  
<a
  href="https://github.com/Pangoraw"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Paul Berg
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Paul Berg
      <a
        href="https://github.com/Pangoraw"
        data-original-href="https://github.com/Pangoraw"
      >
          

      </a>
    </p>
  </h3>
</a>


<AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31 />
<AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31_Reviewers />


<a href="https://www.ber.gp/posts/moments-estimates/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Fast online estimates on the GPU | Posts · 06/08/2021 · 4 minutes
    </a>
</div>
<div id="BenoîtLegat">

  
<a
  href="https://github.com/blegat/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Benoît Legat
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Benoît Legat
      <a
        href="https://github.com/blegat/"
        data-original-href="https://github.com/blegat/"
      >
          

      </a>
    </p>
  </h3>
</a>

<a
      href="https://blegat.github.io/ccir/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <h1>The Applications of Mathematical Optimisation, Mixed-integer Linear Programming</h1>
      <h2>
        Course given at the <i>Cambridge Centre for International Research</i>
      </h2>
    </a>
<p>https://blegat.github.io/teaching/</p>
<p>https://blegat.github.io/ccir/practical1/</p>


<p>
  <strong>Recommended for you:</strong><br />
  jump-dev/MathOptInterface.jl (<a href="https://github.com/jump-dev/MathOptInterface.jl">https://github.com/jump-dev/MathOptInterface.jl</a>) is a data structure for mathematical optimization problems in Julia.
  <br />
  <a href="https://github.com/jump-dev/MathOptInterface.jl">MathOptInterface.jl</a> (Julia) 434 Stars
  <br />
  Contributors: 
  <a href="https://github.com/jump-dev/MathOptInterface.jl/graphs/contributors">View Contributors</a>
</p>
</div>


<div id="pickle_python_object_serialization">
 
<a
  href="https://www.geeksforgeeks.org/pickle-python-object-serialization/"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    The Python Pickle Module
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    The Python Pickle Module
      <a
        href="https://www.geeksforgeeks.org/pickle-python-object-serialization/"
        data-original-href="https://www.geeksforgeeks.org/pickle-python-object-serialization/"
      >
          

      </a>
    </p>
  </h3>
</a>
<li>

  <a
    href="#mrocklin_pickle_python_object_serialization"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Matthew Rocklin
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Matthew Rocklin.
    </h3>
  </a>
</li>
<li>
  
  <a
    href="#glemaitre_pickle_python_object_serialization"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Guillaume Lemaitre
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Guillaume Lemaitre.
    </h3>
  </a>
</li>
</div>

<div id="mrocklin_pickle_python_object_serialization">
  <a
    href="https://github.com/mrocklin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Matthew Rocklin
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Matthew Rocklin.
    </h3>
  </a>

  <a href="https://matthewrocklin.com/blog/work/2018/07/23/protocols-pickle" 
       target="_blank" 
       rel="noopener noreferrer">
        Visit the full article: Pickle isn't slow, it's a protocol | Posted on 2018/07/23 by Matthew Rocklin
    </a>

</div>

<div id="glemaitre_pickle_python_object_serialization">
  <a
    href="https://github.com/glemaitre"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Guillaume Lemaitre
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Guillaume Lemaitre.
    </h3>
  </a>
  <GuillaumeLemaitrelPR_probabl_ai_skore_966_From_204_12_01_To_2024_12_31 />
</div>

<div id="AndriyBurkov">
  <a
    href="https://github.com/aburkov"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Andriy Burkov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Andriy Burkov.
    </h3>
  </a>
  <div id="_AndriyBurkov_erikbern_ann-benchmarks">
      <section className="section-gap-AndriyBurkov">
      <p>
        Andriy Burkov (<a href="https://github.com/aburkov">https://github.com/aburkov</a>) starred a repository on 03/4/25
        <br />
        <a href="https://github.com/erikbern/ann-benchmarks">https://github.com/erikbern/ann-benchmarks</a> (Python) 5.2k Stars
        <p className="f4 my-3">
              Benchmarks of approximate nearest neighbor libraries in Python
            </p>
            <a title="http://ann-benchmarks.com" role="link" target="_blank" rel="noopener noreferrer nofollow" className="text-bold" href="http://ann-benchmarks.com">ann-benchmarks.com</a>
      </p>
      <WhyThisRepo />
      <Erikbern_ann_benchmarks_GitHubRepository_CodeDisplay />

    </section>
 
  </div>

 
</div>
<div id="richlander_containe_workshop">
  <a
    href="https://github.com/richlander/container-workshop"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      .NET 8 container workshop
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    .NET 8 container workshop.
    </h3>
  </a>
</div>
<div id="krasserm">
  <a
    href="https://github.com/krasserm"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Martin Krasser
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Martin Krasser.
    </h3>
  </a>


<section className="section-gap-krasserm">
<p>
Martin Krasser(<a href="https://github.com/krasserm">https://github.com/krasserm</a>) starred a repository on 26/3/25
  <br />
  <a href="https://github.com/wjayesh/mahilo">wjayesh/mahilo </a> (Python) 360 STARS

</p>
</section>

  <Krasserm_fsdl_text_recognizer_2021_labs_From_2021_3_01_To_2021_3_31 />
<WhyThisRepo />
</div>
<div id="SimonWillison">
  <a
    href="https://github.com/simonw"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Simon Willison
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Simon Willison.
    </h3>
  </a>
<div id="SimonWillison_StephenTurner">

</div>
<section className="section-gap-simon-willison">
  <p>
  Simon Willison(<a href="https://github.com/simonw">https://github.com/simonw</a>) contributed to a repository on 14/5/25
    <br />
    <a href="https://github.com/taketwo/llm-ollama">taketwo/llm-ollama </a> (Python) 292 STARS
  </p>
  <h3>
    <a href="https://github.com/taketwo?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Sergey Alexandrov(taketwo) on GitHub
    </a>
  </h3>
  <h3>
    <a href="https://github.com/klmr?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Konrad Rudolph(klmr) on GitHub
    </a>
  </h3>
  <h3>
    <a href="https://github.com/pditommaso?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Paolo Di Tommaso(pditommaso) on GitHub
    </a>
  </h3>
  <a
      href="https://github.com/stephenturner"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
        Stephen Turner
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
        Hi there! I’m Stephen Turner.
      </h3>
    </a>
    <a href="https://blog.stephenturner.us/p/duckdb-vs-dplyr-vs-base-r" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: DuckDB vs dplyr vs base R | Posts · 7/10/2024 
    </a>
</section>

  <section className="section-gap-simon-willison">
<p>
Simon Willison(<a href="https://github.com/simonw">https://github.com/simonw</a>) starred a repository on 3/5/25
  <br />
  <a href="https://github.com/skyzh/tiny-llm">skyzh/tiny-llm </a> (Python, C++) 1.8k STARS

</p>
</section>

  <section className="section-gap-simon-willison">
  <p>
    Simon Willison(<a href="https://github.com/simonw">https://github.com/simonw</a>) starred a repository on 25/4/25
      <br />
      <a href="https://github.com/antirez/hnstyle">antirez/hnstyle </a> (Python) 40 STARS

    </p>

    <p dir="auto">This repository contains the code used in the following blog post and YouTube videos:</p>
    <ul dir="auto">
    <li><a href="https://antirez.com/news/150" rel="nofollow">https://antirez.com/news/150</a></li>
    <li><a href="https://www.youtube.com/@antirez" rel="nofollow">https://www.youtube.com/@antirez</a></li>
    </ul>
    <p>
    Now, we are ready to insert the word into a Redis vector set, using the command: <code>VADD key FP32 [blob with 350 floats] username</code>. The details of vector sets are not covered here, but you can find the documentation <a href="https://github.com/redis/redis/blob/unstable/modules/vector-sets/README.md">here</a>. For additional information regarding Redis, you may also check out this:  <a href="https://antirez.com/news/150">Visit the full article: Reproducing Hacker News writing style fingerprinting</a> Date: 16/4/25.
    </p>
  </section>


<section className="section-gap-simon-willison">
<p>
Simon Willison(<a href="https://github.com/simonw">https://github.com/simonw</a>) starred a repository on 14/4/25
  <br />
  <a href="https://github.com/invisal/sqlite-internal">invisal/sqlite-internal </a> (JavaScript, TypeScript) 260 STARS

</p>
<p style={{ margin: 0 }}><a href="https://github.com/querymx/querym">https://github.com/querymx/querym</a></p>
<WhyThisRepo />
</section>


</div>
<div id="CUDAProgrammingModel">
  

<a
  href=""
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    CUDA Programming Model
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    CUDA Programming Model
      <a
        href=""
        data-original-href=""
      >

      </a>
    </p>
  </h3>
</a>
<li>

<a
  href="#TimurIskhakov_CUDAProgrammingModel"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    
    Timur Iskhakov
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    
    Timur Iskhakov
      <a
        href="https://github.com/timiskhakov"
        data-original-href="https://github.com/timiskhakov"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
</div>
<div id="Rotation_related_problems">



<a
  href=""
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Rotation related problems
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Rotation_related_problems. Quarternions. Rodrigues’ rotation formula
      <a
        href=""
        data-original-href=""
      >

      </a>
    </p>
  </h3>
</a>



<li>
<a
  href="#Andrzej_Więckowski_Rotation_related_problems"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    
    Andrzej Więckowski, Ph.D.
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    
    Andrzej Więckowski, Ph.D.
      <a
        href="https://github.com/andywiecko"
        data-original-href="https://github.com/andywiecko"
      >
          

      </a>
    </p>
  </h3>
</a>
</li>
<li>
<a href="#@j0hnparkhill_Rotation_related_problems" className="vcard-names1" style={{ textDecoration: 'underline' }}>
<h1 style={{ margin: 0 }}>
<span className="p-name vcard-fullname d-block overflow-hidden">
John Parkhill </span>
<span className="p-nickname vcard-username d-block">
ML, director of machine learning Terray Therapeutics (https://x.com/Terray_Tx).
</span>
</h1>
</a>
</li>


</div>

<div id="AlexChiZ">
  

<a
  href="https://github.com/skyzh"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    Alex Chi Z.
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    Alex Chi Z.
      <a
        href=""
        data-original-href=""
      >

      </a>
    </p>
  </h3>
</a>
<section className="section-gap-simon-willison">
<p>
Simon Willison(<a href="https://github.com/simonw">https://github.com/simonw</a>) starred a repository on 3/5/25
  <br />
  <a href="https://github.com/skyzh/tiny-llm">skyzh/tiny-llm </a> (Python, C++) 1.8k STARS

</p>
</section>
<a href="https://www.skyzh.dev/blog/2022-05-29-shared-state-in-risingwave/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Delta Join in the Streaming Engine based on a shared state index | Posts · 29/15/2022 · 10 minutes 
    </a>
</div>
<div id="Andrzej_Więckowski_Rotation_related_problems">

  
<a
  href="https://github.com/andywiecko"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    
    Andrzej Więckowski, Ph.D.
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    
    Andrzej Więckowski, Ph.D.
      <a
        href="https://github.com/andywiecko"
        data-original-href="https://github.com/andywiecko"
      >
          

      </a>
    </p>
  </h3>
</a>
<section className="section-gap-simon-willison">
  <p>
  Martin Evans(<a href="https://github.com/martindevans">https://github.com/martindevans</a>) starred 3 repositories on 2/5/25
      <br />
      <a href="https://github.com/andywiecko/BurstMathUtils">BurstMathUtils</a> (C#) 28 STARS
      <br />
      <a href="https://github.com/andywiecko/BurstCollections">BurstCollections      </a> (C#) 78 STARS
      <br />
      <a href="https://github.com/andywiecko/PBD2D">PBD2D </a> (C#) 98 STARS
      <br />
    </p>
    <p>
  <a href="https://andywiecko.github.io/blog/03-rodrigues-formula.html" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the full article: Rodrigues’ formula | Posts · 16/02/2025 · 4 minutes
  </a>
</p>


  </section>
</div>
<div id="@j0hnparkhill_Rotation_related_problems">

<a href="#@j0hnparkhill" className="vcard-names1" style={{ textDecoration: 'underline' }}>
<h1>
<span className="p-name vcard-fullname d-block overflow-hidden">
John Parkhill </span>
<span className="p-nickname vcard-username d-block">
ML, director of machine learning Terray Therapeutics (https://x.com/Terray_Tx).
</span>
</h1>
</a>
<li style={{ marginBottom: '8px' }}>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span className="post-meta">Sep 5, 2020</span>
    <h3 style={{ margin: '4px 0' }}>
      <a className="post-link" href="https://jparkhill.netlify.app/QuaternionAveraging/">
        Quaternion Averaging in Pytorch
      </a>
    </h3>
    </div>
  </li>
</div>

<div id="TimurIskhakov_CUDAProgrammingModel">

  
<a
  href="https://github.com/timiskhakov"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <h1 style={{ margin: 0 }}>
    <span className="p-name vcard-fullname d-block overflow-hidden">
    
    Timur Iskhakov
    </span>
  </h1>
  <h3 style={{ margin: 0 }}>
    <p style={{ margin: 0 }}>
    
    Timur Iskhakov
      <a
        href="https://github.com/timiskhakov"
        data-original-href="https://github.com/timiskhakov"
      >
          

      </a>
    </p>
  </h3>
</a>
<a href="https://timiskhakov.github.io/posts/computing-the-convex-hull-on-gpu" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Computing the Convex Hull on GPU | Posts · 05/10/2020 · 10 minutes · c# cuda algorithms
    </a>
</div>
<div id="AhmetAlpBalkan">
  <a
    href="https://github.com/ahmetb"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ahmet Alp Balkan
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Ahmet Alp Balkan.
    </h3>
  </a>

  <p>
  Ahmet Alp Balkan(<a href="https://github.com/ahmetb">https://github.com/ahmetb</a>) followed Anish Athalye (<a href="https://github.com/anishathalye">https://github.com/anishathalye</a>) on 5/4/25
</p>
<p>
Ahmet Alp Balkan(<a href="https://github.com/ahmetb">https://github.com/ahmetb</a>) starred a repository on 5/4/25
  <br />
  <a href="https://github.com/anishathalye/porcupine">anishathalye/porcupine </a> (Go) 1k STARS

</p>
</div>

<div id="AnisAthalye">
  <a
    href="https://github.com/anishathalye"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Anish Athalye
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Anish Athalye.
    </h3>
  </a>

  <ul className="vcard-details">
  <li className="vcard-detail pt-1 hide-sm hide-md" itemProp="worksFor" // show_title="false" 
  aria-label="Organization: @cleanlab">
    <svg className="octicon octicon-organization" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true">
      <path d="M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"></path>
    </svg>
    <span className="p-org">
      <div>
        <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/cleanlab/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/cleanlab">@cleanlab</a>
      </div>
    </span>
  </li>

  <li className="vcard-detail pt-1 hide-sm hide-md" itemProp="homeLocation" 
  // show_title="false" 
  aria-label="Home location: San Francisco, CA">
    <svg className="octicon octicon-location" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true">
      <path d="m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"></path>
    </svg>
    <span className="p-label">San Francisco, CA</span>
  </li>

  <li itemProp="email" aria-label="Email: me@anishathalye.com" className="vcard-detail pt-1">
    <svg className="octicon octicon-mail" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true">
      <path d="M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"></path>
    </svg>
    <a className="Link--primary wb-break-all" href="mailto:me@anishathalye.com">me@anishathalye.com</a>
  </li>

  <li itemProp="url" data-test-selector="profile-website-url" className="vcard-detail pt-1">
    <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" className="octicon octicon-link">
      <path d="m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"></path>
    </svg>
    <a className="Link--primary" href="https://anishathalye.com" target="_blank" rel="noopener noreferrer">anishathalye.com</a>
  </li>
</ul>

<p>
  Ahmet Alp Balkan(<a href="https://github.com/ahmetb">https://github.com/ahmetb</a>) followed Anish Athalye (<a href="https://github.com/anishathalye">https://github.com/anishathalye</a>) on 5/4/25
</p>
<p>
Ahmet Alp Balkan(<a href="https://github.com/ahmetb">https://github.com/ahmetb</a>) starred a repository on 5/4/25
  <br />
  <a href="https://github.com/anishathalye/porcupine">anishathalye/porcupine </a> (Go) 1k STARS

</p>

  </div>
<div id="MatLeonard">
<a
    href="https://github.com/mcleonard"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Mat Leonard
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Mat Leonard.
    </h3>
  </a>



<h3>
  <a href="https://github.com/Kritikalcoder?tab=following" target="_blank" rel="noopener noreferrer">
    Followings of Kritika Prakash on GitHub
  </a>
</h3>
<a href="https://mcleonard.github.io/sampyl/tutorial.html#defining-a-model" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Tutorial - How to use Sampyl with a simple linear model | Posts · 21/9/2018 · 10 minutes 
    </a>
    <p></p>
    <a href="https://mcleonard.github.io/sampyl/examples.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full GitHub Documentation: Examples - Models built with Sampyl - German Tank Problem 
    </a>
    <p>
      </p>
      <a href="https://mcleonard.github.io/sampyl/examples/german_tank_problem.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full GitHub Documentation: Example - German Tank Problem, a classic problem in statistics
    </a>
      
</div>
<div id="OriolNieto">
<a
    href="https://github.com/urinieto"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Oriol Nieto
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Oriol Nieto.
    </h3>
  </a>

  <section className="section-gap-Realcat-Vincentqyw">
<p>
Realcat Vincentqyw(<a href="https://github.com/Vincentqyw">https://github.com/Vincentqyw</a>) starred a repository on 7/5/25
  <br />
  <a href="https://github.com/huggingface/nanoVLM">huggingface/nanoVLM </a> (Jupyter Notebook 79.9%, Python 20.1%) 961 STARS

</p>
<Huggingface_nanoVLM_Contributors_ContributorList />
<AndrésMarafioti /> 
<p>
  follows
</p> 
<OriolNieto />
<a href="https://www.urinieto.com/2017/02/deep-xor/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Tutorial - Deep XOR | Posts · 26/2/2017 · 1 minute 
    </a>
</section>

</div>
<div id="ConradLudgate">
<a
    href="https://github.com/conradludgate"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Conrad Ludgate
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Conrad Ludgate.
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
  <a href="https://conradludgate.com/posts/cnpg" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the full article: Postgres | Posts · 5/11/2023 
  </a>
  <WhyThisRepo />
  <p>I've always run the basic <code>postgres</code> docker image with no backups or replicas configured.
Since I have a new cluster now, I thought I should try something new. I recently read about
<a href="https://news.ycombinator.com/item?id=37616033">CloudNative PG on HN</a> so I decided to look into it.
It got high praise from the replies, which is quite remarkable for HN.</p>
<p>It seems to have all the features I would want from a 'managed' postgres:</p>
<ul className="conrad-ludgate">
  <li>Managed backups</li>
  <li>Easily create a new database</li>
  <li>Manage secrets</li>
</ul>
  </section>

</div>
<div id="SQLJoin">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      SQL Join
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    SQL Join.
    </h3>
  </a>
  <li>
  
  <a
    href="#SQLJoin_AlibabaCloudCommunity"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Alibaba Cloud Community
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Alibaba Cloud Community.
    </h3>
  </a>
  <h3 className="no-margin KristofferCarlsson-article-title" 
  // itemprop="name"
  >
  Visit the Blog Post titled 
  <a href="https://www.alibabacloud.com/blog/how-to-write-a-high-performance-sql-join-implementation-and-best-practices-of-joins_599145" 
  // itemprop="url"
  >How to Write a High-Performance SQL Join: Implementation and Best Practices of Joins</a>
  </h3>
</li>
</div>
<div id="SQLJoin_AlibabaCloudCommunity">
<a
    href="https://www.alibabacloud.com/blog/how-to-write-a-high-performance-sql-join-implementation-and-best-practices-of-joins_599145"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Alibaba Cloud Community
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Alibaba Cloud Community.
    </h3>
  </a>
  <h3 className="no-margin KristofferCarlsson-article-title" 
  // itemprop="name"
  >
  Visit the Blog Post titled 
  <a href="https://www.alibabacloud.com/blog/how-to-write-a-high-performance-sql-join-implementation-and-best-practices-of-joins_599145" 
  // itemprop="url"
  >How to Write a High-Performance SQL Join: Implementation and Best Practices of Joins</a>
  </h3>
</div>


<div id="Xuan-SonNguyen">
<a
    href="https://github.com/ngxson/"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Xuan-Son Nguyen
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Xuan-Son Nguyen
    </h3>
  </a>
  <section className="section-gap-Realcat-Vincentqyw">
<p>
Realcat Vincentqyw(<a href="https://github.com/Vincentqyw">https://github.com/Vincentqyw</a>) starred a repository on 13/5/25
  <br />
  <a href="https://github.com/ngxson/smolvlm-realtime-webcam">ngxson/smolvlm-realtime-webcam </a> (HTML) 3.2k STARS

</p>
</section>
  <a href="https://blog.ngxson.com/easier-to-understand-natural-language-processing" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Easier to Understand: Natural Language Processing | Posts · 10/2/2024 · 5 minutes
    </a>
    <WhyThisRepo />
    {/* <p style={{
  maxWidth: '100vw',
  width: '100%',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  marginBottom: '1rem',
}}>
  In fact, convolution neural networks work quite well with images, because in the worst case, you can cut the image to a certain size. For example, creating a model to recognize handwritten digits (MNIST dataset) is one of the <a class=" text-accent " target="_blank" rel="noopener" href="https://colab.research.google.com/github/skorch-dev/skorch/blob/master/notebooks/MNIST.ipynb">very typical and easy-to-experiment exercises for newcomers to machine learning.</a></p> */}
  <p style={{
  maxWidth: '100vw',
  width: '100%',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  marginBottom: '1rem',
}}>
  In fact, convolution neural networks work quite well with images, because in the worst case, you can cut the image to a certain size. For example, creating a model to recognize handwritten digits (MNIST dataset) is one of the <a className="text-accent" target="_blank" rel="noopener" href="https://colab.research.google.com/github/skorch-dev/skorch/blob/master/notebooks/MNIST.ipynb">very typical and easy-to-experiment exercises for newcomers to machine learning.</a>
</p>

</div>

<div id="GuillaumeGuy">
<a
    href="https://github.com/guillaumeguy"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Guillaume Guy
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Guillaume Guy
    </h3>
  </a>
  <section className="section-gap-GuillaumeGuy">
  <Rwightman_pull_mlfoundations_open_clip_pull_1069_From_2025_04_01_To_2025_04_30 />
  <a href="https://www.guillaume.nyc/dont-use-raw-embeddings" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Don't use raw embeddings | Posts · 16/4/2025 · 3 minute 
    </a>
    <WhyThisRepo />
    <p>However, embeddings are still quite large. OpenAI&#39;s <code>text-embedding-3-large</code> can reach up to d=3072, which means 6kB (stored as float32) per entity. From experience, this is enough to overwhelm SQL engines when performing large JOINs, as this data needs to be sent across the network for a distributed JOIN.</p>
  </section>

</div>

<div id="HrishiOlickel">
<a
    href="https://github.com/hrishioa"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Hrishi Olickel
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Hrishi Olickel.
    </h3>
  </a>
  <a href="https://olickel.com/subqueries-and-ctes-an-example-of-query-optimization-in-postgres" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Subqueries and CTEs: an example of query optimization in Postgres | Optimization isn't always premature | Posts · 9/10/2020 · 5 minutes 
    </a>
</div>

<div id="AntonZhiyanov">
<a
    href="https://github.com/nalgeon"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Anton Zhiyanov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Anton Zhiyanov.
    </h3>
  </a>
  <a href="https://antonz.org/sql-join/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: SQL join flavors | Posts · 20/6/20203 · 5 minutes 
    </a>
    <ul dir="auto">
<li><a href="https://github.com/nalgeon/codapi">codapi</a> — Interactive code examples for all types of technical writing.</li>
<li><a href="https://github.com/nalgeon/redka">redka</a> — Redis re-implemented with SQLite.</li>
<li><a href="https://github.com/nalgeon/sqlean">sqlean</a> — SQLite extensions.</li>
</ul>
</div>
<div id="James(@capjamesg)">
<a
    href="https://github.com/capjamesg"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      James (@capjamesg)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m James (@capjamesg).
    </h3>
  </a>
  <a href="https://jamesg.blog/2024/08/19/nosql-database-python" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Building a NoSQL database in Python | Posts · 19/8/2024 · 5 minutes 
    </a>
</div>

<div id="ZonghengYang">
<a
    href="https://github.com/concretevitamin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Zongheng Yang (@concretevitamin)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Zongheng Yang (@concretevitamin).
    </h3>
  </a>
  <section className="section-gap-ZonghengYang">
      <h3>
      <a href="https://github.com/kvfrans?tab=following" target="_blank" rel="noopener noreferrer">
        Followings of Kevin Frans on GitHub
      </a>
    </h3>
    <GautamMittalGitHubProfile />
    <p>
    Gautam Mittal (<a href="https://github.com/gmittal">https://github.com/gmittal</a>) has a repository 
          <br />
          <a href="https://github.com/skypilot-org/skypilot">skypilot-org/skypilot</a> (Python) 8.2k STARS

        </p>
    <ZonghengYang_skypilot_org_skypilot_ContributorList />
      <a href="https://rise.cs.berkeley.edu/blog/sql-query-optimization-meets-deep-reinforcement-learning/" 
          target="_blank" 
          rel="noopener noreferrer">
          Visit the full article: SQL Query Optimization Meets Deep Reinforcement Learning | Posts  · 18/9/2018 
        </a>
  </section>
  
  
</div>

<div id="ChrisDone">
<a
    href="https://github.com/chrisdone"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Chris Done (@chrisdone)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Chris Done (@chrisdone).
    </h3>
  </a>
  <p>
Artin Ghasivand(<a href="https://github.com/Ei30metry">https://github.com/Ei30metry</a>) followed a GitHub user on 27/6/24
  <br />
  <a href="https://github.com/chrisdone">https://github.com/chrisdone </a>
  <div>Artificial Labs <a className="user-mention notranslate" data-hovercard-type="organization" data-hovercard-url="/orgs/artificialio/hovercard" data-octo-click="hovercard-link-click" data-octo-dimensions="link_type:self" href="https://github.com/artificialio">@artificialio</a> </div>
<section className="section-gap-wjayesh">
   <a href="https://chrisdone.com/posts/postgresql-pagination/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Fast pagination on PostgreSQL | Posts  · 19/11/2014  ·  2 minutes
    </a>
</section>
</p>
</div>

<div id="JayeshSharma">
<a
    href="https://github.com/wjayesh"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jayesh Sharma (@wjayesh)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Jayesh Sharma (@wjayesh).
    </h3>
  </a>
  <section className="section-gap-wjayesh">
<p>
Martin Krasser(<a href="https://github.com/krasserm">https://github.com/krasserm</a>) starred a repository on 26/3/25
  <br />
  <a href="https://github.com/wjayesh/mahilo">wjayesh/mahilo </a> (Python) 360 STARS

</p>
  <a href="https://medium.com/c-sharp-programming/building-distributed-apps-using-dapr-locally-and-on-azure-65316a2f259" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Building distributed apps using Dapr, locally and on Azure | Posts  · 17/3/2021  · .Net Programming, Microservices · 10 minutes
    </a>
    <h2 className="heading-element" dir="auto">📑 Latest Blog Posts</h2>
    <ul dir="auto">
<li><a href="https://medium.com/thedeephub/how-mahilo-stands-out-in-the-sea-of-ai-agent-frameworks-07925892b15e?source=rss-18ed07d706ef------2" rel="nofollow">How mahilo Stands Out in The Sea of AI Agent Frameworks</a></li>
<li><a href="https://medium.com/thedeephub/building-a-voice-enabled-python-fastapi-app-using-openais-realtime-api-bfdf2947c3e4?source=rss-18ed07d706ef------2" rel="nofollow">Building a voice-enabled Python FastAPI app using OpenAI’s Realtime API</a></li>
<li><a href="https://wjayesh.medium.com/how-autonomous-agents-work-the-concept-and-its-langchain-implementation-e1a77f612427?source=rss-18ed07d706ef------2" rel="nofollow">How Autonomous Agents Work: The Concept and Its LangChain Implementation</a></li>
<li><a href="https://dev.to/wjayesh/not-just-another-mlflow-on-kubernetes-article-2522" rel="nofollow">Not just another MLflow on Kubernetes article</a></li>
<li><a href="https://dev.to/wjayesh/explained-simply-aws-iam-and-kubernetes-rbac-1hja" rel="nofollow">Explained Simply: AWS IAM and Kubernetes RBAC</a></li>
</ul>
</section>
</div>

<div id="ReshamaShaikh">
<a
    href="https://github.com/reshamas"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Reshama Shaikh (@reshamas)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Reshama Shaikh (@reshamas).
    </h3>
  </a>
<p></p>
    <a href="https://reshamas.github.io/fastai-week-2-classifying-african-and-asian-elephants/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Fastai Week 2 Classifying African And Asian Elephants | Posts · 5/11/2018 · 4 minutes 
    </a>
    <p></p>
    <a href="https://reshamas.github.io/fastai-week-1-classifying-camels-horses-and-elephants/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Fastai Week 1 Classifying Camels Horses And Elephants | Posts · 28/10/2018 · 5 minutes 
    </a>
    <p></p>
    <a href="https://reshamas.github.io/my-first-kaggle-competition/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: My First Kaggle Competition | Posts · 18/4/2018 · 5 minutes 
    </a>

</div>

<div id="GéraldBarré">
<a
    href="https://github.com/meziantou"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Gérald Barré (@meziantou)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Gérald Barré (@meziantou).
    </h3>
  </a>
  <h4 className="heading-element" dir="auto">📗 Recent blog posts</h4>
  <ul dir="auto">
<li><a href="https://www.meziantou.net/using-pattern-matching-in-csharp-for-performance-optimization.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Using Pattern Matching in C# for Performance Optimization</a></li>
<li><a href="https://www.meziantou.net/use-csharp-14-extensions-to-simplify-enum-parsing.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Use C# 14 extensions to simplify enum Parsing</a></li>
<li><a href="https://www.meziantou.net/stringcomparison-invariantculture-is-not-always-invariant.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">StringComparison.InvariantCulture is not always invariant</a></li>
<li><a href="https://www.meziantou.net/using-snapshot-testing-to-validate-ef-core-schema.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Using Snapshot Testing to validate EF Core schema</a></li>
<li><a href="https://www.meziantou.net/migrate-from-mstest-to-xunit-using-a-roslyn-analyzer.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Migrate from MSTest to xUnit using a Roslyn analyzer</a></li>
<li><a href="https://www.meziantou.net/using-roslyn-to-analyze-and-rewrite-code-in-a-solution.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Using Roslyn to analyze and rewrite code in a solution</a></li>
<li><a href="https://www.meziantou.net/hsts-for-httpclient-in-dotnet.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Enhance Your .NET HttpClient with HSTS Support</a></li>
<li><a href="https://www.meziantou.net/exploring-collectionsmarshal-for-dictionary.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Exploring CollectionsMarshal for Dictionary</a></li>
<li><a href="https://www.meziantou.net/signing-commits-in-git-using-ssh-keys-on-windows.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Signing commits in Git using SSH keys on Windows</a></li>
<li><a href="https://www.meziantou.net/reading-usn-journal-with-dotnet.htm?utm_medium=social&amp;utm_source=syndication" rel="nofollow">Reading USN Journal with .NET</a></li>
</ul>
<section className="section-gap-GéraldBarré">
<p>
              Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) followed a GitHub user on 2/5/25
                <br />
                <a href="https://github.com/meziantou">meziantou </a>

              </p>
</section>
 
             
                  <a href="https://www.meziantou.net/prevent-accidental-disclosure-of-configuration-secrets.htm" 
                    target="_blank" 
                    rel="noopener noreferrer">
                    Visit the full article: Prevent accidental disclosure of configuration secrets | Posts · 13/2/2023 · 4 minutes 
                  </a>
             
              <p></p>
              <div id="GéraldBarré_SIMD">
                <a href="https://www.meziantou.net/replace-characters-in-a-string-using-vectorization.htm" 
                    target="_blank" 
                    rel="noopener noreferrer">
                    Visit the full article: Replace characters in a string using Vectorization | Posts · 11/7/2022 · 4 minutes 
                  </a>
              </div>
 
</div>
<div id="Books">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Books
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Books.
    </h3>
  </a>


        <li className="no-margin-bottom1">
              <a
                href="#Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    Artificial Intelligence: A Modern Approach
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  {/* <img src="https://tarlton.info/attachments/Backprop-chain-Drawing-3.png" // width="auto" height="auto" 
  alt=""></img> */}
                  Just re-illustrating the example from the Russell book Chapter 21. Note how the unit “numbers” have changed.
                  Give it a shot if you have literally nothing else to do. There is a reason we make computers do this.</p>

                <a href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the Wikipedia Page: Artificial Intelligence: A Modern Approach |  Written by Stuart J. Russell and Peter Norvig
                </a>
                {/* <div className="mw-body-content"> */}
                <p>
                  <i>AIMA</i> has been called "the most popular artificial intelligence textbook in the world",
                  <sup id="cite_ref-2" className="reference">
                    <a href="#cite_note-2">
                      <span className="cite-bracket">[</span>2<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  and is considered the standard text in the field of AI.
                  <sup id="cite_ref-3" className="reference">
                    <a href="#cite_note-3">
                      <span className="cite-bracket">[</span>3<span className="cite-bracket">]</span>
                    </a>
                  </sup>
                  <sup id="cite_ref-4" className="reference">
                    <a href="#cite_note-4">
                      <span className="cite-bracket">[</span>4<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  As of 2023, it was being used at over 1500 universities worldwide,
                  <sup id="cite_ref-5" className="reference">
                    <a href="#cite_note-5">
                      <span className="cite-bracket">[</span>5<span className="cite-bracket">]</span>
                    </a>
                  </sup>{" "}
                  and it has over 59,000 citations on{" "}
                  <a href="/wiki/Google_Scholar" title="Google Scholar">
                    Google Scholar
                  </a>
                  .
                  <sup id="cite_ref-6" className="reference">
                    <a href="#cite_note-6">
                      <span className="cite-bracket">[</span>6<span className="cite-bracket">]</span>
                    </a>
                  </sup>
                </p>
              </section>
            </li>



</div>
{ <div id="MichaelTarlton">
<a
    href="https://x.com/MichaeTa"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Michael Tarlton
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Michael Tarlton.
    </h3>
  </a>
  <MichaelTarlton_Twitter />
  <p></p>
  <p>
    {/* <img src="https://tarlton.info/attachments/Backprop-chain-Drawing-3.png" // width="auto" height="auto" 
  alt=""></img> */}
Just re-illustrating the example from the Russell book Chapter 21. Note how the unit “numbers” have changed.
Give it a shot if you have literally nothing else to do. There is a reason we make computers do this.</p>

<a href="https://en.wikipedia.org/wiki/Artificial_Intelligence:_A_Modern_Approach#cite_note-index-4th-7" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the Wikipedia Page: Artificial Intelligence: A Modern Approach |  Written by Stuart J. Russell and Peter Norvig 
  </a>
  {/* <div className="mw-body-content"> */}
  <p>
  <i>AIMA</i> has been called "the most popular artificial intelligence textbook in the world",
      <sup id="cite_ref-2" className="reference">
        <a href="#cite_note-2">
          <span className="cite-bracket">[</span>2<span className="cite-bracket">]</span>
        </a>
      </sup>{" "}
      and is considered the standard text in the field of AI.
      <sup id="cite_ref-3" className="reference">
        <a href="#cite_note-3">
          <span className="cite-bracket">[</span>3<span className="cite-bracket">]</span>
        </a>
      </sup>
      <sup id="cite_ref-4" className="reference">
        <a href="#cite_note-4">
          <span className="cite-bracket">[</span>4<span className="cite-bracket">]</span>
        </a>
      </sup>{" "}
      As of 2023, it was being used at over 1500 universities worldwide,
      <sup id="cite_ref-5" className="reference">
        <a href="#cite_note-5">
          <span className="cite-bracket">[</span>5<span className="cite-bracket">]</span>
        </a>
      </sup>{" "}
      and it has over 59,000 citations on{" "}
      <a href="/wiki/Google_Scholar" title="Google Scholar">
        Google Scholar
      </a>
      .
      <sup id="cite_ref-6" className="reference">
        <a href="#cite_note-6">
          <span className="cite-bracket">[</span>6<span className="cite-bracket">]</span>
        </a>
      </sup>
  </p>
<div style={{ textAlign: 'center' }}>
      <img 
        src="https://m.media-amazon.com/images/I/41DXHTpEq6L._SX342_SY445_.jpg"
        alt="Product Image" 
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </div>
    {/* </div> */}


</div> }



<Nelhage_llama_GitHubRepository />
<MatthewRocklinPR_pytorch_pytorch_issues_9168_From_2018_7_01_To_2018_8_31 />
<Roboflow_rf_detr_graphs_contributors_ContributorList />


<div id="daily_dev_idoshamun">
<a
    href="https://github.com/idoshamun"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ido Shamun
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ido Shamun
    </h3>
  </a>
  <a href="https://daily.dev/blog/sql-join-vs-subquery-the-game-changer" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: SQL Join vs Subquery: The Game Changer | Posts · 19/11/2020 · 3 minutes 
    </a>
</div>

<div id="SuYang">
<a
    href="https://github.com/soulteary/"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Su Yang
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Su Yang
    </h3>
  </a>
  <a href="https://soulteary.com/2025/02/07/intel-b580-gpu-with-docker-and-deepseek-r1-distill-qwen-7b.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Intel B580 GPU Large Model Container Inference Practice: A Case Study of DeepSeek R1 Distill Qwen 7B (Part 1) | Posts · 7/2/2025 · 25 minutes 
    </a>
</div>

          <div id="Azure">
            <a
              href="https://azure.microsoft.com/en-in"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Microsoft Azure
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Microsoft Azure
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#github_com_MiguelElGallo_mpzsql_Run_Ducklake_ducklake_select_in_Azure_and_with_own_compute"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    MiguelElGallo/mpzsql
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  <a href="https://x.com/miguelperedo" target="_blank" rel="noopener noreferrer">Miguel Peredo Z (@‪miguelperedo‬)</a> posted  · 17/9/2025
                </p>
                <p>
                </p>
                <a href="https://x.com/miguelperedo/status/1968360764835512369?s=20"
                  target="_blank"
                  rel="noopener noreferrer">
                  View the post on <strong>https://x.com</strong>: #Ducklake 0.3 has been released. Wanna try it running in Azure? Use my MPZSQL server.  https://github.com/MiguelElGallo/mpzsql · posted  17/9/2025
                </a>
              </section>
            </li>
          </div>

          <div id="PrettierIgnore_">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  prettier/prettier
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                prettier/prettier
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#github_com_marimo_team_marimo_lsp_pull_433_Prevent_marimo_py_filename_and_detect_module_shadowing_errors"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    marimo-team/marimo-lsp
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Trevor Manz(@manzt)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created a PR
                  <br />
                  <a href="https://github.com/marimo-team/marimo-lsp/pull/433">marimo-team/marimo-lsp</a> on 4/3/26 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/marimo-team/marimo-lsp/pull/433">Visit the GitHub PR: Prevent marimo.py filename and detect module shadowing errors
                    #433 </a>
                </div>
                <p></p>
                <a href="https://stackoverflow.com/questions/66259151/how-to-make-prettier-to-ignore-a-block-of-code"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: How to make Prettier to ignore a block of code? · by STEEL on 21/7/2021 30/6/2023
                </a>
                <p></p>
                <a href="https://github.com/prettier/prettier/issues/5287"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: known issue - https://github.com/prettier/prettier/issues/5287 · by STEEL on 21/7/2021, where HungThinhIT commented: Best hack I have got for this is - to put all the to-be-ignored code inside a function and put the // prettier-ignore over that function definition to ignore the whole function block.
                  on Oct 14, 2025
                </a>

              </section>
            </li>
          </div>

          <div id="Base64_Conversion_">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Base64 Methods
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Base64 Methods
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#github_com_marimo_team_marimo_pull_8132_Prefer_native_Uint8Array_base64_methods_when_available"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    marimo-team/marimo
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Trevor Manz(@manzt)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created a PR
                  <br />
                  <a href="https://github.com/marimo-team/marimo/pull/8132">marimo-team/marimo</a> on 5/2/26 that received 1 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/marimo-team/marimo/pull/8132">Visit the GitHub PR: Prefer native Uint8Array base64 methods when available #8132 </a>
                </div>
                <p></p>
                <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/fromBase64"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: Uint8Array.fromBase64() | Baseline 2025 Newly available | Posts · JavaScript · Uint8Array.fromBase64 · 09/2025
                </a>
              </section>
            </li>
          </div>


          <div id="github_com_marimo_team_marimo">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  marimo-team/marimo
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                marimo-team/marimo
              </h3>
            </a>
            <div id="github_com_marimo_team_marimo_pull_8132_Prefer_native_Uint8Array_base64_methods_when_available">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Trevor Manz(@manzt)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created a PR
                  <br />
                  <a href="https://github.com/marimo-team/marimo/pull/8132">marimo-team/marimo</a> on 5/2/26 that received 1 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/marimo-team/marimo/pull/8132">Visit the GitHub PR: Prefer native Uint8Array base64 methods when available #8132 </a>
                </div>
                <p></p>
                <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/fromBase64"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: Uint8Array.fromBase64() | Baseline 2025 Newly available | Posts · JavaScript · Uint8Array.fromBase64 · 09/2025
                </a>
              </section>
            </div>

          </div>

          <div id="github_com_marimo_team_marimo_lsp">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  marimo-team/marimo-lsp
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                marimo-team/marimo-lsp
              </h3>
            </a>


            <div id="github_com_marimo_team_marimo_lsp_pull_433_Prevent_marimo_py_filename_and_detect_module_shadowing_errors">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Trevor Manz(@manzt)(<a href="https://github.com/manzt">https://github.com/manzt</a>) Created a PR
                  <br />
                  <a href="https://github.com/marimo-team/marimo-lsp/pull/433">marimo-team/marimo-lsp</a> on 4/3/26 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/marimo-team/marimo-lsp/pull/433">Visit the GitHub PR: Prevent marimo.py filename and detect module shadowing errors
                    #433 </a>
                </div>
                <p></p>
                <a href="https://stackoverflow.com/questions/66259151/how-to-make-prettier-to-ignore-a-block-of-code"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: How to make Prettier to ignore a block of code? · by STEEL on 21/7/2021 30/6/2023
                </a>
                <p></p>
                {/* <a href="https://github.com/prettier/prettier/issues/5287"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: known issue - https://github.com/prettier/prettier/issues/5287 · by STEEL on 21/7/2021, where HungThinhIT on Oct 14, 2025
                </a> */}
                <a href="https://github.com/prettier/prettier/issues/5287"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full article: known issue - https://github.com/prettier/prettier/issues/5287 · by STEEL on 21/7/2021, where HungThinhIT commented: Best hack I have got for this is - to put all the to-be-ignored code inside a function and put the // prettier-ignore over that function definition to ignore the whole function block.
                  on Oct 14, 2025
                </a>

              </section>
            </div>


          </div>


          <div id="GZTimeWalker_GZCTF">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  GZTimeWalker/GZCTF
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                GZTimeWalker/GZCTF
              </h3>
            </a>
            <div id="GZTimeWalker_GZCTF_pull_544_Satori_GC_for_DotNET_10_544">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Steve(@hez2010)(<a href="https://github.com/hez2010">https://github.com/hez2010</a>) Created a PR
                  <br />
                  <a href="https://github.com/GZTimeWalker/GZCTF/pull/544">GZTimeWalker/GZCTF</a> on 1/2/26 that received 10 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/GZTimeWalker/GZCTF/pull/544">Visit the GitHub PR: Satori GC for .NET 10
                    #544 </a>
                </div>
                <p></p>
                <a href="https://github.com/GZTimeWalker/GZCTF/pull/544"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full PR: Copilot AI on Feb 1 In the file: <strong>src/GZCTF/Dockerfile</strong> <strong>Comment on lines +10 to +13</strong>
                </a>
              </section>
            </div>
          </div>




<div id="AaronPowell">
<a
    href="https://github.com/aaronpowell"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Aaron Powell(@aaronpowell)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Aaron Powell(@aaronpowell)
    </h3>
  </a>


            <li className="no-margin-bottom1">
              <a
                href="#Aaron_Powell_github_awesome_copilot_pull_590_Enhance_the_skill_to_include_sampling_of_data_to_detect_better_join#590"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    github/awesome-copilot
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Reviewed 7 PRs
                  <br />
                  <a href="https://github.com/github/awesome-copilot/">github/awesome-copilot/</a> on 19/1/26 that received 5 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/github/awesome-copilot/pull/590">Visit the GitHub PR: Enhance the skill to include sampling of data, to detect better joins. #590 </a>
                </div>
              </section>
            </li>

            <li className="no-margin-bottom1">
              <a
                href="#Aaron_Powell__LANCommander_LANCommander_pull_365_Adding_logging_to_library_endpoints_for_better_debugging"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    LANCommander/LANCommander
                  </span>
                </h3>
              </a>

              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Created a PR
                  <br />
                  <a href="https://github.com/LANCommander/LANCommander">LANCommander/LANCommander</a> on 2/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/LANCommander/LANCommander/pull/365">Visit the GitHub PR: Adding logging to library endpoints for better debugging #365 </a>
                </div>
              </section>
            </li>

  <section className="section-gap-AsankhayaSharma">
    <p>
       Aaron Powell(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>)  Answered 1 discussion in 1 repository
        <br />
        <a href="https://github.com/github/awesome-copilot/discussions/64#discussioncomment-13690191">github/awesome-copilot/discussions/64</a> on 8/7/25

      </p>
      <p></p>
          <a
      href="https://github.com/github/awesome-copilot/discussions/64#discussioncomment-13690191"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the Discussion on <strong>GitHub discussions</strong>: Is there awesome intructions for SQL queries? #64
    </a>
      <p></p>
      <AaronPowell_PR_github_awesome_copilot_discussions_64_From_2025_7_01_To_2025_7_31 />
      <p></p>
      <p>
       Ambily(<a href="https://github.com/ambilykk">https://github.com/ambilykk</a>)  Opened 1 pull request in 1 repository
        <br />
        <a href="https://github.com/github/awesome-copilot/pull/49">github/awesome-copilot</a> on 5/7/25

      </p>
      <Ambily_PR_github_awesome_copilot_pull_49_From_2025_7_01_To_2025_7_31 />
  </section>
</div>
          <div id="LANCommander_LANCommander">
            <a
              href="https://github.com/LANCommander/LANCommander"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  LANCommander/LANCommander
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                LANCommander/LANCommander
              </h3>
            </a>

            <div id="Aaron_Powell__LANCommander_LANCommander_pull_365_Adding_logging_to_library_endpoints_for_better_debugging">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Created a PR
                  <br />
                  <a href="https://github.com/LANCommander/LANCommander">LANCommander/LANCommander</a> on 2/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/LANCommander/LANCommander/pull/365">Visit the GitHub PR: Adding logging to library endpoints for better debugging #365 </a>
                </div>
              </section>
            </div>

          </div>

          <div id="github_awesome_copilot">
            <a
              href="https://github.com/github/awesome-copilot"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  github/awesome-copilot
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                github/awesome-copilot
              </h3>
            </a>

            <div id="Aaron_Powell_github_awesome_copilot_pull_590_Enhance_the_skill_to_include_sampling_of_data_to_detect_better_join#590">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Reviewed 7 PRs
                  <br />
                  <a href="https://github.com/github/awesome-copilot/">github/awesome-copilot/</a> on 19/1/26 that received 5 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/github/awesome-copilot/pull/590">Visit the GitHub PR: Enhance the skill to include sampling of data, to detect better joins. #590 </a>
                </div>
              </section>
              <section className="section-gap-AnthonyShaw">
                <p>
                  <a href="https://x.com/miguelperedo" target="_blank" rel="noopener noreferrer">Miguel Peredo Z (@‪miguelperedo‬)</a> posted  ·  9/2/25
                </p>
                <p>
                </p>
                <a href="https://x.com/miguelperedo/status/1888308497458282961?s=20"
                  target="_blank"
                  rel="noopener noreferrer">
                  View the post on <strong>https://x.com</strong>: Season 1 of my blog "Modelando" is now available!  It is about data and data modeling concepts, covers also file formats, etc.  https://miguelelgallo.github.io/Modelando2025/ · posted  9/2/2025
                </a>
              </section>
            </div>

          </div>

          <div id="MiguelElGallo_mpzsql">
            <a
              href="https://github.com/MiguelElGallo/mpzsql"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  MiguelElGallo/mpzsql
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                MiguelElGallo/mpzsql
              </h3>
            </a>

            <div id="github_com_MiguelElGallo_mpzsql_Run_Ducklake_ducklake_select_in_Azure_and_with_own_compute">
              <section className="section-gap-AnthonyShaw">
                <p>
                  <a href="https://x.com/miguelperedo" target="_blank" rel="noopener noreferrer">Miguel Peredo Z (@‪miguelperedo‬)</a> posted  · 17/9/2025
                </p>
                <p>
                </p>
                <a href="https://x.com/miguelperedo/status/1968360764835512369?s=20"
                  target="_blank"
                  rel="noopener noreferrer">
                  View the post on <strong>https://x.com</strong>: #Ducklake 0.3 has been released. Wanna try it running in Azure? Use my MPZSQL server.  https://github.com/MiguelElGallo/mpzsql · posted  17/9/2025
                </a>
              </section>
            </div>
          </div>

          <div id="MiguelElGallo">
            <a
              href="https://github.com/MiguelElGallo"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Miguel P Z(@MiguelElGallo)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Miguel P Z(@MiguelElGallo)
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#Aaron_Powell_github_awesome_copilot_pull_590_Enhance_the_skill_to_include_sampling_of_data_to_detect_better_join#590"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    github/awesome-copilot
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Reviewed 7 PRs
                  <br />
                  <a href="https://github.com/github/awesome-copilot/">github/awesome-copilot/</a> on 19/1/26 that received 5 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/github/awesome-copilot/pull/590">Visit the GitHub PR: Enhance the skill to include sampling of data, to detect better joins. #590 </a>
                </div>
              </section>
            </li>


            <li className="no-margin-bottom1">
              <a
                href="#github_com_MiguelElGallo_mpzsql_Run_Ducklake_ducklake_select_in_Azure_and_with_own_compute"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    MiguelElGallo/mpzsql
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  <a href="https://x.com/miguelperedo" target="_blank" rel="noopener noreferrer">Miguel Peredo Z (@‪miguelperedo‬)</a> posted  · 17/9/2025
                </p>
                <p>
                </p>
                <a href="https://x.com/miguelperedo/status/1968360764835512369?s=20"
                  target="_blank"
                  rel="noopener noreferrer">
                  View the post on <strong>https://x.com</strong>: #Ducklake 0.3 has been released. Wanna try it running in Azure? Use my MPZSQL server.  https://github.com/MiguelElGallo/mpzsql · posted  17/9/2025
                </a>
              </section>
            </li>
          </div>

<div id="AsankhayaSharma">
<a
    href="https://github.com/codelion"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Asankhaya Sharma
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Asankhaya Sharma
    </h3>
  </a>


  <section className="section-gap-AsankhayaSharma">
    <p>
       Asankhaya Sharma(<a href="https://github.com/codelion">https://github.com/codelion</a>)  contributed to
        <br />
        <a href="https://github.com/codelion/openevolve/pull/148">codelion/openevolve</a> on 15/7/25

      </p>
      <p></p>
          <a
      href="https://github.com/codelion/openevolve/pull/148"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the PR on <strong>GitHub Repository</strong>: fix: MAP-Elite complexity binning issue #147 #148
    </a>
      <p></p>
        
      <Asankhaya_SharmaPR_codelion_openevolve_issues_148_From_2025_7_01_To_2025_7_31 />
      <p></p>
        <p>
       Asankhaya Sharma(<a href="https://github.com/codelion">https://github.com/codelion</a>)  contributed to
        <br />
        <a href="https://github.com/codelion/openevolve/pull/147">codelion/openevolve</a> on 15/7/25

      </p>
                <a
      href="https://github.com/codelion/openevolve/pull/147"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit the PR on <strong>GitHub Repository</strong>: Problems of '_calculate_feature_coords' function #147
    </a> with <strong>Labels: Bug</strong>
    <p></p>
    <Asankhaya_SharmaPR_codelion_openevolve_issues_147_From_2025_7_01_To_2025_7_31 />
  </section>

  <section className="section-gap-AsankhayaSharma">
    <p>
    Asankhaya Sharma(<a href="https://github.com/codelion">https://github.com/codelion</a>) 
    <br />
    {/* <a href="https://github.com/codelion/openevolve">codelion/openevolve </a> (Python) 2.3k STARS
    <br /> */}
    codelion launched their sponsorship page 💖  <a href="https://github.com/codelion">Asankhaya Sharma codelion</a> on 10/6/25
  </p>
  </section>

 <section className="section-gap-AsankhayaSharma">
    <p>
      Asankhaya Sharma(<a href="https://github.com/codelion">https://github.com/codelion</a>) Trending repositories on 23/5/25
        <br />
        <a href="https://github.com/codelion/openevolve">codelion/openevolve </a> (Python) 2.3k STARS

      </p>
 </section>

</div>

<div id="Max_Liani">
<a
    href="https://x.com/maxliani"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Max Liani
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Max Liani
    </h3>
  </a>
  <Max_Liani_Twitter_Following />
  <div dir="auto" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41" data-testid="UserDescription" style={{ color: "rgb(15, 20, 25)"  , display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "5px"}}>
  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3">
    Raytracing Director at Nvidia. Previously: Tech Lead for RenderMan at Pixar, Architect of Glimpse Renderer at Animal Logic
  </span>
  {/* <img alt="🇮🇹" draggable="false" src="https://abs-0.twimg.com/emoji/v2/svg/1f1ee-1f1f9.svg" title="Flag of Italy" className="r-4qtqp9 r-dflpy8 r-k4bwe5 r-1kpi4qh r-pp5qcn r-h9hxbl" />
  <img alt="🇦🇺" draggable="false" src="https://abs-0.twimg.com/emoji/v2/svg/1f1e6-1f1fa.svg" title="Flag of Australia" className="r-4qtqp9 r-dflpy8 r-k4bwe5 r-1kpi4qh r-pp5qcn r-h9hxbl" />
  <img alt="🇺🇸" draggable="false" src="https://abs-0.twimg.com/emoji/v2/svg/1f1fa-1f1f8.svg" title="Flag of United States" className="r-4qtqp9 r-dflpy8 r-k4bwe5 r-1kpi4qh r-pp5qcn r-h9hxbl" />
  <img alt="🇨🇦" draggable="false" src="https://abs-0.twimg.com/emoji/v2/svg/1f1e8-1f1e6.svg" title="Flag of Canada" className="r-4qtqp9 r-dflpy8 r-k4bwe5 r-1kpi4qh r-pp5qcn r-h9hxbl" /> */}
  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3"> Views are my own.</span>
</div>
  <a href="https://maxliani.wordpress.com/2023/03/17/dnnd-1-a-deep-neural-network-dive/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: DNND 1: a Deep Neural Network Dive | Posts  · 27/3/2023  · Software Development · 5 minutes
    </a>
</div>

<div id="Marlene">
<a
    href="https://github.com/marlenezw"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Marlene
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Marlene
    </h3>
  </a>
  <div>Pythonista and Developer Advocate at Microsoft 🥑✨ Learning and teaching Python🐍</div>
  <p>
Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) Created a pull request on 2/6/25
  <br />
  <a href="https://github.com/langchain-ai/langchain-community/pull/88">langchain-ai/langchain-community/pull/88 </a> 

</p>
  <Anthony_ShawPR_langchain_ai_langchain_community_pull_88_From_2025_5_01_To_2025_5_31 />
    <a href="https://marlenezw.hashnode.dev/an-introduction-to-ibis-for-python-programmers" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: An Introduction to Ibis for Python Programmers | A More Pythonic Way To Work With Databases | Posts  · 14/3/2022  · Python, Databases · 10 minutes
    </a>
  
</div>

<div id="EdzerPebesma">
<a
    href="https://github.com/edzer"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Edzer Pebesma
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Edzer Pebesma
    </h3>
  </a>
  <div>geoinformatics, spatial statistics, R.</div>
   <Edzer_Pebesma_VCardDetails />
      <a href="https://r-spatial.org/2017/07/14/Large_scale_OSM_in_R.html" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Setting up large scale OSM environments for R using Osmosis and PostgreSQL with PostGIS | Posts  · 14/6/2017  · Databases, geoinformatics, spatial statistics, R. · 5 minutes
    </a>
</div>

<div id="MicrosoftMVP">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Microsoft MVP
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Microsoft MVP
    </h3>
  </a>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
    href="#GéraldBarré"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Gérald Barré (@meziantou)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Gérald Barré (@meziantou).
    </h3>
  </a>
  </section>
  </li>
</div>
<div id="AnthonyShaw">
<a
    href="https://github.com/tonybaloney"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Anthony Shaw(@tonybaloney)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Anthony Shaw(@tonybaloney)
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
    <p>
       Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) contributed to 
        <br />
        <a href="https://github.com/Azure-Samples/azure-search-openai-demo/pull/2553">Azure-Samples/azure-search-openai-demo</a> on 2/6/25

      </p>
      <p>
        <Anthony_ShawPR_Azure_Samples_azure_search_openai_demo_pull_2553_From_2025_6_01_To_2025_6_30 />
      </p>
  </section>



  <section className="section-gap-AnthonyShaw">
    <p>
       Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) contributed to 
        <br />
        <a href="https://github.com/Azure-Samples/eShopLite/pull/4">Azure-Samples/eShopLite</a> on 31/5/25

      </p>
  </section>
  
  <div id="AnthonyShaw_tonybaloney_CSnakes_573_Implement_Half_spans">
      <section className="section-gap-AnthonyShaw">                   
            {/* <p>
        Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) contributed to 
          <br />
          <a href="https://github.com/langchain-ai/langchain-azure/pull/99">langchain-ai/langchain-azure - langchain-ai/langchain-azure/pull/99 </a> on 10/6/25

        </p> */}
              <p>
       Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) Opened 1 pull request in 1 repository
        <br />
        <a href="https://github.com/tonybaloney/CSnakes/pull/573">tonybaloney/CSnakes</a> on 9/7/25

      </p>
        <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
          <a href="https://github.com/tonybaloney/CSnakes/issues/572">Visit the GitHub Issue: Numpy float16 dtype support #572  </a>  
        </div>
       <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
          <a href="https://github.com/tonybaloney/CSnakes/pull/573">Visit the GitHub PR: Implement Half spans  #573  </a>  
        </div>
         
        
        {/* <Anthony_ShawPR_langchain_ai_langchain_community_pull_99_From_2025_6_01_To_2025_6_30 />
        <WhyThisRepo />
        <p dir="auto">MD5 and SHA1 should never be used for cache keys because there is a chance of collisions.</p>
        <p dir="auto">The implication here is that the in-process cache dictionary will use different cache keys, but that doesn't matter since it's stored in memory and you need to restart to run this update.</p> */}
      </section>
    </div>
  <div id="AnthonyShaw_Replace_MD5_with_SHA256_for_cache_index_entry_keys_and_names">
      <section className="section-gap-AnthonyShaw">
            <p>
        Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) contributed to 
          <br />
          <a href="https://github.com/langchain-ai/langchain-azure/pull/99">langchain-ai/langchain-azure - langchain-ai/langchain-azure/pull/99 </a> on 10/6/25

        </p>
        <Anthony_ShawPR_langchain_ai_langchain_community_pull_99_From_2025_6_01_To_2025_6_30 />
        <WhyThisRepo />
        <p dir="auto">MD5 and SHA1 should never be used for cache keys because there is a chance of collisions.</p>
        <p dir="auto">The implication here is that the in-process cache dictionary will use different cache keys, but that doesn't matter since it's stored in memory and you need to restart to run this update.</p>
      </section>
    </div>


</div>
<div id="CSnakes_Repository">
<a
    href="https://github.com/tonybaloney/CSnakes"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       tonybaloney/CSnakes
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      tonybaloney/CSnakes
    </h3>
  </a>     
            <li className="no-margin-bottom1">
              <a
                href="#SorenFrederiksen_mindzie__thefrederiksen_CSnakesCourse_commit_Upgrade_CSnakes_and_add_deployment_enhancements"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    thefrederiksen/CSnakesCourse
                  </span>
                </h3>
              </a>

              <section className="section-gap-AnthonyShaw">
                <p>
                  Soren Frederiksen @ mindzie(@sorenfrederiksen2)(<a href="https://github.com/sorenfrederiksen2">https://github.com/sorenfrederiksen2</a>) Created a commit
                  <br />
                  <a href="https://github.com/thefrederiksen/CSnakesCourse/">thefrederiksen/CSnakesCourse</a> on 3/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/thefrederiksen/CSnakesCourse/commit/d92c49525697c53132a4fbb5c809e8533bcb37ba">Visit the GitHub commit: Upgrade CSnakes and add deployment enhancements Commit #d92c495 </a>
                </div>
              </section>
            </li>

  <section className="section-gap-AnthonyShaw">
                  <a href="https://youtu.be/dv_Rn1nRQwI"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the tutorial video on <strong>https://www.youtube.com/</strong>: CSnakes: Use Python in .NET Like a Pro! 🐍💻 | Posts  · 25/5/2025  ·  #MAUI #VisualStudio #WPF · 13 minutes
              </a>
              <p>
                Want to run Python code inside your C#/.NET app without installing Python globally?
              </p>
</section>
       <li className="no-margin-bottom1">
        <a
          href="#AnthonyShaw_tonybaloney_CSnakes_573_Implement_Half_spans"
          className="vcard-names1"
          style={{ textDecoration: 'underline' }}
        >
           <h1 style={{ margin: 0 }}>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Anthony Shaw(@tonybaloney)
            </span>
          </h1>
          <h3 style={{ margin: 0 }}>
            Implement Half spans  #573
          </h3>
        </a>
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
         <p>
       Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) Opened 1 pull request in 1 repository
        <br />
        <a href="https://github.com/tonybaloney/CSnakes/pull/573">tonybaloney/CSnakes</a> on 9/7/25

      </p>
        <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
          <a href="https://github.com/tonybaloney/CSnakes/pull/573">Visit the GitHub PR: Implement Half spans  #573  </a>  
        </div>
  </section>
    </li>
            <li className="no-margin-bottom1">
              <a
                href="#KonstantinGukov_tonybaloney_CSnakes_pull_387_Use_redistributable_Python_for_runtime_and_integration_tests"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    Konstantin Gukov(@gukoff)
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <p>
                  Konstantin Gukov(<a href="https://github.com/gukoff">https://github.com/gukoff</a>) Created an PR in
                  <br />
                  <a href="tonybaloney/CSnakes/pull/387">tonybaloney/CSnakes</a> repository on 2/4/25 that received 4 comments
                </p>
                <p style={{ margin: 0 }}>
                  <a href="https://github.com/tonybaloney/CSnakes/pull/387">Visit the GitHub PR: Use redistributable Python for runtime- and integration tests #387  </a>
                </p>
              </section>
            </li>
</div>

          <div id="thefrederiksen_CSnakesCourse">
            <a
              href="https://github.com/thefrederiksen/CSnakesCourse"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Soren Frederiksen @ mindzie(@sorenfrederiksen2)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Soren Frederiksen @ mindzie(@sorenfrederiksen2)
              </h3>
            </a>
            <div id="SorenFrederiksen_mindzie__thefrederiksen_CSnakesCourse_commit_Upgrade_CSnakes_and_add_deployment_enhancements">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Soren Frederiksen @ mindzie(@sorenfrederiksen2)(<a href="https://github.com/sorenfrederiksen2">https://github.com/sorenfrederiksen2</a>) Created a commit
                  <br />
                  <a href="https://github.com/thefrederiksen/CSnakesCourse/">thefrederiksen/CSnakesCourse</a> on 3/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/thefrederiksen/CSnakesCourse/commit/d92c49525697c53132a4fbb5c809e8533bcb37ba">Visit the GitHub commit: Upgrade CSnakes and add deployment enhancements Commit #d92c495 </a>
                </div>
              </section>
            </div>


          </div>


<div id="KonstantinGukov">
<a
    href="https://github.com/gukoff"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Konstantin Gukov(@gukoff)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Konstantin Gukov(@gukoff)
    </h3>
  </a>

 <div id="KonstantinGukov_tonybaloney_CSnakes_pull_387_Use_redistributable_Python_for_runtime_and_integration_tests">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Konstantin Gukov(<a href="https://github.com/gukoff">https://github.com/gukoff</a>) Created an PR in 
                  <br />
                  <a href="tonybaloney/CSnakes/pull/387">tonybaloney/CSnakes</a> repository on 2/4/25 that received 4 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/tonybaloney/CSnakes/pull/387">Visit the GitHub PR: Use redistributable Python for runtime- and integration tests #387  </a>
                </div>
              </section>
            </div>


</div>
<div id="Bowrna">
<a
    href="https://github.com/Bowrna"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Bowrna(@Bowrna)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Bowrna(@Bowrna)
    </h3>
  </a>
      <h3>
    <a href="https://github.com/tonybaloney?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Anthony Shaw(tonybaloney) on GitHub
    </a>
  </h3>
  <div id="ApplicationSecurity_Bowrna_knadh_listmonk_issues_2357">

  </div>
    <section className="section-gap-AnthonyShaw">
    <p>
       Bowrna(<a href="https://github.com/Bowrna">https://github.com/Bowrna</a>) contributed/added 2 commits that reference the issue 
        <br />
        <a href="https://github.com/knadh/listmonk/issues/2357">knadh/listmonk</a> on 15/4/25

      </p>
    </section>
</div>

<div id="MatějŠtágl">
<a
    href="https://github.com/lofcz"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Matěj Štágl(lofcz)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Matěj Štágl(lofcz)
    </h3>
  </a>
 <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <p>
                  Matěj Štágl(lofcz)(<a href="https://github.com/lofcz">https://github.com/lofcz</a>) Reviewed 2 pull requests in 1 repository
                  <br />
                  <a href="https://github.com/jcrist/msgspec/pull/918">lofcz/LLMTornado</a> on 8/8/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lofcz/LLMTornado/pull/73">Visit the GitHub PR: throw HttpRequestException instead of general Exception for api errors #73 </a>
                </div>
              </section>


</div>
<div id="FastCloner_Repository">
<a
    href="https://github.com/lofcz/FastCloner"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       lofcz/FastCloner
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      lofcz/FastCloner
    </h3>
  </a>

            <div id="MatějŠtágl_lofcz__lofcz_FastCloner_commit_5_12_25_Update_README_md">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Matěj Štágl(lofcz)(<a href="https://github.com/lofcz">https://github.com/lofcz</a>) Created 4 commits
                  <br />
                  <a href="https://github.com/lofcz/FastCloner">lofcz/FastCloner</a> on 5/12/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/lofcz/FastCloner/commit/99904e48302449b2040185be801ddef0865484b6">Visit the GitHub commit: Update README.md </a>
                </div>
              </section>
            </div>
</div>
<div id="OfekLev">
<a
    href="https://github.com/ofek"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ofek Lev(ofek)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ofek Lev(ofek)
    </h3>
  </a>

        <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <p>
                  Ofek Lev(ofek)(<a href="https://github.com/ofek">https://github.com/ofek</a>) Opened 20 pull requests in 1 repository
                  <br />
                  <a href="https://github.com/jcrist/msgspec/pull/918">jcrist/msgspec</a> on 6/11/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/jcrist/msgspec/pull/918">Visit the GitHub PR: Update developer experience #918  </a>
                </div>
              </section>

</div>
          <div id="Michael_Chavinda">
            <a
              href="https://github.com/mchav"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Michael Chavinda(mchav)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Michael Chavinda(mchav)
              </h3>
            </a>


            <section className="section-gap-AnthonyShaw">
              <p>
                Trevor Manzt (<a href="https://github.com/manzt">manzt</a>)
                followed Michael Chavinda(mchav) (<a href="https://github.com/mchav">https://github.com/mchav</a>) on 17/3/25.
              </p>
            </section>

            <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
              <p>
                Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Reviewed 1 pull request in 1 repository
                <br />
                <a href="https://github.com/DataHaskell/dataframe/pull/185">DataHaskell/dataframe</a> on 17/3/25
              </p>
              <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                <a href="https://github.com/DataHaskell/dataframe/pull/185">Visit the GitHub PR: fix: alignment in iris tutorial introduction
                  #185  </a>
              </div>
            </section>


            <li className="no-margin-bottom1">
              <a
                href="#Michael_Chavinda_gauss_function_to_plot_a_bell_curve_DataHaskell_sabela_pull_9"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}  Gauss function to plot a bell curve
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/DataHaskell/sabela/pull/9"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article:Football striker example ⚽ #9
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Reviewed 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/sabela/pull/9">DataHaskell/sabela</a> on 2/7/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/sabela/pull/9">Visit the GitHub PR: Football striker example ⚽   </a>
                </div>
              </section>
            </li>

            <li className="no-margin-bottom1">
              <a
                href="#Michael_Chavinda_DataHaskell_dataframe_pull_commit_34af2bc"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */} DataHaskell/dataframe
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/DataHaskell/dataframe/commit/34af2bc1ee84c995b899fefb1d467954d5d8aefa"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Commit 34af2bc
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/dataframe/"> DataHaskell/dataframe</a> on 20/4/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/dataframe/commit/34af2bc1ee84c995b899fefb1d467954d5d8aefa">Visit the GitHub PR: docs: Update documentation for clarity and accuracy across multiple files   </a>
                </div>
              </section>
            </li>
          </div>

          <div id="Anamika1608">
            <a
              href="https://github.com/Anamika1608"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Anamika Aggarwal(Anamika1608)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Anamika Aggarwal(Anamika1608)
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#medium_com_@anamikagg07_oauth-and-openid-connect-1def117ee947"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    OAuth and OpenID Connect
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://medium.com/@anamikagg07/oauth-and-openid-connect-1def117ee947"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: OAuth and OpenID Connect on 11/8/25
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Reviewed 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/dataframe/pull/185">DataHaskell/dataframe</a> on 17/3/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/dataframe/pull/185">Visit the GitHub PR: fix: alignment in iris tutorial introduction
                    #185  </a>
                </div>
              </section>
            </li>
          </div>

          <div id="Maëlle_Salmon">
            <a
              href="https://github.com/maelle"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Maëlle Salmon(maelle)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Maëlle Salmon(maelle)
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#maelle_https_github_com_r-lib_gert_pull_274_changes"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}  Git Rebase
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/r-lib/gert/pull/274/changes"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article:docs: add example to the rebase manual page
                  #274

                </a>
                <p>
                  Maëlle Salmon(maelle)(<a href="https://github.com/maelle">https://github.com/maelle</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/r-lib/gert/pull/274/changes">r-lib/gert</a> on 4/5/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/r-lib/gert/pull/274/changes">Visit the GitHub PR: fix: add example to the rebase manual page
                    #274  </a>
                </div>
              </section>
            </li>

          </div>


<div id="JirkaBorovec">
<a
    href="https://github.com/Borda"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Jirka Borovec(@Borda)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jirka Borovec(@Borda)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
       <p>
      Jirka Borovec(<a href="https://github.com/Borda">https://github.com/Borda</a>) contributed to 
        <br />
        <a href="https://github.com/Lightning-AI/lightning-thunder/pull/2208">Lightning-AI/lightning-thunder/</a> on 10/6/25

      </p>
      <Jirka_Borovec_PR_Lightning_AI_lightning_thunder_pull_2208_From_2025_6_01_To_2025_6_30 />
   </section>
</div>


          <div id="Use_clustered_medoid_for_stay_recommendations_#1">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}  clustered medoid
                </span>
              </h1>
            </a>

            <div id="AmandaSilver_workiq-uber-demo_Use_clustered_medoid_for_stay_recommendations_1">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/AmandaSilver/workiq-uber-demo/pull/1"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article:Use clustered medoid for stay recommendations- #1
                </a>
                <p>
                  Anthony Shaw(tonybaloney)(<a href="https://github.com/tonybaloney">tonybaloney</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/AmandaSilver/workiq-uber-demo/pull/1">AmandaSilver/workiq-uber-demo</a> on 11/6/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/AmandaSilver/workiq-uber-demo/pull/1">Visit the GitHub PR: Use clustered medoid for stay recommendations- #1
                    #1  </a>
                </div>
              </section>
            </div>

          </div>


          <div id="Durand_Kerner_algorithm_akretz_https_github_com_opencv_opencv_pull_29109">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */} Better Durand-Kerner Initialization
                </span>
              </h1>
            </a>

            <div id="Adrian_Kretz_Durand_Kerner_algorithm_akretz_https_github_com_opencv_opencv_pull_29109">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/opencv/opencv/pull/29109"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Better Durand-Kerner Initialization-#29109
                </a>
                <p>
                  Adrian Kretz(akretz)(<a href="https://github.com/akretz">akretz</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="hhttps://github.com/opencv/opencv/pull/29109">opencv/opencv</a> on 11/6/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/opencv/opencv/pull/29109">Visit the GitHub PR: Better Durand-Kerner Initialization- #29109 </a>
                </div>
                <p>
                  While investigating issue #23644, I have found this paper - <a href="https://link.springer.com/article/10.1007/BF01935059">Initial approximations in Durand-Kerner's root finding method</a> published on 1986, which presents a good initialization for the Durand-Kerner algorithm. Basically the idea is to put the initial points equidistantly on a circle on the complex plane. The radius of the circle is computed as
                  <br />

                </p>
              </section>
            </div>

          </div>


          <div id="Durand_Kerner_algorithm">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Durand Kerner algorithm
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Durand Kerner algorithm
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#Adrian_Kretz_Durand_Kerner_algorithm_akretz_https_github_com_opencv_opencv_pull_29109"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */} Better Durand-Kerner Initialization-#29109
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/opencv/opencv/pull/29109"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Better Durand-Kerner Initialization-#29109
                </a>
                <p>
                  Adrian Kretz(akretz)(<a href="https://github.com/akretz">akretz</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="hhttps://github.com/opencv/opencv/pull/29109">opencv/opencv</a> on 11/6/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/opencv/opencv/pull/29109">Visit the GitHub PR: Better Durand-Kerner Initialization- #29109 </a>
                </div>
              </section>
            </li>
          </div>



          <div id="files_community_Files">
            <a
              href="https://github.com/files-community/Files"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  files-community/Files
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                files-community/Files
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#Make_Json_serialization_AOT_friendly_hez2010_files_community_Files_pull_18840"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}  Code Quality: Make Json serialization AOT-friendly- #18840
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/files-community/Files/pull/18840"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Code Quality: Make Json serialization AOT-friendly- #18840
                </a>
                <p>
                  Steve(hez2010)(<a href="https://github.com/hez2010">hez2010</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/files-community/Files/pull/18840">files-community/Files</a> on 19/8/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/files-community/Files/pull/18840">Visit the GitHub PR: Code Quality: Make Json serialization AOT-friendly- #18840 </a>
                </div>
              </section>
            </li>
            <li className="no-margin-bottom1">
              <a
                href="#Feature_Try_emptying_working_set_on_instance_sleep_hez2010_files_community_Files_pull_18865"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}  Feature: Try emptying working set on instance sleep- #18865
                  </span>
                </h3>
              </a>

              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/files-community/Files/pull/18865"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Feature: Try emptying working set on instance sleep- #18865
                  #18865
                </a>
                <p>
                  Steve(hez2010)(<a href="https://github.com/hez2010">hez2010</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/files-community/Files/pull/18865">files-community/Files</a> on 19/8/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/files-community/Files/pull/18865">Visit the GitHub PR: Feature: Try emptying working set on instance sleep- #18865
                    #18865 </a>
                </div>
              </section>
            </li>


          </div>



          <div id="Json_serialization_AOT_friendly_hez2010">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Code Quality: Make Json serialization AOT-friendly- #18840
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Code Quality: Make Json serialization AOT-friendly- #18840
              </h3>
            </a>


            <div id="Make_Json_serialization_AOT_friendly_hez2010_files_community_Files_pull_18840">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/files-community/Files/pull/18840"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Code Quality: Make Json serialization AOT-friendly- #18840
                </a>
                <p>
                  Steve(hez2010)(<a href="https://github.com/hez2010">hez2010</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/files-community/Files/pull/18840">files-community/Files</a> on 19/8/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/files-community/Files/pull/18840">Visit the GitHub PR: Code Quality: Make Json serialization AOT-friendly- #18840 </a>
                </div>
              </section>
            </div>
          </div>


          <div id="Json_serialization">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Json_serialization
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Json_serialization
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#Make_Json_serialization_AOT_friendly_hez2010_files_community_Files_pull_18840"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */} Code Quality: Make Json serialization AOT-friendly- #18840
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/files-community/Files/pull/18840"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Code Quality: Make Json serialization AOT-friendly- #18840
                </a>
                <p>
                  Steve(hez2010)(<a href="https://github.com/hez2010">hez2010</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/files-community/Files/pull/18840">files-community/Files</a> on 19/8/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/files-community/Files/pull/18840">Visit the GitHub PR: Code Quality: Make Json serialization AOT-friendly- #18840 </a>
                </div>
              </section>
            </li>
          </div>


          <div id="wemake_services_django_modern_rest_issues_1390">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  wemake-services/django-modern-rest
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                wemake-services/django-modern-rest
              </h3>
            </a>


            <div id="JWToken_Provide_faster_JWT_decode_and_encode_options_with_msgspec_1390_wemake_services_django_modern_rest">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/wemake-services/django-modern-rest/issues/1390"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Provide faster JWT decode and encode options with msgspec
                  #1390
                </a>
                <p>
                  sobolevn(sobolevn)(<a href="https://github.com/sobolevn">sobolevn</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/wemake-services/django-modern-rest/issues/1390">wemake-services/django-modern-rest</a> on 3/9/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/wemake-services/django-modern-rest/issues/1390">Visit the GitHub PR: Provide faster JWT decode and encode options with msgspec
                    #1390 </a>
                </div>
              </section>
            </div>
          </div>

          <div id="JWToken">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  JWToken JSON Web Token
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                JWToken JSON Web Token
              </h3>
            </a>
            <li className="no-margin-bottom1">
              <a
                href="#JWToken_Provide_faster_JWT_decode_and_encode_options_with_msgspec_1390_wemake_services_django_modern_rest"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */} Provide faster JWT decode and encode options with msgspec
                  #1390
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/wemake-services/django-modern-rest/issues/1390"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request: Provide faster JWT decode and encode options with msgspec
                  #1390
                </a>
                <p>
                  sobolevn(sobolevn)(<a href="https://github.com/sobolevn">sobolevn</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/wemake-services/django-modern-rest/issues/1390">wemake-services/django-modern-rest</a> on 3/9/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/wemake-services/django-modern-rest/issues/1390">Visit the GitHub PR: Provide faster JWT decode and encode options with msgspec
                    #1390 </a>
                </div>
              </section>
            </li>
          </div>


          <div id="nodatime_nodatime_serialization">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  nodatime/nodatime.serialization
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                nodatime/nodatime.serialization
              </h3>
            </a>

            <li className="no-margin-bottom1">
              <a
                href="#Improve_the_exception_message_when_conversion_fails_because_of_invalid_data_143_0xced_nodatime_nodatime_serialization_pull_143"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    {/* Span &#ltT> and Pipelines */}    Improve the exception message when conversion fails because of invalid data- #143
                    #143
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/nodatime/nodatime.serialization/pull/143"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Pull Request:Improve the exception message when conversion fails because of invalid data- #143
                  #143
                </a>
                <p>
                  Cédric Luthi(0xced)(<a href="https://github.com/0xced">0xced</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/nodatime/nodatime.serialization/pull/143">nodatime/nodatime.serialization</a> on 13/2/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/nodatime/nodatime.serialization/pull/143">Visit the GitHub PR: Improve the exception message when conversion fails because of invalid data- #143
                    #143 </a>
                </div>
              </section>
            </li>

          </div>

          <div id="Feature_Try_emptying_working_set_on_instance_sleep_hez2010_files_community_Files_pull_18865">
             <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Garbage Collector(GC)  - Feature: Try emptying working set on instance sleep- #18865
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
              Garbage Collector(GC) - Feature: Try emptying working set on instance sleep- #18865
              </h3>
            </a>
            <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
              <a href="https://github.com/files-community/Files/pull/18865"
                target="_blank"
                rel="noopener noreferrer">
                Visit the full Pull Request: Feature: Try emptying working set on instance sleep- #18865
                #18865
              </a>
              <p>
                Steve(hez2010)(<a href="https://github.com/hez2010">hez2010</a>) Created 1 pull request in 1 repository
                <br />
                <a href="https://github.com/files-community/Files/pull/18865">files-community/Files</a> on 19/8/26
              </p>
              <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                <a href="https://github.com/files-community/Files/pull/18865">Visit the GitHub PR: Feature: Try emptying working set on instance sleep- #18865
                  #18865 </a>
              </div>
            </section>
          </div>


          <div id="Improve_the_exception_message_when_conversion_fails_because_of_invalid_data_143_0xced_nodatime_nodatime_serialization_pull_143">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Improve the exception message when conversion fails because of invalid data- #143
                  #143
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                Improve the exception message when conversion fails because of invalid data- #143
                #143
              </h3>
            </a>
            <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
              <a href="https://github.com/nodatime/nodatime.serialization/pull/143"
                target="_blank"
                rel="noopener noreferrer">
                Visit the full Pull Request:Improve the exception message when conversion fails because of invalid data- #143
                #143
              </a>
              <p>
                Cédric Luthi(0xced)(<a href="https://github.com/0xced">0xced</a>) Created 1 pull request in 1 repository
                <br />
                <a href="https://github.com/nodatime/nodatime.serialization/pull/143">nodatime/nodatime.serialization</a> on 13/2/26
              </p>
              <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                <a href="https://github.com/nodatime/nodatime.serialization/pull/143">Visit the GitHub PR: Improve the exception message when conversion fails because of invalid data- #143
                  #143 </a>
              </div>
            </section>
          </div>

<div id="EthanHarris">
<a
    href="https://github.com/ethanwharris"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ethan Harris(@ethanwharris)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ethan Harris(@ethanwharris)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
        <ul dir="auto">
      <li>Code for our paper <a href="https://arxiv.org/abs/2002.12047" rel="nofollow">"FMix: Enhancing Mixed Sample Data Augmentation"</a></li>
      <li>Used by the <a href="https://www.kaggle.com/c/bengaliai-cv19/discussion/135966" rel="nofollow">second place team in the Bengali.AI Handwritten Grapheme Classification Kaggle competition</a> and by the <a href="https://www.kaggle.com/c/rfcx-species-audio-detection/discussion/220522" rel="nofollow">third place team in the Rainforest Connection Species Audio Detection Kaggle competition</a></li>
      </ul>
        <a href="https://www.kaggle.com/c/bengaliai-cv19/discussion/135966" 
            target="_blank" 
            rel="noopener noreferrer">
            Visit the full article: Bengali.AI Handwritten Grapheme Classification | Classify the components of handwritten Bengali | Discussion  · Bengali.AI · Research Code Competition · 17/3/2020 · 10 minutes
          </a>
   </section>

     <section className="section-gap-AnthonyShaw">
       <p>
      Jirka Borovec(<a href="https://github.com/Borda">https://github.com/Borda</a>) contributed to 
        <br />
        <a href="https://github.com/Lightning-AI/lightning-thunder/pull/2208">Lightning-AI/lightning-thunder/</a> on 10/6/25

      </p>
      <Jirka_Borovec_PR_Lightning_AI_lightning_thunder_pull_2208_From_2025_6_01_To_2025_6_30 />

   </section>
</div>
<div id="DavidPine">
<a
    href="https://github.com/IEvangelist"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       David Pine(@IEvangelist)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      David Pine(@IEvangelist)
    </h3>
  </a>
 <section className="section-gap-AnthonyShaw">
<p dir="auto">I work in Developer Relations at Microsoft, specializing in <a href="https://docs.microsoft.com/dotnet" rel="nofollow">.NET</a> and <a href="https://docs.microsoft.com/azure" rel="nofollow">Azure</a> developer content. I'm also a <a href="https://developers.google.com/community/experts/directory/profile/profile-david-pine" rel="nofollow">Google Developer Expert</a> in Web Technologies, Twilio Champion, and author of <a href="https://bit.ly/learning-blazor" rel="nofollow">"Learning Blazor: Build Single-Page Apps with WebAssembly and C#"</a>. I co-host the <a href="https://dotnet.microsoft.com/live/on-dotnet-live" rel="nofollow">On .NET Live</a> stream and can be followed on Twitter at <a href="https://twitter.com/davidpine7" rel="nofollow">@davidpine7</a> and on Mastodon at <a href="https://dotnet.social/@davidpine" rel="nofollow">@davidpine</a>.</p>
 </section>

  <section className="section-gap-AnthonyShaw">
    <p>
       Anthony Shaw(<a href="https://github.com/tonybaloney">https://github.com/tonybaloney</a>) contributed to 
        <br />
        <a href="https://github.com/Azure-Samples/eShopLite/pull/4">Azure-Samples/eShopLite</a> on 31/5/25

      </p>
        <h3>
                    <a href="https://github.com/elbruno?tab=following" target="_blank" rel="noopener noreferrer">
                      Followings of	El Bruno(@elbruno) on GitHub
                    </a>
                  </h3>
  </section>
  <section className="section-gap-AnthonyShaw">
         <a href="https://davidpine.net/blog/learning-blazor/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Learning Blazor | Build Single-Page Apps with WebAssembly and C# | Posts  · __/09/2022  · .Net Programming, Blazor, WebAssembly, C# · 6 minutes
              </a>
  </section>
  
</div>
<div id="BohdanStupak">
<a
    href="https://github.com/Wkalmar"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Bohdan Stupak(@Wkalmar)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Bohdan Stupak(@Wkalmar)
    </h3>
  </a>
    
      <a href="https://blog.ndepend.com/improve-c-code-performance-with-spant/" 
      target="_blank" 
      rel="noopener noreferrer">
       Visit the full article: Improve C# code performance with Span&lt;T&gt; | Posts  · 24/3/2025  · 9 minutes 
    </a>
</div>
<div id="IanCooper">
<a
    href="https://github.com/iancooper"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ian Cooper(@iancooper)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ian Cooper(@iancooper)
    </h3>
  </a>
    <section className="section-gap-AnthonyShaw">
          <p>
    Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>)  starred a repository on 29/9/25
      <br />
      <a href="https://github.com/BrighterCommand/Brighter">https://github.com/BrighterCommand/Brighter</a> (C# ) 2.3k STARS
    
    </p>
    </section>
       <section className="section-gap-AnthonyShaw">
      <p>
        <a href="https://x.com/ICooper" target="_blank" rel="noopener noreferrer">ICooper (@‪ICooper‬)</a> posted  ·  26/9/2025
      </p>
      <p>       
      </p>
          <a href="https://x.com/ICooper/status/1971486374206300304" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post on <strong>https://x.com</strong>: How can you determine whether you should attend? One easy route is simply to review the course materials. They are available online at https://github.com/iancooper/practical-messaging, including older versions. That will explain what we cover, and if those are topics you want to understand, come along. · posted  26/9/2025 
          </a>
  </section>
</div>
<div id="Friedrich_von_Never">
<a
    href="https://github.com/ForNeVeR"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Friedrich von Never(@ForNeVeR)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Friedrich von Never(@ForNeVeR)
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
      <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) 
        followed Friedrich von Never (<a href="https://github.com/ForNeVeR">https://github.com/ForNeVeR</a>) on 21/2/25.
    </p>
  </section>

<section className="section-gap-AnthonyShaw">
        <a href="https://fornever.me/en/posts/2023-10-21.code-vectorization.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Code Vectorization in .NET and Other Technologies | Posts · 32/10/2023 · 5 minutes 
    </a>
    <p></p>
      <a href="https://fornever.me/en/posts/2021-02-12.constrained-diff-algorithm.html" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: A variant of a diff algorithm for constrained conditions | Posts · 12/2/2021 · 5 minutes 
    </a>
    <h1>Further reading</h1>
    <ul>
<li><a href="https://blog.jcoglan.com/2017/02/12/the-myers-diff-algorithm-part-1/">part 1</a></li>
<li><a href="https://blog.jcoglan.com/2017/02/15/the-myers-diff-algorithm-part-2/">part 2</a></li>
<li><a href="https://blog.jcoglan.com/2017/02/17/the-myers-diff-algorithm-part-3/">part 3</a></li>
</ul>
</section>
</div>
<div id="Will_DePue_@0hq">
<a
    href="https://github.com/0hq"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Will DePue(@0hq)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Will DePue(@0hq)
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
       <a href="https://zeenews.india.com/photos/business/meet-girl-who-mastered-coding-at-11-built-rs-1000000000-crore-startup-at-just-16-she-is-2916239" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full news article: Meet Girl Who Mastered Coding At 11, Built Rs 1,00,00,00,000 Crore Startup At Just 16— She Is… | News Article  · 15/6/2025  · AI · 5 minutes
    </a>
    <Pranjali_Awasthi_raidingAI_Twitter_Following />
    <p></p>
      <a href="https://github.com/0hq/tinyvector" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full news article: A tiny nearest-neighbor embedding database built with SQLite and Pytorch. (In development!) | GitHub Repository  · 12/6/2023  · the tiny, least-dumb, speedy vector embedding database · 5 minutes
    </a>
    <p></p>
         <a href="https://www.pinecone.io/learn/vector-search-filtering/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full news article: The Missing WHERE Clause in Vector Search  | Posts · 30/6/2023  · the tiny, least-dumb, speedy vector embedding database · 5 minutes
    </a>
  </section>

</div>
<div id="AdamSitnik">
<a
    href="https://github.com/adamsitnik"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Adam Sitnik(@adamsitnik)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Adam Sitnik(@adamsitnik)
    </h3>
  </a>
  <div>Open Source contributor, #BenchmarkDotNet maintainer. My job on .NET Team is to make the .NET the fastest developer platform on the planet.</div>
   <a href="https://adamsitnik.com/Span/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Span  | Posts · 13/7/2017  · Span&lt;T&gt;  · 5 minutes
    </a>
</div>
<div id="AshVardanian">
<a
    href="https://github.com/ashvardanian"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ash Vardanian(@ashvardanian)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ash Vardanian(@ashvardanian)
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
          <p>
    Matt DesLauriers (<a href="https://github.com/mattdesl">https://github.com/mattdesl</a>) starred a repository on 17/6/25
      <br />
      <a href="https://github.com/mattdesl/canvas-dimensions">https://github.com/mattdesl/canvas-dimensions</a> (JavaScript ) 32 STARS
    
    </p>
    <a href="https://github.com/unum-cloud/uform/issues/107" 
              target="_blank" 
              rel="noopener noreferrer">
              Created an issue in <a href="https://github.com/unum-cloud/uform">unum-cloud/uform</a> 
            </a> that received 2 comments on 9/6/25
  </section>

</div>
<div id="JimmyLefevre">
<a
    href="https://github.com/JimmyLefevre"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Jimmy Lefevre(@JimmyLefevre)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
       Jimmy Lefevre(@JimmyLefevre)
    </h3>
  </a>
  <a
    href="https://www.linkedin.com/in/jimmy-lefevre/"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
     <h3 style={{ margin: 0 }}>
       Jimmy Lefevre - LinkedIn
    </h3>
  </a>
  
    <p className="passion-text-jimmy-lefevre">
        Passionate about technology, I am particularly committed to training myself and understanding new development best practices. 
        From web to software, including mobile applications and IoT, I put my skills to the service of innovation, 
        but also of transmission by giving courses at CESI in Dijon, Lille, and Nancy, and by sharing my knowledge with my colleagues whenever possible.
      </p>
    <section className="section-gap-AnthonyShaw">
     <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 20/6/25
          <br />
          <a href="https://github.com/JimmyLefevre/kb">JimmyLefevre/kb </a> (C) 275 STARS

     </p>
       <JimmyLefevre_kb_GitHubRepository />
        <WhyThisRepo /> 
        <div className="markdown-heading" dir="auto"><h2 
        // tabindex="-1" 
        className="heading-element" dir="auto">kb_text_shape.h</h2>
        {/* <a id="user-content-kb_text_shapeh" class="anchor" aria-label="Permalink: kb_text_shape.h" href="#kb_text_shapeh"><svg class="octicon octicon-link" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true"><path d="m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"></path></svg></a>
      */}
        </div> 
        <p dir="auto">
          <a href="https://github.com/JimmyLefevre/kb/blob/main/kb_text_shape.h">kb_text_shape.h</a> provides ICU-like text segmentation (i.e. breaking Unicode text by direction, line, word and grapheme). It also provides Harfbuzz-like text shaping for OpenType fonts, which means it is capable of handling complex script layout and ligatures, among other things.</p>
  </section>

</div>
<div id="ShayRojanskyAccordion">
<a
    href="https://github.com/roji/"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Shay Rojansky(@roji)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Shay Rojansky(@roji)
    </h3>
  </a>
       <section className="section-gap-AlexandreMutel">
      <p>
              Wes Doyle(@wesdoyle) (<a href="https://github.com/wesdoyle">https://github.com/wesdoyle</a>) followed a GitHub user on 4/1/24
                <br />
                <a href="https://github.com/roji/">roji </a>

              </p>
      </section>
      <section className="section-gap-AnthonyShaw">
          <ShayRojanskyAccordion />
      </section>

</div>
<div id="TaniaAllard">
<a
    href="https://github.com/trallard"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Tania Allard(@trallard)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Tania Allard(@trallard)
    </h3>
  </a>
   <section className="section-gap-AlexandreMutel">
      <p>
              Anshuman Mishra(@kanpuriyanawab) (<a href="https://github.com/kanpuriyanawab?tab=following">https://github.com/kanpuriyanawab?tab=following</a>) follows a GitHub user 
                <br />
                <a href="https://github.com/trallard">Tania Allard(@trallard) </a>

              </p>
      </section>
      <section className="section-gap-AnthonyShaw">
            <a href="https://github.com/trallard/TLJH-azure-button" 
          target="_blank" 
          rel="noopener noreferrer">
          Visit the featured project: The Littlest JupyterHub deploy button · Deploy a vanilla JupyterHub on Azure · Now supports custom configurations and plugins | JupyterHub, Azure, ARM templates
        </a>
      </section>
</div>
<div id="Ben_chmark_Adams">
<a
    href="https://github.com/benaadams"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ben (chmark) Adams(@benaadams)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ben (chmark) Adams(@benaadams)
    </h3>
  </a>
    <section className="section-gap-AlexandreMutel">
      <p>
              Yoshifumi Kawai(@neuecc) (<a href="https://github.com/neuecc?tab=following">https://github.com/neuecc?tab=following</a>) follows a GitHub user 
                <br />
                <a href="hhttps://github.com/benaadams">Ben (chmark) Adams(@benaadams) </a>

              </p>
      </section>
  <section className="section-gap-AnthonyShaw">
      <p>
        <a href="https://x.com/ben_a_adams" target="_blank" rel="noopener noreferrer">Ben &#34;chmark&#34; Adams ⟠ (@ben_a_adams)</a> reposted 
        <a href="https://x.com/shayrojansky/status/1935768679167189044" target="_blank" rel="noopener noreferrer">Shay Rojansky (@shayrojansky)</a> · June 20, 2025 · Reposted after 12/6/25
      </p>
      <p>       
      </p>
          <a href="https://x.com/shayrojansky/status/1935768679167189044" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post: Just gave a talk about the new .NET abstraction for vector databases — Microsoft.Extensions.VectorData · Originally posted June 20, 2025 · Reposted by @ben_a_adams after  Jun 12, 2025 · .NET, Vector DBs, Data Abstractions
          </a>
  </section>
    <section className="section-gap-AnthonyShaw">
       <p>
        <a href="https://x.com/ben_a_adams" target="_blank" rel="noopener noreferrer">Ben &#34;chmark&#34; Adams ⟠ (@ben_a_adams)</a> reposted 
        <a href="https://x.com/James_M_South/status/1928467284214816890" target="_blank" rel="noopener noreferrer">JimBobSquarePants (@James_M_South)</a> · May 30, 2025 · Reposted between 26/5/25 and 2/6/25
      </p>
      <p></p>
        <a href="https://x.com/James_M_South/status/1928467284214816890" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post: The ImageSharp codebase is rapidly becoming an excellent reference source for people wanting to utilize cross platform #dotnet intrinsics as I work on improving the performance on mobile. · Originally posted May 30, 2025 · Reposted by @ben_a_adams between May 26, 2025 and Jun 2, 2025 · .NET, #dotnet intrinsics, #oss
          </a>
          <p></p>
  <a href="https://mastodon.social/@james_jackson_south/109738725146504380" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post: ImageSharp has over 43.5 million Nuget downloads and only 37 open issues in the issue tracker (soon to be 36).

I'm pretty proud of the quality of the software. 😇. · Originally posted Jan 23, 2023  · .NET, #dotnet intrinsics, #oss
          </a>
          
    </section>
    
</div>
<div id="EllieHuxtable">
<a
    href="https://github.com/ellie"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      EllieHuxtable(@ellie)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      EllieHuxtable(@ellie)
    </h3>
  </a>  
          <section className="section-gap-AnthonyShaw">
            <div id="atuinsh_desktop_issues_47">      
              <p>
              EllieHuxtable(@ellie)(<a href="https://github.com/ellie">https://github.com/ellie</a>)  Opened 5 other issues in 1 repository
                <br />
                <a href="atuinsh/desktop/issues/47">atuinsh/desktop</a> on 1-8/10/25

              </p>
              <Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31_1 />
            </div>
        </section>
          <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
            <a
          href="#KienDang_atuinsh_desktop_issues_99_BUG_Toggling_vim_mode_in_settings_has_no_effect_on_existing_terminals_scripts"
          className="vcard-names1"
          style={{ textDecoration: 'underline' }}
        >
           <h3 style={{ margin: 0 }}>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Kien Dang(@kiendang), EllieHuxtable(@ellie)
            </span>
          </h3>
          <h3 style={{ margin: 0 }}>
            [BUG] Toggling vim mode in settings has no effect on existing terminals/scripts #99
          </h3>
        </a>
  </section>
  </li>
      
        <section className="section-gap-AnthonyShaw">
                  <a href="https://ellie.wtf/notes/debugging-slow-postgres-queries" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Debugging slow PostgreSQL queries  | Posts  · 24/5/2024  · Databases, #postgresql · 1 minute
    </a>
    <p></p>
           <a href="https://ellie.wtf/notes/postgres-hba-tailscale" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Postgres HBA with a Tailscale network  | Posts  · 3/11/2023  · Databases, #postgresql, #tailscale · 1 minute
    </a>
    <p></p>
        <a href="https://www.reddit.com/r/selfhosted/comments/18491e9/tailscale_the_marvellous_tool_that_became/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full Reddit Discussion: Tailscale: the marvellous tool that became indispensable to my tech life  | Discussion  · 26/11/2023  · Databases, #postgresql, #tailscale · 4 minutes
    </a>
    
      </section>
</div>
<div id="KienDang">
<a
    href="https://github.com/kiendang"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Kien Dang(@kiendang)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Kien Dang(@kiendang)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
            <div id="atuinsh_desktop_issues_47">      
              <p>
              EllieHuxtable(@ellie)(<a href="https://github.com/ellie">https://github.com/ellie</a>)  Opened 5 other issues in 1 repository
                <br />
                <a href="atuinsh/desktop/issues/47">atuinsh/desktop</a> on 1-8/10/25

              </p>
              <Kiendang_PR_atuinsh_desktop_issues_47_From_2025_10_01_To_2025_10_31_1 />
            </div>
        </section>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a href="#atuinsh_desktop_issues_47"
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full issue of <strong>atuinsh/desktop</strong>:  · 7/10/2025  · Databases, #postgresql, #atuinsh desktop · 3 minute
    </a>
</section>
</li>
      <div id="KienDang_atuinsh_desktop_issues_99_BUG_Toggling_vim_mode_in_settings_has_no_effect_on_existing_terminals_scripts">
        <li className="no-margin-bottom1">
          <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
              <p>
              Kien Dang(@kiendang)(<a href="https://github.com/kiendang">https://github.com/kiendang</a>) Opened 1 issue in 1 repository
                <br />
                <a href="https://github.com/atuinsh/desktop/issues/99">atuinsh/desktop</a> on 6/10/25

              </p>

        <a
                  href="https://github.com/atuinsh/desktop/issues/99"
                  className="vcard-names1"
                  style={{ textDecoration: 'underline' }}
                >
                  <h3 style={{ margin: 0 }}>
                    <span className="p-name vcard-fullname d-block overflow-hidden">
                    Kien Dang(@kiendang), EllieHuxtable(@ellie)
                    </span>
                  </h3>
                  <h3 style={{ margin: 0 }}>
                    [BUG] Toggling vim mode in settings has no effect on existing terminals/scripts #99
                  </h3>
                </a>
                
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/atuinsh/desktop/issues/99">Visit the GitHub Issue: [BUG] Toggling vim mode in settings has no effect on existing terminals/scripts #99  </a>  
                </div>
          </section>
            </li>
      </div>
  
</div>
          <div id="krisajenkins">
            <a
              href="https://github.com/krisajenkins"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  Kris Jenkins(@krisajenkins)
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Hi there! I’m Kris Jenkins(@krisajenkins).
                  <a
                    href="https://github.com/krisajenkins"
                    data-original-href="https://github.com/krisajenkins"
                  >
                  </a>
                </p>
              </h3>
            </a>

            <div id="Kris_Jenkins_Snowflake_Labs_sfguide_getting_started_with_snowflakeintelligence_and_cke_pull_1_Refactoring_the_setup_script">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Kris Jenkins(@krisajenkins)(<a href="https://github.com/krisajenkins">https://github.com/krisajenkins</a>) Opened 2 pull requests in 2 repositories
                  <br />
                  <a href="https://github.com/Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke/pull/1">Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke</a> on 1/10/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke/pull/1">Visit the GitHub PR: Refactoring the setup script #1  </a>
                </div>
              </section>
            </div>
          </div>

<div id="ReynoldXin">
<a
    href="https://github.com/rxin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Reynold Xin(@rxin)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Reynold Xin(@rxin)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
     <p>
        <a href="https://x.com/jerrinot" target="_blank" rel="noopener noreferrer">Jaromir Hamala (@jerrinot)</a> posted 
        <a href="https://x.com/jerrinot/status/1202129732483108864" target="_blank" rel="noopener noreferrer">Jaromir Hamala (@jerrinot)</a> · Dec 20, 2019 
      </p>
      <p>       
      </p>
          <a href="https://x.com/jerrinot/status/1202129732483108864" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post: My new blogpost was just released. If you have ever wondered how are System.currentTimeMillis() or System.nanoTime() implemented and what's the price of single timestamp then read the post! ·  Posted Dec 20, 2019 
          </a>
          <p></p>
          <h3>
    <a href="https://github.com/jerrinot?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Jaromir Hamala(jerrinot) on GitHub
    </a>
  </h3>
   </section>
</div>
<div id="DavidOrtinau">
<a
    href="https://github.com/davidortinau"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      David Ortinau(@davidortinau)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      David Ortinau(@davidortinau)
    </h3>
  </a>
  <section className="section-gap-AnthonyShaw">
      <h3>
                  <a href="https://github.com/jonathanpeppers?tab=following" target="_blank" rel="noopener noreferrer">
              Followings of	Jonathan Peppers(jonathanpeppers) on GitHub
            </a>
      </h3>
    <p></p>
      <a href="https://dev.to/davidortinau/boosting-github-copilot-accuracy-3ja" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post:Boosting GitHub Copilot Accuracy ·  Posted Mar 10, 2025  · #dotnetmaui, #githubcopilot, #vscode
          </a>
  </section>
</div>
<div id="LaurentKempé">
  <a
    href="https://github.com/laurentkempe"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Laurent Kempé(@laurentkempe)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Laurent Kempé(@laurentkempe)
    </h3>
  </a>
        <section className="section-gap-AlexandreMutel">
             <p>
        Alexandre Mutel (<a href="https://github.com/xoofx">https://github.com/xoofx</a>) starred a repository on 1/7/25
          <br />
          <a href="https://github.com/sailro/AzdTool">sailro/AzdTool </a> (C#) 1 STARS
          </p>
            <h3>
    <a href="https://github.com/sailro?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Sebastien Lebreton(sailro) on GitHub
    </a>
    </h3>
      </section>
       <section className="section-gap-AnthonyShaw">
                    <a href="https://laurentkempe.com/tags/Dapr/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Posts tagged with "Dapr" | Posts 
    </a><p>
    </p>
                      <a href="https://laurentkempe.com/2023/02/27/debugging-dapr-applications-with-rider-or-visual-studio-a-better-way/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Debugging Dapr applications with Rider or Visual Studio: A better way | Posts  · 27/2/2023  · .Net Programming, Dapr, Rider, Visual Studio · 10 minutes
    </a>
       </section>

</div>
<div id="JeffHollan">
  <a
    href="https://github.com/jeffhollan"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jeff Hollan(@jeffhollan)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jeff Hollan(@jeffhollan)
    </h3>
  </a>
       <section className="section-gap-AnthonyShaw">
                <a href="https://medium.com/hackernoon/azure-functions-choosing-between-queues-and-event-hubs-dac4157eee1c" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on  <strong>Medium</strong>: Azure Functions: Choosing between queues and event hubs | Performance and throughput considerations | Posts  · 5/11/2018  · .Net Programming, Serverless, Azure, Azure Functions, Messaging · 8 minutes
              </a>
     </section>
</div>
<div id="Eric_Berg_MVP">
  <a
    href="https://x.com/ericberg_de"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Eric Berg - MVP(@ericberg_de)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Eric Berg - MVP(@ericberg_de)
    </h3>
  </a>
  <Eric_Berg_MVP_TwitterProfile />
  <section className="section-gap-AnthonyShaw">
  <WhyThisRepo />
  <h2 className="widget-title"><span></span>Blogroll</h2>
  <ul className="xoxo blogroll">
<li><a href="http://www.aidanfinn.com" title="A Hyper-V blog, but you’ll also find Windows Server, desktop, systems management, deployment, and so on …">Aidan Finn</a></li>
<li><a href="http://it-pirate.com/" title="Alexander Benoit" target="_blank">Alexander Benoit</a></li>
<li><a href="https://andikrueger.wordpress.com/" rel="contact met colleague" title="SharePoint and Office 365" target="_blank">Andi Krüger</a></li>
<li><a href="http://www.danielstechblog.de/" rel="contact met colleague" title="Daniel’s Tech Blog" target="_blank">Daniel Neumann</a></li>
<li><a href="https://blog.workinghardinit.work/" rel="contact met colleague" title="Working Hard in IT" target="_blank">Didier Van Hoye</a></li>
<li><a href="https://www.reimling.eu" rel="friend met" target="_blank">Gregor Reimling</a></li>
<li><a href="https://mountainss.wordpress.com/" rel="contact met colleague" title="System Center Cloud and DataCenter Management" target="_blank">James van den Berg</a></li>
<li><a href="https://www.zueschen.eu/" rel="contact met colleague" title="MVP – File System Storage" target="_blank">Jan Kappen</a></li>
<li><a href="https://www.mannoni.ch/" target="_blank">Marco Mannoni</a></li>
<li><a href="https://rlevchenko.com/" title="Roman Levchenko – MVP" target="_blank">Roman Levchenko</a></li>
<li><a href="http://stefanroth.net" title="stefanroth.net – Things about System Center and Cloud…" target="_blank">Stefan Roth</a></li>
<li><a href="http://blog.tyang.org/" rel="contact met colleague" title="Tao Yang’s System Center Blog" target="_blank">Tao Yang</a></li>
<li><a href="http://www.thomasmaurer.ch/" rel="contact met colleague" title="Cloud and Virtualization" target="_blank">Thomas Maurer</a></li>
<li><a href="https://www.cloud-architekt.net" rel="friend" target="_blank">Thomas Naunheim</a></li>

	</ul>
  </section>
  
</div>
<div id="KyleBarron">
  <a
    href="https://github.com/kylebarron"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Kyle Barron(@kylebarron)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Kyle Barron(@kylebarron)
    </h3>
  </a>
    <h3>
    <a href="https://github.com/jashanbhullar?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	json singh(jashanbhullar) on GitHub
    </a>
  </h3>
         <section className="section-gap-AnthonyShaw">
                <a href="https://kylebarron.dev/blog/zero-copy-apache-arrow-with-webassembly/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Zero-copy Apache Arrow with WebAssembly | Posts  · 22/08/2022 Edits 9/07/2023 · .Javascript, WebAssembly, Apache Arrow C Data Interface · 8 minutes
              </a>
     </section>
</div>
<div id="BrendanLeGlaunec">
  <a
    href="https://github.com/Ullaakut"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Brendan Le Glaunec(@Ullaakut)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Brendan Le Glaunec(@Ullaakut)
    </h3>
  </a>
  <a rel="nofollow me" className="Link--primary wb-break-all" href="https://ullaakut.github.io">https://ullaakut.github.io</a>
          <section className="section-gap-AnthonyShaw">
                    <h3>
            <a href="https://github.com/gurr-i?tab=following" target="_blank" rel="noopener noreferrer">
              Followings of	Gurveer(gurr-i) on GitHub
            </a>
          </h3>
          </section>
          <div id="BrendanLeGlaunec_Ullaakut_Gorsair">
                <section className="section-gap-AnthonyShaw">
              <GorsairComponent />
                </section>
          </div>

</div>
<div id="PamelaFox">
  <a
    href="https://github.com/pamelafox"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Pamela Fox(@pamelafox)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Pamela Fox(@pamelafox)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
                    <h3>
            <a href="https://github.com/winglian?tab=following" target="_blank" rel="noopener noreferrer">
              Followings of	Wing Lian(winglian) on GitHub
            </a>
          </h3>
          </section>
           <section className="section-gap-AnthonyShaw">
           <a href="https://blog.pamelafox.org/2024/06/rag-on-database-table-with-postgresql.html" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>Blogger</strong>: RAG on a database table with PostgreSQL | Posts  · 10/6/2024  · azure, openai, python · 10 minutes
              </a>
              <p></p>
                  <a href="https://blog.pamelafox.org/2023/05/postgresql-bicep.html" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>Blogger</strong>: Deploying PostgreSQL servers with Bicep | Posts  · 8/5/2023  · Azure, Bicep, PostgreSQL servers · 10 minutes
              </a>
           </section>

</div>
<div id="JerriePelser">
  <a
    href="https://github.com/jerriep"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jerrie Pelser(@jerriep)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jerrie Pelser(@jerriep)
    </h3>
  </a>
        <h3>
                  <a href="https://github.com/elanderson?tab=following" target="_blank" rel="noopener noreferrer">
              Followings of	Eric Anderson(elanderson) on GitHub
            </a>
      </h3>
      <div id="JerriePelser_ASP_NET_Core_and_Serilog"> 
       <section className="section-gap-AnthonyShaw">
              <a href="https://www.jerriepelser.com/posts/implement-user-facing-log-files/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Implement user-facing logs with ASP.NET Core and Serilog | Posts  · 25/2/2025  ·   asp.net core, serilog · 9 minutes
              </a>
       </section>
      </div>
</div>
<div id="DillionLowry">
  <a
    href="https://github.com/DillionLowry"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Dillion Lowry(@DillionLowry)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Dillion Lowry(@DillionLowry)
    </h3>
  </a>
      <p>
Martin Evans (<a href="https://github.com/martindevans">https://github.com/martindevans</a>) starred a repository on 23/3/25
  <br />
  <a href="https://github.com/DillionLowry/NeuralCodecs">https://github.com/DillionLowry/NeuralCodecs </a> (C#) 43 STARS
</p>
      <div id="DillionLowry_ASP_NET_Core_and_Serilog"> 
       <section className="section-gap-AnthonyShaw">
              <a href="https://github.com/DillionLowry/Serilog.Sinks.ObservableCollection" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full GitHub Repository: Serilog sink for logging to an ObservableCollection | Posts  · 28/4/2025  ·   asp.net core, serilog · 9 minutes
              </a>
       </section>
      </div>
</div>
<div id="MichalStrehovský">
  <a
    href="https://github.com/michalstrehovsky"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Michal Strehovský(@MichalStrehovsky)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Michal Strehovský(@MichalStrehovsky)
    </h3>
  </a>
  <div id="MichalStrehovsky_DotNetRuntime"> 
       <section className="section-gap-AnthonyShaw">
              <a href="https://migeel.sk/blog/2024/01/02/building-a-self-contained-game-in-csharp-under-2-kilobytes/"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Building a self-contained game in C# under 2 kilobytes | How I fit a graphical game in C# into 2 kilobytes, with no .NET runtime required.| Posts  · 2/1/2024  · dotnet, long form · 13 minutes
              </a>
       </section>
      </div>
</div>
<div id="JohannaLarsson">
  <a
    href="https://github.com/joladev"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Johanna Larsson(@joladev)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Johanna Larsson(@joladev)
    </h3>
  </a>
    <section className="section-gap-AnthonyShaw">
      <p>
        <a href="https://bsky.app/profile/josevalim.bsky.social" target="_blank" rel="noopener noreferrer">José Valim (@‪josevalim.bsky.social‬)</a> posted  ·  12/10/2023
      </p>
      <p>       
      </p>
          <a href="https://bsky.app/profile/josevalim.bsky.social/post/3kbivz6c3wj2k" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post on <strong>bsky.app</strong>: What if you could:

* upload a .csv file to see & plot its contents
* stream and transform GBs of .parquet files from S3
* drag and drop a sqlite3 database and query it
* drag and drop an audio/video file for live transcription· posted  12/10/2023 
          </a>
  </section>
   <section className="section-gap-AnthonyShaw">
      <p>
      <a href="https://bsky.app/profile/josevalim.bsky.social" target="_blank" rel="noopener noreferrer">José Valim (@‪josevalim.bsky.social‬)</a> reposted
        <a href="https://bsky.app/profile/whatyouhi.de" target="_blank" rel="noopener noreferrer">Andrea Leopardi (@whatyouhi.de)</a> ·  2/1/2025 · Reposted between 21/1/25 and 14/1/25
      </p>
      <p>       
      </p>
          <a href="https://bsky.app/profile/whatyouhi.de/post/3lepn6vsmxk2q" 
            target="_blank" 
            rel="noopener noreferrer">
            View the post  on <strong>bsky.app</strong>: Super nice post about @elixir-lang.org's nimble_ownership library by Alex Martsinovich: · Originally posted  2/1/2025 · Reposted by @‪josevalim.bsky.social‬ between 21/1/25 and 14/1/25
          </a>
  </section>
  <section className="section-gap-AnthonyShaw">
     <h3>
    <a href="https://github.com/martosaur?tab=following" target="_blank" rel="noopener noreferrer">
      Followings of	Alex Martsinovich(martosaur) on GitHub
    </a>
    </h3>
  </section>
   <section className="section-gap-AnthonyShaw">
              <a href="https://jola.dev/posts/health-checks-for-plug-and-phoenix"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Health checks for Plug and Phoenix.| Posts  · 1/6/2019  · HealthChecks, Kubernetes, Plug and Phoenix  · 5 minutes
              </a>
       </section>
  

</div>
<div id="MiguelYoung">
  <a
    href="https://github.com/mcy"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Miguel Young(@mcy)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Miguel Young(@mcy)
    </h3>
  </a>
</div>
<div id="AmbarishGanguly">
  <a
    href="https://github.com/ambarishg"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Ambarish Ganguly(@ambarishg)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ambarish Ganguly(@ambarishg)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
       <h3>
                        <a href="https://www.linkedin.com/in/ambarish-ganguly/" target="_blank" rel="noopener noreferrer">
                          Ambarish Ganguly on LinkedIn
                        </a>
                      </h3>
                      <h3>
                        <a href="https://github.com/rahulrai-in?tab=following" target="_blank" rel="noopener noreferrer">
                          Followings of	Rahul Rai(@rahulrai-in) on GitHub
                        </a>
                      </h3>
   </section>
<section className="section-gap-AnthonyShaw">
                  <a href="https://dev.to/ambarishg/azure-ml-aks-and-a-bit-of-mlops-2gj7"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>https://dev.to/</strong>: Red Wine Quality prediction using AzureML, AKS | Posts  · 23/4/2021  · azure, machine learning, kubernetes, mlops · 13 minutes
              </a>
</section>
      
</div>
<div id="DmitryBrant">
  <a
    href="https://github.com/dbrant"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Dmitry Brant(@dbrant)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Dmitry Brant(@dbrant)
    </h3>
  </a>


            <li className="no-margin-bottom1">
              <a
                href="#DmitryBrant__unframework_licheepi_nano_buildroot_pull_33_Improve_docker_build_in_Windows_and_fix_executable_flag_on_post_image_sh"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    unframework/licheepi-nano-buildroot/
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Dmitry Brant(@dbrant)(<a href="https://github.com/dbrant">https://github.com/dbrant</a>) Created a PR
                  <br />
                  <a href="https://github.com/unframework/licheepi-nano-buildroot/">unframework/licheepi-nano-buildroot/</a> on 25/10/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/unframework/licheepi-nano-buildroot/pull/33">Visit the GitHub PR: Improve docker build in Windows, and fix executable flag on post-image.sh. #33 </a>
                </div>
              </section>
            </li>



  <WhyThisRepo />
  <section className="section-gap-AnthonyShaw">
     <p>
        Olivier Grisel (<a href="https://github.com/ogrisel">https://github.com/ogrisel</a>) starred a repository on 8/9/25
          <br />
          <a href="https://github.com/dbrant/ftape">dbrant/ftape </a> (C) 86 STARS

     </p>
    <div id="Karen_Payne_Visual_Studio_shared_user_secrets_21_7_25">
                   <a href="https://dmitrybrant.com/2025/06/26/diskdigger-avalonia-ui-a-success-story"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: DiskDigger + Avalonia UI: a success story | Posts  · Posted on 26/6/2025  · #csharp, #dotnetcore  · 5 minutes
              </a>
             
    </div>
     <p>.NET itself has also made its own strides in being able to bundle your app into a single executable, with a single command:</p>
    </section>
</div>

 <div id="unframework_licheepi-nano-buildroot">
            <a
              href="https://github.com/unframework/licheepi-nano-buildroot/"
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  unframework/licheepi-nano-buildroot/
                </span>
              </h1>
              <h3 style={{ margin: 0 }}>
                unframework/licheepi-nano-buildroot/
              </h3>
            </a>

            <div id="DmitryBrant__unframework_licheepi_nano_buildroot_pull_33_Improve_docker_build_in_Windows_and_fix_executable_flag_on_post_image_sh">
              <section className="section-gap-AnthonyShaw">
                <p>
                  Dmitry Brant(@dbrant)(<a href="https://github.com/dbrant">https://github.com/dbrant</a>) Created a PR
                  <br />
                  <a href="https://github.com/unframework/licheepi-nano-buildroot/">unframework/licheepi-nano-buildroot/</a> on 25/10/25 that received 0 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/unframework/licheepi-nano-buildroot/pull/33">Visit the GitHub PR: Improve docker build in Windows, and fix executable flag on post-image.sh #33 </a>
                </div>
              </section>
            </div>

          </div>




<div id="KarenPayne">
  <a
    href="https://github.com/karenpayneoregon"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Karen Payne(@karenpayneoregon)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Karen Payne(@karenpayneoregon)
    </h3>
  </a>
   <section className="section-gap-AnthonyShaw">
    <div id="Karen_Payne_Visual_Studio_shared_user_secrets_21_7_25">
                   <a href="https://dev.to/karenpayneoregon/visual-studio-shared-user-secrets-14ki"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>https://dev.to/</strong>: Visual Studio shared user secrets | Working with database with C# (55 Part Series) | Posts  · Posted on 21/7/2025  · #csharp, #dotnetcore, #devops, #security   · 5 minutes
              </a>
             
    </div>
            <p></p>
              <a href="https://dev.to/karenpayneoregon/working-with-dappersql-server-framework-48-c-57je"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>https://dev.to/</strong>: Working with Dapper/SQL-Server Framework 4.8 C# | Working with database with C# (9 Part Series) | Posts  · Posted on Jan 28/1/2024 • Edited on 25/2/2024  · #database, #csharp, #dotnet  · 5 minutes
              </a>
             
 
       </section>
</div>
<div id="Span_T_andPipelines_Scooletz">
<a
    href="https://github.com/Scooletz"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        Szymon Kulec
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Szymon Kulec
    </h3>
  </a>
  <a href="https://krasserm.github.io/2015/01/13/event-sourcing-at-global-scale/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Event sourcing at global scale | Posts · 13/1/2015 · 5 minutes 
    </a>
    <p>
    Scooletz (<a href="https://disqus.com/by/scooletz/">https://disqus.com/by/scooletz/</a>) commented on 18/1/15
    </p>
  <a href="https://blog.scooletz.com/2018/08/14/thruster-building-a-not-so-fast-memory-pool/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: A fast and efficient implementation of a MemoryPool&lt;T&gt; | Posts · 13/1/2015 · 5 minutes 
    </a>
    
</div>

<div id="Dapr">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Dapr
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Dapr
    </h3>
  </a>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#JayeshSharma"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jayesh Sharma (@wjayesh)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Jayesh Sharma (@wjayesh).
    </h3>
  </a>
  <a href="https://medium.com/c-sharp-programming/building-distributed-apps-using-dapr-locally-and-on-azure-65316a2f259" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article on <strong>Medium</strong>: Building distributed apps using Dapr, locally and on Azure | Posts  · 17/3/2021  · .Net Programming, Microservices · 10 minutes
    </a>
  </section>
  </li>

  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
            <a
    href="#LaurentKempé"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Laurent Kempé(@laurentkempe)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Laurent Kempé(@laurentkempe)
    </h3>
  </a>
                   <a href="https://laurentkempe.com/tags/Dapr/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Posts tagged with "Dapr" | Posts 
    </a>
  </section>
  </li>

</div>
<div id="ApplicationSecurity">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Application Security
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Application Security
    </h3>
  </a>
     <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
      <a
          href="#BrendanLeGlaunec_Ullaakut_Gorsair"
          className="vcard-names1"
          style={{ textDecoration: 'underline' }}
        >
          <h1 style={{ margin: 0 }}>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Brendan Le Glaunec(@Ullaakut)
            </span>
          </h1>
          <h3 style={{ margin: 0 }}>
            Brendan Le Glaunec(@Ullaakut)
          </h3>
        </a>

        <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
          <a href="https://github.com/Ullaakut/Gorsair">Visit the GitHub Repository: Gorsair gives root access on remote docker containers that expose their APIs  </a>  
        </div>
  </section>
  </li>
     <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
          href="#AnthonyShaw_Replace_MD5_with_SHA256_for_cache_index_entry_keys_and_names"
          className="vcard-names1"
          style={{ textDecoration: 'underline' }}
        >
           <h1 style={{ margin: 0 }}>
            <span className="p-name vcard-fullname d-block overflow-hidden">
            Anthony Shaw(@tonybaloney)
            </span>
          </h1>
          <h3 style={{ margin: 0 }}>
            Anthony Shaw(@tonybaloney)
          </h3>
        </a>
        
        <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
          <a href="https://github.com/langchain-ai/langchain-azure/pull/99">Visit the GitHub PR: Replace MD5 with SHA256 for cache index entry keys and names #99  </a>  
        </div>
  </section>
    </li>
     <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
           <a
            href="#Karen_Payne_Visual_Studio_shared_user_secrets_21_7_25"
            className="vcard-names1"
            style={{ textDecoration: 'underline' }}
          >
            <h1 style={{ margin: 0 }}>
              <span className="p-name vcard-fullname d-block overflow-hidden">
              Karen Payne(@karenpayneoregon)
              </span>
            </h1>
            <h3 style={{ margin: 0 }}>
              Karen Payne(@karenpayneoregon)
            </h3>
          </a>
           <a href="https://dev.to/karenpayneoregon/visual-studio-shared-user-secrets-14ki"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article on <strong>https://dev.to/</strong>: Visual Studio shared user secrets | Working with database with C# (55 Part Series) | Posts  · Posted on 21/7/2025  · #csharp, #dotnetcore, #devops, #security   · 5 minutes
              </a>
  </section>
</li>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#ApplicationSecurity_Bowrna_knadh_listmonk_issues_2357"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Bowrna(@Bowrna)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Bowrna(@Bowrna)
    </h3>
  </a>
   <p>
       Bowrna(<a href="https://github.com/Bowrna">https://github.com/Bowrna</a>) contributed/added 2 commits that reference the issue, 
        <br />
         <a href="https://github.com/knadh/listmonk/issues/2357"><strong>PostgreSQL Database Exposed to the Internet #2357</strong>, knadh/listmonk</a> on 15/4/25

      </p>
  </section>
  </li>

            <li className="no-margin-bottom1">
              <a
                href="#GZTimeWalker_GZCTF_pull_544_Satori_GC_for_DotNET_10_544"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    GZTimeWalker/GZCTF
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Steve(@hez2010)(<a href="https://github.com/hez2010">https://github.com/hez2010</a>) Created a PR
                  <br />
                  <a href="https://github.com/GZTimeWalker/GZCTF/pull/544">GZTimeWalker/GZCTF</a> on 1/2/26 that received 10 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/GZTimeWalker/GZCTF/pull/544">Visit the GitHub PR: Satori GC for .NET 10
                    #544 </a>
                </div>
                <p></p>
                <a href="https://github.com/GZTimeWalker/GZCTF/pull/544"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full PR: Copilot AI on Feb 1 In the file: <strong>src/GZCTF/Dockerfile</strong> <strong>Comment on lines +10 to +13</strong>
                </a>
              </section>
            </li>
</div>
          <div id="OAuth_and_OpenID_Connect">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}  OAuth and OpenID Connect
                </span>
              </h1>
            </a>

            <div id="medium_com_@anamikagg07_oauth-and-openid-connect-1def117ee947">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://medium.com/@anamikagg07/oauth-and-openid-connect-1def117ee947"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: OAuth and OpenID Connect on 11/8/25
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Reviewed 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/dataframe/pull/185">DataHaskell/dataframe</a> on 17/3/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/dataframe/pull/185">Visit the GitHub PR: fix: alignment in iris tutorial introduction
                    #185  </a>
                </div>
              </section>
            </div>

          </div>




          <div id="Git_add_example_to_the_rebase">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}  Git Rebase
                </span>
              </h1>
            </a>

            <div id="maelle_https_github_com_r-lib_gert_pull_274_changes">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/r-lib/gert/pull/274/changes"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article:docs: add example to the rebase manual page
                  #274

                </a>
                <p>
                  Maëlle Salmon(maelle)(<a href="https://github.com/maelle">https://github.com/maelle</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/r-lib/gert/pull/274/changes">r-lib/gert</a> on 4/5/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/r-lib/gert/pull/274/changes">Visit the GitHub PR: fix: add example to the rebase manual page
                    #274  </a>
                </div>
              </section>
            </div>

          </div>



          <div id="Random_thoughts_#11">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}  TutteInstitute/hirank  Random thoughts #11
                </span>
              </h1>
            </a>

            <div id="TutteInstitute_hirank_issues_11">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/TutteInstitute/hirank/issues/11"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Random thoughts #11
                </a>
                <p>
                  Leland McInnes(lmcinnes)(<a href="https://github.com/lmcinnes">https://github.com/lmcinnes</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/TutteInstitute/hirank/issues/11">TutteInstitute/hirank</a> on 23/6/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/TutteInstitute/hirank/issues/11"> Visit the full Article: Random thoughts #11  </a>
                </div>
              </section>
            </div>

          </div>


          <div id="Michael_Chavinda_gauss_function_to_plot_a_bell_curve">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}   Gauss function to plot a bell curve
                </span>
              </h1>
            </a>

            <div id="Michael_Chavinda_gauss_function_to_plot_a_bell_curve_DataHaskell_sabela_pull_9">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/DataHaskell/sabela/pull/9"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article:Football striker example ⚽ #9
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Reviewed 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/sabela/pull/9">DataHaskell/sabela</a> on 2/7/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/sabela/pull/9">Visit the GitHub PR: Football striker example ⚽   </a>
                </div>
                 <p>
                  <strong>Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>)</strong> commented on 2/7/26: </p><p>Dash is used as a parenthetical here. Prefer parentheses. But the whole sentence could be rewritten a little bit to:</p>
                <p>We use the gauss function to plot a bell curve that labels the x-axis... etc.</p>
                <p>Sounds less &#34;salesy&#34;</p>
              </section>
            </div>

          </div>


          <div id="Michael_Chavinda_GitHub_Reposiotyr_DataHaskell_dataframe">
            <a
              href=""
              className="vcard-names1"
              style={{ textDecoration: 'underline' }}
            >
              <h1 style={{ margin: 0 }}>
                <span className="p-name vcard-fullname d-block overflow-hidden">
                  {/* Span &#ltT> and Pipelines */}   DataHaskell/dataframe
                </span>
              </h1>
            </a>

            <div id="Michael_Chavinda_DataHaskell_dataframe_pull_commit_34af2bc">
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <a href="https://github.com/DataHaskell/dataframe/commit/34af2bc1ee84c995b899fefb1d467954d5d8aefa"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visit the full Article: Commit 34af2bc
                </a>
                <p>
                  Michael Chavinda(mchav)(<a href="https://github.com/mchav">https://github.com/mchav</a>) Created 1 pull request in 1 repository
                  <br />
                  <a href="https://github.com/DataHaskell/dataframe/"> DataHaskell/dataframe</a> on 20/4/26
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/DataHaskell/dataframe/commit/34af2bc1ee84c995b899fefb1d467954d5d8aefa">Visit the GitHub PR: docs: Update documentation for clarity and accuracy across multiple files   </a>
                </div>
              </section>
            </div>

          </div>

<div id="Serilog">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Serilog
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        Serilog
    </h3>
  </a>
      <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#JerriePelser_ASP_NET_Core_and_Serilog"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Jerrie Pelser(@jerriep)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Jerrie Pelser(@jerriep)
    </h3>
  </a>
              <a href="https://www.jerriepelser.com/posts/implement-user-facing-log-files/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Implement user-facing logs with ASP.NET Core and Serilog | Posts  · 25/2/2025  ·   asp.net core, serilog · 9 minutes
              </a>
  </section>
    </li>

      <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#AndrewLock_.NETEscapades_Elasticsearch_Fluentd_Serilog_ASP_DOTNET_Core"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      AndrewLock
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m AndrewLock.
    </h3>
  </a>
   <a href="https://andrewlock.net/writing-logs-to-elasticsearch-with-fluentd-using-serilog-in-asp-net-core/" 
       target="_blank" 
       rel="noopener noreferrer">
        Visit the full article: Writing Logs to Elasticsearch with Fluentd using Serilog in ASP.NET Core
    </a>
  </section>
</li>
 <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#DillionLowry_ASP_NET_Core_and_Serilog"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Dillion Lowry(@DillionLowry)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Dillion Lowry(@DillionLowry)
    </h3>
  </a>
              <a href="https://github.com/DillionLowry/Serilog.Sinks.ObservableCollection" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full GitHub Repository: Serilog sink for logging to an ObservableCollection | Posts  · 28/4/2025  ·   asp.net core, serilog · 9 minutes
              </a>
  </section>
</li>
</div>
<div id="DotNetRuntime">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  DotNet Runtime
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        DotNet Runtime
    </h3>
  </a>

    <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
          <a
    href="#MichalStrehovsky_DotNetRuntime"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Michal Strehovský(@MichalStrehovsky)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Michal Strehovský(@MichalStrehovsky)
    </h3>
  </a>
   <a href="https://migeel.sk/blog/2024/01/02/building-a-self-contained-game-in-csharp-under-2-kilobytes/"
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Building a self-contained game in C# under 2 kilobytes | How I fit a graphical game in C# into 2 kilobytes, with no .NET runtime required.| Posts  · 2/1/2024  · dotnet, long form · 13 minutes
              </a>
  </section>
    </li>

</div>
<div id="WebAssembly">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  WebAssembly
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
        WebAssembly
    </h3>
  </a>
    <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#KyleBarron"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Kyle Barron(@kylebarron)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Kyle Barron(@kylebarron)
    </h3>
  </a>
    <a href="https://kylebarron.dev/blog/zero-copy-apache-arrow-with-webassembly/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Zero-copy Apache Arrow with WebAssembly | Posts  · 22/08/2022 Edits 9/07/2023 · .Javascript, WebAssembly, Apache Arrow C Data Interface · 8 minutes
              </a>
  </section>
  </li>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
        href="#DavidPine"
        className="vcard-names1"
        style={{ textDecoration: 'underline' }}
      >
        <h1 style={{ margin: 0 }}>
          <span className="p-name vcard-fullname d-block overflow-hidden">
          David Pine(@IEvangelist)
          </span>
        </h1>
        <h3 style={{ margin: 0 }}>
          David Pine(@IEvangelist)
        </h3>
      </a>
       <a href="https://davidpine.net/blog/learning-blazor/" 
                target="_blank" 
                rel="noopener noreferrer">
                Visit the full article: Learning Blazor | Build Single-Page Apps with WebAssembly and C# | Posts  · __/09/2022  · .Net Programming, Blazor, WebAssembly, C# · 6 minutes
              </a>
  </section>
  </li>


</div>

<div id="Span_T_andPipelines">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
        {/* Span &#ltT> and Pipelines */}  Span&lt;T&gt; and Pipelines
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
   {/* Span<T> and Pipelines */} Span&lt;T&gt; and Pipelines
    </h3>
  </a>


  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
     <a
    href="#TimurIskhakov_Span_T_andPipelines"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Timur Iskhakov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Timur Iskhakov.
    </h3>
  </a>

<a href="https://timiskhakov.github.io/posts/exploring-spans-and-pipelines" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Exploring Spans and Pipelines | Improving the performance of file parsing by using new goodies in .NET Core | Posts · 31/10/2019 · 5 minutes · c# cuda algorithms
    </a>
  </section>
  </li>



<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
      href="#Span_T_andPipelines_Scooletz"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
          Szymon Kulec
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
        Szymon Kulec
      </h3>
    </a>
    <a href="https://blog.scooletz.com/2018/08/14/thruster-building-a-not-so-fast-memory-pool/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: A fast and efficient implementation of a MemoryPool&lt;T&gt; | Posts · 13/1/2015 · 5 minutes 
    </a>
  </section>
  </li>
<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
    href="#BohdanStupak"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Bohdan Stupak(@Wkalmar)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Bohdan Stupak(@Wkalmar)
    </h3>
  </a>
    
 <a href="https://blog.ndepend.com/improve-c-code-performance-with-spant/" 
      target="_blank" 
      rel="noopener noreferrer">
       Visit the full article: Improve C# code performance with Span&lt;T&gt; | Posts  · 24/3/2025  · 9 minutes 
    </a>
  </section>
  </li>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#AdamSitnik"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Adam Sitnik(@adamsitnik)
      </span>
    </h1>
  </a>
  <div>Open Source contributor, #BenchmarkDotNet maintainer. My job on .NET Team is to make the .NET the fastest developer platform on the planet.</div>
   <a href="https://adamsitnik.com/Span/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Span  | Posts · 13/7/2017  · Span&lt;T&gt;  · 5 minutes
    </a>
  </section>
    </li>
</div>
<div id="DB">
<a
    href=""
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      DB
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    DB.
    </h3>
  </a>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
      href="#SQLJoin"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
        SQL Join 
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
      SQL Join.
      </h3>
    </a>
    {/* <h3 className="no-margin KristofferCarlsson-article-title" 
    // itemprop="name"
    >
    Visit the Blog Post titled 
    <a href="https://www.alibabacloud.com/blog/how-to-write-a-high-performance-sql-join-implementation-and-best-practices-of-joins_599145" 
    // itemprop="url"
    >How to Write a High-Performance SQL Join: Implementation and Best Practices of Joins</a>
    </h3> */}
  </section>
</li>





<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#AlexChiZ"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Alex Chi Z.
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      <p style={{ margin: 0 }}>
      Alex Chi Z.
        <a
          href=""
          data-original-href=""
        >
  
        </a>
      </p>
    </h3>
  </a>
  <h3 className="no-margin KristofferCarlsson-article-title" 
    // itemprop="name" 
    style={{ margin: 0 }}
    >
    <a href="https://www.skyzh.dev/blog/2022-05-29-shared-state-in-risingwave/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Delta Join in the Streaming Engine based on a shared state index | Posts · 29/15/2022 · 10 minutes 
    </a>
    </h3>
    {/* <a
      href="#SQLJoin"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
        SQL Join 
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
      SQL Join.
      </h3>
    </a> */}

  </section>
</li>

<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#ConradLudgate"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Conrad Ludgate
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
    Conrad Ludgate.
    </h3>
  </a>
  <a href="https://conradludgate.com/posts/cnpg" 
     target="_blank" 
     rel="noopener noreferrer">
     Visit the full article: Postgres | Posts · 5/11/2023 
  </a>
    </section>
</li>

<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
        href="#SimonWillison_StephenTurner"
        className="vcard-names1"
        style={{ textDecoration: 'underline' }}
      >
        <h1 style={{ margin: 0 }}>
          <span className="p-name vcard-fullname d-block overflow-hidden">
          Stephen Turner
          </span>
        </h1>
        <h3 style={{ margin: 0 }}>
          Hi there! I’m Stephen Turner.
        </h3>
      </a>
      <a href="https://blog.stephenturner.us/p/duckdb-vs-dplyr-vs-base-r" 
        target="_blank" 
        rel="noopener noreferrer" style={{ margin: 0 }}>
        Visit the full article: DuckDB vs dplyr vs base R | Posts · 7/10/2024 
      </a>
    </section>
</li>
<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
      href="#SimonWillison_StephenTurner"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
          Stephen Turner
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
        Hi there! I’m Stephen Turner.
      </h3>
    </a>
    <a
      href="https://blog.stephenturner.us/p/duckdb-vs-dplyr-vs-base-r"
      target="_blank"
      rel="noopener noreferrer"
      style={{ margin: 0 }}
    >
      Visit the full article: DuckDB vs dplyr vs base R | Posts · 7/10/2024
    </a>
  </section>
</li>

<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
      <a
    href="#_AndriyBurkov_erikbern_ann-benchmarks"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Andriy Burkov
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Andriy Burkov.
    </h3>
  </a>
      {/* <p>
        Andriy Burkov (<a href="https://github.com/aburkov">https://github.com/aburkov</a>) starred a repository on 03/4/25
        <br />
        <a href="https://github.com/erikbern/ann-benchmarks">https://github.com/erikbern/ann-benchmarks</a> (Python) 5.2k Stars
       
      </p>
      <WhyThisRepo />
      <Erikbern_ann_benchmarks_GitHubRepository_CodeDisplay /> */}

      <p className="f4 my-3">
              Benchmarks of approximate nearest neighbor libraries in Python
            </p>
            <a title="http://ann-benchmarks.com" role="link" target="_blank" rel="noopener noreferrer nofollow" className="text-bold" href="http://ann-benchmarks.com">ann-benchmarks.com</a>
    </section>
</li>
<li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#HrishiOlickel"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Hrishi Olickel
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Hrishi Olickel.
    </h3>
  </a>
  <a href="https://olickel.com/subqueries-and-ctes-an-example-of-query-optimization-in-postgres" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Subqueries and CTEs: an example of query optimization in Postgres | Optimization isn't always premature | Posts · 9/10/2020 · 10 minutes 
    </a>
  </section>
  </li>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
    <a
        href="#AntonZhiyanov"
        className="vcard-names1"
        style={{ textDecoration: 'underline' }}
      >
        <h1 style={{ margin: 0 }}>
          <span className="p-name vcard-fullname d-block overflow-hidden">
          Anton Zhiyanov
          </span>
        </h1>
        <h3 style={{ margin: 0 }}>
          Hi there! I’m Anton Zhiyanov.
        </h3>
      </a>
      <a href="https://antonz.org/sql-join/" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: SQL join flavors | Posts · 20/6/20203 · 5 minutes 
    </a>
  </section>
  </li>
  <li className="no-margin-bottom1">
  <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
  <a
    href="#James(@capjamesg)"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      James (@capjamesg)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m James (@capjamesg).
    </h3>
  </a>
  <a href="https://jamesg.blog/2024/08/19/nosql-database-python" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: Building a NoSQL database in Python | Posts · 19/8/2024 · 5 minutes 
    </a>
    </section>
  </li>

<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
      href="#YanCui(theburningmonk)"
      className="vcard-names1"
      style={{ textDecoration: 'underline' }}
    >
      <h1 style={{ margin: 0 }}>
        <span className="p-name vcard-fullname d-block overflow-hidden">
        Yan Cui
        </span>
      </h1>
      <h3 style={{ margin: 0 }}>
        Hi there! I’m Yan Cui(theburningmonk).
      </h3>
    </a>
    <a href="https://theburningmonk.com/2023/12/how-to-perform-database-migration-for-a-live-service-with-no-downtime/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: How to perform database migration for a live service with no downtime | Posts · AWS, DynamoDB, Serverless · 12/2023 
    </a>
</section>
</li>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#ZonghengYang"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Zongheng Yang (@concretevitamin)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Zongheng Yang (@concretevitamin).
    </h3>
  </a>
  <a href="https://rise.cs.berkeley.edu/blog/sql-query-optimization-meets-deep-reinforcement-learning/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: SQL Query Optimization Meets Deep Reinforcement Learning | Posts  · 18/9/2018 
    </a>
</section>
</li>



<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#daily_dev_idoshamun"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Ido Shamun
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Ido Shamun
    </h3>
  </a>
  <a href="https://daily.dev/blog/sql-join-vs-subquery-the-game-changer" 
       target="_blank" 
       rel="noopener noreferrer">
       Visit the full article: SQL Join vs Subquery: The Game Changer | Posts · 19/11/2020 · 3 minutes 
    </a>
</section>
</li>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#ChrisDone"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Chris Done (@chrisdone)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Hi there! I’m Chris Done (@chrisdone).
    </h3>
  </a>
    <a href="https://chrisdone.com/posts/postgresql-pagination/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Fast pagination on PostgreSQL | Posts  · 19/11/2014  ·  2 minutes
    </a>
</section>
</li>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#Marlene"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Marlene
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Marlene
    </h3>
  </a>
      <a href="https://marlenezw.hashnode.dev/an-introduction-to-ibis-for-python-programmers" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: An Introduction to Ibis for Python Programmers | A More Pythonic Way To Work With Databases | Posts  · 14/3/2022  · Python, Databases · 10 minutes
    </a>
</section>
</li>

<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#EdzerPebesma"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Edzer Pebesma
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Edzer Pebesma
    </h3>
  </a>
   <a href="https://r-spatial.org/2017/07/14/Large_scale_OSM_in_R.html" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Setting up large scale OSM environments for R using Osmosis and PostgreSQL with PostGIS | Posts  · 14/6/2017  · Databases, geoinformatics, spatial statistics, R. · 5 minutes
    </a>
</section>
</li>

<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#Will_DePue_@0hq"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
       Will DePue(@0hq)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Will DePue(@0hq)
    </h3>
  </a>
    <a href="https://www.pinecone.io/learn/vector-search-filtering/" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full news article: The Missing WHERE Clause in Vector Search  | Posts · 30/6/2023  · the tiny, least-dumb, speedy vector embedding database · 5 minutes
    </a>
</section>
</li>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
        <a
    href="#EllieHuxtable"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      EllieHuxtable(@ellie)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      EllieHuxtable(@ellie)
    </h3>
  </a>
             <a href="https://ellie.wtf/notes/postgres-hba-tailscale" 
      target="_blank" 
      rel="noopener noreferrer">
      Visit the full article: Postgres HBA with a Tailscale network  | Posts  · 3/11/2023  · Databases, #postgresql, #tailscale · 1 minute
    </a>
</section>
</li>
<li className="no-margin-bottom1">
<section className="section-gap-SQL-Join" style={{ margin: 0 }}>
<a
    href="#ReynoldXin"
    className="vcard-names1"
    style={{ textDecoration: 'underline' }}
  >
    <h1 style={{ margin: 0 }}>
      <span className="p-name vcard-fullname d-block overflow-hidden">
      Reynold Xin(@rxin)
      </span>
    </h1>
    <h3 style={{ margin: 0 }}>
      Reynold Xin(@rxin)
    </h3>
  </a>
</section>
</li>
<li className="no-margin-bottom1">
              <a
                href="#Kris_Jenkins_Snowflake_Labs_sfguide_getting_started_with_snowflakeintelligence_and_cke_pull_1_Refactoring_the_setup_script"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    Kris Jenkins(@krisajenkins)
                  </span>
                </h3>
              </a>
              <section className="section-gap-SQL-Join" style={{ margin: 0 }}>
                <p>
                  Kris Jenkins(@krisajenkins)(<a href="https://github.com/krisajenkins">https://github.com/krisajenkins</a>) Opened 2 pull requests in 2 repositories
                  <br />
                  <a href="https://github.com/Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke/pull/1">Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke</a> on 1/10/25
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/Snowflake-Labs/sfguide-getting-started-with-snowflake-intelligence-and-cke/pull/1">Visit the GitHub PR: Refactoring the setup script #1  </a>
                </div>
              </section>
</li>
            <li className="no-margin-bottom1">
              <a
                href="#Aaron_Powell_github_awesome_copilot_pull_590_Enhance_the_skill_to_include_sampling_of_data_to_detect_better_join#590"
                className="vcard-names1"
                style={{ textDecoration: 'underline' }}
              >
                <h3 style={{ margin: 0 }}>
                  <span className="p-name vcard-fullname d-block overflow-hidden">
                    github/awesome-copilot
                  </span>
                </h3>
              </a>
              <section className="section-gap-AnthonyShaw">
                <p>
                  Aaron Powell(@aaronpowell)(<a href="https://github.com/aaronpowell">https://github.com/aaronpowell</a>) Reviewed 7 PRs
                  <br />
                  <a href="https://github.com/github/awesome-copilot/">github/awesome-copilot/</a> on 19/1/26 that received 5 comments
                </p>
                <div className="Ullaakut-Gorsair-text-gray Ullaakut-Gorsair-mb-2 Ullaakut-Gorsair-ws-normal">
                  <a href="https://github.com/github/awesome-copilot/pull/590">Visit the GitHub PR: Enhance the skill to include sampling of data, to detect better joins. #590 </a>
                </div>
                 <p>
                  <a href="https://x.com/miguelperedo" target="_blank" rel="noopener noreferrer">Miguel Peredo Z (@‪miguelperedo‬)</a> posted  ·  9/2/25
                </p>
                <p>
                </p>
                <a href="https://x.com/miguelperedo/status/1888308497458282961?s=20"
                  target="_blank"
                  rel="noopener noreferrer">
                  View the post on <strong>https://x.com</strong>: Season 1 of my blog "Modelando" is now available!  It is about data and data modeling concepts, covers also file formats, etc.  https://miguelelgallo.github.io/Modelando2025/ · posted  9/2/2025
                </a>
                <p></p>
                <a href="https://miguelelgallo.github.io/Modelando2025/Season%202/S2E1/S2E1%20Keys/">Keys</a>
              </section>
            </li>



</div>
<div id="githubcom_huggingface_transformers_pull_35848">
<a
  href="https://github.com/huggingface/transformers/pull/35848"
  className="vcard-names1"
  style={{ textDecoration: 'underline' }}
>
  <div id="githubcom_huggingface_transformers_pull_35848">

  <h1 className="gh-header-title">
      <bdi className="js-issue-title markdown-title">🚨🚨🚨 image-classification pipeline single-label and multi-label prob type squashing fns (sigmoid vs softmax) are backwards</bdi>
      <span className="f1-light color-fg-muted">#35848</span>
    </h1>
    
  </div>
</a>

<h1 dir="auto">What does this PR do?</h1>
<p dir="auto">Use the proper squashing/activation function to calc probabilities for image-classification pipeline.</p>
<p dir="auto">Currently 'sigmoid' is used for models with the single-label problem type. This is not correct.</p>


</div>







</div>




        </div> {/* Closing for className="App-header_replica"*/}
        








<TwitterTweetEmbed tweetId="1855509794993692780"  />
      
    </div>
  );
}

export default App;
